{
  "app.name": "DoneTalk",
  "nav.inbox": "Atendimentos",
  "nav.contacts": "Contatos",
  "nav.flows": "Fluxos",
  "nav.assistants": "Assistentes",
  "nav.numbers": "Números",
  "nav.settings": "Configurações",
  "inbox.view.mine": "Meus",
  "inbox.view.team": "Minha equipe",
  "inbox.view.queue": "Fila",
  "inbox.view.waiting_contact": "Aguardando contato",
  "inbox.view.snoozed": "Soneca",
  "inbox.view.closed": "Concluídos",
  "conversation.status.new": "Novo",
  "conversation.status.active": "Em atendimento",
  "conversation.status.waiting_contact": "Aguardando contato",
  "conversation.status.waiting_internal": "Aguardando interno",
  "conversation.status.snoozed": "Em soneca",
  "conversation.status.closed": "Concluído",
  "conversation.outcome": "Desfecho",
  "conversation.close": "Concluir atendimento",
  "handler.flow": "Fluxo",
  "handler.assistant": "Assistente",
  "handler.human": "Pessoa",
  "common.close": "Fechar",
  "common.cancel": "Cancelar",
  "common.save": "Salvar",
  "locale.name": "Português (Brasil)",
  "auth.title": "Entrar",
  "auth.email": "E-mail",
  "auth.password": "Senha",
  "auth.submit": "Entrar",
  "auth.invalid": "E-mail ou senha incorretos.",
  "auth.blocked": "Este acesso está bloqueado.",
  "auth.logout": "Sair",
  "workspaces.title": "Escolha o cliente",
  "workspaces.subtitle": "Seu acesso vale para mais de um cliente.",
  "workspaces.none": "Você ainda não tem acesso a nenhum cliente.",
  "workspaces.not_ready": "Em preparação",
  "role.owner": "Dono",
  "role.admin": "Administrador",
  "role.manager": "Gestor",
  "role.supervisor": "Supervisor",
  "role.operator": "Atendente",
  "role.auditor": "Auditor",
  "role.integration": "Integração",
  "inbox.search": "Pesquisar por nome ou telefone",
  "inbox.empty": "Nenhum atendimento nesta visão",
  "inbox.empty_hint": "Troque a visão ou aguarde novas mensagens.",
  "inbox.select": "Selecione um atendimento",
  "inbox.select_hint": "Os atendimentos da visão escolhida aparecem à esquerda.",
  "inbox.loading": "Carregando…",
  "inbox.no_messages": "Nenhuma mensagem ainda.",
  "inbox.action.take": "Assumir",
  "inbox.action.assign": "Atribuir",
  "inbox.action.transfer": "Transferir",
  "handoff.to_assistant": "Devolver ao assistente",
  "handoff.to_flow": "Iniciar um fluxo…",
  "handoff.assistant_title": "Devolver ao assistente de IA",
  "handoff.flow_title": "Iniciar um fluxo",
  "handoff.assistant_text": "Se o cliente está esperando resposta, o assistente responde agora; se não, responde a próxima mensagem dele. Ele chama a equipe de novo se precisar, e você deixa de atender esta conversa.",
  "handoff.flow_text": "O fluxo começa agora: do início, de onde parou quando alguém da equipe escreveu, ou numa etapa escolhida. Você deixa de atender esta conversa.",
  "handoff.window_closed": "A janela de 24 horas está fechada: um fluxo só pode começar depois que o cliente escrever de novo.",
  "handoff.flow_pick": "Fluxo publicado",
  "handoff.assistant_pick": "Assistente publicado",
  "handoff.no_flows": "Nenhum fluxo publicado. Publique um no construtor de fluxos.",
  "handoff.no_assistants": "Nenhum assistente publicado. Publique um em Configurações › Assistentes de IA.",
  "handoff.confirm": "Devolver",
  "handoff.assistant_done": "O assistente assumiu a conversa.",
  "handoff.flow_done": "O fluxo começou.",
  "errors.flow_not_published": "Esse fluxo não está publicado.",
  "errors.outside_session_window": "A janela de 24 horas está fechada. Use um modelo aprovado.",
  "errors.conversation_closed": "Esta conversa já foi concluída.",
  "inbox.action.snooze": "Soneca",
  "inbox.action.wait_contact": "Aguardar contato",
  "inbox.action.wait_internal": "Aguardar interno",
  "inbox.action.resume": "Retomar",
  "inbox.action.close": "Concluir",
  "inbox.action.reopen": "Reabrir",
  "inbox.action.note": "Anotar",
  "inbox.action.more": "Mais ações",
  "inbox.header.queue": "Na fila",
  "inbox.header.mine": "Comigo",
  "inbox.header.with": "Com {name}",
  "inbox.header.assistant": "Com o assistente",
  "inbox.header.flow": "No fluxo",
  "inbox.header.closed": "Concluído: {outcome}",
  "inbox.window.remaining": "Janela de resposta: {time} restantes",
  "inbox.window.expired": "A janela de 24 horas fechou. Só é possível enviar um modelo aprovado.",
  "inbox.window.free": "Conversa de anúncio: gratuita por {time}",
  "inbox.window.send_template": "Enviar modelo",
  "inbox.snoozed_until": "Em soneca até {time}",
  "inbox.priority.low": "Baixa",
  "inbox.priority.normal": "Normal",
  "inbox.priority.high": "Alta",
  "inbox.priority.urgent": "Urgente",
  "outcome.title": "Concluir atendimento",
  "outcome.select": "Desfecho",
  "outcome.note": "Observação",
  "outcome.note_required": "Este desfecho exige uma observação.",
  "outcome.confirm": "Concluir",
  "outcome.success": "Sucesso",
  "outcome.neutral": "Neutro",
  "outcome.negative": "Negativo",
  "outcome.invalid": "Inválido",
  "assign.title": "Atribuir atendimento",
  "assign.member": "Atendente",
  "assign.unassigned": "Sem atendente",
  "assign.confirm": "Atribuir",
  "transfer.title": "Transferir atendimento",
  "transfer.team": "Equipe",
  "transfer.keep_team": "Manter equipe",
  "transfer.member": "Atendente",
  "transfer.any_member": "Qualquer atendente da equipe",
  "transfer.note": "Contexto para quem recebe",
  "transfer.confirm": "Transferir",
  "snooze.title": "Soneca",
  "snooze.hint": "O atendimento sai da caixa e volta sozinho no horário escolhido.",
  "snooze.1h": "Em 1 hora",
  "snooze.3h": "Em 3 horas",
  "snooze.tomorrow": "Amanhã às 9h",
  "snooze.next_week": "Próxima semana",
  "snooze.custom": "Escolher data e hora",
  "snooze.reason": "Motivo",
  "snooze.confirm": "Adiar",
  "note.title": "Nota interna",
  "note.placeholder": "Visível só para a equipe",
  "note.save": "Salvar nota",
  "event.created": "Atendimento aberto",
  "event.assigned": "Atribuído a {name}",
  "event.unassigned": "Devolvido à fila",
  "event.transferred": "Transferido",
  "event.status_changed": "Status: {to}",
  "event.snoozed": "Soneca até {until}",
  "event.closed": "Concluído",
  "event.reopened": "Reaberto",
  "event.note_added": "Nota adicionada",
  "event.priority_changed": "Prioridade: {to}",
  "event.outcome_set": "Desfecho: {outcome}",
  "event.policy": "Regra automática",
  "event.handler_changed": "Quem atende: {to}",
  "message.failed": "Não enviada",
  "message.queued": "Enviando…",
  "message.media.image": "Imagem",
  "message.media.audio": "Áudio",
  "message.media.video": "Vídeo",
  "message.media.document": "Documento",
  "message.media.sticker": "Figurinha",
  "message.location": "Localização",
  "message.template": "Modelo",
  "message.reaction": "Reagiu com {emoji}",
  "time.yesterday": "Ontem",
  "time.now": "agora",
  "time.minutes": "{n} min",
  "time.hours": "{n} h",
  "common.confirm": "Confirmar",
  "common.back": "Voltar",
  "common.error": "Algo deu errado. Tente novamente.",
  "common.none": "Nenhum",
  "common.styleguide": "Styleguide",
  "flows.title": "Fluxos",
  "flows.new": "Novo fluxo",
  "flows.empty": "Nenhum fluxo ainda",
  "flows.empty_hint": "Crie um fluxo para atender automaticamente antes de chegar a uma pessoa.",
  "flows.name": "Nome",
  "flows.description": "Descrição",
  "flows.status.draft": "Rascunho",
  "flows.status.published": "Publicado",
  "flows.status.archived": "Arquivado",
  "flows.active_runs": "{n} em andamento",
  "flows.version": "v{n}",
  "flows.unsaved": "Alterações não salvas",
  "builder.save": "Salvar rascunho",
  "builder.saved": "Rascunho salvo",
  "builder.publish": "Publicar",
  "builder.published": "Versão {n} publicada",
  "builder.test": "Testar",
  "builder.triggers": "Gatilhos",
  "builder.versions": "Versões",
  "builder.restore": "Restaurar",
  "builder.restored": "Versão {n} restaurada como v{next}",
  "builder.add": "Adicionar bloco",
  "builder.delete_node": "Remover bloco",
  "builder.inspector_empty": "Selecione um bloco para editar",
  "builder.exit": "Saída",
  "builder.exit_next": "Próximo",
  "builder.exit_fallback": "Sem resposta válida",
  "builder.exit_invalid": "Inválido",
  "builder.exit_error": "Erro",
  "builder.exit_default": "Senão",
  "builder.exit_inside": "Dentro do horário",
  "builder.exit_outside": "Fora do horário",
  "builder.exit_done": "Ao terminar",
  "builder.unconnected": "Saída sem destino",
  "builder.invalid": "O fluxo tem erros: {detail}",
  "builder.channel_default": "Quando um contato inicia uma conversa no número",
  "builder.keywords": "Palavras-chave (uma por linha)",
  "builder.trigger_saved": "Gatilhos salvos",
  "builder.variables_hint": "Use {{contact.name}}, {{vars.nome}} ou {{input.text}} no texto.",
  "node.start": "Início",
  "node.message": "Mensagem",
  "node.menu": "Menu",
  "node.input": "Pergunta",
  "node.condition": "Condição",
  "node.http_request": "Chamada de API",
  "node.script": "Script",
  "node.field.code": "Código (JavaScript)",
  "node.field.code_hint": "Use vars (variáveis do fluxo) e contact (nome e campos) e devolva um objeto: cada chave vira uma variável. Roda isolado, sem internet, por até 0,2 segundo; se falhar, segue pela saída Erro com vars.script_error.",
  "node.set_variable": "Definir variável",
  "node.set_field": "Gravar campo do contato",
  "node.tag": "Etiquetar",
  "node.wait": "Esperar",
  "node.business_hours": "Horário de atendimento",
  "node.transfer": "Transferir para pessoa",
  "node.assistant": "Assistente de IA",
  "node.close": "Concluir",
  "node.event": "Registrar evento",
  "node.exception": "Exceção",
  "node.end": "Fim",
  "node.field.text": "Texto",
  "node.field.body": "Texto do menu",
  "node.field.header": "Cabeçalho",
  "node.field.footer": "Rodapé",
  "node.field.options": "Opções",
  "node.field.option_title": "Título",
  "node.field.option_id": "Identificador",
  "node.field.add_option": "Adicionar opção",
  "node.field.retries": "Tentativas",
  "node.field.retry_text": "Texto ao não entender",
  "node.field.variable": "Guardar em",
  "node.field.prompt": "Pergunta",
  "node.field.validation": "Validação",
  "node.field.pattern": "Expressão regular",
  "node.field.error_text": "Texto ao ser inválido",
  "node.field.rules": "Regras",
  "node.field.add_rule": "Adicionar regra",
  "node.field.op": "Operador",
  "node.field.value": "Valor",
  "node.field.method": "Método",
  "node.field.url": "URL",
  "node.field.headers": "Cabeçalhos (JSON)",
  "node.field.request_body": "Corpo",
  "node.field.timeout": "Tempo limite (ms)",
  "node.field.field": "Campo",
  "node.field.tag": "Etiqueta",
  "node.field.seconds": "Segundos",
  "node.field.business_hours": "Horário",
  "node.field.team": "Equipe",
  "node.field.member": "Atendente",
  "node.field.note": "Contexto para quem recebe",
  "node.field.assistant": "Assistente",
  "node.field.outcome": "Desfecho",
  "node.field.event_name": "Nome do evento",
  "node.field.any": "Qualquer",
  "validation.text": "Texto livre",
  "validation.number": "Número",
  "validation.email": "E-mail",
  "validation.phone": "Telefone",
  "validation.cpf": "CPF",
  "validation.cnpj": "CNPJ",
  "validation.date": "Data",
  "validation.regex": "Expressão regular",
  "op.exists": "existe",
  "op.eq": "é igual a",
  "op.neq": "é diferente de",
  "op.contains": "contém",
  "op.starts_with": "começa com",
  "op.ends_with": "termina com",
  "op.gt": "maior que",
  "op.gte": "maior ou igual a",
  "op.lt": "menor que",
  "op.lte": "menor ou igual a",
  "op.regex": "casa com regex",
  "op.in": "está entre",
  "simulator.title": "Teste do fluxo",
  "simulator.hint": "Converse como o cliente. O rascunho atual é executado em memória, sem enviar nada.",
  "simulator.placeholder": "Responda como o cliente",
  "simulator.reset": "Reiniciar",
  "simulator.state": "Estado: {status}",
  "simulator.action": "Ação: {type}",
  "gate.title": "Revisão antes de enviar",
  "gate.hint": "A política da empresa revisou sua mensagem antes de sair.",
  "gate.draft": "Sua mensagem",
  "gate.suggestion": "Sugestão",
  "gate.reasons": "Motivos",
  "gate.verdict.rewrite": "Ajuste sugerido",
  "gate.verdict.block": "Bloqueada",
  "gate.accept": "Usar sugestão",
  "gate.edit": "Enviar minha edição",
  "gate.override": "Enviar mesmo assim",
  "gate.blocked_hint": "Esta mensagem não pode ser enviada como está. Edite o texto.",
  "gate.rule.blocked_term": "termo bloqueado",
  "gate.rule.pii": "dado sensível",
  "gate.rule.link": "link não permitido",
  "gate.rule.promise": "promessa",
  "settings.title": "Configurações",
  "settings.numbers": "Números",
  "settings.team": "Equipe e pessoas",
  "settings.assistants": "Assistentes de IA",
  "settings.knowledge": "Base de conhecimento",
  "settings.policies": "Políticas",
  "settings.ai": "IA: modelos, chaves e uso",
  "settings.integrations": "Integrações",
  "settings.save": "Salvar",
  "settings.saved": "Salvo",
  "settings.new": "Novo",
  "settings.none": "Nada por aqui ainda",
  "numbers.connect": "Conectar número",
  "numbers.connect_hint": "Cole o token do usuário de sistema ou o código do cadastro incorporado da Meta.",
  "numbers.waba": "ID da conta WhatsApp Business (WABA)",
  "numbers.phone_id": "ID do número",
  "numbers.token": "Token de acesso",
  "numbers.pin": "PIN de registro (opcional)",
  "numbers.mode": "Modo de atendimento",
  "numbers.quality": "Qualidade",
  "numbers.tier": "Limite",
  "numbers.templates": "Modelos aprovados",
  "numbers.templates_hint": "1 modelo nesta conta. Crie, corrija e acompanhe a análise da Meta.|{count} modelos nesta conta. Crie, corrija e acompanhe a análise da Meta.",
  "numbers.sync": "Sincronizar com a Meta",
  "numbers.synced": "{n} modelos sincronizados, {changes} mudaram de categoria",
  "numbers.category": "Categoria",
  "numbers.language": "Idioma",
  "numbers.status": "Status",
  "team.members": "Pessoas",
  "team.invite": "Convidar",
  "team.invite_hint": "O convite gera um link para a pessoa criar a senha. Ainda sem e-mail automático: copie e envie.",
  "team.invite_link": "Link do convite",
  "team.name": "Nome",
  "team.role": "Papel",
  "team.presence": "Presença",
  "team.teams": "Equipes",
  "team.new_team": "Nova equipe",
  "team.distribution": "Distribuição",
  "team.capacity": "Capacidade por pessoa",
  "team.auto_assign": "Distribuir automaticamente",
  "team.add_member": "Adicionar à equipe",
  "team.hours": "Horário de atendimento",
  "team.new_hours": "Novo horário",
  "team.timezone": "Fuso horário",
  "distribution.least_busy": "Menos ocupado",
  "distribution.most_idle": "Mais ocioso",
  "distribution.round_robin": "Rodízio",
  "distribution.manual": "Manual",
  "presence.online": "Online",
  "presence.paused": "Em pausa",
  "presence.offline": "Offline",
  "assistant.new": "Novo assistente",
  "assistant.persona_name": "Nome da persona",
  "assistant.tone": "Tom",
  "assistant.language": "Idioma das respostas",
  "assistant.instructions": "Instruções",
  "assistant.instructions_hint": "Explique o negócio, o que responder, o que nunca prometer e quando chamar uma pessoa.",
  "assistant.knowledge": "Bases de conhecimento",
  "assistant.tools": "Ferramentas",
  "assistant.exit": "Condições de saída",
  "assistant.exit_field": "Quando o campo estiver preenchido",
  "assistant.exit_keyword": "Quando o cliente disser",
  "assistant.filters": "Termos bloqueados na resposta (um por linha)",
  "assistant.fallback": "Texto de segurança",
  "assistant.max_turns": "Máximo de respostas antes de passar para uma pessoa",
  "assistant.handoff_team": "Equipe que recebe",
  "assistant.publish": "Publicar",
  "assistant.published": "Versão {n} publicada",
  "assistant.status.draft": "Rascunho",
  "assistant.status.active": "Ativo",
  "assistant.status.archived": "Arquivado",
  "assistant.running": "{n} em atendimento",
  "assistant.temperature": "Criatividade",
  "knowledge.collections": "Coleções",
  "knowledge.new_collection": "Nova coleção",
  "knowledge.documents": "Documentos",
  "knowledge.add": "Adicionar conteúdo",
  "knowledge.source.text": "Texto",
  "knowledge.source.site": "Site",
  "knowledge.source.faq": "Perguntas frequentes",
  "knowledge.site_url": "Endereço da página",
  "knowledge.site_crawl": "Ler também as páginas ligadas do mesmo site (até 10)",
  "knowledge.site_hint": "Cada página vira um documento. Páginas com pouco texto e as que já estão na coleção ficam de fora.",
  "knowledge.site_read": "Ler o site",
  "knowledge.site_error.private": "Esse endereço não é de um site público.",
  "knowledge.site_error.missing": "Página não encontrada nesse endereço.",
  "knowledge.site_error.not_page": "Esse endereço não é uma página de texto.",
  "knowledge.site_error.unreachable": "Não conseguimos abrir o site agora. Confira o endereço e tente de novo.",
  "knowledge.site_added": "1 página adicionada|{count} páginas adicionadas",
  "knowledge.pdf_ready": "{name}: {pages} páginas, {chars} caracteres de texto.",
  "knowledge.pdf_truncated": "Só o começo do arquivo cabe; o resto fica de fora.",
  "knowledge.pdf_no_text": "Esse PDF não tem texto para ler (talvez seja uma imagem escaneada).",
  "knowledge.doc_title": "Título",
  "knowledge.doc_text": "Conteúdo",
  "knowledge.chunks": "{n} trechos",
  "knowledge.search": "Testar busca",
  "knowledge.search_hint": "Veja o que o assistente encontraria para uma pergunta.",
  "knowledge.status.ready": "Pronto",
  "knowledge.status.processing": "Processando",
  "knowledge.status.failed": "Falhou",
  "knowledge.status.pending": "Pendente",
  "policy.new": "Nova política",
  "policy.kind": "Tipo",
  "policy.kind.lifecycle": "Encerramento automático",
  "policy.kind.gate": "Revisão de mensagens",
  "policy.scope": "Escopo",
  "policy.scope.customer": "Toda a empresa",
  "policy.scope.team": "Equipe",
  "policy.scope.channel": "Número",
  "policy.mode": "Modo",
  "policy.mode.shadow": "Sombra (só registra)",
  "policy.mode.log": "Registrar",
  "policy.mode.suggest": "Sugerir ao atendente",
  "policy.mode.auto_fix": "Corrigir e enviar",
  "policy.mode.block": "Bloquear",
  "policy.active": "Ativa",
  "policy.rules": "Regras",
  "policy.rule.no_inbound_for": "Sem resposta do contato há {hours} h, concluir como",
  "policy.rule.window_expired": "Janela de 24 h fechada: marcar como aguardando contato",
  "policy.rule.unanswered_new_for": "Sem primeira resposta há {hours} h: prioridade",
  "policy.hours": "Horas",
  "policy.outcome": "Desfecho",
  "policy.add_rule": "Adicionar regra",
  "policy.gate.blocked": "Termos bloqueados (um por linha)",
  "policy.gate.domains": "Domínios permitidos em links (um por linha)",
  "policy.gate.promises": "Padrões de promessa (regex, um por linha)",
  "policy.gate.pii": "Bloquear dados sensíveis (cartão, CPF)",
  "policy.gate.judge": "Usar juiz de IA",
  "policy.gate.instructions": "Política para o juiz de IA",
  "policy.gate.override": "Papéis que podem enviar mesmo assim",
  "ai.own_keys": "Usar minhas próprias chaves de IA",
  "ai.budget": "Orçamento mensal (USD)",
  "ai.budget_action": "Ao atingir o orçamento",
  "ai.budget.warn": "Avisar",
  "ai.budget.block": "Bloquear",
  "ai.keys": "Chaves",
  "ai.add_key": "Adicionar chave",
  "ai.provider": "Provedor",
  "ai.key": "Chave",
  "ai.usage": "Uso no mês",
  "ai.surface.assistant.reply": "Respostas do assistente",
  "ai.surface.gate.judge": "Revisão de mensagens",
  "ai.surface.outcome.classify": "Sugestão de desfecho",
  "ai.surface.summary.brief": "Resumo do atendimento",
  "ai.surface.knowledge.embed": "Base de conhecimento",
  "ai.surface.audio.transcribe": "Transcrição de áudio",
  "ai.surface.learning.mine": "Aprendizado semanal",
  "ai.surface.onboarding.propose": "Sugestões da implantação",
  "ai.calls.previous": "Mês anterior",
  "ai.calls.next": "Próximo mês",
  "ai.calls.cost": "Custo",
  "ai.calls.of_budget": "de {budget} no mês ({share}%)",
  "ai.calls.calls": "Chamadas",
  "ai.calls.tokens": "Tokens",
  "ai.calls.cached": "{n} em cache",
  "ai.calls.failed": "Com falha",
  "ai.calls.failed_detail": "{errors} erros · {blocked} bloqueadas pelo orçamento",
  "ai.calls.n_calls": "1 chamada|{count} chamadas",
  "ai.calls.use": "Uso",
  "ai.calls.all_uses": "Todos os usos",
  "ai.calls.status_label": "Situação",
  "ai.calls.all_status": "Todas",
  "ai.calls.status.success": "Concluída",
  "ai.calls.status.error": "Erro",
  "ai.calls.status.blocked": "Bloqueada",
  "ai.calls.when": "Quando",
  "ai.calls.model": "Modelo",
  "ai.calls.latency": "Tempo",
  "ai.calls.conversation": "Ver atendimento",
  "ai.calls.own_key": "chave própria",
  "ai.calls.none": "Nenhuma chamada de IA neste período.",
  "ai.calls.more": "Carregar mais",
  "ai.label": "Rótulo",
  "member.status.active": "Ativo",
  "member.status.invited": "Convidado",
  "member.status.suspended": "Suspenso",
  "contact.panel": "Dados do contato",
  "contact.name": "Nome do contato",
  "contact.edit_name": "Editar nome",
  "contact.this_conversation": "Este atendimento",
  "contact.source": "Origem",
  "contact.goal": "Objetivo",
  "contact.channel": "Canal",
  "contact.started": "Início",
  "contact.meta_cost": "Custo Meta",
  "contact.fields": "Campos",
  "contact.consent": "Consentimento e bloqueio",
  "contact.consent_marketing": "Aceita mensagens de marketing",
  "contact.blocked": "Contato bloqueado",
  "contact.history": "Atendimentos anteriores",
  "contact.no_history": "Primeiro atendimento deste contato.",
  "source.inbound": "Contato iniciou",
  "source.ad": "Anúncio (clique para WhatsApp)",
  "source.template": "Modelo enviado",
  "source.campaign": "Campanha",
  "source.api": "API",
  "source.flow": "Fluxo",
  "source.connector": "Integração",
  "source.reopen": "Reabertura",
  "common.yes": "Sim",
  "common.no": "Não",
  "template.pick": "Enviar modelo aprovado",
  "template.search": "Buscar modelo",
  "template.none_approved": "Nenhum modelo aprovado nesta conta do WhatsApp. Se você já criou e a Meta aprovou, sincronize; se não, crie um em Configurações › Modelos de mensagem.",
  "template.waiting": "Ainda não liberados pela Meta",
  "template.category.marketing": "Marketing",
  "template.category.utility": "Utilidade",
  "template.category.authentication": "Autenticação",
  "template.change": "Trocar modelo",
  "template.param": "Variável {n}",
  "template.header": "cabeçalho",
  "template.no_params": "Este modelo não tem variáveis.",
  "template.preview": "Prévia",
  "template.send": "Enviar modelo",
  "settings.templates": "Modelos de mensagem",
  "template.param_button": "Final do link de “{text}”",
  "common.more": "Mais opções",
  "templates.title": "Modelos de mensagem",
  "templates.lead": "Depois de 24 horas da última mensagem do cliente, o WhatsApp só deixa a empresa escrever com um modelo aprovado pela Meta. Crie os modelos aqui e acompanhe a análise.",
  "templates.new": "Novo modelo",
  "templates.sync": "Buscar da Meta",
  "templates.no_account": "Conecte um número em Configurações › Números para criar modelos.",
  "templates.empty": "Nenhum modelo ainda. Crie o primeiro ou busque os que já existem na Meta.",
  "templates.filter.all": "Todos",
  "templates.filter.approved": "Aprovados",
  "templates.filter.review": "Em análise",
  "templates.filter.rejected": "Com problema",
  "templates.filter.draft": "Rascunhos",
  "templates.status.draft": "Rascunho",
  "templates.status.pending": "Em análise",
  "templates.status.approved": "Aprovado",
  "templates.status.rejected": "Recusado",
  "templates.status.paused": "Pausado",
  "templates.status.disabled": "Desativado",
  "templates.status.archived": "Excluído",
  "templates.quality.GREEN": "Qualidade alta",
  "templates.quality.YELLOW": "Qualidade média",
  "templates.quality.RED": "Qualidade baixa",
  "templates.quality.UNKNOWN": "Qualidade em avaliação",
  "templates.recategorized": "A Meta mudou a categoria de {from} para {to}. O preço de cada envio segue a categoria da Meta.",
  "templates.reason": "Motivo da Meta: {reason}",
  "templates.reason.ABUSIVE_CONTENT": "conteúdo abusivo",
  "templates.reason.INCORRECT_CATEGORY": "categoria incorreta",
  "templates.reason.INVALID_FORMAT": "formato inválido (variáveis, exemplos ou botões)",
  "templates.reason.PROMOTIONAL": "conteúdo promocional fora da categoria marketing",
  "templates.reason.SCAM": "suspeita de golpe",
  "templates.reason.TAG_CONTENT_MISMATCH": "o conteúdo não corresponde à categoria escolhida",
  "templates.reason.NONE": "a Meta não informou o motivo",
  "templates.not_editable": "Feito no WhatsApp Manager com recursos que este editor ainda não escreve (código de toque único, carrossel, catálogo ou fluxo). Continua disponível para envio.",
  "templates.edit": "Editar",
  "templates.fix": "Corrigir e reenviar",
  "templates.duplicate": "Duplicar",
  "templates.delete": "Excluir",
  "templates.delete_title": "Excluir modelo?",
  "templates.delete_confirm": "O modelo {name} ({language}) será excluído na Meta. As mensagens já enviadas continuam no histórico, e a Meta bloqueia esse nome por 30 dias.",
  "templates.delete_draft": "O rascunho {name} será descartado. A Meta nunca o recebeu.",
  "templates.deleted": "Modelo excluído",
  "templates.back": "Voltar para os modelos",
  "templates.new_title": "Novo modelo",
  "templates.edit_title": "Editar modelo",
  "templates.add": "Adicionar",
  "templates.remove": "Remover",
  "templates.field.account": "Conta do WhatsApp",
  "templates.field.name": "Nome do modelo",
  "templates.field.name_hint": "Na Meta: {name}",
  "templates.field.name_locked": "O nome e o idioma não mudam depois que a Meta recebe o modelo. Para outro nome, duplique.",
  "templates.field.language": "Idioma",
  "templates.field.category": "Categoria",
  "templates.category.utility_hint": "Confirmações, lembretes e atualizações de algo que o cliente pediu ou comprou.",
  "templates.category.marketing_hint": "Ofertas, novidades, convites e mensagens para retomar o contato.",
  "templates.category.note": "A Meta confere a categoria e pode mudá-la. O preço de cada envio segue a categoria final.",
  "templates.field.header": "Cabeçalho",
  "templates.field.header_text": "Texto do cabeçalho",
  "templates.field.body": "Mensagem",
  "templates.field.body_text": "Texto da mensagem",
  "templates.field.examples": "Exemplos das variáveis",
  "templates.field.examples_hint": "A Meta usa os exemplos para analisar o modelo. Use valores realistas, sem dados de clientes de verdade.",
  "templates.field.example": "Exemplo de {variable}",
  "templates.field.footer": "Rodapé",
  "templates.field.footer_text": "Texto do rodapé",
  "templates.field.buttons": "Botões",
  "templates.button.add": "Adicionar botão",
  "templates.button.quick_reply": "Resposta rápida",
  "templates.button.url": "Abrir site",
  "templates.button.phone": "Ligar",
  "templates.button.remove": "Remover botão",
  "templates.button.text": "Texto do botão",
  "templates.button.url_field": "Endereço do site",
  "templates.button.url_hint": "Com https://. Para um link por cliente, termine com {{1}}.",
  "templates.button.url_example": "Exemplo do final do endereço",
  "templates.button.phone_field": "Telefone com código do país",
  "templates.variable.add": "Adicionar variável",
  "templates.format.bold": "Negrito",
  "templates.format.italic": "Itálico",
  "templates.format.strike": "Tachado",
  "templates.format.sample": "texto",
  "templates.preview": "Como o cliente vê",
  "templates.preview_empty": "Escreva a mensagem para ver a prévia.",
  "templates.all_options": "Ver todas as opções",
  "templates.save_draft": "Salvar rascunho",
  "templates.submit": "Enviar para a Meta",
  "templates.saved": "Rascunho salvo",
  "templates.submitted": "Enviado para a análise da Meta. Costuma levar de minutos a 24 horas, e o status muda aqui sozinho.",
  "templates.approved_now": "A Meta aprovou o modelo {name} na hora.",
  "templates.meta_refused": "A Meta recusou o envio",
  "templates.pending_issues": "Falta 1 ajuste antes de enviar|Faltam {count} ajustes antes de enviar",
  "templates.ready": "Pronto para enviar à Meta",
  "templates.rules.title": "O que a Meta confere",
  "templates.rules.1": "Variáveis em sequência ({{1}}, {{2}}…), nunca no começo nem no fim da mensagem.",
  "templates.rules.2": "Mensagem clara e completa: textos vagos ou feitos quase só de variáveis são recusados.",
  "templates.rules.3": "Utilidade é sobre algo que o cliente pediu. Oferta, desconto ou convite é marketing.",
  "templates.rules.4": "Links com o domínio da empresa, sem encurtadores.",
  "templates.rules.5": "Nunca peça dados sensíveis, como senha, número completo de cartão ou documento.",
  "templates.issue.name_format": "Dê um nome com letras, números ou _.",
  "templates.issue.name_too_long": "O nome pode ter até 512 caracteres.",
  "templates.issue.language_required": "Escolha o idioma.",
  "templates.issue.header_too_long": "O cabeçalho pode ter até 60 caracteres.",
  "templates.issue.header_format": "O cabeçalho é uma linha só.",
  "templates.issue.header_variables": "O cabeçalho aceita uma variável, a {{1}}.",
  "templates.issue.header_example_missing": "Escreva um exemplo para a variável do cabeçalho.",
  "templates.issue.body_required": "Escreva a mensagem.",
  "templates.issue.body_too_long": "A mensagem pode ter até 1.024 caracteres.",
  "templates.issue.variables_not_sequential": "As variáveis precisam seguir a ordem {{1}}, {{2}}, {{3}}… sem pular números.",
  "templates.issue.variable_at_edge": "A Meta recusa mensagens que começam ou terminam com variável. Coloque texto antes e depois.",
  "templates.issue.example_missing": "Escreva um exemplo para cada variável.",
  "templates.issue.footer_too_long": "O rodapé pode ter até 60 caracteres.",
  "templates.issue.footer_variables": "O rodapé não aceita variáveis.",
  "templates.issue.too_many_buttons": "No máximo 10 botões.",
  "templates.issue.too_many_url_buttons": "No máximo 2 botões de site.",
  "templates.issue.too_many_phone_buttons": "No máximo 1 botão de ligar.",
  "templates.issue.buttons_not_grouped": "Deixe as respostas rápidas juntas, antes ou depois dos botões de site e de ligar.",
  "templates.issue.button_text_required": "Escreva o texto do botão.",
  "templates.issue.button_text_too_long": "O texto do botão pode ter até 25 caracteres.",
  "templates.issue.button_text_duplicate": "Cada botão precisa de um texto diferente.",
  "templates.issue.url_invalid": "Use um endereço completo começando com https://.",
  "templates.issue.url_variable_position": "O link aceita uma variável, a {{1}}, no final do endereço.",
  "templates.issue.url_example_missing": "Escreva um exemplo do final do endereço.",
  "templates.issue.phone_invalid": "Use o telefone com + e código do país, como +55 11 99999-0000.",
  "templates.warning.variables_dense": "Muitas variáveis para pouco texto: a Meta costuma recusar. Escreva mais texto fixo.",
  "templates.warning.adjacent_variables": "Duas variáveis seguidas, sem texto entre elas, costumam ser recusadas.",
  "templates.warning.promotional_utility": "O texto parece promocional. A Meta deve classificar como marketing, que custa mais.",
  "templates.warning.url_shortener": "Links encurtados (bit.ly e similares) costumam ser recusados. Use o endereço completo.",
  "errors.template_name_taken": "Já existe um modelo com esse nome e idioma nesta conta.",
  "errors.template_not_editable": "Este modelo não pode ser editado agora: em análise ele espera a Meta, e um aprovado pode ser duplicado.",
  "errors.template_identity_locked": "O nome e o idioma não mudam depois que a Meta recebe o modelo. Duplique para usar outro nome.",
  "errors.template_rejected_by_meta": "A Meta recusou o modelo.",
  "errors.template_not_found": "Modelo não encontrado. Atualize a página.",
  "errors.template_other_account": "Este modelo é de outra conta do WhatsApp: só sai pelos números dessa conta.",
  "presence.title": "Minha disponibilidade",
  "inbox.contact_info": "Dados do contato",
  "nav.reports": "Relatórios",
  "reports.title": "Relatórios",
  "reports.tab.overview": "Visão geral",
  "reports.tab.team": "Equipe",
  "reports.tab.outcomes": "Desfechos",
  "reports.tab.gate": "Revisão de mensagens",
  "reports.tab.audit": "Auditoria",
  "reports.period": "Período",
  "reports.period.7d": "7 dias",
  "reports.period.30d": "30 dias",
  "reports.period.month": "Este mês",
  "reports.period.custom": "Personalizado",
  "reports.from": "De",
  "reports.to": "Até",
  "reports.team": "Equipe",
  "reports.all_teams": "Todas as equipes",
  "reports.export": "Exportar CSV",
  "reports.loading": "Calculando…",
  "reports.empty": "Sem dados no período.",
  "reports.kpi.opened": "Atendimentos abertos",
  "reports.kpi.closed": "Concluídos",
  "reports.kpi.success": "Taxa de sucesso",
  "reports.kpi.first_response": "1ª resposta (mediana)",
  "reports.kpi.handling": "Duração (mediana)",
  "reports.kpi.messages": "Mensagens",
  "reports.kpi.inbound": "recebidas",
  "reports.kpi.outbound": "enviadas",
  "reports.kpi.meta_cost": "Custo Meta",
  "reports.kpi.meta_charged": "1 mensagem cobrada · estimativa|{count} mensagens cobradas · estimativa",
  "reports.kpi.ai_cost": "Custo de IA",
  "reports.kpi.p90": "p90",
  "reports.daily": "Por dia",
  "reports.daily.opened": "Abertos",
  "reports.daily.closed": "Concluídos",
  "reports.daily.success": "Sucesso",
  "reports.open_by_status": "Em aberto agora",
  "reports.closed_by": "Quem concluiu",
  "reports.closer.member": "Pessoas",
  "reports.closer.assistant": "Assistente de IA",
  "reports.closer.policy": "Política automática",
  "reports.closer.contact": "Contato",
  "reports.closer.api": "API",
  "reports.handler_mix": "Quem atendeu",
  "reports.handler.flow": "Fluxo",
  "reports.handler.assistant": "Assistente",
  "reports.handler.human": "Humano",
  "reports.members": "Por pessoa",
  "reports.teams": "Por equipe",
  "reports.col.name": "Nome",
  "reports.col.assigned": "Atribuídos",
  "reports.col.closed": "Concluídos",
  "reports.col.success": "Sucesso",
  "reports.col.first_response": "1ª resposta",
  "reports.col.queue_wait": "Espera na fila",
  "reports.col.sent": "Enviadas",
  "reports.col.active": "Em aberto",
  "reports.outcomes": "Desfechos no período",
  "reports.without_outcome": "Sem desfecho",
  "reports.col.count": "Qtd.",
  "reports.col.share": "Participação",
  "reports.gate.decisions": "Decisões",
  "reports.gate.verdict.approve": "Aprovadas",
  "reports.gate.verdict.rewrite": "Reescritas",
  "reports.gate.verdict.block": "Bloqueadas",
  "reports.gate.actions": "Ação da pessoa",
  "reports.gate.action.accepted": "Aceitou a sugestão",
  "reports.gate.action.edited": "Editou",
  "reports.gate.action.overridden": "Enviou mesmo assim",
  "reports.gate.action.cancelled": "Cancelou",
  "reports.gate.action.auto_sent": "Corrigida automaticamente",
  "reports.gate.action.pending": "Pendente",
  "reports.gate.latency": "Latência do juiz",
  "reports.gate.top_rules": "Regras mais acionadas",
  "reports.gate.review": "Mensagens humanas revisadas",
  "reports.gate.none": "Nenhuma política de revisão ativa no período.",
  "audit.title": "Auditoria",
  "audit.search": "Buscar na ação",
  "audit.action": "Ação",
  "audit.all_actions": "Todas as ações",
  "audit.actor": "Autor",
  "audit.actor.member": "Pessoa",
  "audit.actor.system": "Sistema",
  "audit.actor.assistant": "Assistente",
  "audit.actor.flow": "Fluxo",
  "audit.actor.policy": "Política",
  "audit.when": "Quando",
  "audit.entity": "Entidade",
  "audit.details": "Detalhes",
  "audit.before": "Antes",
  "audit.after": "Depois",
  "audit.load_more": "Carregar mais",
  "audit.empty": "Nenhum evento no período.",
  "audit.actor.api_key": "Chave de API",
  "audit.actor.platform_admin": "Admin da plataforma",
  "integrations.title": "Integrações",
  "integrations.api_keys": "Chaves de API",
  "integrations.api_keys_hint": "Use no cabeçalho Authorization: ApiKey <chave>. A chave aparece uma única vez.",
  "integrations.new_key": "Nova chave",
  "integrations.key_name": "Nome da chave",
  "integrations.key_created": "Copie agora: esta chave não será mostrada de novo.",
  "integrations.revoke": "Revogar",
  "integrations.last_used": "Último uso",
  "integrations.never": "nunca",
  "integrations.copy": "Copiar",
  "integrations.copied": "Copiado",
  "integrations.hooks": "Entrada de leads (webhook de entrada)",
  "integrations.hooks_hint": "Envie um POST com JSON ou formulário para o endereço do gancho. O contato é criado ou reaproveitado e um atendimento é aberto.",
  "integrations.new_hook": "Novo gancho",
  "integrations.hook_name": "Nome",
  "integrations.hook_phone": "Caminho do telefone no payload",
  "integrations.hook_contact_name": "Caminho do nome",
  "integrations.hook_fields": "Campos do contato (chave = caminho, um por linha)",
  "integrations.hook_goal": "Objetivo do atendimento",
  "integrations.hook_team": "Equipe padrão",
  "integrations.hook_flow": "Fluxo inicial",
  "integrations.hook_url": "Endereço do gancho",
  "integrations.hook_created": "Copie o endereço agora: o token não será mostrado de novo.",
  "integrations.rotate": "Gerar novo token",
  "integrations.active": "Ativo",
  "integrations.webhooks": "Webhooks de saída",
  "integrations.webhooks_hint": "Recebemos eventos e enviamos um POST assinado: DoneTalk-Signature traz t=<horário>,v1=<HMAC SHA-256 de \"t.corpo\">. O cabeçalho antigo x-donetalk-signature segue junto até 21/01/2027.",
  "integrations.new_webhook": "Novo webhook",
  "integrations.webhook_url": "URL de destino",
  "integrations.events": "Eventos",
  "integrations.secret_created": "Segredo para validar a assinatura. Copie agora: não será mostrado de novo.",
  "integrations.test": "Enviar teste",
  "integrations.test_sent": "Evento de teste enfileirado.",
  "integrations.pause": "Pausar",
  "integrations.resume": "Retomar",
  "integrations.deliveries": "Entregas",
  "integrations.failures": "falhas seguidas",
  "integrations.status.active": "Ativo",
  "integrations.status.paused": "Pausado",
  "integrations.status.failing": "Com falhas",
  "integrations.event.conversation.opened": "Atendimento aberto",
  "integrations.event.conversation.closed": "Atendimento concluído",
  "integrations.event.conversation.assigned": "Atendimento atribuído",
  "integrations.event.conversation.transferred": "Atendimento transferido",
  "integrations.event.conversation.reopened": "Atendimento reaberto",
  "integrations.event.contact.updated": "Contato atualizado",
  "integrations.event.message.received": "Mensagem recebida",
  "integrations.event.message.sent": "Mensagem enviada",
  "integrations.event.flow.event": "Evento de fluxo",
  "common.edit": "Editar",
  "common.remove": "Remover",
  "contacts.title": "Contatos",
  "contacts.search": "Buscar por nome ou telefone",
  "contacts.import": "Importar CSV",
  "contacts.new": "Novo contato",
  "contacts.start": "Iniciar atendimento",
  "contacts.col.name": "Nome",
  "contacts.col.phone": "Telefone",
  "contacts.col.tags": "Etiquetas",
  "contacts.col.last_activity": "Última atividade",
  "contacts.col.source": "Origem",
  "contacts.empty": "Nenhum contato encontrado.",
  "contacts.load_more": "Carregar mais",
  "contacts.blocked": "Bloqueado",
  "contacts.open_conversation": "Abrir atendimento",
  "contacts.source.inbound": "Espontâneo",
  "contacts.source.ad": "Anúncio",
  "contacts.source.import": "Importação",
  "contacts.source.api": "API",
  "contacts.source.connector": "Integração",
  "contacts.source.manual": "Manual",
  "import.title": "Importar dados",
  "import.file": "Escolha um arquivo CSV (separado por vírgula ou ponto e vírgula, com cabeçalho)",
  "import.rows": "{n} linhas encontradas",
  "import.map": "Mapeie as colunas",
  "import.col.phone": "Telefone (obrigatório)",
  "import.col.name": "Nome",
  "import.col.tags": "Etiquetas (separadas por vírgula)",
  "import.col.marketing": "Aceita marketing (sim/não)",
  "import.col.external": "ID externo",
  "import.col.field": "Campo do contato",
  "import.col.ignore": "Ignorar",
  "import.marketing_all": "Marcar todos como aceitando marketing",
  "import.preview": "Prévia",
  "import.run": "Importar {n} contatos",
  "import.progress": "Importando… {done} de {total}",
  "import.done": "Importação concluída: {created} novos, {updated} atualizados, {errors} com erro.",
  "import.errors": "Linhas com erro",
  "import.reason.invalid_phone": "Telefone inválido",
  "start.title": "Iniciar atendimento por modelo",
  "start.goal": "Objetivo",
  "start.team": "Equipe",
  "start.open_exists": "Este contato já tem um atendimento aberto.",
  "start.marketing_opted_out": "O contato recusou mensagens de marketing.",
  "start.blocked": "Contato bloqueado.",
  "tags.title": "Etiquetas",
  "tags.add": "Adicionar etiqueta",
  "tags.new": "Nova etiqueta",
  "tags.name": "Nome",
  "tags.color": "Cor",
  "tags.applies": "Aplica-se a",
  "tags.applies.contact": "Contatos",
  "tags.applies.conversation": "Atendimentos",
  "tags.applies.both": "Ambos",
  "tags.usage": "{contacts} contatos · {conversations} atendimentos",
  "tags.none": "Sem etiquetas",
  "snippets.title": "Respostas prontas",
  "snippets.hint": "Digite / no campo de mensagem para buscar. Variáveis: {{contact.first_name}}, {{contact.name}}, {{member.name}}, {{member.first_name}}.",
  "snippets.new": "Nova resposta",
  "snippets.name": "Título",
  "snippets.shortcut": "Atalho",
  "snippets.body": "Texto",
  "snippets.team": "Equipe (vazio = todas)",
  "snippets.global": "Todas as equipes",
  "snippets.picker": "Respostas prontas",
  "snippets.no_match": "Nenhuma resposta encontrada",
  "optout.title": "Descadastro por palavra-chave",
  "optout.hint": "Quando o contato envia uma destas palavras, registramos a recusa de marketing e, se configurado, respondemos automaticamente.",
  "optout.keywords": "Palavras-chave (uma por linha)",
  "optout.reply": "Resposta automática (opcional)",
  "settings.organization": "Desfechos, etiquetas e respostas",
  "platform.title": "Console da plataforma",
  "platform.open": "Abrir console da plataforma",
  "platform.tab.overview": "Visão geral",
  "platform.tab.customers": "Clientes",
  "platform.tab.plans": "Planos",
  "platform.tab.ai": "IA",
  "platform.tab.admins": "Administradores",
  "platform.tab.audit": "Auditoria",
  "platform.kpi.customers": "Clientes",
  "platform.kpi.active": "Ativos",
  "platform.kpi.trial": "Em teste",
  "platform.kpi.failed": "Bancos com falha",
  "platform.kpi.conversations": "Atendimentos no mês",
  "platform.kpi.messages_out": "Mensagens enviadas no mês",
  "platform.kpi.ai_cost": "Custo de IA no mês",
  "platform.kpi.meta_cost": "Custo Meta no mês",
  "platform.days": "Últimos 14 dias",
  "platform.by_lifecycle": "Por situação",
  "platform.by_db": "Por estado do banco",
  "platform.lifecycle.prospect": "Prospect",
  "platform.lifecycle.trial": "Teste",
  "platform.lifecycle.active": "Ativo",
  "platform.lifecycle.suspended": "Suspenso",
  "platform.lifecycle.churned": "Encerrado",
  "platform.db.pending": "Pendente",
  "platform.db.provisioning": "Provisionando",
  "platform.db.migrating": "Migrando",
  "platform.db.seeding": "Semeando",
  "platform.db.ready": "Pronto",
  "platform.db.failed": "Falhou",
  "platform.customers.search": "Buscar por nome, identificador ou dono",
  "platform.customers.new": "Novo cliente",
  "platform.customers.col.name": "Cliente",
  "platform.customers.col.plan": "Plano",
  "platform.customers.col.lifecycle": "Situação",
  "platform.customers.col.db": "Banco",
  "platform.customers.col.members": "Pessoas",
  "platform.customers.col.created": "Criado em",
  "platform.customers.empty": "Nenhum cliente.",
  "platform.customer.slug": "Identificador",
  "platform.customer.name": "Nome",
  "platform.customer.legal_name": "Razão social",
  "platform.customer.tax_id": "CNPJ",
  "platform.customer.owner_email": "E-mail do dono",
  "platform.customer.owner_name": "Nome do dono",
  "platform.customer.locale": "Idioma padrão",
  "platform.customer.timezone": "Fuso horário",
  "platform.customer.plan": "Plano",
  "platform.customer.no_plan": "Sem plano",
  "platform.customer.visibility": "Visibilidade dos atendimentos",
  "platform.visibility.open": "Todos veem tudo",
  "platform.visibility.team": "Por equipe",
  "platform.visibility.own": "Só os próprios",
  "platform.customer.lifecycle": "Situação",
  "platform.customer.created": "Cliente criado. Dono: {email}.",
  "platform.customer.invite": "Link de acesso do dono (mostrado uma vez)",
  "platform.customer.provision": "Provisionar banco de novo",
  "platform.customer.provisioned": "Banco provisionado: {state}",
  "platform.customer.stats": "Números",
  "platform.customer.stat.contacts": "Contatos",
  "platform.customer.stat.open": "Atendimentos abertos",
  "platform.customer.stat.closed_month": "Concluídos no mês",
  "platform.customer.stat.channels": "Números",
  "platform.customer.stat.flows": "Fluxos publicados",
  "platform.customer.stat.assistants": "Assistentes ativos",
  "platform.customer.members": "Pessoas",
  "platform.customer.add_owner": "Adicionar dono",
  "platform.customer.usage": "Uso no mês",
  "platform.customer.open_workspace": "Abrir como cliente",
  "platform.plans.new": "Novo plano",
  "platform.plans.code": "Código",
  "platform.plans.name": "Nome",
  "platform.plans.limits": "Limites",
  "platform.plans.features": "Recursos incluídos",
  "platform.plans.customers": "{n} clientes",
  "platform.plans.invalid_json": "JSON inválido",
  "platform.ai.models": "Modelos",
  "platform.ai.keys": "Chaves da plataforma",
  "platform.ai.surfaces": "Roteamento por tarefa",
  "platform.ai.refresh": "Ler modelos dos provedores",
  "platform.ai.sync_pricing": "Atualizar catálogo e preços",
  "platform.ai.col.model": "Modelo",
  "platform.ai.col.provider": "Provedor",
  "platform.ai.col.input": "Entrada / 1M",
  "platform.ai.col.output": "Saída / 1M",
  "platform.ai.col.enabled": "Ativo",
  "platform.ai.add_key": "Adicionar chave",
  "platform.ai.surface": "Tarefa",
  "platform.ai.default_model": "Modelo padrão",
  "platform.admins.add": "Adicionar administrador",
  "platform.admins.email": "E-mail (usuário existente)",
  "platform.admins.role": "Papel",
  "platform.admins.role.super": "Super",
  "platform.admins.role.support": "Suporte",
  "platform.admins.remove": "Remover",
  "platform.audit.actor": "Quem",
  "platform.audit.action": "Ação",
  "platform.audit.entity": "Entidade",
  "platform.audit.data": "Dados",
  "auth.account": "Conta",
  "media.unsupported": "Tipo de arquivo não aceito pelo WhatsApp.",
  "media.too_large": "Arquivo grande demais para o WhatsApp.",
  "reports.by_tag": "Por etiqueta",
  "settings.learning": "Aprendizado",
  "learning.title": "Aprendizado da conta",
  "learning.hint": "Toda semana o sistema analisa os atendimentos concluídos com sucesso e propõe respostas para o playbook, ajustes de instrução do assistente, perguntas para o fluxo e documentos de conhecimento. Nada muda sozinho: você aprova.",
  "learning.generate": "Analisar agora",
  "learning.generating": "Analisando…",
  "learning.period": "Período",
  "learning.status.generating": "Analisando",
  "learning.status.ready": "Pronto",
  "learning.status.failed": "Falhou",
  "learning.status.archived": "Arquivado",
  "learning.trigger.manual": "Manual",
  "learning.trigger.weekly": "Semanal",
  "learning.stats": "{analyzed} atendimentos analisados · {successful} com sucesso",
  "learning.suggestions": "Sugestões",
  "learning.counts": "{proposed} propostas · {applied} aplicadas · {rejected} rejeitadas",
  "learning.summary": "Resumo",
  "learning.empty": "Nenhuma análise ainda. Gere a primeira ou aguarde a semanal.",
  "learning.no_suggestions": "Nenhuma sugestão neste relatório.",
  "learning.kind.playbook_reply": "Resposta para o playbook",
  "learning.kind.prompt_change": "Ajuste do assistente",
  "learning.kind.flow_question": "Pergunta para o fluxo",
  "learning.kind.knowledge_doc": "Documento de conhecimento",
  "learning.rationale": "Por quê",
  "learning.evidence": "Evidências",
  "learning.success_rate": "{rate}% de sucesso em {n} atendimentos",
  "learning.approve": "Aprovar e aplicar",
  "learning.approve_only": "Aprovar",
  "learning.reject": "Rejeitar",
  "learning.applied": "Aplicado",
  "learning.rejected": "Rejeitado",
  "learning.approved": "Aprovado",
  "learning.target.collection": "Coleção de destino",
  "learning.target.assistant": "Assistente de destino",
  "learning.target.team": "Equipe (vazio = todas)",
  "learning.body": "Texto (você pode editar antes de aplicar)",
  "learning.archive": "Arquivar",
  "learning.prompt_note": "O texto entra no rascunho do assistente. Publique depois de testar.",
  "brief.generate": "Resumo da IA",
  "brief.generating": "Resumindo…",
  "brief.title": "Resumo do atendimento",
  "brief.empty": "Sem mensagens para resumir.",
  "outcome.suggestion": "Sugestão da IA: {label} · {confidence}%",
  "outcome.suggestion_reason": "Motivo",
  "hours.title": "Horários de atendimento",
  "hours.new": "Novo horário",
  "hours.name": "Nome",
  "hours.timezone": "Fuso horário",
  "hours.weekly": "Dias e horários",
  "hours.from": "Abre {day}",
  "hours.to": "Fecha {day}",
  "hours.closed": "Fechado",
  "hours.none": "Sem horário",
  "hours.day.mon": "Segunda",
  "hours.day.tue": "Terça",
  "hours.day.wed": "Quarta",
  "hours.day.thu": "Quinta",
  "hours.day.fri": "Sexta",
  "hours.day.sat": "Sábado",
  "hours.day.sun": "Domingo",
  "hours.hint": "Fora do horário, o fluxo pode responder com a mensagem de ausência e o atendimento fica na fila.",
  "reports.tab.monitor": "Monitor ao vivo",
  "monitor.updated": "Atualizado {time}",
  "monitor.total.open": "Em aberto",
  "monitor.total.waiting_reply": "Aguardando resposta nossa",
  "monitor.total.unanswered": "Sem resposta há 15+ min",
  "monitor.total.closed_today": "Concluídos hoje",
  "monitor.total.success_today": "Sucesso hoje",
  "monitor.queues": "Filas",
  "monitor.col.queue": "Fila",
  "monitor.col.waiting": "Na fila",
  "monitor.col.oldest": "Espera mais antiga",
  "monitor.col.active": "Em atendimento",
  "monitor.col.online": "Online",
  "monitor.no_team": "Sem equipe",
  "monitor.members": "Pessoas agora",
  "monitor.col.member": "Pessoa",
  "monitor.col.presence": "Disponibilidade",
  "monitor.col.load": "Carga",
  "monitor.col.oldest_unanswered": "Sem resposta há",
  "monitor.alerts": "Alertas",
  "monitor.alert.first_response_over": "{name} espera a 1ª resposta há {minutes} min",
  "monitor.alert.unanswered_over": "{name} sem resposta há {minutes} min",
  "monitor.alert.queue_over": "Fila {name} com espera de {minutes} min",
  "monitor.no_alerts": "Tudo em dia.",
  "monitor.open": "Abrir",
  "inbox.window.chip": "{time} restantes",
  "inbox.window.free_chip": "Anúncio · grátis por {time}",
  "inbox.window.closing": "Janela fechando",
  "fields.title": "Campos do contato",
  "fields.hint": "Campos extras que aparecem nos dados do contato, na importação e no gancho de entrada. Marque «a IA pode preencher» para o assistente gravar o valor durante a conversa.",
  "fields.new": "Novo campo",
  "fields.label": "Nome do campo",
  "fields.key": "Chave (API e importação)",
  "fields.type": "Tipo",
  "fields.options": "Opções (uma por linha)",
  "fields.ai": "A IA pode preencher",
  "fields.ai_hint": "Dica para a IA (como identificar o valor)",
  "fields.required": "Obrigatório",
  "fields.active": "Ativo",
  "fields.type.text": "Texto",
  "fields.type.number": "Número",
  "fields.type.date": "Data",
  "fields.type.boolean": "Sim/não",
  "fields.type.select": "Lista de opções",
  "fields.type.phone": "Telefone",
  "fields.type.email": "E-mail",
  "fields.type.cpf": "CPF",
  "fields.type.cnpj": "CNPJ",
  "fields.key_taken": "Já existe um campo com essa chave.",
  "policy.priority": "Prioridade",
  "select.search": "Buscar…",
  "select.empty": "Nenhuma opção encontrada",
  "inbox.action.open": "Abrir",
  "inbox.action.copy_phone": "Copiar telefone",
  "message.reply": "Responder",
  "message.copy": "Copiar texto",
  "message.download": "Baixar arquivo",
  "message.copied": "Copiado",
  "message.replying": "Respondendo a",
  "contact.media": "Mídia, links e docs",
  "contact.media.tab.media": "Mídia",
  "contact.media.tab.docs": "Docs",
  "contact.media.tab.links": "Links",
  "contact.media.empty": "Nenhum item para mostrar",
  "inbox.reconnecting": "Reconectando…",
  "composer.failed": "Falha ao enviar",
  "composer.attach.label": "Anexar",
  "composer.attach.document": "Documento",
  "composer.attach.media": "Fotos e vídeos",
  "composer.attach.camera": "Câmera",
  "composer.attach.audio": "Áudio",
  "composer.attach.contact": "Contato",
  "composer.attach.poll": "Enquete",
  "composer.attach.event": "Evento",
  "composer.attach.sticker": "Nova figurinha",
  "composer.mic_denied": "Não foi possível acessar o microfone. Libere a permissão do navegador ou anexe um arquivo de áudio.",
  "composer.mic_unavailable": "Microfone indisponível",
  "composer.voice_note": "Mensagem de voz",
  "composer.edit": "Editar mensagem",
  "composer.reply": "Responder",
  "composer.cancel_reference": "Cancelar resposta ou edição",
  "composer.voice_discard": "Descartar gravação",
  "composer.voice_preview": "Ouvir prévia da gravação",
  "composer.voice_resume": "Retomar gravação",
  "composer.voice_pause": "Pausar gravação",
  "composer.voice_send": "Enviar áudio",
  "composer.no_snippet": "Nenhuma resposta encontrada",
  "composer.expressions": "Emojis, GIFs e figurinhas",
  "composer.placeholder": "Digite uma mensagem",
  "composer.save_edit": "Salvar edição",
  "composer.send": "Enviar",
  "composer.voice": "Mensagem de voz",
  "media.pages": "{count} página|{count} páginas",
  "media.composer_label": "Enviar arquivos",
  "media.preparing": "Preparando arquivo…",
  "media.remove": "Remover arquivo",
  "media.remove_file": "Remover {name}",
  "media.no_preview": "Prévia indisponível",
  "media.drop_more": "Solte para adicionar",
  "media.drop_here": "Solte os arquivos para enviar",
  "media.caption": "Digite uma mensagem",
  "media.caption_none": "Áudios e figurinhas não levam legenda",
  "media.emoji": "Emojis",
  "media.files": "Arquivos selecionados",
  "media.add_more": "Adicionar arquivo",
  "media.refused_count": "{count} arquivo não será enviado|{count} arquivos não serão enviados",
  "media.send": "Enviar {count} arquivo|Enviar {count} arquivos",
  "media.error.type": "O WhatsApp não aceita arquivos {ext} pela API oficial.",
  "media.error.too_large": "Maior que o limite do WhatsApp para este tipo de arquivo ({max}).",
  "media.error.empty": "O arquivo está vazio.",
  "media.error.heic": "Este navegador não abre fotos HEIC. Abra o DoneTalk no Safari ou exporte a foto como JPG.",
  "media.error.conversion": "Não foi possível preparar este arquivo.",
  "media.error.gate": "A legenda precisa de revisão antes do envio.",
  "media.error.network": "Falha de conexão durante o envio.",
  "media.note.converted_jpeg": "Vai como foto JPG, o formato que o WhatsApp aceita.",
  "media.note.compressed": "Foto compactada para caber no limite de 5 MB do WhatsApp.",
  "media.note.as_text": "Vai como arquivo de texto, com o nome original.",
  "media.note.sticker": "Vira uma figurinha de 512 × 512.",
  "media.open": "Abrir mídia",
  "media.download_named": "Baixar {name}",
  "media.retry": "Tentar de novo",
  "media.discard": "Descartar",
  "media.album": "Álbum com {count} itens",
  "media.album_more": "Mais {count} itens",
  "media.audio.play": "Reproduzir",
  "media.audio.pause": "Pausar",
  "media.audio.position": "Posição do áudio",
  "media.audio.rate": "Velocidade de reprodução",
  "media.viewer.label": "Visualizador de mídia",
  "media.viewer.you": "Você",
  "media.viewer.previous": "Anterior",
  "media.viewer.next": "Próxima",
  "media.viewer.item": "Item {n} de {total}",
  "camera.title": "Tirar foto",
  "camera.denied": "Não foi possível acessar a câmera. Libere a permissão do navegador.",
  "camera.shoot": "Tirar foto",
  "share_contact.title": "Enviar contato",
  "share_contact.search": "Pesquisar contatos",
  "share_contact.empty": "Nenhum contato com WhatsApp encontrado.",
  "share_contact.count": "{count} de {max} selecionados",
  "share_contact.send": "Enviar",
  "media.caption_refused": "Este arquivo não será enviado",
  "delivery.pending": "Pendente",
  "delivery.sent": "Enviada",
  "delivery.delivered": "Entregue",
  "delivery.read": "Lida",
  "delivery.failed": "Não enviada",
  "delivery.help.pending": "Aguardando conexão ou confirmação do envio.",
  "delivery.help.sent": "Aceita pelo serviço; ainda sem confirmação de entrega.",
  "delivery.help.delivered": "Entregue ao destinatário.",
  "delivery.help.read": "Leitura confirmada pelo destinatário.",
  "delivery.help.failed": "O envio falhou. Você pode tentar novamente.",
  "delivery.demo.title": "Estados de envio",
  "delivery.demo.description": "Escolha um estado para inspecionar ou simule o envio. Esta demonstração é local e não envia mensagens.",
  "delivery.demo.states": "Estados da mensagem",
  "delivery.demo.scenario": "Condição da rede",
  "delivery.demo.normal": "Normal",
  "delivery.demo.slow": "Rede lenta",
  "delivery.demo.offline": "Sem conexão",
  "delivery.demo.failure": "Falha no envio",
  "delivery.demo.start": "Simular envio",
  "delivery.demo.reconnect": "Restaurar conexão",
  "delivery.demo.message": "Tudo pronto! Te envio os detalhes por aqui.",
  "delivery.demo.error": "Não foi possível enviar esta mensagem.",
  "delivery.demo.discarded": "Mensagem descartada. Simule um novo envio para recomeçar.",
  "delivery.played": "Reproduzida",
  "delivery.info.title": "Dados da mensagem",
  "delivery.info.at": "{day} às {time}",
  "delivery.info.code": "Código da Meta: {code}",
  "delivery.info.no_read": "O WhatsApp só informa a leitura quando o contato abre a conversa e mantém a confirmação de leitura ativada.",
  "meta.pricing.title": "Cobrança da Meta",
  "meta.pricing.estimate_hint": "Estimativa pela tabela pública da Meta. Descontos por volume podem baixar o valor; a fatura da Meta é a referência.",
  "meta.pricing.free_customer_service": "Grátis · dentro da janela de atendimento de 24 horas",
  "meta.pricing.free_entry_point": "Grátis · janela gratuita de quem veio de anúncio",
  "meta.pricing.charged_unknown": "Cobrada pela Meta · {category}",
  "meta.pricing.unknown_currency_hint": "O valor aparece quando a conta do WhatsApp na Meta tiver moeda definida.",
  "meta.pricing.category.marketing": "Marketing",
  "meta.pricing.category.marketing_lite": "Marketing (MM Lite)",
  "meta.pricing.category.utility": "Utilidade",
  "meta.pricing.category.authentication": "Autenticação",
  "meta.pricing.category.authentication-international": "Autenticação internacional",
  "meta.pricing.category.service": "Serviço",
  "meta.pricing.category.referral_conversion": "Entrada gratuita",
  "meta.market.north_america": "América do Norte",
  "meta.market.rest_of_africa": "Resto da África",
  "meta.market.rest_of_asia_pacific": "Resto da Ásia-Pacífico",
  "meta.market.rest_of_central_eastern_europe": "Resto da Europa Central e Oriental",
  "meta.market.rest_of_latin_america": "Resto da América Latina",
  "meta.market.rest_of_middle_east": "Resto do Oriente Médio",
  "meta.market.rest_of_western_europe": "Resto da Europa Ocidental",
  "meta.market.other": "Outros países",
  "delivery.retry.window": "Mais de 24 horas sem mensagem do cliente: envie um modelo para retomar.",
  "delivery.retry.final": "Esta falha precisa ser resolvida antes de um novo envio.",
  "delivery.error.131047": "Mais de 24 horas desde a última mensagem do cliente. Envie um modelo para retomar a conversa.",
  "delivery.error.131026": "Não entregue: o número pode não ter WhatsApp, estar desatualizado ou o contato pode ter bloqueado a empresa.",
  "delivery.error.131049": "A Meta não entregou para preservar o engajamento: limite de mensagens de marketing para este contato.",
  "delivery.error.131050": "O contato pediu para não receber mensagens de marketing.",
  "delivery.error.131051": "Tipo de mensagem não aceito pelo WhatsApp.",
  "delivery.error.131053": "Falha ao enviar a mídia: formato ou tamanho não aceitos pelo WhatsApp.",
  "delivery.error.131056": "Muitas mensagens para o mesmo contato em pouco tempo. Aguarde e tente de novo.",
  "delivery.error.130429": "Limite de envio do número atingido. Tente de novo em instantes.",
  "delivery.error.131048": "Envio limitado pela Meta por bloqueios ou denúncias recentes.",
  "delivery.error.131042": "Problema de pagamento na conta do WhatsApp Business: moeda, forma de pagamento ou limite de crédito. Confira em Faturamento e pagamentos, no Meta Business Suite.",
  "delivery.error.131031": "A conta do WhatsApp Business está bloqueada pela Meta.",
  "delivery.error.368": "Envio bloqueado por violação das políticas do WhatsApp.",
  "delivery.error.131000": "Erro inesperado na Meta. Tente de novo.",
  "delivery.error.131005": "O token do número não tem permissão para enviar. Reconecte o número.",
  "delivery.error.132000": "O número de variáveis não confere com o modelo aprovado.",
  "delivery.error.132001": "O modelo não existe neste idioma ou ainda não foi aprovado.",
  "delivery.error.132015": "O modelo foi pausado pela Meta por baixa qualidade.",
  "delivery.error.132016": "O modelo foi desativado pela Meta.",
  "delivery.error.133010": "O número da empresa não está registrado na API do WhatsApp.",
  "delivery.error.130472": "O contato está num experimento da Meta que suspende mensagens de marketing.",
  "delivery.error.credential_invalid": "A credencial do número não pôde ser lida. Reconecte o número em Configurações › Números.",
  "delivery.error.media_missing": "O arquivo desta mensagem não foi encontrado para envio.",
  "delivery.error.contact_without_identity": "O contato não tem número de WhatsApp.",
  "message.edited": "editada",
  "message.contact": "Contato",
  "message.options": "Opções da mensagem",
  "message.quote_unavailable": "Mensagem não carregada",
  "message.quote.photo": "Foto",
  "message.quote.video": "Vídeo",
  "message.quote.voice": "Mensagem de voz",
  "message.quote.audio": "Áudio",
  "message.quote.sticker": "Figurinha",
  "message.quote.contact": "Contato",
  "outcomes.title": "Desfechos",
  "outcomes.new": "Novo desfecho",
  "outcomes.hint": "Todo atendimento termina com um desfecho. Os de sucesso contam como resultado nos relatórios e no aprendizado.",
  "outcomes.name": "Nome",
  "outcomes.category": "Tipo",
  "outcomes.category.success": "Sucesso",
  "outcomes.category.neutral": "Neutro",
  "outcomes.category.negative": "Sem sucesso",
  "outcomes.category.invalid": "Inválido",
  "outcomes.requires_note": "Pedir uma nota ao concluir",
  "outcomes.reopen": "Permitir reabrir o atendimento",
  "outcomes.used": "Usado em {count} atendimento|Usado em {count} atendimentos",
  "outcomes.unused": "Ainda não usado",
  "outcomes.note": "pede nota",
  "outcomes.move_up": "Subir",
  "outcomes.move_down": "Descer",
  "outcomes.archived_hint": "Arquivado: não aparece mais para concluir, mas continua no histórico e nos relatórios.",
  "errors.validation_failed": "Confira os campos e tente de novo.",
  "errors.last_active_outcome": "Mantenha pelo menos um desfecho ativo: todo atendimento precisa de um para ser concluído.",
  "errors.outcome_not_found": "Esse desfecho não existe mais.",
  "errors.forbidden": "Você não tem permissão para isso.",
  "common.done": "Pronto",
  "handler.hybrid": "Híbrido",
  "numbers.connected": "Conectado",
  "numbers.off": "Desligado",
  "numbers.display_name": "Nome de exibição",
  "numbers.name.approved": "Aprovado pela Meta",
  "numbers.name.pending": "Em análise pela Meta",
  "numbers.name.declined": "Recusado pela Meta",
  "numbers.name.expired": "Expirado",
  "numbers.quality.green": "Alta",
  "numbers.quality.yellow": "Média",
  "numbers.quality.red": "Baixa",
  "numbers.quality.unknown": "Sem avaliação",
  "numbers.health.ok": "Pronto para enviar mensagens",
  "numbers.health.limited": "Envio limitado pela Meta",
  "numbers.health.blocked": "Algo impede o envio de mensagens",
  "numbers.health.unknown": "Ainda não verificado com a Meta",
  "numbers.health.checked": "Verificado em {when}",
  "numbers.health.check": "Verificar agora",
  "numbers.health.meta_code": "Código da Meta: {code}",
  "numbers.health.code.141006": "Falta uma forma de pagamento válida na Meta. Sem ela, a empresa não consegue iniciar conversas com modelos. Adicione um cartão no WhatsApp Manager.",
  "numbers.manager": "Abrir no WhatsApp Manager",
  "numbers.pin.show": "Ver PIN",
  "numbers.pin.title": "PIN de confirmação em duas etapas",
  "numbers.pin.fresh_title": "Número conectado. Guarde o PIN",
  "numbers.pin.explain": "Registramos {number} na API oficial com este PIN de confirmação em duas etapas:",
  "numbers.pin.keep": "Ele fica guardado aqui, cifrado. Você vai precisar dele se um dia levar o número para outra plataforma.",
  "numbers.pin.copy": "Copiar PIN",
  "numbers.pin.copied": "PIN copiado",
  "numbers.meta.title": "Conectar um número do WhatsApp",
  "numbers.meta.hint": "A conexão acontece na janela oficial da Meta, sem instalar nada. Quando terminar, você volta para cá.",
  "numbers.meta.before": "Você vai precisar de",
  "numbers.meta.req_facebook": "O Facebook de quem administra a empresa",
  "numbers.meta.req_number": "Um número livre, ou o do WhatsApp Business da empresa (ele continua funcionando no celular)",
  "numbers.meta.req_code": "O celular desse número por perto, para receber o código por SMS ou ligação",
  "numbers.meta.connect": "Conectar com a Meta",
  "numbers.meta.step1": "Entrar com o Facebook",
  "numbers.meta.step2": "Escolher ou criar o portfólio da empresa",
  "numbers.meta.step3": "Nome de exibição, categoria e número",
  "numbers.meta.step4": "Confirmar o número com o código",
  "numbers.meta.unavailable": "A conexão pela janela da Meta ainda não foi configurada nesta plataforma. Use a conexão manual ou fale com o suporte.",
  "numbers.meta.connected": "{number} conectado",
  "numbers.meta.cancelled": "A janela da Meta foi fechada antes de terminar. Nada mudou.",
  "numbers.meta.sdk_blocked": "Não foi possível abrir a janela da Meta. Verifique se um bloqueador de anúncios ou de pop-ups está ativo.",
  "numbers.manual.toggle": "Conexão manual (avançado)",
  "errors.waba_not_found": "A Meta não informou qual conta do WhatsApp foi escolhida. Refaça a conexão e conclua todos os passos da janela.",
  "errors.waba_without_number": "A conta do WhatsApp foi conectada, mas ainda não tem número. Refaça a conexão e adicione o número na janela da Meta.",
  "errors.phone_number_required": "Essa conta tem mais de um número. Refaça a conexão e escolha o número na janela da Meta.",
  "errors.pin_not_found": "Este número não tem PIN guardado aqui.",
  "errors.account_without_credential": "A conta do WhatsApp perdeu o acesso. Conecte o número de novo.",
  "errors.channel_not_found": "Esse número não existe mais.",
  "numbers.name.unknown": "Ainda não informado pela Meta",
  "numbers.health.info.display_name_pending": "O nome de exibição ainda não foi aprovado pela Meta. O limite de mensagens sobe depois da aprovação.",
  "numbers.token_soon": "O acesso da Meta a este número vence em {date}. A renovação é automática; se não acontecer, reconecte o número para não parar de atender.",
  "numbers.token_expired": "O acesso da Meta a este número venceu em {date}. Reconecte o número para voltar a enviar e receber mensagens.",
  "numbers.reconnect": "Reconectar com a Meta",
  "platform.customer.billing": "Cobrança da Meta",
  "platform.customer.billing.customer": "O cliente paga a Meta com o próprio cartão",
  "platform.customer.billing.partner": "Linha de crédito de parceiro (a Nuvvun paga e cobra o cliente)",
  "numbers.meta.billing_partner": "As mensagens da Meta são cobradas pela linha de crédito do nosso parceiro: não precisa cadastrar cartão",
  "nav.onboarding": "Implantação",
  "common.copy_link": "Copiar link",
  "common.link_copied": "Link copiado",
  "errors.channel_unavailable": "Conecte um número de WhatsApp primeiro.",
  "errors.step_required": "Este passo é obrigatório e não pode ser pulado.",
  "errors.onboarding_incomplete": "Ainda faltam passos obrigatórios.",
  "errors.onboarding_not_answered": "Responda o questionário primeiro.",
  "errors.assistant_not_published": "Publique o assistente antes de escolhê-lo.",
  "onboarding.stage.welcome": "Boas-vindas",
  "onboarding.stage.whatsapp": "WhatsApp",
  "onboarding.stage.team": "Equipe",
  "onboarding.stage.organization": "Organização",
  "onboarding.stage.entry": "Entrada",
  "onboarding.stage.outbound": "Mensagens ativas",
  "onboarding.stage.golive": "Ensaio e go-live",
  "onboarding.stage.welcome.summary": "Conte sobre a empresa para a jornada se ajustar a você.",
  "onboarding.stage.whatsapp.summary": "Ligue o número oficial da empresa ao DoneTalk.",
  "onboarding.stage.team.summary": "Quem atende, em quais filas e em que horário.",
  "onboarding.stage.organization.summary": "Como os atendimentos terminam e como a equipe se organiza.",
  "onboarding.stage.entry.summary": "O que o cliente recebe quando manda a primeira mensagem.",
  "onboarding.stage.outbound.summary": "Para falar primeiro com o cliente, a Meta exige modelos aprovados.",
  "onboarding.stage.golive.summary": "Teste de ponta a ponta com o seu celular; depois, é abrir para a equipe.",
  "onboarding.step.welcome.questionnaire": "Questionário rápido",
  "onboarding.step.whatsapp.connect": "Conectar pela Meta",
  "onboarding.step.whatsapp.payment": "Forma de pagamento na Meta",
  "onboarding.step.team.invite": "Convidar pessoas",
  "onboarding.step.team.queues": "Equipes (filas)",
  "onboarding.step.team.hours": "Horário de atendimento",
  "onboarding.step.organization.outcomes": "Desfechos",
  "onboarding.step.organization.snippets": "Respostas prontas",
  "onboarding.step.organization.autoclose": "Encerramento automático",
  "onboarding.step.organization.tags": "Etiquetas",
  "onboarding.step.entry.first_contact": "Primeiro contato",
  "onboarding.step.entry.after_hours": "Fora do horário",
  "onboarding.step.entry.assistant": "Assistente de IA",
  "onboarding.step.outbound.templates": "Modelos aprovados",
  "onboarding.step.outbound.optout": "Descadastro",
  "onboarding.step.golive.rehearsal": "Ensaio geral",
  "onboarding.step.golive.tour": "Tour da equipe",
  "onboarding.step.golive.live": "Ir ao ar",
  "onboarding.when.welcome.questionnaire": "Pronto quando respondido ou pulado.",
  "onboarding.when.whatsapp.connect": "Pronto quando o número estiver ativo. O nome de exibição segue em análise, e dá para usar enquanto isso.",
  "onboarding.when.whatsapp.payment": "Pronto quando o cartão estiver cadastrado. Sem ele não saem modelos nem, a partir de 1º de outubro de 2026, as respostas além das 1.000 grátis do mês.",
  "onboarding.when.team.invite": "Pronto quando um convite for enviado ou você escolher atender sozinho.",
  "onboarding.when.team.queues": "Pronto quando uma equipe tiver pessoas.",
  "onboarding.when.team.hours": "Pronto quando o horário estiver salvo e ligado às equipes.",
  "onboarding.when.organization.outcomes": "Pronto quando a lista for revisada, com os de sucesso marcados.",
  "onboarding.when.organization.snippets": "Pronto com três ou mais.",
  "onboarding.when.organization.autoclose": "Pronto com uma regra ativa.",
  "onboarding.when.organization.tags": "Pronto com uma ou mais.",
  "onboarding.when.entry.first_contact": "Pronto quando menu, assistente ou equipe estiverem escolhidos e publicados.",
  "onboarding.when.entry.after_hours": "Pronto quando a mensagem estiver publicada com o menu.",
  "onboarding.when.entry.assistant": "Pronto quando publicado, com conhecimento.",
  "onboarding.when.outbound.templates": "Pronto quando a Meta aprovar um modelo.",
  "onboarding.when.outbound.optout": "Pronto quando as palavras estiverem salvas. A resposta de confirmação é opcional.",
  "onboarding.when.golive.rehearsal": "Pronto quando o atendimento de teste terminar com um desfecho.",
  "onboarding.when.golive.tour": "Pronto quando a equipe convidada tiver visto o tour.",
  "onboarding.when.golive.live": "Pronto quando todos os obrigatórios estiverem feitos.",
  "onboarding.done.welcome.questionnaire": "Questionário respondido",
  "onboarding.done.whatsapp.connect": "Número conectado",
  "onboarding.done.whatsapp.payment": "Forma de pagamento cadastrada na Meta",
  "onboarding.done.team.invite": "Convites enviados",
  "onboarding.done.team.queues": "Equipes com pessoas",
  "onboarding.done.team.hours": "Horário ligado às equipes",
  "onboarding.done.organization.outcomes": "Desfechos revisados",
  "onboarding.done.organization.snippets": "Respostas prontas criadas",
  "onboarding.done.organization.autoclose": "Encerramento automático ligado",
  "onboarding.done.organization.tags": "Etiquetas criadas",
  "onboarding.done.entry.first_contact": "Entrada publicada",
  "onboarding.done.entry.after_hours": "Mensagem fora do horário publicada",
  "onboarding.done.entry.assistant": "Assistente publicado, com conhecimento",
  "onboarding.done.outbound.templates": "Modelo aprovado pela Meta",
  "onboarding.done.outbound.optout": "Descadastro configurado",
  "onboarding.done.golive.rehearsal": "Ensaio geral concluído",
  "onboarding.done.golive.tour": "A equipe viu o tour",
  "onboarding.done.golive.live": "No ar",
  "onboarding.lead.welcome.questionnaire": "Conte um pouco sobre a empresa. Com as respostas, a jornada sugere equipes, desfechos, respostas prontas e a mensagem de boas-vindas.",
  "onboarding.lead.whatsapp.connect": "Conecte o número oficial da empresa pela janela da Meta. Leva uns 10 minutos.",
  "onboarding.lead.whatsapp.payment": "Cadastre um cartão na Meta. Sem ele não saem modelos e, a partir de 1º de outubro de 2026, as respostas também param depois das 1.000 grátis do mês por número. O pagamento das mensagens vai direto para a Meta.",
  "onboarding.lead.team.invite": "Chame as pessoas da empresa e escolha o papel de cada uma. Elas recebem o convite por e-mail. Leva uns 5 minutos.",
  "onboarding.lead.team.queues": "Crie as filas por assunto e coloque as pessoas em cada uma.",
  "onboarding.lead.team.hours": "Ligue o horário de atendimento às equipes.",
  "onboarding.lead.organization.outcomes": "Revise como os atendimentos terminam e marque os que contam como sucesso.",
  "onboarding.lead.organization.snippets": "Deixe prontas as respostas que a equipe mais escreve.",
  "onboarding.lead.organization.autoclose": "Ligue o encerramento automático para nenhum atendimento ficar aberto por esquecimento.",
  "onboarding.lead.organization.tags": "Crie etiquetas para marcar e filtrar contatos e atendimentos.",
  "onboarding.lead.entry.first_contact": "Escolha o que o cliente recebe na primeira mensagem: menu, assistente ou direto para a equipe.",
  "onboarding.lead.entry.after_hours": "Escreva a mensagem que o cliente recebe fora do horário.",
  "onboarding.lead.entry.assistant": "Publique um assistente de IA com o conhecimento da empresa.",
  "onboarding.lead.outbound.templates": "Crie um modelo de retomada e um de lembrete e envie para a Meta aprovar.",
  "onboarding.lead.outbound.optout": "Defina as palavras de descadastro e a resposta.",
  "onboarding.lead.golive.rehearsal": "Faça o caminho do seu cliente com o seu celular, do “Oi” ao desfecho.",
  "onboarding.lead.golive.tour": "Envie o tour curto para a equipe ver no primeiro acesso.",
  "onboarding.lead.golive.live": "Tudo pronto: abra o atendimento para a equipe.",
  "onboarding.level.required": "Obrigatório",
  "onboarding.level.recommended": "Recomendado",
  "onboarding.level.optional": "Opcional",
  "onboarding.status.done": "Concluída",
  "onboarding.status.now": "Agora",
  "onboarding.status.step_done": "Feito",
  "onboarding.status.skipped": "Pulado",
  "onboarding.hub.title": "Implantação",
  "onboarding.hub.started": "Começou em {date}.",
  "onboarding.hub.left": "Faltam cerca de {minutes} minutos de trabalho.",
  "onboarding.hub.no_left": "Todas as etapas estão prontas.",
  "onboarding.hub.done_count": "{done} de {total} etapas concluídas",
  "onboarding.hub.now": "Agora · etapa {n} · {stage}",
  "onboarding.hub.start": "Começar",
  "onboarding.hub.skip_now": "Pular por agora",
  "onboarding.hub.open": "Abrir",
  "onboarding.hub.resume": "Retomar",
  "onboarding.hub.steps_progress": "{done} de {total} passos · cerca de {minutes} min",
  "onboarding.hub.minutes": "cerca de {minutes} min",
  "onboarding.hub.meta_review": "mais a análise da Meta",
  "onboarding.hub.help_title": "Precisa de ajuda?",
  "onboarding.hub.help_text": "Um especialista da Nuvvun faz esta etapa com você numa chamada.",
  "onboarding.hub.help_cta": "Falar com um especialista",
  "onboarding.hub.share_title": "Divida a implantação",
  "onboarding.hub.share_text": "Convide quem cuida do WhatsApp ou da equipe como admin. A pessoa vê este mesmo painel.",
  "onboarding.hub.share_cta": "Convidar para ajudar",
  "onboarding.hub.end_title": "Quando terminar",
  "onboarding.hub.end_text": "A implantação sai do menu depois do go-live e fica em Configurações › Conta, se quiser rever.",
  "onboarding.hub.go_live_ready": "Tudo o que é obrigatório está pronto.",
  "onboarding.hub.live_since": "No ar desde {date}.",
  "onboarding.detail.connected": "{number} conectado",
  "onboarding.detail.name_review": "nome em análise pela Meta",
  "onboarding.detail.name_approved": "nome aprovado",
  "onboarding.detail.name_declined": "nome recusado pela Meta",
  "onboarding.detail.paid_by_partner": "A Nuvvun paga a Meta por você",
  "onboarding.detail.solo": "Você vai atender sozinho por enquanto",
  "onboarding.detail.invited": "1 pessoa convidada|{count} pessoas convidadas",
  "onboarding.detail.teams": "1 equipe com pessoas|{count} equipes com pessoas",
  "onboarding.detail.snippets": "1 resposta pronta|{count} respostas prontas",
  "onboarding.detail.tags": "1 etiqueta|{count} etiquetas",
  "onboarding.detail.templates_approved": "1 aprovado|{count} aprovados",
  "onboarding.detail.templates_pending": "1 em análise pela Meta|{count} em análise pela Meta",
  "onboarding.detail.from_questionnaire": "Veio do questionário",
  "onboarding.detail.suggestion_ready": "Sugestão pronta",
  "onboarding.detail.entry_menu": "Menu de boas-vindas publicado",
  "onboarding.detail.entry_team": "Direto para a equipe",
  "onboarding.detail.entry_assistant": "Assistente de IA na entrada",
  "onboarding.detail.tour_pending": "1 pessoa ainda não viu|{count} pessoas ainda não viram",
  "onboarding.welcome.eyebrow": "Boas-vindas",
  "onboarding.welcome.title": "Olá, {name}. Vamos deixar o DoneTalk pronto para a {company}.",
  "onboarding.welcome.lead": "Em 7 etapas curtas você conecta o WhatsApp, monta a equipe e faz um atendimento de teste do seu celular. Pode parar e continuar quando quiser: a implantação fica no menu até o go-live.",
  "onboarding.q.title": "Conte um pouco sobre a {company}",
  "onboarding.q.lead": "Leva 2 minutos. Com as respostas, o DoneTalk sugere equipes, desfechos, respostas prontas e a mensagem de boas-vindas. Você revisa tudo antes de aplicar.",
  "onboarding.q.purposes": "O que vocês vão fazer pelo WhatsApp?",
  "onboarding.purpose.sell": "Vender",
  "onboarding.purpose.support": "Atender clientes",
  "onboarding.purpose.tech_support": "Suporte técnico",
  "onboarding.purpose.billing": "Cobrança",
  "onboarding.purpose.scheduling": "Agendamentos",
  "onboarding.q.segment": "Segmento",
  "onboarding.segment.real_estate": "Imobiliária",
  "onboarding.segment.education": "Educação",
  "onboarding.segment.health": "Saúde",
  "onboarding.segment.retail": "Varejo",
  "onboarding.segment.services": "Serviços",
  "onboarding.segment.finance": "Financeiro",
  "onboarding.segment.automotive": "Automotivo",
  "onboarding.segment.travel": "Turismo",
  "onboarding.segment.other": "Outro",
  "onboarding.q.team_size": "Quantas pessoas vão atender?",
  "onboarding.size.solo": "Só eu",
  "onboarding.size.small": "2 a 5",
  "onboarding.size.medium": "6 a 20",
  "onboarding.size.large": "Mais de 20",
  "onboarding.q.hours": "Horário de atendimento",
  "onboarding.q.hours_to": "às",
  "onboarding.q.add_hours": "Adicionar horário",
  "onboarding.q.remove_hours": "Remover horário",
  "onboarding.q.website": "Site da empresa (opcional)",
  "onboarding.q.website_hint": "A IA lê o site para sugerir respostas prontas e o conhecimento do assistente.",
  "onboarding.q.submit": "Montar minha implantação",
  "onboarding.q.skip": "Pular e ver a lista de passos",
  "onboarding.q.refining": "Ajustando as sugestões à {company}…",
  "onboarding.page.eyebrow": "Implantação · etapa {n} de 7",
  "onboarding.page.key_moment": "momento-chave",
  "onboarding.page.ready_when": "Pronto quando",
  "onboarding.page.back": "Voltar à implantação",
  "onboarding.page.faq": "Dúvidas comuns",
  "onboarding.page.minutes": "cerca de {minutes} minutos",
  "onboarding.page.close_guide": "Fechar o guia",
  "onboarding.org.title": "Organize o atendimento",
  "onboarding.org.lead": "Estas sugestões vieram do questionário. Revise, ajuste e aplique; nada muda antes disso.",
  "onboarding.org.badge_ai": "Sugestões da IA",
  "onboarding.org.badge_presets": "Sugestões para o seu segmento",
  "onboarding.org.outcomes_hint": "Todo atendimento termina com um. É o que alimenta relatórios e aprendizado.",
  "onboarding.org.add_outcome": "Adicionar desfecho",
  "onboarding.org.outcome_label": "Nome do desfecho",
  "onboarding.org.snippets_hint": "No compositor, digite / e o atalho. As variáveis viram o nome do contato e de quem atende.",
  "onboarding.org.tags_hint": "Para marcar contatos e atendimentos e filtrar depois.",
  "onboarding.org.add_tag": "Adicionar",
  "onboarding.org.tag_name": "Nova etiqueta",
  "onboarding.org.autoclose_hint": "Nenhum atendimento fica aberto por esquecimento.",
  "onboarding.org.autoclose_rule": "Sem resposta do contato por {days} dias: concluir como “{outcome}”",
  "onboarding.org.window_rule": "Janela de 24 horas vencida: mover para “Aguardando contato”",
  "onboarding.org.selected": "1 sugestão selecionada. Depois você edita tudo em Configurações.|{count} sugestões selecionadas. Depois você edita tudo em Configurações.",
  "onboarding.org.later": "Revisar depois",
  "onboarding.org.apply": "Aplicar e continuar",
  "onboarding.org.applied": "Aplicado. Tudo fica em Configurações para editar.",
  "onboarding.org.guide_title": "Como os atendimentos terminam",
  "onboarding.org.guide_text": "Os desfechos são o coração do DoneTalk: dizem o que deu certo e o que não deu. Marque como sucesso os que contam como resultado.",
  "onboarding.org.why_title": "Por que isto é uma página própria",
  "onboarding.org.why_text": "Junta quatro configurações que ficam em telas diferentes. Depois de aplicar, cada uma aparece no seu lugar em Configurações.",
  "onboarding.org.ready_text": "Os desfechos revisados. O resto é recomendado.",
  "onboarding.org.none": "Responda o questionário para receber sugestões.",
  "onboarding.entry.title": "Como o atendimento começa",
  "onboarding.entry.lead": "Escolha o que o cliente recebe quando manda a primeira mensagem.",
  "onboarding.entry.suggested": "Sugerido",
  "onboarding.entry.mode.menu": "Menu de boas-vindas",
  "onboarding.entry.mode.menu_text": "O cliente escolhe o assunto e cai na fila certa.",
  "onboarding.entry.mode.assistant": "Assistente de IA",
  "onboarding.entry.mode.assistant_text": "Responde com o conhecimento da empresa e chama a equipe quando precisa.",
  "onboarding.entry.mode.team": "Direto para a equipe",
  "onboarding.entry.mode.team_text": "Sem automação: a mensagem entra na fila e alguém responde.",
  "onboarding.entry.message": "Mensagem de boas-vindas",
  "onboarding.entry.options": "Opções e para onde cada uma vai",
  "onboarding.entry.option": "Opção {n}",
  "onboarding.entry.add_option": "Adicionar opção",
  "onboarding.entry.remove_option": "Remover opção",
  "onboarding.entry.options_hint": "Até 3 opções viram botões no WhatsApp; de 4 a 10, uma lista.",
  "onboarding.entry.team": "Equipe que recebe",
  "onboarding.entry.after_hours": "Fora do horário",
  "onboarding.entry.after_hours_hint": "Vai antes do menu quando alguém escreve fora do horário de atendimento. Deixe em branco para não enviar.",
  "onboarding.entry.assistant_pick": "Assistente",
  "onboarding.entry.no_assistant": "Nenhum assistente publicado ainda. Crie um em Configurações › Assistentes de IA e volte aqui.",
  "onboarding.entry.open_assistants": "Abrir assistentes",
  "onboarding.entry.behind": "Por trás, isto vira um fluxo publicado; você pode abri-lo no construtor quando quiser.",
  "onboarding.entry.open_builder": "Abrir no construtor",
  "onboarding.entry.publish": "Publicar",
  "onboarding.entry.published": "Publicado. Os próximos atendimentos já começam assim.",
  "onboarding.entry.no_teams": "Crie as equipes na etapa Equipe antes de montar a entrada.",
  "onboarding.entry.open_team": "Abrir equipes",
  "onboarding.entry.preview": "Como o cliente vê",
  "onboarding.entry.preview_hi": "Oi",
  "onboarding.entry.list_button": "Ver opções",
  "onboarding.entry.guide_title": "A primeira impressão",
  "onboarding.entry.guide_text": "O menu separa os assuntos antes de chegar em alguém, e cada atendimento já entra na fila certa.",
  "onboarding.entry.ai_title": "Quer o assistente de IA?",
  "onboarding.entry.ai_text": "Dá para começar pelo menu e ligar o assistente depois, com a base de conhecimento pronta.",
  "onboarding.entry.ready_text": "A entrada publicada. A mensagem fora do horário é recomendada.",
  "onboarding.rehearsal.title": "Ensaio geral",
  "onboarding.rehearsal.lead": "Faça o caminho do seu cliente com o seu celular. Você vê cada peça funcionando: número, boas-vindas, fila, resposta e desfecho.",
  "onboarding.rehearsal.start": "Começar o ensaio",
  "onboarding.rehearsal.restart": "Recomeçar o ensaio",
  "onboarding.rehearsal.send_title": "Mande “Oi” para a {company}",
  "onboarding.rehearsal.send_text": "Aponte a câmera do celular para o código ou abra o link no celular. A mensagem já vai com o código do teste.",
  "onboarding.rehearsal.open_whatsapp": "Abrir no WhatsApp",
  "onboarding.rehearsal.test_note": "Este atendimento fica marcado como teste e não entra nos relatórios.",
  "onboarding.rehearsal.live_title": "Acompanhe ao vivo",
  "onboarding.rehearsal.s.received": "Mensagem recebida",
  "onboarding.rehearsal.s.received_text": "Com o código do teste, do seu celular",
  "onboarding.rehearsal.s.automated": "Boas-vindas enviadas",
  "onboarding.rehearsal.s.automated_text": "A entrada publicada respondeu",
  "onboarding.rehearsal.s.queued": "Entrou na fila",
  "onboarding.rehearsal.s.queued_text": "O atendimento chegou a uma equipe",
  "onboarding.rehearsal.s.taken": "Pegue o atendimento e responda",
  "onboarding.rehearsal.s.taken_text": "Como qualquer pessoa da equipe faria",
  "onboarding.rehearsal.s.closed": "Conclua com um desfecho",
  "onboarding.rehearsal.s.closed_text": "Escolha como o atendimento terminou",
  "onboarding.rehearsal.s.monitor": "Veja no monitor ao vivo",
  "onboarding.rehearsal.s.monitor_text": "A fila e o tempo de resposta aparecem em Relatórios › Ao vivo",
  "onboarding.rehearsal.open_inbox": "Abrir no inbox",
  "onboarding.rehearsal.open_monitor": "Abrir o monitor",
  "onboarding.rehearsal.blocked": "Já havia um atendimento aberto com esse celular, e o teste precisa começar um novo. Conclua o atendimento aberto e mande a mensagem de novo.",
  "onboarding.rehearsal.open_blocked": "Abrir o atendimento aberto",
  "onboarding.rehearsal.done": "Ensaio concluído em {minutes} min, com o desfecho “{outcome}”.",
  "onboarding.rehearsal.no_number": "Conecte o número na etapa WhatsApp para fazer o ensaio.",
  "onboarding.rehearsal.waiting": "Esperando a sua mensagem…",
  "onboarding.live.title_done": "A {company} está no ar",
  "onboarding.live.lead_done": "A equipe já pode atender, e o tour curto aparece para cada pessoa no primeiro acesso.",
  "onboarding.live.title_ready": "Tudo pronto para ir ao ar",
  "onboarding.live.lead_ready": "Tudo o que é obrigatório está pronto. Ao ir ao ar, a implantação sai do menu e o tour curto aparece para cada pessoa da equipe no primeiro acesso.",
  "onboarding.live.title_pending": "Faltam alguns passos",
  "onboarding.live.lead_pending": "Termine os passos obrigatórios para liberar o go-live.",
  "onboarding.live.cta": "Ir ao ar",
  "onboarding.live.resend_tour": "Reenviar o tour para a equipe",
  "onboarding.live.tour_resent": "O tour vai aparecer de novo para a equipe.",
  "onboarding.live.open_inbox": "Abrir o inbox",
  "onboarding.live.not_set": "Não configurado",
  "onboarding.live.beyond": "Vá além",
  "onboarding.live.beyond.review.title": "Revisão de mensagens",
  "onboarding.live.beyond.review.text": "A IA avalia o que a equipe envia, em modo sombra, sem bloquear nada, para você calibrar as regras.",
  "onboarding.live.beyond.import.title": "Importar contatos",
  "onboarding.live.beyond.import.text": "Traga a base por planilha, com o consentimento de cada contato.",
  "onboarding.live.beyond.integrations.title": "Integrações",
  "onboarding.live.beyond.integrations.text": "Formulários, CRM e API: os leads entram direto como atendimento.",
  "onboarding.live.beyond.reports.title": "Relatórios e monitor",
  "onboarding.live.beyond.reports.text": "Filas, tempos de resposta e desfechos, ao vivo e por período.",
  "onboarding.live.beyond.learning.title": "Aprendizado semanal",
  "onboarding.live.beyond.learning.text": "Toda segunda, sugestões tiradas dos atendimentos que deram certo.",
  "onboarding.guide.whatsapp.title": "Conecte o WhatsApp da empresa",
  "onboarding.guide.whatsapp.text": "É o número oficial que seus clientes vão ver. A conexão usa a API oficial da Meta, e tudo que chegar nele aparece nos atendimentos.",
  "onboarding.guide.whatsapp.q1": "Posso usar o número que já está no WhatsApp?",
  "onboarding.guide.whatsapp.a1": "Sim. Com a conta apagada no aplicativo, ele vai inteiro para o DoneTalk; ou, se preferir, mantenha o app do WhatsApp Business junto, pela opção de coexistência.",
  "onboarding.guide.whatsapp.a1_soon": "Sim, depois de apagar a conta dele no aplicativo. Manter o app do WhatsApp Business junto chega em breve.",
  "onboarding.guide.whatsapp.q2": "Quanto custa?",
  "onboarding.guide.whatsapp.a2": "A Meta cobra por mensagem entregue, no cartão cadastrado nela: modelos sempre, pelo preço da categoria (marketing, utilidade ou autenticação). A partir de 1º de outubro de 2026, as respostas dentro das 24 horas também são cobradas, depois das 1.000 grátis do mês por número. Quem chega por anúncio de clique para o WhatsApp tem 72 horas grátis. O custo de cada mensagem aparece em Dados da mensagem, nos relatórios e em Configurações › Custos e limites.",
  "onboarding.guide.whatsapp.a2_partner": "A Nuvvun paga a Meta pelos modelos enviados e repassa no seu plano. Responder dentro das 24 horas depois da mensagem do cliente não é cobrado.",
  "onboarding.guide.whatsapp.q3": "O nome não foi aprovado. E agora?",
  "onboarding.guide.whatsapp.a3": "Avisamos aqui, no cartão do número. Envie outro nome pelo WhatsApp Manager seguindo as regras da Meta: o nome precisa ter relação com a empresa.",
  "onboarding.guide.payment_title": "Forma de pagamento na Meta",
  "onboarding.guide.payment_text": "Necessária para enviar modelos e, a partir de 1º de outubro de 2026, para as respostas além das 1.000 grátis do mês por número: sem cartão, a Meta deixa de entregá-las. O pagamento vai direto para a Meta.",
  "onboarding.guide.payment_cta": "Abrir pagamento na Meta",
  "onboarding.guide.payment_partner": "A Nuvvun paga a Meta por você; não precisa cadastrar cartão.",
  "onboarding.guide.team.title": "Monte a equipe",
  "onboarding.guide.team.text": "Cada atendimento novo entra numa fila e vai para quem está online e com menos atendimentos abertos.",
  "onboarding.guide.team.roles": "Os papéis",
  "onboarding.guide.team.role_operator": "Atendente: responde os atendimentos das equipes em que está.",
  "onboarding.guide.team.role_manager": "Gestor: além disso, convida pessoas, publica fluxos e assistentes e cria campanhas.",
  "onboarding.guide.team.role_admin": "Administrador: configura tudo, como você, inclusive números, custos e integrações.",
  "onboarding.guide.team.suggested": "Equipes sugeridas pelo questionário",
  "onboarding.guide.team.create": "Criar estas equipes",
  "onboarding.guide.team.created": "Equipes criadas. Agora coloque as pessoas em cada uma.",
  "onboarding.guide.team.solo": "Vou atender sozinho por enquanto",
  "onboarding.guide.team.ready": "Um convite enviado. As equipes e o horário são recomendados.",
  "onboarding.guide.outbound.title": "Fale primeiro com o cliente",
  "onboarding.guide.outbound.text": "Para retomar uma conversa parada ou lembrar de uma visita, a Meta exige um modelo aprovado. Comece com um de retomada e um de lembrete.",
  "onboarding.guide.outbound.categories": "As categorias da Meta",
  "onboarding.guide.outbound.utility": "Utilidade: avisos sobre algo que o cliente já pediu, como lembrete, confirmação ou status.",
  "onboarding.guide.outbound.marketing": "Marketing: ofertas e retomadas. Custa mais por mensagem, e a Meta pode mudar a categoria na análise.",
  "onboarding.guide.outbound.suggested": "Modelos sugeridos",
  "onboarding.guide.outbound.use": "Usar esta sugestão",
  "onboarding.guide.outbound.optout": "Descadastro",
  "onboarding.guide.outbound.optout_text": "Quem escreve uma das palavras de descadastro (como SAIR ou PARAR) deixa de receber modelos de marketing. Confira as palavras e, se quiser, escreva uma resposta de confirmação.",
  "onboarding.guide.outbound.optout_cta": "Abrir descadastro",
  "onboarding.guide.outbound.ready": "Um modelo aprovado. Dá para ir ao ar sem ele e voltar aqui depois.",
  "onboarding.guide.entry.title": "Assistente de IA",
  "onboarding.guide.entry.text": "Responde com o conhecimento da empresa e chama a equipe quando precisa. Publique-o aqui e depois escolha-o na etapa Entrada.",
  "onboarding.guide.entry.ready": "Publicado, com conhecimento. É opcional.",
  "tour.step": "{n} de {total}",
  "tour.skip": "Pular tour",
  "tour.next": "Próximo",
  "tour.done": "Começar a atender",
  "tour.1.title": "Pegue um atendimento da fila",
  "tour.1.text": "Os atendimentos novos das suas equipes aparecem aqui. Abra um e toque em “Assumir” para ficar com ele.",
  "tour.2.title": "Responda como no WhatsApp",
  "tour.2.text": "Escreva normalmente. Digite / para usar uma resposta pronta, com o nome do cliente já preenchido.",
  "tour.3.title": "Transfira com uma nota",
  "tour.3.text": "Se outra pessoa ou equipe precisa continuar, transfira e deixe uma nota com o que já foi feito.",
  "tour.4.title": "Conclua com um desfecho",
  "tour.4.text": "Ao terminar, escolha como o atendimento acabou. É isso que alimenta os relatórios e o aprendizado.",
  "platform.customer.onboarding": "Implantação",
  "platform.customer.onboarding_live": "No ar desde {date}",
  "platform.customer.onboarding_progress": "{done} de {total} etapas · agora: {stage}",
  "platform.customer.onboarding_pending": "Pendente: {steps}",
  "platform.customer.onboarding_none": "Ainda não começou",
  "permissions.open": "Permissões",
  "permissions.title": "Permissões de {name}",
  "permissions.lead": "Cada permissão segue o papel ({role}) ou vale só para esta pessoa: permitida ou negada.",
  "permissions.readonly": "Você só pode mudar as permissões de quem está abaixo do seu papel.",
  "permissions.role_yes": "Papel: sim",
  "permissions.role_no": "Papel: não",
  "permissions.allow": "Permitir",
  "permissions.deny": "Negar",
  "permissions.exceptions": "1 exceção ao papel|{count} exceções ao papel",
  "permissions.group.conversations": "Atendimentos",
  "permissions.group.contacts": "Contatos",
  "permissions.group.flows": "Fluxos",
  "permissions.group.assistants": "Assistentes de IA",
  "permissions.group.members": "Equipe",
  "permissions.group.channels": "Números e modelos",
  "permissions.group.policies": "Políticas",
  "permissions.group.other": "Outros",
  "permission.conversations.read": "Ver atendimentos",
  "permission.conversations.write": "Responder",
  "permission.conversations.assign": "Atribuir a alguém",
  "permission.conversations.transfer": "Transferir e devolver",
  "permission.conversations.close": "Concluir com desfecho",
  "permission.conversations.send_template": "Enviar modelos (mensagens ativas)",
  "permission.contacts.read": "Ver contatos",
  "permission.contacts.write": "Editar e importar contatos",
  "permission.contacts.export": "Exportar contatos",
  "permission.flows.read": "Ver fluxos",
  "permission.flows.write": "Editar fluxos",
  "permission.flows.publish": "Publicar fluxos",
  "permission.assistants.read": "Ver assistentes",
  "permission.assistants.write": "Editar assistentes",
  "permission.assistants.publish": "Publicar assistentes",
  "permission.members.read": "Ver a equipe",
  "permission.members.manage": "Convidar e gerenciar pessoas",
  "permission.channels.read": "Ver números e modelos",
  "permission.channels.manage": "Conectar números e criar modelos",
  "permission.policies.read": "Ver políticas",
  "permission.policies.manage": "Editar políticas",
  "permission.reports.read": "Ver relatórios e monitor",
  "permission.audit.read": "Ver registro de auditoria",
  "permission.settings.manage": "Mudar configurações da empresa",
  "permission.api.use": "Usar a API",
  "errors.permission_above_own_level": "Você não pode dar uma permissão que você mesmo não tem.",
  "errors.member_above_own_level": "Essa pessoa está no seu nível ou acima.",
  "errors.cannot_modify_self": "Você não pode mudar as próprias permissões.",
  "nav.main": "Navegação principal",
  "common.search": "Pesquisar",
  "composer.poll.title": "Criar enquete",
  "composer.poll.question": "Pergunta",
  "composer.poll.question_placeholder": "Faça uma pergunta",
  "composer.poll.options": "Opções",
  "composer.poll.option": "Opção {n}",
  "composer.poll.option_placeholder": "Adicionar texto",
  "composer.poll.move_up": "Mover opção {n} para cima",
  "composer.poll.remove": "Remover opção {n}",
  "composer.poll.add": "Adicionar opção",
  "composer.poll.multiple": "Permitir várias respostas",
  "composer.poll.anonymous": "Ocultar nomes dos votantes",
  "composer.poll.end": "Definir horário de término",
  "composer.poll.ends_at": "Encerrar em",
  "composer.event.title": "Criar evento",
  "composer.event.name": "Nome do evento",
  "composer.event.name_placeholder": "Ex.: Conversa sobre o projeto",
  "composer.event.when": "Data e horário",
  "composer.event.description": "Descrição",
  "composer.event.description_placeholder": "Adicione mais informações",
  "composer.event.call_link": "Link de ligação do WhatsApp",
  "composer.contact.title": "Compartilhar contato",
  "composer.contact.demo_hint": "Escolha um contato de demonstração.",
  "composer.contact.pick": "Contato para compartilhar",
  "composer.contact.share": "Compartilhar",
  "composer.contact.message": "Contato: {name}",
  "emoji.pick_reaction": "Escolher reação",
  "emoji.panel": "Emojis, GIFs e figurinhas",
  "emoji.back_to_quick": "Voltar às reações rápidas",
  "emoji.close": "Fechar expressões",
  "emoji.search_reaction": "Pesquisar reação",
  "emoji.search_emoji": "Pesquisar emoji",
  "emoji.search_gif": "Pesquisar GIFs",
  "emoji.search_sticker": "Pesquisar figurinhas",
  "emoji.category.smileys": "Smileys e pessoas",
  "emoji.category.animals": "Animais e natureza",
  "emoji.category.food": "Comidas e bebidas",
  "emoji.category.activities": "Atividades",
  "emoji.category.travel": "Viagens e lugares",
  "emoji.category.objects": "Objetos",
  "emoji.category.symbols": "Símbolos",
  "emoji.category.flags": "Bandeiras",
  "message.select": "Selecionar mensagem {text}",
  "message.poll.pick_many": "Selecione uma ou mais opções",
  "message.poll.pick_one": "Selecione uma opção",
  "message.see_reactions": "Ver reações",
  "message.react": "Reagir à mensagem",
  "reaction.quick": "Reações rápidas",
  "reaction.with": "Reagir com {emoji}",
  "reaction.more": "Mais emojis",
  "reaction.error.window": "A janela de 24 horas fechou: o WhatsApp só aceita reação com ela aberta.",
  "reaction.error.too_old": "O WhatsApp só aceita reação em mensagens de até 30 dias.",
  "reaction.error.not_allowed": "O WhatsApp não aceita reação nesta mensagem.",
  "reaction.error.failed": "Não foi possível enviar a reação.",
  "chat.unread": "1 mensagem não lida|{count} mensagens não lidas",
  "builder.default_option": "Opção {n}",
  "builder.script_default": "// vars: variáveis do fluxo; contact: nome e campos do contato\nreturn { resultado: vars.resposta };",
  "snippets.body_placeholder": "Olá {{contact.first_name}}, aqui é {{member.first_name}} da {company}.",
  "message.poll.votes": "1 voto|{count} votos",
  "message.poll.anonymous": "Anônima",
  "message.event.going": "Participando",
  "message.event.join": "Vou participar",
  "auth.forgot": "Esqueci minha senha",
  "auth.forgot_help": "Se o e-mail não chegar, peça a um administrador da sua empresa: em Configurações › Equipe ele gera um link para você criar uma senha nova.",
  "auth.mfa.title": "Verificação em duas etapas",
  "auth.mfa.lead": "Digite o código de 6 dígitos que aparece no app autenticador do seu celular.",
  "auth.mfa.recovery_lead": "Sem o celular? Use um dos códigos de recuperação que você guardou. Cada um funciona uma vez.",
  "auth.mfa.code": "Código do app",
  "auth.mfa.recovery_code": "Código de recuperação",
  "auth.mfa.submit": "Confirmar",
  "auth.mfa.use_recovery": "Usar um código de recuperação",
  "auth.mfa.use_app": "Usar o código do app",
  "auth.mfa.back": "Entrar com outra conta",
  "account.title": "Minha conta",
  "account.mfa.title": "Verificação em duas etapas",
  "account.mfa.on": "Ativada",
  "account.mfa.off": "Desativada",
  "account.mfa.on_lead": "Desde {since}, a entrada pede o código do app autenticador depois da senha.",
  "account.mfa.off_lead": "Proteja sua conta: depois da senha, a entrada pede um código do app autenticador do celular (Google Authenticator, Microsoft Authenticator ou outro).",
  "account.mfa.enable": "Ativar",
  "account.mfa.disable": "Desativar",
  "account.mfa.disabled": "Verificação em duas etapas desativada.",
  "account.mfa.regenerate": "Gerar novos códigos de recuperação",
  "account.mfa.codes_left": "1 código de recuperação restante|{count} códigos de recuperação restantes",
  "account.mfa.code_or_recovery": "Código do app ou de recuperação",
  "account.mfa.setup_title": "Ativar a verificação em duas etapas",
  "account.mfa.setup_step1": "Instale um app autenticador no celular, se ainda não tiver.",
  "account.mfa.setup_step2": "No app, adicione uma conta e leia este QR code com a câmera.",
  "account.mfa.setup_step3": "Digite o código de 6 dígitos que o app mostrar.",
  "account.mfa.qr_label": "QR code para o app autenticador",
  "account.mfa.manual": "Não consegue ler? Digite esta chave no app:",
  "account.mfa.confirm": "Confirmar e ativar",
  "account.mfa.codes_title": "Guarde seus códigos de recuperação",
  "account.mfa.codes_lead": "Se perder o celular, cada código abre sua conta uma vez. Eles não aparecem de novo: copie ou baixe e guarde num lugar seguro.",
  "account.mfa.copy": "Copiar",
  "account.mfa.download": "Baixar",
  "account.mfa.done": "Já guardei",
  "account.mfa.codes_copied": "Códigos copiados.",
  "account.mfa.codes_file_title": "Códigos de recuperação do DoneTalk · {email}",
  "account.mfa.codes_hint": "Cada código funciona uma vez, no lugar do código do app.",
  "account.password.title": "Senha",
  "account.password.change": "Trocar senha",
  "account.password.current": "Senha atual",
  "account.password.new": "Nova senha",
  "account.password.confirm": "Repita a nova senha",
  "account.password.hint": "Pelo menos 10 caracteres, com letras e números.",
  "account.password.save": "Salvar senha",
  "account.password.changed": "Senha trocada. As outras sessões abertas foram encerradas.",
  "account.password.mismatch": "As duas senhas novas não são iguais.",
  "reset.title": "Criar uma senha nova",
  "reset.save": "Salvar senha",
  "reset.done": "Senha criada. Entre com ela.",
  "reset.mfa_stays": "A verificação em duas etapas continua ativada.",
  "reset.to_login": "Ir para a entrada",
  "team.reset_link": "Link para nova senha",
  "team.reset_link_title": "Link para {name} criar uma senha nova",
  "team.reset_link_lead": "Envie este link só para essa pessoa. Ele funciona uma vez, até {until}, e encerra as sessões abertas dela.",
  "team.reset_link_copy": "Copiar link",
  "team.reset_link_copied": "Link copiado.",
  "errors.too_many_attempts": "Muitas tentativas. Espere alguns minutos e tente de novo.",
  "errors.mfa_code_invalid": "Código incorreto. Confira o app e digite o código atual.",
  "errors.mfa_code_used": "Esse código já foi usado. Espere o próximo aparecer no app.",
  "errors.mfa_challenge_expired": "O tempo para o código acabou. Entre com a senha de novo.",
  "errors.mfa_already_enabled": "A verificação em duas etapas já está ativada.",
  "errors.mfa_not_enabled": "A verificação em duas etapas não está ativada.",
  "errors.mfa_not_set_up": "Comece a ativação de novo para gerar o QR code.",
  "errors.current_password_wrong": "A senha atual está incorreta.",
  "errors.password_reset_invalid": "Este link não vale mais: já foi usado ou passou de 24 horas. Peça um novo ao administrador.",
  "errors.password_reset_needs_support": "Essa pessoa também usa a plataforma em outra empresa. Por segurança, só o suporte da Nuvvun pode gerar a nova senha.",
  "errors.invite_not_found": "Este convite não existe mais. Peça um novo a quem convidou você.",
  "errors.invite_expired": "Este convite venceu. Peça um novo a quem convidou você.",
  "errors.already_member": "Você já é membro deste cliente: abra o workspace direto.",
  "errors.member_not_found": "Essa pessoa não está mais na equipe.",
  "errors.user_blocked": "Este acesso está bloqueado.",
  "errors.session_invalid": "Sua sessão terminou. Entre de novo.",
  "platform.access.mfa_reset": "Desligar a verificação em duas etapas",
  "platform.access.mfa_title": "Desligar a verificação em duas etapas de {name}",
  "platform.access.mfa_lead": "Só para quem perdeu o celular e os códigos de recuperação, depois de confirmar quem é por outro canal. As sessões abertas da pessoa terminam e ela ativa de novo em Minha conta.",
  "platform.access.mfa_confirm": "Desligar",
  "platform.access.mfa_done": "Verificação em duas etapas de {name} desligada.",
  "platform.access.password_lead": "O link vale uma vez, por 24 horas, e encerra as sessões abertas da pessoa. Envie só para ela, depois de confirmar quem é.",
  "platform.access.password_confirm": "Gerar link",
  "platform.access.reason": "Motivo (fica na auditoria)",
  "platform.access.reason_placeholder": "Ex.: pediu pelo WhatsApp do suporte, confirmado por ligação",
  "errors.platform_super_required": "Só um administrador geral da plataforma pode fazer isso com alguém da equipe da Nuvvun.",
  "errors.user_not_found": "Essa pessoa não existe mais.",
  "security.title": "Proteja sua conta",
  "security.lead": "Quem é gestor, administrador ou dono precisa da verificação em duas etapas: depois da senha, a entrada pede um código do app autenticador do celular. Leva um minuto.",
  "security.leave": "Sair ({email})",
  "errors.mfa_required": "Ative a verificação em duas etapas para continuar.",
  "settings.privacy": "Dados e privacidade",
  "privacy.retention.title": "Por quanto tempo guardar",
  "privacy.retention.lead": "Passado o prazo, o conteúdo sai e os números ficam: os atendimentos continuam nos relatórios, com tempos, desfechos e custos, sem as mensagens, os arquivos e as notas. O prazo das mensagens conta da conclusão do atendimento.",
  "privacy.retention.messages": "Mensagens",
  "privacy.retention.media": "Fotos, áudios, vídeos e documentos",
  "privacy.retention.audit": "Registro de auditoria",
  "privacy.retention.technical": "Cópias técnicas (avisos brutos da Meta, entregas de webhooks e buscas na base de conhecimento) ficam 30 a 90 dias. A auditoria guarda pelo menos 6 meses, como pede o Marco Civil da Internet.",
  "privacy.retention.last_run": "Última limpeza: {when} · {conversations} atendimentos e {files} arquivos",
  "privacy.keep.forever": "Guardar sempre",
  "privacy.keep.years": "1 ano|{count} anos",
  "privacy.keep.days": "1 dia|{count} dias",
  "privacy.export.title": "Exportação completa",
  "privacy.export.lead": "Um arquivo ZIP com todos os dados da empresa: contatos, atendimentos com as mensagens, equipe, modelos, fluxos, assistentes, base de conhecimento e auditoria. Fica disponível por 7 dias. Senhas e chaves nunca vão junto.",
  "privacy.export.media": "Incluir as fotos, áudios, vídeos e documentos",
  "privacy.export.request": "Gerar exportação",
  "privacy.export.requested": "Exportação pedida. Ela aparece aqui quando ficar pronta.",
  "privacy.export.with_media": "com arquivos",
  "privacy.export.until": "disponível até {when}",
  "privacy.export.download": "Baixar",
  "privacy.export.status.queued": "Na fila",
  "privacy.export.status.running": "Gerando",
  "privacy.export.status.ready": "Pronta",
  "privacy.export.status.failed": "Falhou",
  "privacy.export.status.expired": "Expirada",
  "privacy.subjects.title": "Pedidos dos titulares (LGPD)",
  "privacy.subjects.lead": "Para atender quem pede uma cópia dos próprios dados ou a eliminação deles, abra o contato: no fim do painel estão Exportar dados e Apagar dados.",
  "contact.privacy": "Privacidade (LGPD)",
  "contact.export_data": "Exportar dados deste contato",
  "contact.erase.open": "Apagar dados deste contato",
  "contact.erase.title": "Apagar os dados de {name}",
  "contact.erase.lead": "Use quando a própria pessoa pedir a eliminação dos dados dela. Não tem volta.",
  "contact.erase.goes": "Sai: nome, número, campos, etiquetas, todas as mensagens, arquivos e notas.",
  "contact.erase.stays": "Fica: os atendimentos nos relatórios, sem nada que identifique a pessoa.",
  "contact.erase.confirm": "A pessoa pediu, e eu entendo que não tem volta",
  "contact.erase.submit": "Apagar dados",
  "contact.erase.done": "Dados do contato apagados.",
  "message.purged": "Conteúdo removido pela política de privacidade",
  "errors.contact_has_open_conversation": "Conclua o atendimento aberto desse contato antes de apagar os dados.",
  "errors.contact_not_found": "Esse contato não existe mais.",
  "errors.export_in_progress": "Já tem uma exportação sendo gerada. Espere ela terminar.",
  "errors.export_not_ready": "Essa exportação ainda não está pronta ou já expirou.",
  "errors.export_not_found": "Essa exportação não existe mais.",
  "errors.export_too_large": "A exportação passou de 2 GB. Gere sem os arquivos ou fale com o suporte.",
  "numbers.app.title": "WhatsApp Business no celular",
  "numbers.app.lead": "O número continua no app do celular. O que for enviado por lá aparece aqui, e a Meta copia uma vez os contatos e as conversas dos últimos 180 dias, se a empresa aceitou no app.",
  "numbers.app.contacts": "Contatos da agenda",
  "numbers.app.history": "Conversas anteriores",
  "numbers.app.not_requested": "Ainda não pedido",
  "numbers.app.requested": "Pedido à Meta, chegando",
  "numbers.app.running": "Copiando: {progress}%",
  "numbers.app.contacts_done": "1 contato recebido|{count} contatos recebidos",
  "numbers.app.history_done": "Concluído · 1 mensagem|Concluído · {count} mensagens",
  "numbers.app.declined": "A empresa não compartilhou o histórico no app",
  "numbers.app.failed": "A Meta não aceitou o pedido",
  "numbers.app.retry": "Pedir de novo",
  "errors.app_sync_expired": "A Meta só entrega a cópia do app nas primeiras 24 horas depois de conectar. Para ter de novo, desconecte no app e conecte outra vez.",
  "errors.not_coexistence": "Esse número não está no app WhatsApp Business.",
  "message.deleted_text": "Mensagem apagada",
  "message.from_phone": "Enviada pelo celular",
  "contact.history_app": "Histórico do WhatsApp Business",
  "deletion.title": "Pedido de exclusão de dados",
  "deletion.received": "Recebemos seu pedido (código {code}) em {when}.",
  "deletion.done": "Concluído: o DoneTalk não guarda dados do seu perfil do Facebook. Ao conectar um número, só fica com a empresa o acesso à conta do WhatsApp Business dela.",
  "deletion.business": "As conversas de WhatsApp pertencem à empresa que atende você. Para pedir a eliminação delas, fale com a empresa; para desconectar um número, ela usa Configurações › Números ou o WhatsApp Manager da Meta.",
  "deletion.not_found": "Não encontramos um pedido com o código {code}.",
  "errors.deletion_request_not_found": "Pedido não encontrado.",
  "crm.note.title": "Atendimento no WhatsApp",
  "crm.note.outcome": "Desfecho: {outcome}",
  "crm.note.attendant": "Atendente: {name}",
  "crm.note.team": "Equipe: {name}",
  "crm.note.goal": "Objetivo: {goal}",
  "crm.note.summary": "Resumo",
  "crm.note.messages": "Mensagens: {inbound} do contato, {outbound} da empresa",
  "crm.note.open": "Abrir o atendimento no DoneTalk",
  "crm.title": "CRM",
  "crm.lead": "Ligue o OutboundPro ou o Pipedrive: cada atendimento concluído vira uma nota na pessoa (e no negócio aberto dela), e o painel do contato mostra os negócios abertos.",
  "crm.kind.outboundpro": "OutboundPro",
  "crm.kind.pipedrive": "Pipedrive",
  "crm.provider": "CRM",
  "crm.token": "Token da API",
  "crm.token_hint.outboundpro": "No OutboundPro, em Configurações › API e tokens.",
  "crm.token_hint.pipedrive": "No Pipedrive, em Preferências pessoais › API.",
  "crm.token_kept": "Token guardado. Deixe em branco para manter o atual.",
  "crm.base_url": "Endereço da API",
  "crm.create_persons": "Criar a pessoa no CRM quando o número não estiver lá",
  "crm.log_conversations": "Registrar cada atendimento concluído como nota",
  "crm.deal_outcome": "Desfecho de sucesso marca o negócio aberto como ganho; negativo, como perdido",
  "crm.connect": "Conectar",
  "crm.save": "Salvar",
  "crm.remove": "Desconectar",
  "crm.connected_as": "Conectado como {user}",
  "crm.status.active": "Ativo",
  "crm.status.error": "Com erro",
  "crm.tasks": "{done} atendimentos registrados na última semana · {pending} na fila",
  "crm.dead": "1 atendimento não pôde ser registrado|{count} atendimentos não puderam ser registrados",
  "crm.last_error": "Último erro: {error}",
  "crm.saved": "CRM conectado.",
  "crm.removed": "CRM desconectado.",
  "crm.card.title": "No {crm}",
  "crm.card.none": "Esse número ainda não está no {crm}.",
  "crm.card.create": "Criar pessoa no {crm}",
  "crm.card.deals": "Negócios abertos",
  "crm.card.no_deals": "Nenhum negócio aberto.",
  "crm.card.open": "Abrir no {crm}",
  "crm.card.error": "Não foi possível falar com o {crm} agora.",
  "errors.crm_token_rejected": "O CRM recusou esse token. Confira se copiou inteiro e se ele ainda vale.",
  "errors.crm_unreachable": "Não foi possível falar com o CRM. Confira o endereço e tente de novo.",
  "errors.crm_address_refused": "Esse endereço não pode ser usado.",
  "errors.crm_error": "O CRM respondeu com um erro.",
  "errors.connector_not_found": "Esse conector não existe mais.",
  "templates.header.kind": "Tipo do cabeçalho",
  "templates.header.text": "Texto",
  "templates.header.image": "Imagem",
  "templates.header.video": "Vídeo",
  "templates.header.document": "Documento",
  "templates.header.sample_none": "Nenhum arquivo de exemplo",
  "templates.header.sample_kept": "Arquivo de exemplo guardado",
  "templates.header.sample_choose": "Escolher arquivo",
  "templates.header.sample_hint_image": "JPG ou PNG até 5 MB. A Meta usa o exemplo para aprovar; em cada envio vai a imagem que você escolher.",
  "templates.header.sample_hint_video": "MP4 até 16 MB. A Meta usa o exemplo para aprovar; em cada envio vai o vídeo que você escolher.",
  "templates.header.sample_hint_document": "PDF até 100 MB. A Meta usa o exemplo para aprovar; em cada envio vai o documento que você escolher.",
  "templates.issue.header_media_sample_missing": "Escolha um arquivo de exemplo: a Meta precisa dele para aprovar.",
  "templates.issue.header_media_type": "Esse tipo de arquivo não vale para esse cabeçalho.",
  "templates.issue.header_media_too_large": "O arquivo passou do limite desse tipo.",
  "templates.issue.header_conflict": "O cabeçalho é de texto ou de mídia, não dos dois.",
  "template.header_file": "Arquivo do cabeçalho",
  "template.header_file_hint": "Esse modelo começa com {kind}: escolha o arquivo deste envio.",
  "template.header_file_choose": "Escolher arquivo",
  "errors.template_sample_missing": "O arquivo de exemplo do cabeçalho sumiu. Escolha de novo antes de enviar para a Meta.",
  "errors.header_media_required": "Escolha o arquivo do cabeçalho deste modelo.",
  "platform.customer.billing_unavailable": "A linha de crédito de parceiro fica disponível depois que a solução com um Parceiro de Soluções da Meta estiver cadastrada.",
  "platform.customer.billing_stale": "Este cliente está marcado com a linha de crédito de parceiro, mas não há solução cadastrada: a Meta continua pedindo o cartão dele. Salve para voltar ao cartão do cliente.",
  "errors.meta_solution_missing": "Cadastre a solução com o Parceiro de Soluções da Meta antes de usar a linha de crédito de parceiro.",
  "contact.ai_cost": "Custo de IA",
  "contact.ai_cost_hint": "Chamadas de IA deste atendimento (assistente, resumos e revisão de mensagens), em dólares, como cobram os provedores.",
  "tags.color.blue": "Azul",
  "tags.color.green": "Verde",
  "tags.color.yellow": "Amarelo",
  "tags.color.red": "Vermelho",
  "tags.color.purple": "Roxo",
  "tags.color.light_gray": "Cinza-claro",
  "tags.color.brown": "Marrom",
  "tags.color.orange": "Laranja",
  "tags.color.dark_gray": "Cinza-escuro",
  "tags.color.pink": "Rosa",
  "tags.color.custom": "Outra cor",
  "onboarding.org.add_snippet": "Adicionar resposta",
  "onboarding.org.snippet_shortcut": "atalho",
  "onboarding.org.snippet_body": "Texto da resposta",
  "integrations.event.contact.consent_changed": "Consentimento alterado",
  "integrations.event.message.delivered": "Mensagem entregue",
  "integrations.event.message.read": "Mensagem lida",
  "integrations.event.message.failed": "Mensagem com falha",
  "errors.integration_template_only": "Pela API, só dá para enviar modelos aprovados. Textos e arquivos são enviados por pessoas e passam pela revisão de mensagens.",
  "errors.members_only": "Só uma pessoa da equipe pode fazer isso; uma chave de API não.",
  "event.gate_held_assistant": "A revisão de mensagens segurou uma resposta do assistente e passou o atendimento para uma pessoa: “{draft}”",
  "event.gate_held_flow": "A revisão de mensagens segurou uma mensagem do fluxo e passou o atendimento para uma pessoa: “{draft}”",
  "inbox.gate_logged": "Enviada. A revisão de mensagens marcou esta mensagem para o gestor ver.",
  "policy.gate.shadow_of": "Modo que está calibrando",
  "policy.gate.shadow_hint": "Na sombra, as mensagens saem como foram escritas e ninguém vê nada. A revisão anota o que o modo escolhido teria feito; os números ficam em Relatórios › Revisão de mensagens.",
  "reports.gate.action.held": "Segurada e passada para uma pessoa",
  "reports.gate.action.shadowed": "Avaliada na sombra",
  "reports.gate.authors": "Quem escreveu",
  "reports.gate.author.member": "Pessoas",
  "reports.gate.author.assistant": "Assistente",
  "reports.gate.author.flow": "Fluxos",
  "reports.gate.shadow": "Na sombra",
  "reports.gate.shadow_hint": "O que o modo em calibração teria feito com as mensagens avaliadas na sombra.",
  "reports.gate.simulated.pass": "Teria enviado como estava",
  "reports.gate.simulated.rewrite": "Teria enviado corrigida",
  "reports.gate.simulated.review": "Teria pedido revisão",
  "reports.gate.simulated.block": "Teria bloqueado",
  "weekday.short.sun": "dom",
  "weekday.short.mon": "seg",
  "weekday.short.tue": "ter",
  "weekday.short.wed": "qua",
  "weekday.short.thu": "qui",
  "weekday.short.fri": "sex",
  "weekday.short.sat": "sáb",
  "node.template": "Enviar modelo",
  "node.field.template": "Modelo aprovado",
  "node.template.none": "Nenhum modelo aprovado ainda. Crie e envie para a Meta em Configurações › Modelos de mensagem.",
  "node.template.variable": "Valor de {{{name}}}",
  "node.template.header_link": "Link público do arquivo do cabeçalho",
  "node.template.button": "Final do link do botão {n}",
  "node.template.hint": "Modelos podem ser enviados mesmo depois das 24 horas. Use {{contact.name}} ou {{vars.x}} nos valores.",
  "node.wait.mode": "Esperar",
  "node.wait.mode.seconds": "Por um tempo",
  "node.wait.mode.until": "Até uma data e hora",
  "node.wait.mode.at": "Até um horário do dia",
  "node.wait.amount": "Quanto tempo",
  "node.wait.unit": "Unidade",
  "node.wait.unit.minutes": "minutos",
  "node.wait.unit.hours": "horas",
  "node.wait.unit.days": "dias",
  "node.wait.until": "Data e hora",
  "node.wait.until_hint": "Uma variável com a data, como {{vars.data_visita}} ou {{contact.fields.retorno}}. Aceita 02/10/2026 15:30, só a data (às 9h) ou o formato ISO. Data já passada segue na hora.",
  "node.wait.at": "Horário",
  "node.wait.weekdays": "Dias da semana",
  "node.wait.time_zone": "Fuso horário",
  "builder.exit_invalid_date": "Data inválida",
  "builder.wait_until_summary": "até {when}",
  "builder.wait_at_summary": "até as {time}",
  "builder.wait_at_days_summary": "até as {time} · {days}",
  "builder.wait_minutes": "{n} min",
  "builder.wait_hours": "{n} h",
  "builder.wait_days": "{n} dias",
  "builder.flow_settings": "Configurações do fluxo",
  "builder.exception_target": "Se der erro, ir para",
  "builder.exception_none": "Encerrar o fluxo",
  "builder.inactivity_minutes": "Tempo limite de resposta (minutos)",
  "builder.timeout_target": "Depois do tempo limite, ir para",
  "builder.timeout_end": "Encerrar o fluxo",
  "builder.inactivity_hint": "Vale para menus e perguntas: se o contato não responder nesse tempo, o fluxo segue pelo caminho escolhido. 0 desliga.",
  "simulator.template": "Envia o modelo {name}",
  "simulator.assistant": "O assistente assume a conversa",
  "simulator.wait": "Espera até {until}",
  "simulator.transfer": "Passa para uma pessoa",
  "simulator.close": "Encerra com o desfecho {outcome}",
  "simulator.vars": "Variáveis:",
  "simulator.no_vars": "nenhuma",
  "simulator.assistant_waiting": "Aqui o assistente conversaria com o contato.",
  "simulator.assistant_done": "Terminar o assistente e seguir",
  "assistant.versions": "Versões publicadas",
  "assistant.version": "Versão {n}",
  "assistant.version_active": "Em uso",
  "assistant.restore": "Restaurar",
  "assistant.restored": "A versão {from} voltou a valer como versão {n}.",
  "context.from": "Do sistema: {source}",
  "context.open": "Abrir no sistema",
  "context.updated": "Atualizado em {when}",
  "simulator.status.running": "em andamento",
  "simulator.status.waiting": "esperando o contato",
  "simulator.status.completed": "concluído",
  "simulator.status.failed": "parou com erro",
  "simulator.status.handed_off": "com uma pessoa",
  "assistant.tool.transfer_to_human": "Passar para uma pessoa",
  "assistant.tool.close_conversation": "Encerrar com desfecho",
  "assistant.tool.set_contact_field": "Gravar dado do contato",
  "assistant.tool.end_assistant": "Devolver ao fluxo",
  "assistant.tool.start_flow": "Iniciar um fluxo",
  "assistant.tool_hint.transfer_to_human": "Quando o contato pede uma pessoa, está chateado ou o pedido foge do que o assistente pode fazer.",
  "assistant.tool_hint.close_conversation": "Quando o objetivo foi alcançado ou o contato recusou com clareza.",
  "assistant.tool_hint.set_contact_field": "Guarda o que o contato informou (nome, documento, e-mail, preferência).",
  "assistant.tool_hint.end_assistant": "Dentro de um fluxo: termina a parte do assistente e o fluxo continua.",
  "assistant.tool_hint.start_flow": "Chama um fluxo para uma tarefa com roteiro (agendar, preencher um cadastro, pagar).",
  "assistant.start_flow_hint": "Ficam disponíveis os fluxos publicados marcados com “O assistente de IA pode iniciar este fluxo” (no construtor, em Gatilhos).",
  "builder.assistant_tool": "O assistente de IA pode iniciar este fluxo",
  "builder.assistant_tool_when": "Quando o assistente deve usar",
  "builder.assistant_tool_placeholder": "Ex.: quando o contato quiser agendar uma visita",
  "contact.ad": "Anúncio",
  "reports.by_source": "Por origem",
  "reports.by_ad": "Por anúncio",
  "reports.col.source": "Origem",
  "reports.col.opened": "Abertos",
  "reports.col.ad": "Anúncio",
  "email.greeting": "Olá, {name}!",
  "email.signature": "Equipe DoneTalk",
  "email.reset.subject": "Crie uma nova senha no DoneTalk",
  "email.reset.body": "Recebemos um pedido para criar uma nova senha na sua conta. Use o botão abaixo para escolher a nova senha.",
  "email.reset.button": "Criar nova senha",
  "email.reset.expires": "O link vale por {count} hora e só pode ser usado uma vez.|O link vale por {count} horas e só pode ser usado uma vez.",
  "email.reset.ignore": "Se não foi você que pediu, ignore este e-mail: a sua senha continua a mesma.",
  "email.invite.subject": "{inviter} convidou você para a {workspace} no DoneTalk",
  "email.invite.body": "{inviter} convidou você para atender os clientes da {workspace} pelo WhatsApp no DoneTalk. Aceite o convite e crie a sua senha.",
  "email.invite.button": "Aceitar convite",
  "email.invite.expires": "O convite vale por {count} dia.|O convite vale por {count} dias.",
  "auth.forgot_lead": "Enviamos um link para o e-mail acima. Com ele você cria uma senha nova.",
  "auth.forgot_send": "Enviar link por e-mail",
  "auth.forgot_sent": "Se houver uma conta com {email}, o link já está a caminho. Ele vale por 1 hora.",
  "auth.forgot_email_first": "Escreva o seu e-mail acima primeiro.",
  "team.invite_emailed": "Convite enviado para {email}. O link abaixo também funciona.",
  "inbox.view.mentions": "Menções",
  "message.forward": "Encaminhar",
  "message.pin": "Fixar",
  "message.unpin": "Desafixar",
  "message.remove": "Apagar",
  "message.restore": "Restaurar mensagem",
  "message.restored": "Mensagem restaurada",
  "message.removed_by": "Apagada por {name} · {when}",
  "message.removed_show": "Ver a mensagem apagada",
  "message.removed_hide": "Esconder a mensagem apagada",
  "message.someone": "alguém do time",
  "message.pinned_label": "Mensagem fixada",
  "pin.banner": "Ir para a mensagem fixada",
  "pin.done": "Mensagem fixada para o time. O contato não vê.",
  "pin.undone": "Mensagem desafixada",
  "pin.not_loaded": "Essa mensagem fixada é antiga e não está carregada na conversa.",
  "selection.count": "1 item selecionado|{count} itens selecionados",
  "selection.cancel": "Cancelar seleção",
  "remove.title": "Apagar a mensagem?|Apagar {count} mensagens?",
  "remove.hint": "Some desta conversa para o time, e fica registrado quem apagou e quando. O contato continua vendo no WhatsApp dele: a Meta não permite apagar lá.",
  "remove.confirm": "Apagar",
  "remove.done": "Mensagem apagada|{count} mensagens apagadas",
  "forward.title": "Encaminhar mensagem|Encaminhar {count} mensagens",
  "forward.search": "Pesquisar conversa ou colega",
  "forward.chats": "Conversas",
  "forward.chats_hint": "Aparecem as conversas abertas com a janela de 24 horas aberta: fora dela, o WhatsApp só aceita modelos.",
  "forward.no_chats": "Nenhuma conversa com a janela aberta agora.",
  "forward.team": "Time",
  "forward.team_hint": "Recebe numa nota desta conversa",
  "forward.comment": "Recado para o colega (opcional)",
  "forward.send": "Encaminhar",
  "forward.done": "Encaminhada para 1 destino.|Encaminhada para {count} destinos.",
  "forward.failed": "Não foi para {name}: {reason}.",
  "forward.reason.window": "a janela de 24 horas fechou",
  "forward.reason.closed": "a conversa foi concluída",
  "forward.held": "Algumas mensagens ficaram para a revisão de mensagens e não foram.",
  "forward.received": "{name} encaminhou mensagens para você. Veja em Menções.",
  "notes.forwarded_to": "Encaminhado para {names}",
  "permission.conversations.view_hidden": "Ver mensagens apagadas",
  "event.info.open": "Dados do evento",
  "event.info.title": "Dados do evento",
  "event.info.who": "Quem",
  "event.info.when": "Quando",
  "event.info.from": "De",
  "event.info.to": "Para",
  "event.info.reason": "Motivo",
  "event.info.note": "Recado",
  "event.info.until": "Até",
  "event.info.outcome": "Desfecho",
  "event.info.queue": "Fila",
  "event.actor.contact": "O contato",
  "event.actor.flow": "Fluxo automático",
  "event.actor.assistant": "Assistente de IA",
  "event.actor.api": "Integração",
  "event.actor.policy": "Regra automática",
  "event.actor.system": "DoneTalk (automático)",
  "event.reason.first_reply": "Respondeu primeiro",
  "event.reason.self": "Assumiu a conversa",
  "event.reason.distribution": "Distribuição automática",
  "event.reason.manual": "Atribuição manual",
  "event.reason.integration": "Integração",
  "event.reason.business_app_reply": "Respondeu pelo app WhatsApp Business",
  "composer.voice_preview_pause": "Pausar a prévia",
  "inbox.row_options": "Opções da conversa com {name}",
  "permission.conversations.send_marketing": "Enviar modelo de marketing avulso",
  "permission.campaigns.read": "Ver campanhas",
  "permission.campaigns.write": "Criar e editar campanhas",
  "permission.campaigns.start": "Iniciar, pausar e cancelar campanhas",
  "permission.campaigns.approve": "Aprovar campanhas",
  "permission.costs.read": "Ver custos",
  "permission.costs.manage": "Mudar orçamentos e limites de gasto",
  "permissions.group.campaigns": "Campanhas",
  "permissions.group.costs": "Custos",
  "email.cost_alert.subject": "DoneTalk · {workspace}: {title}",
  "email.cost_alert.cta": "Ver os custos",
  "email.cost_alert.why": "Você recebe este aviso porque acompanha os custos da empresa no DoneTalk. Quem recebe é definido em Configurações › Custos e limites.",
  "cost.scope.company": "A empresa",
  "cost.scope.team": "A equipe {name}",
  "cost.alert.budget_threshold.title": "{scope} passou de {threshold}% do orçamento do mês",
  "cost.alert.budget_threshold.text": "{spent} de {amount} gastos neste mês.",
  "cost.alert.forecast_over.title": "{scope} deve passar do orçamento no dia {day}",
  "cost.alert.forecast_over.text": "No ritmo atual, o mês fecha em {forecast} para um orçamento de {amount}.",
  "cost.alert.daily_spike.title": "Gasto de hoje {factor}× o normal",
  "cost.alert.daily_spike.text": "{spent} até agora; o normal para este dia da semana é {usual}.",
  "cost.alert.category_changed.title": "Modelo mudou de categoria",
  "cost.alert.category_changed.text": "A Meta passou “{name}” de {from} para {to}: cada envio fica mais caro. Foram {volume} envios nos últimos 30 dias.",
  "cost.alert.campaign_costly.title": "Campanha cara por resposta",
  "cost.alert.campaign_costly.text": "“{name}” custa {perReply} por resposta; a média das campanhas é {average}.",
  "errors.marketing_not_allowed": "Você não tem permissão para enviar modelos de marketing. Peça a um gestor.",
  "errors.budget_limit_reached": "O orçamento do mês acabou: este envio precisa de quem aprova campanhas.",
  "nav.campaigns": "Campanhas",
  "settings.costs": "Custos e limites",
  "reports.tab.costs": "Custos",
  "reports.period.last_month": "Mês passado",
  "reports.period.90d": "Últimos 90 dias",
  "costs.view.overview": "Visão geral",
  "costs.view.meta": "Estimado × Meta",
  "costs.view.trends": "Tendências e alertas",
  "costs.mixed_currencies": "Há números cobrados em outra moeda: os valores abaixo somam só os cobrados em {currency}.",
  "costs.kpi.meta": "Custo Meta",
  "costs.kpi.delta": "{delta}% que o período anterior",
  "costs.kpi.confirmed": "{value} confirmado pela Meta",
  "costs.kpi.ai": "IA",
  "costs.kpi.ai_no_rate": "Em dólar: a cotação de hoje ainda não chegou",
  "costs.kpi.per_conversation": "Por atendimento",
  "costs.kpi.conversations": "1 atendimento com resposta|{count} atendimentos com resposta",
  "costs.kpi.per_success": "Por venda",
  "costs.kpi.successes": "1 desfecho de sucesso|{count} desfechos de sucesso",
  "costs.kpi.forecast": "Previsão do mês",
  "costs.kpi.forecast_hint": "{spent} em {day} de {days} dias",
  "costs.daily": "Custo por dia",
  "costs.previous_period": "Período anterior",
  "costs.who": "Quem gerou o custo",
  "costs.by.source": "Origem",
  "costs.by.team": "Equipe",
  "costs.by.channel": "Número",
  "costs.by.member": "Pessoa",
  "costs.source.campaign": "Campanhas",
  "costs.source.member": "Pessoas",
  "costs.source.flow": "Fluxos",
  "costs.source.assistant": "Assistente",
  "costs.source.api": "Integrações e API",
  "costs.source.system": "Sistema",
  "costs.no_team": "Sem equipe",
  "costs.templates": "Modelos que mais custaram",
  "costs.col.template": "Modelo",
  "costs.col.category": "Categoria",
  "costs.col.charged": "Cobradas",
  "costs.col.cost": "Custo",
  "costs.col.day": "Dia",
  "costs.col.estimated": "Estimado na hora",
  "costs.col.meta": "Valor da Meta",
  "costs.col.difference": "Diferença",
  "costs.col.status": "Situação",
  "costs.projection.badge": "A partir de 01/10",
  "costs.projection.title": "Com a nova cobrança, responder custaria {value}",
  "costs.projection.text": "O período teve {messages} mensagens de serviço. {free} seriam grátis ({numbers} números × 1.000 por mês); {chargeable} seriam cobradas.",
  "costs.top_conversations": "Atendimentos mais caros",
  "costs.period_note": "Custos pelo dia em que a Meta cobrou (a entrega), de {from} a {to}. O valor confirmado pela Meta substitui o estimado no dia seguinte.",
  "costs.meta.days": "Dia a dia",
  "costs.meta.last_sync": "Meta consultada em {at}",
  "costs.meta.never": "A Meta ainda não foi consultada",
  "costs.meta.sync": "Consultar agora",
  "costs.meta.synced": "Meta consultada: 1 grupo confirmado|Meta consultada: {count} grupos confirmados",
  "costs.meta.sync_errors": "A Meta não respondeu para 1 conta|A Meta não respondeu para {count} contas",
  "costs.meta.status.confirmed": "Confirmado",
  "costs.meta.status.partial": "1 mensagem sem retorno da Meta|{count} mensagens sem retorno da Meta",
  "costs.meta.status.estimated": "Estimado",
  "costs.meta.status.no_cost": "A Meta não informa o valor",
  "costs.meta.empty": "Nenhuma mensagem cobrada no período.",
  "costs.meta.how": "Como o valor chega",
  "costs.meta.how_1": "Na hora: a Meta diz a categoria de cada mensagem entregue e se foi cobrada; o DoneTalk calcula pela tabela pública do mercado do contato.",
  "costs.meta.how_2": "No dia seguinte: o relatório de preços da Meta traz o valor por dia, número, país e categoria. Ele substitui o estimado e reparte a diferença pelas mensagens do dia.",
  "costs.meta.how_3": "No mês: a fatura da Meta é a referência final. Descontos por volume em utilidade e autenticação só aparecem aqui e na fatura.",
  "costs.meta.credit_line": "Se a empresa paga a Meta pela linha de crédito de um parceiro, a Meta não informa o valor: fica o estimado.",
  "costs.meta.quota": "Mensagens de serviço grátis neste mês",
  "costs.meta.quota_used": "{used} de {free}",
  "costs.meta.quota_over": "As {free} grátis acabaram",
  "costs.meta.quota_hint": "Desde 01/10/2026 cada número tem 1.000 mensagens de serviço grátis por mês, sem acumular. Depois, cada resposta é cobrada.",
  "costs.meta.tiers": "Faixa de volume",
  "costs.meta.tier_open": "a partir de {from}",
  "costs.meta.tier_range": "{from} a {to}",
  "costs.meta.tiers_hint": "A Meta dá desconto em utilidade e autenticação quando o volume do mês passa de certas faixas, somando todas as contas da empresa na Meta.",
  "costs.trends.months": "Custo por mês",
  "costs.trends.meta": "Meta",
  "costs.trends.ai": "IA",
  "costs.trends.forecast": "Previsão",
  "costs.trends.forecast_hint": "O mês deve fechar em {value} no ritmo atual ({day} de {days} dias).",
  "costs.save.title": "Onde economizar",
  "costs.save.split_title": "Respostas picadas custam.",
  "costs.save.split_text": "Cada resposta sai em {perReply} mensagens em média. Depois das 1.000 grátis do mês, juntar em uma só economizaria cerca de {value} por mês.",
  "costs.save.ads_title": "Anúncio de clique para o WhatsApp:",
  "costs.save.ads_text": "as 72 horas depois do anúncio são grátis, modelos incluídos. 1 atendimento veio de anúncio nos últimos 30 dias.|as 72 horas depois do anúncio são grátis, modelos incluídos. {count} atendimentos vieram de anúncio nos últimos 30 dias.",
  "costs.save.utility_title": "Utilidade custa 9× menos que marketing.",
  "costs.save.utility_text": "Avisos de parcela, pedido e agenda devem ser utilidade; a Meta decide a categoria e pode mudá-la.",
  "costs.save.quota_title": "Cada número tem 1.000 respostas grátis por mês.",
  "costs.save.quota_text": "O controle está em Estimado × Meta.",
  "costs.alerts.title": "Alertas",
  "costs.alerts.dismiss": "Dispensar alerta",
  "costs.alerts.none": "Nenhum alerta aberto.",
  "costs.settings.lead": "Governança do gasto: quanto cada área pode gastar por mês, quem é avisado e o que acontece no limite. Tudo fica na auditoria.",
  "costs.settings.budgets": "Orçamento do mês · Meta + IA",
  "costs.settings.budgets_lead": "Em reais, somando o que a Meta cobrou e a IA pelo dólar de hoje. Sem orçamento, nada é limitado.",
  "costs.settings.spent": "{spent} de {amount}",
  "costs.settings.forecast": "Previsão: {value} no fim do mês",
  "costs.settings.monthly": "Por mês (R$)",
  "costs.settings.team": "Equipe",
  "costs.settings.add_team": "Adicionar equipe",
  "costs.settings.campaign_budget": "Cada campanha pode ter o próprio orçamento, definido nela.",
  "costs.settings.saved": "Salvo.",
  "costs.settings.limit": "Quando o orçamento chega a 100%",
  "costs.limit.notify": "Só avisar",
  "costs.limit.notify_hint": "Nada para. Bom para começar e entender o gasto.",
  "costs.limit.pause_campaigns": "Pausar campanhas e segurar marketing avulso",
  "costs.limit.pause_campaigns_hint": "Campanhas pausam; um modelo de marketing avulso só sai por quem aprova campanhas. Recomendado.",
  "costs.limit.pause_paid": "Pausar todo envio pago que não seja resposta",
  "costs.limit.pause_paid_hint": "Campanhas, fluxos e modelos avulsos param até alguém que aprova campanhas liberar.",
  "costs.settings.never_blocked": "Nunca param: respostas dentro do atendimento e códigos de acesso. O cliente que escreveu sempre é respondido.",
  "costs.settings.alerts": "Avisos",
  "costs.settings.who_hears": "Quem recebe, além do aviso na tela de custos:",
  "costs.settings.email": "Também por e-mail",
  "costs.settings.approval": "Aprovação de campanha",
  "costs.settings.approval_on": "Pedir aprovação antes de campanhas grandes",
  "costs.settings.approval_amount": "Quando a campanha puder custar mais de (R$)",
  "costs.settings.approval_audience": "Ou for para mais de (pessoas)",
  "costs.settings.approval_hint": "Quem aprova: quem tem a permissão de aprovar campanhas (donos e admins). Quem criou não aprova a própria.",
  "costs.settings.frequency": "Frequência de marketing",
  "costs.settings.frequency_days": "Dias entre campanhas de marketing",
  "costs.settings.frequency_hint": "Um contato que recebeu uma campanha de marketing fica fora das próximas por esse número de dias. 0 desliga.",
  "costs.settings.who_spends": "Quem pode gastar",
  "costs.settings.who_spends_hint": "Padrão de cada papel. Exceções por pessoa ficam em Equipe › Permissões.",
  "costs.settings.insights": "Métricas de modelos da Meta",
  "costs.settings.insights_lead": "Liga, na Meta, o gasto, o custo por entrega e os cliques em botões de cada modelo. A Meta não deixa desligar depois, e não funciona para contas da Europa e do Japão.",
  "costs.settings.insights_active": "Ligadas",
  "costs.settings.insights_enable": "Ligar métricas",
  "costs.settings.insights_confirm_title": "Ligar métricas de modelos?",
  "costs.settings.insights_confirm": "As métricas de modelos da conta {name} serão ligadas na Meta. Isso não pode ser desfeito.",
  "costs.settings.insights_on": "Métricas de modelos ligadas.",
  "contact.costs.title": "Custo deste atendimento",
  "contact.costs.bucket.marketing": "Marketing",
  "contact.costs.bucket.utility": "Utilidade",
  "contact.costs.bucket.authentication": "Autenticação",
  "contact.costs.bucket.service": "Serviço",
  "contact.costs.bucket.other": "Outras",
  "contact.costs.ai": "IA",
  "contact.costs.messages": "1 mensagem|{count} mensagens",
  "contact.costs.messages_free": "1 mensagem, {free} grátis|{count} mensagens, {free} grátis",
  "contact.costs.quota_over": "As 1.000 mensagens de serviço grátis deste número acabaram em {day}. Até o fim do mês cada resposta é cobrada.",
  "contact.costs.contact_year": "Este contato: 1 atendimento em 12 meses, {value}|Este contato: {count} atendimentos em 12 meses, {value}",
  "meta.pricing.free_quota": "Grátis · dentro das 1.000 mensagens de serviço do mês deste número",
  "meta.pricing.confirmed": "Confirmado pela Meta em {day}",
  "segments.title": "Segmentos",
  "segments.new": "Novo segmento",
  "segments.everyone_item": "Todos os contatos",
  "segments.note": "Segmento é um filtro salvo com nome. Quem passa a cumprir as condições entra sozinho; quem deixa de cumprir sai.",
  "segments.save": "Salvar segmento",
  "segments.update": "Atualizar segmento",
  "segments.delete": "Apagar segmento",
  "segments.saved": "Segmento salvo.",
  "segments.name": "Nome do segmento",
  "segments.add_condition": "Condição",
  "segments.remove_condition": "Remover condição",
  "segments.field": "Campo",
  "segments.condition": "Condição",
  "segments.value": "Valor",
  "segments.value_days": "Dias",
  "segments.add": "Adicionar",
  "segments.everyone": "Todos os contatos",
  "segments.days": "1 dia|{count} dias",
  "segments.field.tag": "Etiqueta",
  "segments.field.source": "Origem do contato",
  "segments.field.last_outcome": "Último desfecho",
  "segments.field.last_conversation": "Último atendimento",
  "segments.field.created": "Cadastro",
  "segments.field.marketing": "Marketing",
  "segments.field.name": "Nome",
  "segments.op.eq": "é",
  "segments.op.neq": "não é",
  "segments.op.has": "tem",
  "segments.op.not_has": "não tem",
  "segments.op.contains": "contém",
  "segments.op.empty": "está vazio",
  "segments.op.not_empty": "está preenchido",
  "segments.op.gt": "maior que",
  "segments.op.lt": "menor que",
  "segments.op.none": "nunca teve",
  "segments.op.days_gt": "há mais de",
  "segments.op.days_lt": "há menos de",
  "segments.marketing.opted_in": "Aceita",
  "segments.marketing.opted_out": "Não aceita",
  "segments.marketing.unknown": "Sem registro",
  "segments.col.last_outcome": "Último desfecho",
  "segments.col.marketing": "Marketing",
  "segments.total": "1 contato|{count} contatos",
  "segments.marketing_ok": "1 pode receber marketing|{count} podem receber marketing",
  "segments.selected": "1 selecionado|{count} selecionados",
  "segments.clear": "Limpar seleção",
  "segments.add_tag": "Adicionar etiqueta",
  "segments.apply": "Aplicar",
  "segments.tagged": "Etiqueta aplicada a 1 contato.|Etiqueta aplicada a {count} contatos.",
  "segments.export": "Exportar",
  "segments.create_campaign": "Criar campanha",
  "segments.select": "Selecionar {name}",
  "segments.select_all": "Selecionar todos da página",
  "segments.fields_note": "Os campos são os do contato. Planilhas, Pipedrive, OutboundPro e as outras integrações preenchem esses mesmos campos, então o segmento não depende de onde o contato veio.",
  "segments.import_tag": "Importação {when}",
  "campaigns.new": "Nova campanha",
  "campaigns.new_name": "Nova campanha",
  "campaigns.lead": "Envio de modelo aprovado para um segmento de contatos, com o custo por resposta e por venda.",
  "campaigns.kpi.count": "Campanhas no mês",
  "campaigns.kpi.reached": "Pessoas alcançadas",
  "campaigns.kpi.cost": "Custo no mês",
  "campaigns.kpi.per_reply": "Custo por resposta",
  "campaigns.tab.all": "Todas",
  "campaigns.tab.draft": "Rascunhos",
  "campaigns.tab.pending_approval": "Para aprovar",
  "campaigns.tab.scheduled": "Agendadas",
  "campaigns.tab.running": "Enviando",
  "campaigns.tab.done": "Concluídas",
  "campaigns.status.draft": "Rascunho",
  "campaigns.status.pending_approval": "Aguardando aprovação",
  "campaigns.status.scheduled": "Agendada",
  "campaigns.status.running": "Enviando",
  "campaigns.status.paused": "Pausada",
  "campaigns.status.completed": "Concluída",
  "campaigns.status.cancelled": "Cancelada",
  "campaigns.status.scheduled_at": "Agendada · {at}",
  "campaigns.col.campaign": "Campanha",
  "campaigns.col.status": "Situação",
  "campaigns.col.audience": "Público",
  "campaigns.col.delivered": "Entregues",
  "campaigns.col.replied": "Responderam",
  "campaigns.col.sales": "Vendas",
  "campaigns.col.cost": "Custo",
  "campaigns.col.per_reply": "Por resposta",
  "campaigns.col.sent": "Enviada",
  "campaigns.col.read": "Lida",
  "campaigns.col.replied_at": "Respondeu",
  "campaigns.up_to": "até {value}",
  "campaigns.empty": "Nenhuma campanha aqui.",
  "campaigns.replies_note": "As respostas viram atendimentos com origem “Campanha”, na equipe, fluxo ou assistente escolhido na campanha.",
  "campaigns.name": "Nome da campanha",
  "campaigns.save_draft": "Salvar rascunho",
  "campaigns.saved": "Rascunho salvo.",
  "campaigns.step.1": "Público",
  "campaigns.step.2": "Mensagem",
  "campaigns.step.3": "Envio e respostas",
  "campaigns.step.4": "Revisão",
  "campaigns.next.2": "Próximo: mensagem",
  "campaigns.next.3": "Próximo: envio",
  "campaigns.next.4": "Próximo: revisão",
  "campaigns.source.segment": "Segmento de contatos",
  "campaigns.source.segment_hint": "Um segmento criado em Contatos, sempre atualizado",
  "campaigns.source.filter": "Filtro só desta campanha",
  "campaigns.source.filter_hint": "As mesmas condições de Contatos, sem salvar",
  "campaigns.source.contacts": "Contatos escolhidos",
  "campaigns.source.contacts_hint": "1 contato escolhido em Contatos|{count} contatos escolhidos em Contatos",
  "campaigns.source.import": "Importar planilha",
  "campaigns.source.import_hint": "Os contatos entram na base com os campos e viram o segmento “Importação”",
  "campaigns.which_segment": "Qual segmento",
  "campaigns.edit_in_contacts": "Editar em Contatos",
  "campaigns.who_enters": "Quem entra",
  "campaigns.fields_note": "Os segmentos nascem em Contatos, pelos campos do contato. Quem chega por Contatos › Criar campanha já encontra o público escolhido.",
  "campaigns.frozen_note": "Quando a campanha começa a enviar, a lista é congelada: quem entrar no segmento depois não recebe esta campanha.",
  "campaigns.who_receives": "Quem vai receber",
  "campaigns.found": "Encontrados",
  "campaigns.skip.blocked": "Contato bloqueado",
  "campaigns.skip.no_whatsapp": "Sem número de WhatsApp",
  "campaigns.skip.opted_out": "Pediram para não receber promoções",
  "campaigns.skip.duplicate": "Número repetido",
  "campaigns.skip.frequency": "Receberam marketing há pouco",
  "campaigns.skip.open_conversation": "Estão em atendimento agora",
  "campaigns.skip.cancelled": "Campanha cancelada",
  "campaigns.receive": "Vão receber",
  "campaigns.skip_note": "“Pediram para não receber promoções” e a frequência de marketing não podem ser desmarcados; a frequência é ajustada em Configurações › Custos e limites.",
  "campaigns.samples": "Exemplos: {names}",
  "campaigns.pick_audience": "Escolha um segmento ou monte um filtro.",
  "campaigns.template": "Modelo",
  "campaigns.number": "Número",
  "campaigns.approved_template": "Modelo aprovado",
  "campaigns.quality": "Qualidade {q}",
  "campaigns.template_hint": "Só aparecem modelos aprovados da conta deste número. O preço por entrega aparece na revisão.",
  "campaigns.variables": "Variáveis",
  "campaigns.var.from": "Vem de",
  "campaigns.var.format": "Formato",
  "campaigns.var.fallback": "Se estiver vazio",
  "campaigns.var.text": "Texto",
  "campaigns.var.first_name": "Primeiro nome",
  "campaigns.var.name": "Nome",
  "campaigns.var.phone": "Telefone",
  "campaigns.var.field": "Campo: {name}",
  "campaigns.var.fixed": "Texto fixo",
  "campaigns.var.button": "Final do link do botão {n}",
  "campaigns.format.none": "Como está",
  "campaigns.format.title": "Nome Próprio",
  "campaigns.format.first": "Só a primeira palavra",
  "campaigns.format.upper": "MAIÚSCULAS",
  "campaigns.format.lower": "minúsculas",
  "campaigns.header": "Arquivo do cabeçalho ({kind})",
  "campaigns.header_choose": "Escolher arquivo",
  "campaigns.media.image": "foto",
  "campaigns.media.video": "vídeo",
  "campaigns.media.document": "documento",
  "campaigns.buttons": "Botões",
  "campaigns.quick_reply": "Resposta rápida",
  "campaigns.when_tapped": "Quando tocar",
  "campaigns.button.route": "Abre atendimento como a resposta",
  "campaigns.button.optout": "Tira o contato do marketing",
  "campaigns.button.none": "Só conta o toque",
  "campaigns.preview": "Prévia · {name}",
  "campaigns.prev_sample": "Exemplo anterior",
  "campaigns.next_sample": "Próximo exemplo",
  "campaigns.missing": "Falta valor para {slots}: a Meta recusaria esta mensagem.",
  "campaigns.test_phone": "Enviar teste para",
  "campaigns.send_test": "Enviar teste",
  "campaigns.test_hint": "O teste vai para esse WhatsApp, abre um atendimento de teste para você e não entra nos números da campanha.",
  "campaigns.test_sent": "Teste enviado.",
  "campaigns.when": "Quando",
  "campaigns.when_now": "Agora",
  "campaigns.when_later": "Agendar",
  "campaigns.start_at": "Começa em",
  "campaigns.window": "Envia só nestes dias e horários (horário de Brasília):",
  "campaigns.from": "Das",
  "campaigns.to": "Até",
  "campaigns.window_hint": "A velocidade é automática: respeita o limite diário da Meta de pessoas novas, somando todos os números e envios da empresa. Sem nenhum dia marcado, envia a qualquer hora.",
  "campaigns.stop": "Para sozinha se",
  "campaigns.stop_template": "A Meta pausar ou reprovar o modelo",
  "campaigns.stop_quality": "A qualidade do número cair para baixa",
  "campaigns.stop_optout": "Mais de 3% pedirem para parar",
  "campaigns.stop_budget": "O orçamento da campanha acabar",
  "campaigns.budget": "Orçamento da campanha (R$)",
  "campaigns.stop_hint": "Quando para, avisa quem criou e mostra o motivo. Retomar é um clique.",
  "campaigns.on_reply": "Quando alguém responder",
  "campaigns.reply.team": "Abre atendimento na equipe",
  "campaigns.reply.team_hint": "Distribui como as outras conversas",
  "campaigns.reply.flow": "Começa um fluxo",
  "campaigns.reply.flow_hint": "Um fluxo publicado conduz a conversa",
  "campaigns.reply.assistant": "O assistente atende",
  "campaigns.reply.assistant_hint": "Com a mensagem da campanha como contexto",
  "campaigns.reply.pick_team": "Equipe",
  "campaigns.reply.pick_flow": "Fluxo",
  "campaigns.reply.pick_assistant": "Assistente",
  "campaigns.reply.default_team": "Equipe padrão do número",
  "campaigns.goal": "Objetivo do atendimento",
  "campaigns.success_days": "Dias para contar a venda",
  "campaigns.success_hint": "Venda = atendimento aberto pela resposta e concluído com desfecho de sucesso em até {days} dias. Se o contato estava em duas campanhas, conta só para a última.",
  "campaigns.summary": "Resumo",
  "campaigns.people": "1 pessoa|{count} pessoas",
  "campaigns.starts": "Começa",
  "campaigns.estimate": "Custo estimado",
  "campaigns.market": "Mercado",
  "campaigns.price": "Preço",
  "campaigns.up_to_col": "Até",
  "campaigns.total": "Total",
  "campaigns.estimate_hint": "“Até” porque só é cobrado o que for entregue; quem bateu o limite de marketing do dia não é cobrado. As respostas abertas pela campanha também custam (serviço) e entram no resultado.",
  "campaigns.checks": "Antes de enviar",
  "campaigns.check.template": "Modelo aprovado",
  "campaigns.check.number": "Número pode enviar · qualidade {quality}",
  "campaigns.check.days": "Termina em 1 dia (limite de {limit} pessoas novas por dia)|Termina em {days} dias (limite de {limit} pessoas novas por dia)",
  "campaigns.check.unlimited": "Sem limite diário na Meta",
  "campaigns.check.budget": "{scope}: {spent} de {amount}; com esta campanha, até {after}",
  "campaigns.needs_approval": "Precisa de aprovação",
  "campaigns.needs_approval_hint": "A campanha passa do valor ou do público que a regra da empresa manda aprovar.",
  "campaigns.ask": "Pedir para",
  "campaigns.request_approval": "Pedir aprovação",
  "campaigns.ready_hint": "Tudo pronto. A campanha começa agora ou na hora agendada.",
  "campaigns.schedule": "Agendar",
  "campaigns.send_now": "Enviar agora",
  "campaigns.submitted.pending_approval": "Pedido de aprovação enviado.",
  "campaigns.submitted.running": "Campanha enviando.",
  "campaigns.submitted.scheduled": "Campanha agendada.",
  "campaigns.byline": "Criada por {who} · {at}",
  "campaigns.api": "integração",
  "campaigns.approved_by": "aprovada por {name}",
  "campaigns.duplicate": "Duplicar",
  "campaigns.banner.running": "Enviando · {sent} de {total}. Respeita o horário da campanha e o limite diário da Meta.",
  "campaigns.banner.scheduled": "Agendada para {at}.",
  "campaigns.banner.pending": "Esperando a aprovação de um admin.",
  "campaigns.pause_reason.member": "Pausada por uma pessoa.",
  "campaigns.pause_reason.template_paused": "Pausada sozinha: a Meta pausou ou reprovou o modelo.",
  "campaigns.pause_reason.quality_low": "Pausada sozinha: a qualidade do número caiu.",
  "campaigns.pause_reason.optout_rate": "Pausada sozinha: muita gente pediu para parar.",
  "campaigns.pause_reason.budget": "Pausada sozinha: o orçamento da campanha acabou.",
  "campaigns.pause_reason.company_budget": "Pausada sozinha: o orçamento do mês chegou ao limite.",
  "campaigns.pause_reason.channel_unavailable": "Pausada sozinha: o número não pode enviar.",
  "campaigns.pause": "Pausar",
  "campaigns.resume": "Retomar",
  "campaigns.cancel": "Cancelar campanha",
  "campaigns.approve": "Aprovar",
  "campaigns.reject": "Recusar com motivo",
  "campaigns.reject_reason": "Motivo",
  "campaigns.kpi.campaign_cost": "Custo da campanha",
  "campaigns.kpi.estimated": "Estimado: até {value}",
  "campaigns.kpi.with_conversations": "Com os atendimentos",
  "campaigns.kpi.follow_hint": "+ {value} das respostas (serviço)",
  "campaigns.kpi.per_sale": "Por venda",
  "campaigns.funnel": "Funil",
  "campaigns.funnel_step.audience": "Público",
  "campaigns.funnel_step.sent": "Enviadas",
  "campaigns.funnel_step.delivered": "Entregues",
  "campaigns.funnel_step.read": "Lidas",
  "campaigns.funnel_step.replied": "Responderam",
  "campaigns.funnel_step.sales": "Vendas",
  "campaigns.sale_rule": "Venda = atendimento aberto pela campanha e concluído com desfecho de sucesso em até {days} dias.",
  "campaigns.link": "Link",
  "campaigns.links_hint": "Cliques em links vêm das métricas de modelo da Meta, com até 2 dias de atraso, e somam todos os envios do modelo nos dias da campanha.",
  "campaigns.failures": "Não entregues · {count}",
  "campaigns.no_failures": "Nenhuma falha.",
  "campaigns.retry": "Tentar de novo os que podem",
  "campaigns.requeued": "1 pessoa voltou para a fila.|{count} pessoas voltaram para a fila.",
  "campaigns.skipped_title": "Fora da lista",
  "campaigns.people_title": "Pessoas",
  "campaigns.filter.all": "Todas",
  "campaigns.filter.delivered": "Entregues",
  "campaigns.filter.read": "Lidas",
  "campaigns.filter.replied": "Responderam",
  "campaigns.filter.success": "Vendas",
  "campaigns.filter.failed": "Falharam",
  "campaigns.filter.skipped": "Fora",
  "campaigns.filter.queued": "Na fila",
  "campaigns.recipient.queued": "Na fila",
  "campaigns.recipient.sending": "Enviando",
  "campaigns.recipient.sent": "Enviada",
  "campaigns.recipient.delivered": "Entregue",
  "campaigns.recipient.read": "Lida",
  "campaigns.recipient.failed": "Não entregue",
  "campaigns.recipient.replied": "Respondeu",
  "campaigns.recipient.success": "Comprou",
  "campaigns.recipient.skip.blocked": "Fora: bloqueado",
  "campaigns.recipient.skip.no_whatsapp": "Fora: sem WhatsApp",
  "campaigns.recipient.skip.opted_out": "Fora: não aceita promoções",
  "campaigns.recipient.skip.duplicate": "Fora: número repetido",
  "campaigns.recipient.skip.frequency": "Fora: recebeu marketing há pouco",
  "campaigns.recipient.skip.open_conversation": "Fora: em atendimento",
  "campaigns.recipient.skip.cancelled": "Fora: campanha cancelada",
  "campaigns.recipient.skip.other": "Fora",
  "campaigns.failure.131049": "Limite de marketing da pessoa no dia",
  "campaigns.failure.131026": "Número sem WhatsApp",
  "campaigns.failure.131050": "Bloqueou marketing no WhatsApp",
  "campaigns.failure.131047": "Fora da janela de 24 horas",
  "campaigns.failure.131051": "Tipo de mensagem não aceito",
  "campaigns.failure.132015": "Modelo pausado pela Meta",
  "campaigns.failure.135000": "Ritmo de envio da Meta",
  "campaigns.failure.131042": "Problema de pagamento na Meta",
  "campaigns.failure.variable_missing": "Faltou valor numa variável",
  "campaigns.failure.cancelled": "Campanha cancelada",
  "campaigns.failure.unknown": "Motivo não informado",
  "campaigns.failure.other": "Erro {code}",
  "campaigns.next.tomorrow": "Tenta sozinha amanhã · não cobrado",
  "campaigns.next.mark": "Não tenta de novo",
  "campaigns.next.optout": "Sai do marketing",
  "campaigns.next.retry": "Pode tentar de novo",
  "campaigns.open_conversation": "Abrir atendimento",
  "campaigns.no_people": "Ninguém aqui.",
  "errors.campaign_not_editable": "Esta campanha já saiu do rascunho e não pode ser editada.",
  "errors.campaign_audience_empty": "Ninguém para receber: revise o público.",
  "errors.campaign_not_pending": "Esta campanha não está esperando aprovação.",
  "errors.campaign_own_approval": "Quem criou a campanha não pode aprová-la.",
  "errors.campaign_wrong_status": "A campanha não está numa situação que permita isso.",
  "errors.campaign_not_found": "Campanha não encontrada.",
  "errors.segment_not_found": "Segmento não encontrado.",
  "errors.template_without_media_header": "Este modelo não tem cabeçalho com arquivo.",
  "errors.upload_used": "Este arquivo já foi usado; escolha de novo.",
  "errors.template_not_approved": "O modelo não está aprovado pela Meta.",
  "campaigns.var.slot_header": "Cabeçalho {name}",
  "campaigns.var.slot_body": "Texto {name}",
  "campaigns.check.missing": "1 pessoa ficaria sem valor numa variável: preencha “Se estiver vazio”|{count} pessoas ficariam sem valor numa variável: preencha “Se estiver vazio”",
  "campaigns.not_ready_hint": "Resolva os itens marcados acima para enviar.",
  "fx.approx_today": "≈ {value} hoje",
  "fx.approx": "≈ {value}",
  "fx.rate": "Dólar de hoje: US$ 1 = {rate} (PTAX de {day})",
  "fx.no_rate": "A cotação do dólar ainda não chegou",
  "fx.ai_note": "IA cobrada em dólar e convertida pelo dólar de hoje: US$ 1 = {rate} (PTAX de {day}).",
  "platform.ai.pricing_synced": "Preço atualizado em {count} modelo|Preços atualizados em {count} modelos",
  "platform.ai.last_sync": "Última atualização do catálogo: {when}, preço de {count} modelo. A tabela pública do LiteLLM é lida todo dia às 3h15 (Brasília).|Última atualização do catálogo: {when}, preços de {count} modelos. A tabela pública do LiteLLM é lida todo dia às 3h15 (Brasília).",
  "platform.ai.alert.retiring": "{model} será aposentado pelo fornecedor em {date}.",
  "platform.ai.alert.price_moved": "{model}: o preço de {field} mudou de {from} para {to} por milhão de tokens. Confira antes de repassar.",
  "platform.ai.alert.input": "entrada",
  "platform.ai.alert.output": "saída",
  "platform.ai.unpriced": "Sem preço na tabela (a IA desses modelos conta como zero): {models}",
  "platform.ai.retires": "aposenta em {date}",
  "platform.ai.synced_at": "Preço da tabela do LiteLLM de {when}",
  "page.back_to": "Voltar para {name}",
  "page.unsaved": "Alterações não salvas",
  "page.leave_title": "Sair sem salvar?",
  "page.leave_text": "As alterações desta página ainda não foram salvas e serão perdidas.",
  "page.leave": "Sair sem salvar",
  "page.stay": "Continuar editando",
  "chips.remove": "Remover {value}",
  "assistants.lead": "Quem responde pela empresa enquanto não há uma pessoa. Clique num assistente para abrir.",
  "assistants.empty": "Nenhum assistente ainda. Crie o primeiro e teste antes de publicar.",
  "assistants.speaks_as": "Fala como {name} · {tone}",
  "assistants.no_tone": "tom não definido",
  "assistants.no_persona": "Sem persona definida",
  "assistants.now": "Agora",
  "assistants.consults": "Consulta",
  "assistants.hands_to": "Passa para",
  "assistants.running": "{count} atendimento|{count} atendimentos",
  "assistants.none_now": "Nenhum agora",
  "assistants.never_published": "Nunca publicado",
  "assistants.collections": "{count} coleção|{count} coleções",
  "assistants.consults_nothing": "Nada ainda",
  "assistants.same_team": "Fila da equipe atual",
  "assistants.published_on": "Versão {n} · publicada em {day}",
  "assistants.created_on": "Alterado em {day}",
  "assistants.show_archived": "Ver arquivado ({count})|Ver arquivados ({count})",
  "assistants.show_active": "Voltar aos ativos",
  "assistants.unpublished": "Alterações não publicadas",
  "assistants.live": "Ativo · versão {n}",
  "assistants.not_found": "Esse assistente não existe mais.",
  "assistants.default_name": "Novo assistente",
  "assistants.save_draft": "Salvar rascunho",
  "assistants.tab.voice": "Como fala",
  "assistants.tab.knows": "O que sabe e faz",
  "assistants.tab.handoff": "Quando passa para uma pessoa",
  "assistants.tab.versions": "Versões e uso",
  "assistants.field.name": "Nome interno",
  "assistants.field.persona": "Nome que o contato vê",
  "assistants.instructions_hint": "Escreva como se explicasse o trabalho para uma pessoa nova na equipe: o negócio, o que responder, o que nunca prometer e quando chamar alguém.",
  "assistants.creativity.low": "mais previsível",
  "assistants.creativity.mid": "equilibrado",
  "assistants.creativity.high": "mais criativo",
  "assistants.knows.title": "O que ele consulta",
  "assistants.knows.hint": "Coleções da Base de conhecimento que ele lê antes de responder.",
  "assistants.knows.none": "Nenhuma coleção ainda.",
  "assistants.knows.open": "Abrir Base de conhecimento",
  "assistants.does.title": "O que ele pode fazer",
  "assistants.does.hint": "Ações que o assistente toma sozinho durante o atendimento.",
  "assistants.handoff.title": "Quando passa para uma pessoa",
  "assistants.handoff.keywords": "Quando o contato disser",
  "assistants.handoff.keywords_placeholder": "atendente, humano",
  "assistants.handoff.hint": "Ele também passa quando não sabe responder ou o contato pede, se “Passar para uma pessoa” estiver ligado em “O que sabe e faz”.",
  "assistants.limits.title": "Limites da resposta",
  "assistants.limits.blocked": "Termos que ele nunca usa",
  "assistants.limits.blocked_placeholder": "garantido, sem juros",
  "assistants.limits.hint": "Se uma resposta tiver um desses termos, ele manda o texto de segurança no lugar.",
  "assistants.versions.none": "Nenhuma versão publicada ainda.",
  "assistants.runs.title": "Atendimentos recentes",
  "assistants.runs.none": "Ele ainda não atendeu ninguém.",
  "assistants.runs.turns": "{count} resposta|{count} respostas",
  "assistants.run.running": "Atendendo",
  "assistants.run.completed": "Concluído",
  "assistants.run.handed_off": "Passou para pessoa",
  "assistants.run.cancelled": "Interrompido",
  "assistants.run.failed": "Falhou",
  "assistants.test.title": "Testar",
  "assistants.test.open": "Testar",
  "assistants.test.close": "Fechar o teste",
  "assistants.test.draft": "Com o que está na tela",
  "assistants.test.restart": "Recomeçar",
  "assistants.test.empty": "Escreva como se fosse o contato. O assistente responde com o que está na tela, mesmo sem salvar.",
  "assistants.test.placeholder": "Escreva como se fosse o contato",
  "assistants.test.send": "Enviar mensagem de teste",
  "assistants.test.typing": "Respondendo",
  "assistants.test.note": "Não envia nada ao WhatsApp e não entra nos relatórios. O custo de IA aparece em Uso de IA como teste.",
  "assistants.test.consulted": "Consultou: {sources}",
  "assistants.test.handoff": "Passaria para uma pessoa ({team}). Motivo: {reason}",
  "assistants.test.closes": "Concluiria o atendimento como {outcome}",
  "assistants.test.set_field": "Gravaria no contato: {field} = {value}",
  "assistants.test.start_flow": "Iniciaria o fluxo {flow}",
  "assistants.test.end": "Devolveria o atendimento ao fluxo",
  "assistants.test.exit_keyword": "O contato disse “{keyword}”: passaria para uma pessoa ({team})",
  "assistants.test.exit_field": "O campo {field} foi preenchido: passaria para uma pessoa ({team})",
  "assistants.test.max_turns": "Chegou ao limite de respostas: passaria para uma pessoa ({team})",
  "assistants.test.ended": "O teste terminou aqui. Recomece para testar de novo.",
  "assistants.test.closed_hint": "O teste está fechado. “Testar” no topo abre de novo, em qualquer aba.",
  "knowledge.lead": "O que os assistentes consultam para responder, organizado em coleções.",
  "knowledge.empty": "Nenhuma coleção ainda. Crie uma e adicione textos, páginas do site ou PDFs.",
  "knowledge.new_collection_button": "Nova coleção",
  "knowledge.collection_name": "Nome da coleção",
  "knowledge.collection_hint": "Depois é só adicionar conteúdo e marcar a coleção nos assistentes que devem consultá-la.",
  "knowledge.create": "Criar",
  "knowledge.card.contents": "{count} conteúdo|{count} conteúdos",
  "knowledge.card.ready": "Tudo pronto",
  "knowledge.card.processing": "Processando",
  "knowledge.card.empty": "Vazia",
  "knowledge.card.failed": "{count} com erro|{count} com erro",
  "knowledge.card.used_by": "Usada por",
  "knowledge.card.unused": "Nenhum assistente usa. Marque em “O que ele consulta” no assistente.",
  "knowledge.not_found": "Essa coleção não existe mais.",
  "knowledge.page.used_by": "Usada por {names}",
  "knowledge.page.empty": "Nenhum conteúdo ainda. Use “Adicionar conteúdo”.",
  "knowledge.rename": "Renomear",
  "knowledge.col.content": "Conteúdo",
  "knowledge.col.source": "Fonte",
  "knowledge.col.chunks": "Trechos",
  "knowledge.col.status": "Situação",
  "knowledge.failed_generic": "Não foi possível ler este conteúdo.",
  "knowledge.retry": "Tentar de novo",
  "knowledge.remove": "Remover {name}",
  "knowledge.test.title": "Testar a busca",
  "knowledge.test.hint": "Escreva uma pergunta de cliente e veja os trechos que o assistente leria antes de responder.",
  "knowledge.test.question": "Pergunta",
  "knowledge.test.placeholder": "Qual o prazo de entrega?",
  "knowledge.test.search": "Buscar",
  "knowledge.test.very_close": "muito parecido",
  "knowledge.test.close": "parecido",
  "knowledge.test.far": "pouco parecido",
  "knowledge.test.nothing": "Nenhum trecho parecido. Falta conteúdo sobre isso.",
  "knowledge.test.advice": "Se o trecho certo não aparece, falta conteúdo ou ele está escrito de um jeito diferente de como o cliente pergunta.",
  "learning.lead": "Toda semana a IA lê os atendimentos concluídos e sugere melhorias. Nada muda sem a sua aprovação.",
  "learning.waiting": "{count} sugestão esperando você|{count} sugestões esperando você",
  "learning.waiting_hint": "Do relatório de {period}. As aprovadas viram respostas prontas, ajustes de assistente ou conteúdo da base.",
  "learning.review_now": "Revisar agora",
  "learning.row_counts": "{analyzed} atendimentos lidos · {applied} aplicadas",
  "learning.to_review": "{count} para revisar|{count} para revisar",
  "learning.reviewed": "Revisado",
  "learning.show_archived": "Ver arquivado ({count})|Ver arquivados ({count})",
  "learning.show_current": "Voltar aos atuais",
  "learning.period_range": "{from} a {to}",
  "learning.week_of": "Semana de {period}",
  "learning.filter.proposed": "Para revisar",
  "learning.filter.applied": "Aplicadas",
  "learning.filter.rejected": "Recusadas",
  "learning.filter_empty.proposed": "Nada para revisar neste relatório.",
  "learning.filter_empty.applied": "Nenhuma sugestão aplicada ainda.",
  "learning.filter_empty.rejected": "Nenhuma sugestão recusada.",
  "learning.body_editable": "Texto (dá para editar antes de aprovar)",
  "learning.evidence_count": "Ver {count} atendimento de exemplo|Ver os {count} atendimentos de exemplo",
  "learning.approve_draft": "Aprovar como rascunho",
  "learning.the_week": "A semana",
  "learning.stat.analyzed": "Atendimentos lidos",
  "learning.stat.successful": "Concluídos com sucesso",
  "learning.stat.suggestions": "Sugestões",
  "policy.lead": "Regras automáticas que valem para os atendimentos, sem ninguém precisar lembrar.",
  "policy.empty": "Nenhuma política ainda.",
  "policy.kind_hint.lifecycle": "Fecha ou prioriza atendimentos parados",
  "policy.kind_hint.gate": "Confere o que a equipe escreve antes de enviar",
  "policy.inactive": "Desligada",
  "policy.new_title": "O que a nova política faz?",
  "policy.kind_choice.lifecycle": "Conclui, prioriza ou marca como aguardando depois de um tempo sem resposta.",
  "policy.kind_choice.gate": "Barra palavras, promessas e dados sensíveis, com ou sem revisão por IA.",
  "policy.continue": "Continuar",
  "policy.not_found": "Essa política não existe mais.",
  "policy.scope_team": "equipe {name}",
  "policy.applies_to": "Vale para",
  "policy.when": "Quando",
  "policy.rule_kind": "O que acontece",
  "policy.when_kind.no_inbound_for": "o contato não responde",
  "policy.when_kind.unanswered_new_for": "um atendimento novo fica sem primeira resposta",
  "policy.when_kind.window_expired": "a janela de 24 h fecha",
  "policy.for": "por",
  "policy.hours_word": "horas",
  "policy.then_close": "concluir como",
  "policy.then_priority": "prioridade",
  "policy.then_waiting": "marcar como aguardando contato",
  "policy.remove_rule": "Remover regra",
  "policy.sentence.no_inbound_for": "Quando o contato não responde por {hours} horas → concluir como {outcome}",
  "policy.sentence.unanswered_new_for": "Quando um atendimento novo fica {hours} horas sem primeira resposta → prioridade {priority}",
  "policy.sentence.window_expired": "Quando a janela de 24 h fecha → marcar como aguardando contato",
  "policy.practice.title": "Como fica na prática",
  "policy.practice.t0": "Início",
  "policy.practice.t1": "Depois",
  "policy.practice.t2": "{hours} h depois",
  "policy.practice.last_message": "O contato manda a última mensagem.",
  "policy.practice.reply": "A equipe responde, e o contato não volta.",
  "policy.practice.closed": "Concluído como {outcome}, pela política. Nos relatórios aparece como encerrado automaticamente.",
  "policy.practice.other": "As regras valem para os atendimentos de toda a empresa ou da equipe escolhida.",
  "policy.practice.many": "Só a regra mais específica vale para cada conversa: a da campanha, depois a do número, a da equipe e por fim a da empresa. Regras do mesmo nível valem juntas: age a que vencer primeiro.",
  "policy.advanced": "Avançado",
  "policy.gate.when_fails": "Quando uma mensagem não passa",
  "policy.mode_card.log": "Só registrar",
  "policy.mode_card.suggest": "Sugerir ao atendente",
  "policy.mode_card.auto_fix": "Corrigir e enviar",
  "policy.mode_card.block": "Bloquear",
  "policy.mode_hint.log": "Envia como está e anota para os relatórios.",
  "policy.mode_hint.suggest": "Mostra o problema e uma versão corrigida. O atendente escolhe.",
  "policy.mode_hint.auto_fix": "Troca pelo texto corrigido sozinho.",
  "policy.mode_hint.block": "Não envia. O atendente reescreve.",
  "policy.gate.checks": "O que a revisão confere",
  "policy.gate.blocked_chips": "Não deixa passar",
  "policy.gate.blocked_placeholder": "garantido, sem juros",
  "policy.gate.phrases": "Promessas, por frases de exemplo",
  "policy.gate.phrases_placeholder": "garanto que sai, com certeza aprova",
  "policy.gate.phrases_hint": "Pega a frase com maiúsculas, sem acento ou com até três palavras no meio: “garanto que sai” pega “Garanto que sua carta sai”.",
  "policy.gate.domains_chips": "Links só destes sites",
  "policy.gate.judge_label": "Revisão por IA",
  "policy.gate.judge_hint": "Uma segunda IA lê a mensagem com as orientações abaixo.",
  "policy.summary.blocks": "Não deixa passar: {words}",
  "policy.summary.pii": "barra cartão e CPF",
  "policy.summary.links": "links só de {count} site|links só de {count} sites",
  "policy.summary.judge_on": "revisão por IA ligada",
  "policy.summary.judge_off": "sem revisão por IA",
  "policy.example.title": "O que o atendente vê",
  "policy.example.draft": "Garanto que seu crédito é aprovado hoje, sem juros!",
  "policy.example.hint": "O exemplo muda com o que você escolhe acima.",
  "policy.example.log.title": "Enviada como foi escrita",
  "policy.example.log.text": "A revisão anota que prometia aprovação e usava “sem juros”; aparece nos relatórios.",
  "policy.example.suggest.title": "Não enviada: promete aprovação e usa “sem juros”",
  "policy.example.suggest.text": "Sugestão: “Posso verificar as condições e te explicar como funciona a aprovação.” O atendente usa a sugestão ou edita.",
  "policy.example.auto_fix.title": "Enviada já corrigida",
  "policy.example.auto_fix.text": "O contato recebe: “Posso verificar as condições e te explicar como funciona a aprovação.”",
  "policy.example.block.title": "Não enviada",
  "policy.example.block.text": "O atendente vê o motivo e precisa reescrever a mensagem.",
  "templates.not_found": "Esse modelo não existe mais.",
  "errors.ai_key_missing": "Nenhuma chave de IA está configurada. Cadastre uma em Configurações › IA e chaves ou fale com o suporte.",
  "errors.ai_budget_exceeded": "O limite de gasto com IA deste mês foi atingido.",
  "errors.ai_provider_error": "O fornecedor de IA não respondeu direito. Tente de novo em instantes.",
  "errors.ai_provider_timeout": "O fornecedor de IA demorou demais para responder. Tente de novo.",
  "errors.ai_surface_not_configured": "Nenhum modelo de IA foi escolhido para esta tarefa. Fale com o suporte.",
  "errors.ai_capability_unsupported": "O modelo de IA escolhido não faz isso.",
  "errors.ai_provider_unsupported": "Esse fornecedor de IA não é aceito.",
  "templates.cannot_edit": "Só dá para editar rascunhos e modelos recusados ou pausados pela Meta. Para mudar um aprovado, duplique-o.",
  "ai.calls.test": "teste",
  "settings.fields": "Campos do contato",
  "settings.optout": "Descadastro",
  "settings.hours": "Horários de atendimento",
  "settings.search": "Buscar nas configurações",
  "settings.search_empty": "Nada encontrado para “{query}”.",
  "settings.in_section": "em {section}",
  "settings.find.numbers": "whatsapp, conectar, telefone, número, api oficial, qualidade, pin, coexistência, meta",
  "settings.find.templates": "template, hsm, meta, aprovação, marketing, utilidade, mensagem ativa",
  "settings.find.optout": "sair, parar, stop, opt-out, descadastrar, consentimento, não quero mais",
  "settings.find.members": "membros, convidar, atendentes, usuários, papéis, permissões, senha, acesso, login",
  "settings.find.teams": "times, grupos, distribuição, capacidade, rodízio, fila, atribuição automática",
  "settings.find.hours": "expediente, horário comercial, fuso horário, fim de semana, feriado, ausência",
  "settings.find.assistants": "bot, robô, chatbot, persona, instruções, ia, inteligência artificial, testar",
  "settings.find.knowledge": "documentos, pdf, site, faq, perguntas frequentes, conteúdo, coleção",
  "settings.find.learning": "sugestões, melhorias, relatório semanal, análise",
  "settings.find.policies": "encerramento automático, fechar atendimento, revisão de mensagens, gate, palavras proibidas, promessas, prioridade, regex",
  "settings.find.outcomes": "resultado, venda, encerrar, motivo de fechamento, sucesso",
  "settings.find.tags": "tags, marcadores, cores, classificar",
  "settings.find.snippets": "atalhos, mensagens rápidas, textos prontos, playbook",
  "settings.find.fields": "cpf, cnpj, dados do contato, cadastro, campos personalizados, segmentação, importação",
  "settings.find.budgets": "orçamento, limite de gasto, custo, dinheiro, meta",
  "settings.find.limit": "pausar, bloquear envio, estourar orçamento",
  "settings.find.cost_alerts": "alertas, avisos de custo, e-mail, notificação",
  "settings.find.approval": "aprovar campanha, aprovação, campanhas caras",
  "settings.find.frequency": "frequência, intervalo, quantas mensagens, marketing, dias",
  "settings.find.spenders": "quem pode enviar marketing, permissões de envio, modelos",
  "settings.find.insights": "métricas, cliques, template analytics, desempenho de modelos",
  "settings.find.ai_keys": "chaves de ia, openai, anthropic, gemini, claude, gpt, própria chave, api key",
  "settings.find.ai_usage": "uso de ia, custo de ia, tokens, chamadas, orçamento de ia",
  "settings.find.api_keys": "chaves de api, token, integração, desenvolvedor",
  "settings.find.hooks": "webhook de entrada, captura de leads, formulário, site, anúncios",
  "settings.find.webhooks": "webhooks, eventos, notificações, callback, integração",
  "settings.find.crm": "crm, pipedrive, outboundpro, negócios, funil",
  "settings.find.retention": "retenção, apagar dados, guardar, tempo, arquivos",
  "settings.find.export": "exportar, backup, baixar dados, cópia",
  "settings.find.subjects": "lgpd, titular, apagar contato, direito, dados pessoais",
  "fields.lead": "O que a empresa registra de cada contato. Segmentos, campanhas, importação, integrações e o assistente usam estes campos.",
  "fields.ai_short": "a IA preenche",
  "fields.used_by": "Marque “A IA pode preencher” para o assistente gravar o valor durante a conversa.",
  "fields.options_chips": "Opções",
  "fields.options_placeholder": "Escreva uma opção e aperte Enter",
  "optout.keywords_chips": "Palavras que tiram do marketing",
  "optout.keywords_placeholder": "sair, parar, stop",
  "optout.effect": "Quem pede para sair não recebe mais campanhas nem modelos de marketing até pedir para voltar. Mensagens de utilidade e conversas iniciadas pelo contato continuam normalmente.",
  "hours.lead": "Quando cada equipe atende. Fora do horário, o atendimento espera na fila e o fluxo pode responder com a mensagem de ausência.",
  "hours.used_by": "usado por {teams}",
  "hours.unused": "nenhuma equipe usa",
  "hours.empty": "Nenhum horário ainda. Crie um e escolha em cada equipe, em Equipe e pessoas.",
  "hours.where": "Cada equipe escolhe o seu horário em Equipe e pessoas. Nos fluxos, o passo “Horário de atendimento” divide o caminho entre dentro e fora do horário.",
  "hours.short.mon": "seg",
  "hours.short.tue": "ter",
  "hours.short.wed": "qua",
  "hours.short.thu": "qui",
  "hours.short.fri": "sex",
  "hours.short.sat": "sáb",
  "hours.short.sun": "dom",
  "hours.span": "{from} a {to}",
  "hours.always_closed": "Sempre fechado",
  "team.hours_hint": "Os horários que cada equipe pode escolher ficam em",
  "settings.group.channel": "Canal e mensagens",
  "settings.group.service": "Atendimento",
  "settings.group.ai": "Inteligência artificial",
  "settings.group.account": "Conta",
  "settings.marketing": "Regras de marketing",
  "settings.outcomes": "Desfechos",
  "settings.tags": "Etiquetas",
  "settings.snippets": "Respostas prontas",
  "marketing.lead": "Quem recebe marketing e com que frequência: o pedido para sair, o intervalo entre mensagens, quando uma campanha precisa de aprovação e quem pode enviar.",
  "marketing.who": "Quem pode enviar e aprovar",
  "tags.lead": "Marcadores para contatos e atendimentos, com cor. Servem para filtrar, segmentar e nos relatórios.",
  "costs.settings.ai_limit": "Limite de gasto com IA",
  "costs.settings.ai_limit_hint": "Em dólar, como os fornecedores de IA cobram. Ao chegar no limite, só avisa ou para a IA até o mês seguinte.",
  "ai.lead": "As chaves que a IA usa e o uso do mês. O limite de gasto fica em Custos e limites.",
  "ai.own_keys_hint": "Usa as chaves da própria empresa em vez das da plataforma.",
  "ai.limit_is": "Limite mensal de IA: {value}.",
  "ai.no_limit": "Sem limite mensal de IA.",
  "ai.limit_where": "Ajustar em Custos e limites",
  "settings.find.marketing": "marketing, campanhas, regras, consentimento, envio em massa",
  "settings.find.ai_limit": "limite de ia, orçamento de ia, gasto com ia, dólar, bloquear ia",
  "numbers.lead": "Os números de WhatsApp da empresa, conectados pela API oficial da Meta, com a saúde de cada um.",
  "team.lead": "Quem atende e em que equipe. Os papéis dão as permissões; exceções ficam em cada pessoa.",
  "integrations.lead": "Como outros sistemas conversam com o DoneTalk: CRM, chaves de API, entrada de leads e avisos de eventos.",
  "privacy.lead": "Por quanto tempo os dados ficam guardados, a cópia completa da conta e os pedidos das pessoas pela LGPD.",
  "platform.group.customers": "Clientes",
  "platform.group.business": "Comercial",
  "platform.group.platform": "Plataforma",
  "platform.lead.overview": "Como a plataforma está hoje: clientes, atendimentos, mensagens e custos do mês.",
  "platform.lead.customers": "Cada empresa que usa o DoneTalk. Cadastre, acompanhe a implantação e cuide do acesso das pessoas.",
  "platform.lead.plans": "O que cada cliente contrata: limites e recursos de cada plano.",
  "platform.lead.ai": "Chaves das IAs da plataforma, modelos disponíveis, preços e qual modelo faz cada tarefa.",
  "platform.lead.admins": "Quem da Nuvvun entra neste console e o que pode fazer.",
  "platform.lead.audit": "Tudo o que a equipe da Nuvvun fez no console, com quem, quando e o quê.",
  "platform.trial_over": "Teste vencido",
  "platform.trial_until": "Teste até {date}",
  "platform.people": "1 pessoa|{count} pessoas",
  "platform.invited": "1 convite pendente|{count} convites pendentes",
  "platform.onboarding_short": "{done} de {total} etapas",
  "platform.action.customer_created": "Cliente criado",
  "platform.action.customer_updated": "Dados ou situação alterados",
  "platform.action.owner_added": "Dono adicionado",
  "platform.action.provisioned": "Banco de dados criado",
  "platform.action.provision_failed": "Falha ao criar o banco de dados",
  "platform.action.password_link": "Link de nova senha gerado",
  "platform.action.mfa_reset": "Verificação em duas etapas desligada",
  "platform.action.plan_created": "Plano criado",
  "platform.action.plan_updated": "Plano alterado",
  "platform.action.admin_added": "Administrador adicionado",
  "platform.action.admin_removed": "Administrador removido",
  "platform.filter.all": "Todos",
  "platform.owner_and_more": "{email} e mais {count}",
  "platform.no_owner": "Sem dono",
  "platform.created_on": "Criado em {date}",
  "platform.db_state": "Banco: {state}",
  "platform.customers.none_match": "Nenhum cliente com esse nome ou nessa situação.",
  "platform.customers.empty_lead": "Nenhum cliente ainda. Cadastre o primeiro: o dono recebe um convite para criar a senha e começar a implantação.",
  "platform.start.trial": "Em teste por 14 dias",
  "platform.start.active": "Ativo (cliente pagante)",
  "platform.new.create": "Cadastrar cliente",
  "platform.new.done_title": "Cliente cadastrado: {name}",
  "platform.new.done_active": "{email} já tem conta no DoneTalk e já pode entrar neste cliente.",
  "platform.new.done_emailed": "Mandamos o convite para {email}. Se não chegar, envie este link:",
  "platform.new.done_link": "O e-mail não foi enviado. Mande este link para {name} criar a senha:",
  "platform.new.link_hint": "O convite vale 7 dias e só funciona uma vez. Mande por um canal seguro, como o WhatsApp da pessoa.",
  "platform.new.open": "Abrir o cliente",
  "platform.new.another": "Cadastrar outro",
  "platform.new.company": "Empresa",
  "platform.new.slug_taken": "Esse identificador já é de outro cliente. Escolha outro.",
  "platform.new.slug_hint": "Identificador do cliente: {slug}. Aparece nas integrações e na API, nunca no endereço das telas. Letras minúsculas, números e hífen; não muda depois.",
  "platform.new.owner": "Dono da conta",
  "platform.new.owner_hint": "O dono recebe um convite para criar a própria senha. Ninguém da Nuvvun escolhe ou vê a senha.",
  "platform.new.start": "Como começa",
  "platform.new.start_hint": "Em teste, o cliente usa tudo por 14 dias; depois você muda para Ativo em Plano e situação.",
  "platform.link_copied": "Link copiado",
  "common.copy": "Copiar",
  "common.loading": "Carregando…",
  "platform.page.summary": "Resumo",
  "platform.page.company": "Dados",
  "platform.page.people": "Pessoas",
  "platform.page.plan": "Plano e situação",
  "platform.page.numbers": "Números",
  "platform.page.usage": "Uso",
  "platform.page.history": "Histórico",
  "platform.summary.account": "Conta",
  "platform.summary.address": "Identificador",
  "platform.summary.created": "Cliente desde",
  "platform.summary.database": "Banco de dados",
  "platform.summary.owners": "Donos",
  "platform.company.slug_fixed": "O identificador {slug} não muda, para não quebrar as integrações do cliente.",
  "platform.people.title": "1 pessoa|{count} pessoas",
  "platform.people.never": "nunca entrou",
  "platform.people.seen": "último acesso: {when}",
  "platform.people.mfa_on": "duas etapas ligada",
  "platform.people.mfa_off": "duas etapas desligada",
  "platform.people.reinvite": "Reenviar convite",
  "platform.people.password_link": "Gerar link de nova senha",
  "platform.people.hint": "O resto da equipe do cliente é convidado pelo próprio dono, em Configurações › Equipe e pessoas.",
  "platform.people.invite_title": "Convite de {name}",
  "platform.people.seated": "{email} já tinha conta e já pode entrar como dono.",
  "platform.people.password_title": "Link de nova senha para {name}",
  "platform.people.send_invite": "Convidar",
  "platform.lifecycle_hint.trial": "Em teste: o cliente usa tudo até o fim do teste de 14 dias.",
  "platform.lifecycle_hint.active": "Ativo: cliente pagante, com acesso normal.",
  "platform.lifecycle_hint.suspended": "Suspenso: ninguém da empresa entra e as automações param, até você reativar. Os dados ficam guardados.",
  "platform.lifecycle_hint.churned": "Encerrado: o cliente saiu. Ninguém entra e as automações param; os dados seguem a retenção combinada.",
  "platform.plan.trial_ends": "O teste termina em {date}.",
  "platform.numbers.empty": "Nenhum número aqui.",
  "platform.numbers.account": "Conta {name} ({id})",
  "platform.numbers.method.embedded_signup": "cadastro pela Meta",
  "platform.numbers.method.coexistence": "junto com o app WhatsApp Business",
  "platform.numbers.method.token": "token do sistema",
  "platform.numbers.since": "desde {date}",
  "platform.numbers.quality": "Qualidade {value}",
  "platform.numbers.can_send.AVAILABLE": "Pode enviar",
  "platform.numbers.can_send.LIMITED": "Envio limitado",
  "platform.numbers.can_send.BLOCKED": "Bloqueado pela Meta",
  "platform.numbers.status.active": "Ativo",
  "platform.numbers.status.pending": "Pendente",
  "platform.numbers.status.disabled": "Desligado",
  "platform.numbers.status.error": "Com erro",
  "platform.usage.title": "Uso em {month}",
  "platform.usage.conversations_opened": "Atendimentos abertos",
  "platform.usage.conversations_closed": "Atendimentos concluídos",
  "platform.usage.messages_inbound": "Mensagens recebidas",
  "platform.usage.messages_outbound": "Mensagens enviadas",
  "platform.usage.active_contacts": "Contatos ativos",
  "platform.usage.day": "Dia",
  "platform.usage.empty": "Sem movimento neste mês ainda.",
  "platform.confirm.suspended.title": "Suspender {name}?",
  "platform.confirm.suspended.lead": "Ninguém da empresa consegue entrar e os fluxos, assistentes e campanhas param até você reativar. Nada é apagado.",
  "platform.confirm.suspended.button": "Suspender",
  "platform.confirm.churned.title": "Encerrar {name}?",
  "platform.confirm.churned.lead": "Use quando o cliente saiu. Ninguém entra e as automações param. Os dados seguem a retenção combinada até serem apagados.",
  "platform.confirm.churned.button": "Encerrar",
  "platform.admins.count": "1 administrador|{count} administradores",
  "platform.admins.you": "você",
  "platform.admins.since": "desde {date}",
  "platform.admins.only_super": "Só administradores Super adicionam ou removem pessoas.",
  "platform.admins.roles_title": "O que cada papel pode",
  "platform.admins.role_hint.super": "tudo: clientes, planos, IA, administradores e o acesso de qualquer pessoa, inclusive da equipe da Nuvvun.",
  "platform.admins.role_hint.support": "cadastra e acompanha clientes e ajuda no acesso das pessoas deles; não mexe em administradores.",
  "platform.admins.email_label": "E-mail",
  "platform.admins.name": "Nome",
  "platform.admins.new_account": "Esse e-mail ainda não tem conta. Informe o nome: a conta é criada e você recebe um link para a pessoa criar a senha.",
  "platform.admins.added": "{name} agora é administrador.",
  "platform.admins.remove_title": "Remover {name} do console?",
  "platform.admins.remove_lead": "A pessoa deixa de ver o console na hora. A conta dela continua existindo.",
  "platform.admins.link_title": "Link de acesso de {name}",
  "platform.admins.link_lead": "Mande este link para a pessoa criar a senha. Ele vale 3 dias e funciona uma vez.",
  "platform.attention.title": "Precisa de atenção",
  "platform.attention.none": "Nada pedindo atenção agora.",
  "platform.attention.db_failed": "O banco de dados não foi criado",
  "platform.attention.trial_over": "O teste venceu em {date}",
  "platform.attention.trial_ending": "O teste termina em {date}",
  "platform.attention.invite_pending": "O dono ainda não aceitou o convite",
  "platform.attention.urgent": "Resolver",
  "platform.attention.soon": "Acompanhar",
  "settings.plan": "Plano",
  "settings.find.plan": "plano assinatura mensalidade preço limites contrato cota clientes atendidos",
  "plan.lead": "O que a empresa contratou, o que está incluído e quanto de cada limite já está em uso.",
  "plan.none": "Nenhum plano definido ainda: nada é limitado. Fale com a Nuvvun para escolher o seu.",
  "plan.on_request": "Sob consulta",
  "plan.per_month": "{price}/mês",
  "plan.usage": "Uso agora",
  "plan.label.customers_month": "Clientes atendidos no mês",
  "plan.label.channels": "Números de WhatsApp",
  "plan.label.members": "Pessoas",
  "plan.label.flows_published": "Fluxos publicados",
  "plan.label.assistants_active": "Assistentes ativos",
  "plan.label.ai_usd_month": "IA paga pela plataforma no mês",
  "plan.short.channels": "Números",
  "plan.short.ai_usd_month": "IA por mês",
  "plan.feature.campaigns": "Campanhas",
  "plan.feature.api": "API e integrações",
  "plan.feature.gate": "Revisão do que é dito antes de enviar",
  "plan.feature.sso": "Login pela conta da empresa (SSO)",
  "plan.feature.dedicated_db": "Servidor de banco de dados exclusivo",
  "plan.extra_hint": "Passando de {quota} clientes atendidos no mês, cada cliente a mais custa {price}.",
  "plan.change_hint": "Para mudar de plano, fale com a Nuvvun. No limite, só o que é novo fica bloqueado: o que já funciona continua funcionando.",
  "plan.no_limit": "{used} · sem limite",
  "plan.used_of": "{used} de {limit}",
  "plan.limit.channels": "1 número de WhatsApp|{count} números de WhatsApp",
  "plan.limit.members": "1 pessoa|{count} pessoas",
  "plan.limit.flows_published": "1 fluxo publicado|{count} fluxos publicados",
  "plan.limit.assistants_active": "1 assistente ativo|{count} assistentes ativos",
  "plan.limit.ai_usd_month": "US$ {max} de IA por mês",
  "plan.limit.customers_month": "{max} clientes atendidos por mês",
  "errors.plan_limit": "Seu plano permite {what}. Para ter mais, fale com a Nuvvun. O que já funciona continua funcionando.",
  "platform.plans.active": "Ativo",
  "platform.plans.inactive": "Inativo",
  "platform.plans.customers_count": "1 cliente neste plano|{count} clientes neste plano",
  "platform.plans.empty": "Nenhum plano ainda.",
  "platform.plans.identity": "Plano",
  "platform.plans.description": "Descrição para o cliente",
  "platform.plans.translations": "Nome e descrição em inglês e espanhol",
  "platform.plans.name_en": "Nome em inglês",
  "platform.plans.name_es": "Nome em espanhol",
  "platform.plans.description_en": "Descrição em inglês",
  "platform.plans.description_es": "Descrição em espanhol",
  "platform.plans.sort": "Ordem na lista",
  "platform.plans.price": "Preço",
  "platform.plans.monthly": "Mensalidade (R$)",
  "platform.plans.extra": "Cada cliente atendido além da cota (R$)",
  "platform.plans.price_hint": "Mensalidade vazia = sob consulta. As mensagens da Meta são sempre à parte: o cliente paga direto à Meta.",
  "platform.plans.unlimited": "Sem limite",
  "platform.plans.limits_hint": "Vazio = sem limite. O cliente é avisado a partir de 80% e, no limite, só o que é novo fica bloqueado.",
  "platform.plans.features_hint": "Aparecem para o cliente em Configurações › Plano.",
  "platform.plans.hint.customers_month": "Contatos que escreveram no mês, cada um uma vez. Nunca bloqueia: o excedente é cobrado.",
  "platform.plans.hint.channels": "Números conectados. Bloqueia conectar mais um.",
  "platform.plans.hint.members": "Pessoas com acesso, contando convites. Bloqueia convidar mais uma.",
  "platform.plans.hint.flows_published": "Bloqueia publicar mais um fluxo.",
  "platform.plans.hint.assistants_active": "Bloqueia ativar mais um assistente.",
  "platform.plans.hint.ai_usd_month": "Em dólar, só o que a plataforma paga; a chave de IA do próprio cliente não conta. No limite, a IA para até o mês virar.",
  "email.support.subject": "O suporte da Nuvvun entrou no DoneTalk da {workspace}",
  "email.support.body_view": "{who}, do suporte da Nuvvun, entrou no DoneTalk da {workspace} só para olhar, até {until}.",
  "email.support.body_edit": "{who}, do suporte da Nuvvun, entrou no DoneTalk da {workspace} com permissão para ajustar configurações, até {until}.",
  "email.support.reason": "Motivo: {reason}",
  "email.support.button": "Ver ou encerrar o acesso",
  "email.support.why": "Você recebe este aviso porque é dono da conta. Tudo o que o suporte faz fica na Auditoria, e você pode desligar o acesso do suporte em Configurações › Dados e privacidade.",
  "platform.support.enter": "Entrar como suporte",
  "platform.support.open": "Abrir como suporte",
  "platform.support.until": "Suporte até {time}",
  "platform.support.end": "Encerrar acesso",
  "platform.support.title": "Entrar como suporte em {name}",
  "platform.support.lead": "O acesso fica registrado para a Nuvvun e para o cliente, os donos recebem um aviso por e-mail e o cliente pode encerrá-lo a qualquer momento.",
  "platform.support.reason": "Motivo (o cliente vê)",
  "platform.support.reason_placeholder": "Ex.: a Maria pediu ajuda para configurar o fluxo de boas-vindas",
  "platform.support.duration": "Por quanto tempo",
  "platform.support.minutes.30": "30 minutos",
  "platform.support.minutes.60": "1 hora",
  "platform.support.minutes.120": "2 horas",
  "platform.support.minutes.240": "4 horas",
  "platform.support.level": "O que você pode fazer",
  "platform.support.level.view": "Só olhar",
  "platform.support.level.edit": "Ajustar configurações",
  "platform.support.level_hint.view": "Vê tudo como um auditor, sem mudar nada.",
  "platform.support.level_hint.edit": "Muda configurações como um administrador. Não mexe em donos nem no plano.",
  "platform.support.confirm": "Entrar",
  "platform.support.off": "Este cliente desligou o acesso do suporte. Um administrador dele religa em Configurações › Dados e privacidade.",
  "platform.support.ended": "Acesso de suporte encerrado.",
  "platform.action.support_started": "Acesso de suporte iniciado",
  "platform.action.support_ended": "Acesso de suporte encerrado",
  "support.banner": "Você está como suporte da Nuvvun em {name}, {level}, até {time}",
  "support.leave": "Encerrar e sair",
  "support.title": "Acesso do suporte da Nuvvun",
  "support.lead": "Quando você pede ajuda, alguém da Nuvvun pode entrar aqui por um tempo limitado, com o motivo registrado. Os donos recebem um aviso por e-mail, tudo fica na Auditoria e você pode encerrar a qualquer momento.",
  "support.allow": "Permitir que o suporte da Nuvvun entre quando precisar",
  "support.none": "Ninguém do suporte está aqui agora.",
  "support.session": "{name} · {level} · até {time}",
  "support.session_reason": "Motivo: {reason}",
  "support.end": "Encerrar",
  "support.level.view": "só olhando",
  "support.level.edit": "podendo ajustar configurações",
  "errors.support_access_off": "O acesso do suporte está desligado para este cliente.",
  "errors.customer_not_open": "Este cliente não está ativo agora.",
  "errors.support_cannot_change_consent": "Só a própria empresa liga ou desliga o acesso do suporte.",
  "settings.find.support": "suporte nuvvun acesso ajuda atendimento técnico consentimento",
  "phone.ddi": "DDI",
  "phone.number": "DDD e telefone",
  "phone.invalid": "Confira o número. Para este país ele fica assim: {example}",
  "template.no_number": "Nenhum número de WhatsApp conectado ainda. Os modelos vêm da conta do WhatsApp do número: conecte um para usá-los.",
  "template.connect_number": "Conectar um número",
  "template.sync_now": "Sincronizar com a Meta",
  "template.create": "Criar modelo",
  "template.synced": "1 modelo trazido da Meta.|{count} modelos trazidos da Meta.",
  "template.synced_none": "A Meta não devolveu nenhum modelo para esta conta.",
  "mobile.tab.you": "Você",
  "mobile.company": "Empresa",
  "mobile.switch_company": "Trocar de empresa",
  "mobile.mfa_setup": "Para usar o app, ative a verificação em duas etapas no DoneTalk pelo computador (Segurança) e entre de novo.",
  "mobile.soon": "Chega na próxima versão do app.",
  "mobile.signin_title": "Entrar no DoneTalk",
  "mobile.today": "Hoje",
  "push.queue.title": "Novo atendimento na fila",
  "push.assigned.title": "Atendimento com você",
  "push.assigned.body": "{name} agora é seu.",
  "push.campaign.title": "Campanha esperando sua aprovação",
  "push.cost.title": "Alerta de custo",
  "push.cost.body": "Veja em Custos e limites.",
  "mobile.faceid": "Abrir com Face ID",
  "mobile.faceid_reason": "Desbloquear o DoneTalk",
  "mobile.locked": "O DoneTalk está bloqueado.",
  "mobile.unlock": "Desbloquear",
  "mobile.notifications": "Notificações",
  "mobile.security": "Segurança e Face ID",
  "mobile.faceid_hint": "O app pede o Face ID ao abrir e depois de um minuto fora dele.",
  "mobile.mfa_hint": "Para desativar ou gerar novos códigos de recuperação, use o DoneTalk no computador.",
  "mobile.group.service_hint": "horários, desfechos…",
  "mobile.group.ai": "Automação e IA",
  "mobile.group.ai_hint": "fluxos, assistentes…",
  "mobile.group.account": "Conta da empresa",
  "mobile.group.account_hint": "plano, custos…",
  "mobile.push.lead": "O DoneTalk avisa neste celular quando:",
  "mobile.push.rule.message": "chega mensagem num atendimento seu",
  "mobile.push.rule.queue": "um atendimento entra na fila da sua equipe",
  "mobile.push.rule.assigned": "alguém passa um atendimento para você",
  "mobile.push.rule.mention": "alguém menciona você numa nota",
  "mobile.push.rule.campaign": "uma campanha espera sua aprovação",
  "mobile.push.rule.cost": "um limite de custo está perto de ser atingido",
  "mobile.push.presence": "A fila só avisa quem está Online. Em Offline, mensagens e atendimentos passados para você ficam sem aviso; menções, aprovações e custos avisam sempre.",
  "mobile.push.system": "Ajustes de notificação do celular",
  "mobile.numbers.approved": "1 aprovado|{count} aprovados",
  "mobile.numbers.sending": "Envio",
  "mobile.numbers.sync_templates": "Sincronizar modelos",
  "mobile.numbers.connect_other": "Conectar outro número",
  "mobile.numbers.connect_hint": "Abre a janela oficial da Meta num navegador dentro do app. Você entra no DoneTalk com seu e-mail, depois no Facebook de quem administra a empresa, escolhe o portfólio e confirma o número por SMS.",
  "mobile.team.more": "Equipes, horários e permissões",
  "mobile.team.role_changed": "Papel alterado",
  "mobile.flows.starts": "Começa quando",
  "mobile.flows.trigger.channel_default": "Nova conversa no número",
  "mobile.flows.trigger.keyword": "Mensagem com: {words}",
  "mobile.flows.trigger.out_of_hours": "Mensagem fora do horário",
  "mobile.flows.trigger.api": "Chamada pela API",
  "mobile.flows.trigger.template_reply": "Resposta a um modelo",
  "mobile.flows.trigger.assistant_tool": "O assistente de IA inicia o fluxo",
  "mobile.flows.trigger.manual": "Uma pessoa inicia o fluxo",
  "mobile.flows.trigger.none": "Nenhum gatilho ainda",
  "mobile.flows.version_line": "Versão {n} publicada",
  "mobile.flows.draft_line": "rascunho com mudanças",
  "mobile.flows.not_published": "Ainda não publicado",
  "mobile.flows.changed": "alterado",
  "mobile.flows.other_blocks": "Outros blocos",
  "mobile.flows.phone_note": "No celular: ver, testar, publicar, voltar versão e editar textos. Para mudar caminhos e blocos, use o computador ou o iPad.",
  "mobile.flows.edit_text": "Editar texto",
  "mobile.flows.publish_confirm": "As próximas conversas usam a nova versão. As que já estão no fluxo terminam na versão em que começaram.",
  "mobile.flows.restore_confirm": "Voltar para a versão {n}? Ela é publicada de novo, como uma versão nova.",
  "mobile.flows.no_draft": "Nada novo para publicar",
  "mobile.mfa_hint_off": "Para ativar, use o DoneTalk no computador: ele mostra o QR code para o app autenticador.",
  "contact.marketing": "Mensagens de marketing",
  "contact.marketing_hint": "Campanhas de marketing vão para quem aceita e para quem está sem registro. Quem não aceita fica de fora.",
  "onboarding.guide.team.role_supervisor": "Supervisor: acompanha as filas, distribui, transfere e vê os relatórios.",
  "onboarding.guide.team.role_auditor": "Auditor: vê tudo, sem mudar nada.",
  "onboarding.guide.team.hours_next": "Depois das equipes, ligue o horário de atendimento a elas. Fora dele, o atendimento espera na fila.",
  "onboarding.guide.team.hours_cta": "Abrir horários",
  "onboarding.guide.hours.title": "Horário de atendimento",
  "onboarding.guide.hours.text": "O horário do questionário já está salvo aqui. Falta ligá-lo às equipes: fora dele, o atendimento espera na fila e a entrada pode mandar a mensagem de ausência.",
  "onboarding.guide.hours.no_teams": "Ainda não há equipes. Crie as equipes primeiro e volte aqui para ligar o horário.",
  "onboarding.guide.hours.without": "1 equipe ainda está sem horário.|{count} equipes ainda estão sem horário.",
  "onboarding.guide.hours.link": "Usar este horário nas equipes",
  "onboarding.guide.hours.linked": "Horário ligado a 1 equipe.|Horário ligado a {count} equipes.",
  "onboarding.guide.hours.all_linked": "Todas as equipes já têm horário.",
  "onboarding.guide.hours.where_title": "Horários diferentes por equipe",
  "onboarding.guide.hours.where_text": "Crie outro horário aqui e escolha-o na equipe, em Equipe e pessoas.",
  "onboarding.guide.hours.ready": "O horário salvo e ligado às equipes. É recomendado.",
  "onboarding.guide.whatsapp.ready": "O número está ativo. O nome de exibição segue em análise, e dá para usar enquanto isso.",
  "onboarding.guide.optout.title": "Quem não quer receber marketing",
  "onboarding.guide.optout.frequency_title": "Frequência e aprovação",
  "onboarding.guide.optout.frequency_text": "Nesta mesma tela ficam o intervalo entre campanhas para o mesmo contato e quando uma campanha precisa de aprovação. Os padrões já protegem a empresa; ajuste quando for fazer a primeira campanha.",
  "onboarding.guide.optout.ready": "As palavras e a resposta salvas. É recomendado.",
  "onboarding.guide.optout.back_templates": "Voltar aos modelos",
  "onboarding.guide.budget.title": "Orçamento do mês",
  "onboarding.guide.budget.text": "Diga quanto a empresa pode gastar por mês com a Meta e a IA. Sem orçamento, nada é limitado: é o jeito de evitar surpresa na fatura antes das campanhas.",
  "onboarding.guide.budget.limit_title": "O que acontece no limite",
  "onboarding.guide.budget.limit_text": "Comece com “Só avisar” para conhecer o gasto. Depois, dá para pausar campanhas ou todo envio pago quando o orçamento chegar a 100%. Quem cuida dos custos recebe os alertas.",
  "onboarding.guide.budget.short": "Defina quanto a empresa pode gastar por mês com a Meta e a IA, e o que acontece perto do limite.",
  "onboarding.guide.budget.cta": "Abrir custos e limites",
  "onboarding.guide.budget.ready": "Um orçamento mensal salvo para a empresa. É recomendado.",
  "onboarding.guide.knowledge.title": "Base de conhecimento",
  "onboarding.guide.knowledge.text": "O que o assistente sabe sobre a empresa: o site, PDFs e textos. Ele responde só com o que está aqui.",
  "onboarding.guide.knowledge.ready_count": "1 documento pronto na base.|{count} documentos prontos na base.",
  "onboarding.guide.knowledge.none": "O assistente só conta como pronto com pelo menos um documento na base de conhecimento.",
  "onboarding.guide.knowledge.cta": "Abrir base de conhecimento",
  "onboarding.guide.knowledge.back": "Voltar aos assistentes",
  "onboarding.rehearsal.ready_text": "O atendimento de teste concluído com um desfecho.",
  "onboarding.step.outbound.budget": "Orçamento do mês",
  "onboarding.when.outbound.budget": "Pronto quando houver um orçamento mensal para a empresa.",
  "onboarding.done.outbound.budget": "Orçamento do mês definido",
  "onboarding.lead.outbound.budget": "Defina quanto a empresa pode gastar por mês com a Meta e a IA, e o que acontece perto do limite.",
  "onboarding.detail.budget": "Até {amount} por mês",
  "onboarding.live.beyond.campaigns.title": "Campanhas",
  "onboarding.live.beyond.campaigns.text": "Um modelo aprovado para um segmento de contatos, com custo por resposta e por venda.",
  "onboarding.live.beyond.costs.title": "Custos e limites",
  "onboarding.live.beyond.costs.text": "Quanto a Meta e a IA custam, por número, equipe e campanha, com orçamento e alertas.",
  "onboarding.guide.hours.text_empty": "Crie aqui o horário em que a empresa atende e ligue-o às equipes: fora dele, o atendimento espera na fila e a entrada pode mandar a mensagem de ausência.",
  "onboarding.guide.hours.create_first": "Crie o primeiro horário em “Novo horário”. Depois, ele pode ir para todas as equipes de uma vez.",
  "push.number_code.title": "Código do WhatsApp chegou",
  "push.number_code.body": "{code} é o código para o número {number}.",
  "push.number_return.title": "Número ainda não ligado ao WhatsApp",
  "push.number_return.body": "Se {number} não for ligado ao WhatsApp, ele é devolvido em {date}, sem cobrança.",
  "numbers.connect.two_paths": "Use um número que a empresa já tem, ou contrate um aqui mesmo.",
  "numbers.connect.own_title": "Já tenho um número",
  "numbers.connect.own_price": "Sem custo extra",
  "numbers.connect.own_time": "uns 10 minutos",
  "numbers.connect.rent_title": "Contratar um número pelo DoneTalk",
  "numbers.connect.new": "Novo",
  "numbers.connect.rent_text": "Um número de celular novo, só para o WhatsApp da empresa. Sem chip e sem celular: o código da Meta chega aqui.",
  "numbers.connect.rent_ddd": "Você escolhe o DDD",
  "numbers.connect.rent_fast": "Pronto em uns 5 minutos",
  "numbers.connect.rent_app": "Funciona pelo DoneTalk; não serve para o app WhatsApp Business do celular",
  "numbers.connect.rent_cta": "Contratar número",
  "numbers.connect.rent_ask": "Peça a um Dono ou Administrador",
  "numbers.connect.rent_billing": "junto com o plano, a partir da ativação",
  "numbers.rent.title": "Contratar um número",
  "numbers.rent.lead": "Escolha o DDD. O número em si é sorteado entre os disponíveis.",
  "numbers.rent.search": "Cidade, estado ou DDD",
  "numbers.rent.ddds": "DDDs disponíveis",
  "numbers.rent.out_of_stock": "O DDD {ddd} está sem números agora. Tente outro ou volte mais tarde.",
  "numbers.rent.none": "Nenhum DDD encontrado.",
  "numbers.rent.summary": "Número de celular com DDD {ddd}",
  "numbers.rent.per_month": "{price} por mês",
  "numbers.rent.cond_billing": "Cobrado junto com o plano a partir do dia em que o número for ativado no WhatsApp.",
  "numbers.rent.cond_owner": "O número é fornecido pela Nuvvun e fica com a sua empresa enquanto for cliente. Se sair, pode pedir a transferência da linha ({fee}).",
  "numbers.rent.cond_cancel": "Pode cancelar quando quiser: vale no fim do ciclo, e o mês em curso é cobrado inteiro.",
  "numbers.rent.cond_app": "Funciona só pelo DoneTalk, na API oficial do WhatsApp; não serve para o app WhatsApp Business do celular.",
  "numbers.rent.plan_place": "Conta no limite de números do plano: este será o {n}º de {max}.",
  "numbers.rent.plan_full": "O plano já está no limite de números",
  "numbers.rent.sandbox": "Ambiente de teste da Salvy: o número é de mentira, não recebe SMS de verdade e não é cobrado. Só a equipe da Nuvvun vê esta opção.",
  "numbers.rent.accept": "Li e aceito as",
  "numbers.rent.terms": "condições do número contratado",
  "numbers.rent.confirm": "Contratar por {price}/mês",
  "numbers.rent.done": "Número contratado. Agora é só ligar ao WhatsApp.",
  "numbers.rented.awaiting": "Esperando o código",
  "numbers.rented.sandbox": "Teste (sandbox)",
  "numbers.rented.not_billed": "Ainda sem cobrança",
  "numbers.rented.your_number": "Seu número novo",
  "numbers.rented.copy_number": "Copiar número",
  "numbers.rented.number_copied": "Número copiado, sem o +55",
  "numbers.rented.phase1_title": "Agora ligue o número ao WhatsApp",
  "numbers.rented.phase1_step1": "Clique em “Conectar com a Meta” e entre com o Facebook de quem administra a empresa.",
  "numbers.rented.phase1_step2": "Quando a Meta pedir o número, escolha adicionar um novo número e cole o número acima.",
  "numbers.rented.phase1_step3": "Escolha receber o código por SMS (este número não recebe ligações).",
  "numbers.rented.phase1_step4": "Copie o código que aparece aqui ao lado e cole na janela da Meta.",
  "numbers.rented.phase1_hint": "Se precisar parar, o número fica guardado aqui. A cobrança só começa quando ele estiver ativo.",
  "numbers.rented.phase2_title": "Ligar ao WhatsApp da empresa",
  "numbers.rented.phase2_lead": "Na janela da Meta você só escolhe a empresa e a conta do WhatsApp. O DoneTalk adiciona o número, confirma o código e registra, sem nada para digitar.",
  "numbers.rented.display_name": "Nome que os clientes vão ver",
  "numbers.rented.phase2_start": "Ligar com a Meta",
  "numbers.rented.step_rented": "Número contratado com DDD {ddd}",
  "numbers.rented.step_adding": "Adicionando o número à conta do WhatsApp",
  "numbers.rented.step_requesting": "Pedindo o código à Meta",
  "numbers.rented.step_awaiting": "Esperando o SMS com o código",
  "numbers.rented.step_verifying": "Confirmando o código",
  "numbers.rented.step_registering": "Registrando com o PIN de segurança",
  "numbers.rented.phase2_failed": "Não deu certo: {reason}",
  "numbers.rented.retry": "Tentar de novo",
  "numbers.rented.returns": "Se não for ligado ao WhatsApp até {date}, o número é devolvido sem cobrança.",
  "numbers.rented.swap": "Trocar de número",
  "numbers.rented.swap_confirm": "Devolver este número e contratar outro? Ele ainda não foi usado, então não há cobrança.",
  "numbers.rented.simulate": "Simular SMS da Meta",
  "numbers.rented.code_title": "Código do WhatsApp",
  "numbers.rented.code_at": "Chegou às {time} por SMS",
  "numbers.rented.copy_code": "Copiar código",
  "numbers.rented.code_copied": "Código copiado",
  "numbers.rented.code_arrived": "O código do WhatsApp chegou",
  "numbers.rented.code_waiting": "Esperando o SMS da Meta…",
  "numbers.rented.code_waiting_hint": "Costuma chegar em segundos. Se passar de 2 minutos, peça outro código na janela da Meta.",
  "numbers.rented.raw_title": "Outro SMS recebido|{count} outros SMS recebidos",
  "numbers.rented.code_app": "Também avisamos no app do celular de quem contratou.",
  "numbers.rented.by_donetalk": "Contratado pelo DoneTalk",
  "numbers.rented.active_line": "{price}/mês · ativo desde {since} · próxima cobrança em {next}",
  "numbers.rented.cancel_line": "Cancelamento agendado: o número funciona até {date}.",
  "numbers.rented.transfer_line": "Transferência pedida em {date}. A equipe do DoneTalk vai falar com você; o número segue funcionando.",
  "numbers.rented.transferred_line": "A linha foi transferida para a sua empresa.",
  "numbers.rented.sms_title": "Códigos e SMS recebidos",
  "numbers.rented.sms_none": "Nenhum SMS recebido ainda.",
  "numbers.rented.sms_code": "Código",
  "numbers.rented.undo": "Desfazer o cancelamento",
  "numbers.rented.take": "Levar o número",
  "numbers.rented.cancel": "Cancelar o número",
  "numbers.rented.cancel_title": "Cancelar o número {number}?",
  "numbers.rented.cancel_lead": "O cancelamento vale no fim do ciclo.",
  "numbers.rented.cancel_1": "Até lá o número segue atendendo normalmente.",
  "numbers.rented.cancel_2": "No fim do ciclo, o DoneTalk desliga o número no WhatsApp e encerra a linha. As conversas continuam no histórico.",
  "numbers.rented.cancel_3": "Por 6 meses, o DoneTalk não entrega este número a nenhuma outra empresa.",
  "numbers.rented.cancel_4": "Depois de encerrado, o número não volta. Se quiser ficar com ele, peça a transferência.",
  "numbers.rented.cancel_digits": "Para confirmar, digite os 4 últimos dígitos do número",
  "numbers.rented.keep": "Manter o número",
  "numbers.rented.cancel_confirm": "Cancelar no fim do ciclo",
  "numbers.rented.cancel_done": "Cancelamento agendado. Dá para desfazer até a data.",
  "numbers.rented.take_title": "Levar o número",
  "numbers.rented.take_lead": "Para passar a linha para o nome da sua empresa, com outra operadora ou fora do DoneTalk.",
  "numbers.rented.take_1": "Você envia o pedido por aqui.",
  "numbers.rented.take_2": "A equipe do DoneTalk responde em até 2 dias úteis com o que precisa (normalmente o CNPJ e quem assina).",
  "numbers.rented.take_3": "O número segue funcionando até a transferência terminar.",
  "numbers.rented.take_fee": "Taxa de transferência: {fee}, cobrada uma vez junto com o plano.",
  "numbers.rented.take_note": "Algo que a equipe precise saber? (opcional)",
  "numbers.rented.take_confirm": "Pedir a transferência",
  "numbers.rented.transfer_done": "Pedido enviado. A equipe do DoneTalk vai falar com você.",
  "errors.numbers_unavailable": "A contratação de números não está disponível agora. Tente de novo em instantes ou fale com a Nuvvun.",
  "errors.area_code_out_of_stock": "Este DDD ficou sem números agora. Escolha outro.",
  "errors.numbers_provider_error": "A operadora do número não respondeu. Tente de novo em instantes.",
  "errors.number_not_found": "Número não encontrado.",
  "errors.number_not_cancellable": "Este número não pode ser cancelado agora.",
  "errors.number_not_cancel_scheduled": "Este número não tem cancelamento agendado.",
  "errors.number_not_transferable": "A transferência só pode ser pedida para um número ativo.",
  "errors.number_not_transfer_requested": "Este número não tem pedido de transferência.",
  "errors.number_not_awaiting": "Este número já foi ligado ao WhatsApp.",
  "errors.auto_attach_off": "A ligação automática ainda não está disponível. Use “Conectar com a Meta”.",
  "errors.attach_not_failed": "Nada para tentar de novo.",
  "errors.sandbox_only": "Só no ambiente de teste.",
  "plan.addon.title": "Adicionais",
  "plan.addon.numbers": "Números contratados pelo DoneTalk",
  "plan.addon.count": "{count} × {price} neste mês|{count} × {price} neste mês",
  "plan.addon.awaiting": "esperando ligar ao WhatsApp, ainda sem cobrança",
  "plan.addon.since": "ativo desde {date}",
  "plan.addon.ends": "cancelamento agendado, encerra em {date}",
  "plan.addon.closed": "encerrado em {date}",
  "plan.addon.transferred": "transferido para a empresa",
  "plan.addon.total": "Total do mês, sem as mensagens da Meta",
  "plan.addon.hint": "As mensagens da Meta continuam cobradas pela Meta, direto no cartão da empresa. O adicional dos números é cobrado pela Nuvvun junto com o plano.",
  "plan.addon.rented_count": "1 contratado pelo DoneTalk|{count} contratados pelo DoneTalk",
  "platform.tab.numbers": "Números contratados",
  "platform.lead.numbers": "As linhas da Salvy que o DoneTalk fornece aos clientes: quem usa, quanto rende e custa, e o que está pendente.",
  "platform.numbers.kpi.active": "Ativos",
  "platform.numbers.kpi.charged": "Cobrado no mês",
  "platform.numbers.kpi.paid": "Pago à Salvy",
  "platform.numbers.kpi.margin": "Sobra no mês",
  "platform.numbers.kpi.fees": "Taxas de transferência",
  "platform.numbers.filter.all": "Todos",
  "platform.numbers.filter.awaiting": "Esperando ligar",
  "platform.numbers.filter.cancel": "Cancelamento agendado",
  "platform.numbers.filter.transfer": "Transferência pedida",
  "platform.numbers.filter.quarantine": "Quarentena",
  "platform.numbers.col.number": "Número",
  "platform.numbers.col.customer": "Cliente",
  "platform.numbers.col.state": "Situação",
  "platform.numbers.col.next": "Próximo passo",
  "platform.numbers.col.action": "Ação",
  "platform.numbers.state.awaiting_code": "Esperando ligar ao WhatsApp",
  "platform.numbers.state.active": "Ativo",
  "platform.numbers.state.cancel_scheduled": "Cancelamento agendado",
  "platform.numbers.state.transfer_requested": "Transferência pedida",
  "platform.numbers.state.transferred": "Transferido",
  "platform.numbers.state.quarantine": "Quarentena",
  "platform.numbers.state.closed": "Encerrado",
  "platform.numbers.next.returns": "devolvido sozinho em {date} se não for ligado",
  "platform.numbers.next.active": "cobrado desde {date}",
  "platform.numbers.next.ends": "encerra em {date}",
  "platform.numbers.next.transfer": "falar com o cliente sobre a transferência",
  "platform.numbers.next.transferred": "transferido em {date}",
  "platform.numbers.next.free_on": "livre em {date}",
  "platform.numbers.next.closed": "encerrado em {date}",
  "platform.numbers.mark_transferred": "Marcar como transferido",
  "platform.numbers.cancel_cycle": "Cancelar no fim do ciclo",
  "platform.numbers.cancel_now": "Cancelar agora",
  "platform.numbers.cancel_now_confirm": "Cancelar {number} agora? Ele sai do WhatsApp na hora e entra na quarentena.",
  "platform.numbers.cancel_cycle_confirm": "Agendar o cancelamento de {number} para o fim do ciclo?",
  "platform.numbers.hint": "A quarentena vale dentro do DoneTalk: um número em quarentena nunca é entregue a outro cliente; se a Salvy sortear um deles numa contratação nova, o DoneTalk devolve e pede outro. Linhas de teste (sandbox) não entram nos totais.",
  "platform.action.number_rented": "Número contratado pelo DoneTalk",
  "platform.action.number_transfer_requested": "Transferência de número pedida",
  "platform.action.number_transferred": "Número transferido ao cliente",
  "platform.action.number_cancelled": "Número cancelado pela Nuvvun",
  "onboarding.q.number": "Qual número vai usar no WhatsApp oficial?",
  "onboarding.q.number_hint": "Sem número livre? O DoneTalk fornece um, com o DDD que você escolher.",
  "onboarding.number.app": "O do WhatsApp Business do celular",
  "onboarding.number.own": "Um número livre da empresa",
  "onboarding.number.rent": "Quero contratar um pelo DoneTalk",
  "onboarding.guide.rent_title": "Não tem um número livre?",
  "onboarding.guide.rent_text": "Contrate um aqui por {price}/mês. Você escolhe o DDD, o código da Meta chega na tela e a conexão termina em uns 5 minutos.",
  "onboarding.guide.rent_cta": "Contratar um número",
  "onboarding.guide.rented_title": "Seu número contratado está pronto",
  "onboarding.guide.rented_text": "Falta ligar {number} ao WhatsApp: siga os passos no cartão do número. O código da Meta aparece lá.",
  "onboarding.guide.whatsapp.q_rent_app": "Posso usar o número contratado no celular?",
  "onboarding.guide.whatsapp.a_rent_app": "Não. Ele funciona só pelo DoneTalk, na API oficial. Para atender também pelo app do celular, conecte o número que você já usa nele.",
  "onboarding.guide.whatsapp.q_rent_owner": "O número contratado é meu?",
  "onboarding.guide.whatsapp.a_rent_owner": "Ele é fornecido pela Nuvvun e fica com a sua empresa enquanto for cliente. Se sair, você pode pedir a transferência da linha.",
  "onboarding.detail.rented_waiting": "Número contratado ({number}), falta ligar na Meta",
  "mobile.numbers.rented_paste": "Cole o código na janela da Meta, no computador. Contratado pelo DoneTalk; ainda sem cobrança.",
  "numbers.rented.code_received": "Código recebido",
  "plan.addon.count_none": "Nada cobrado neste mês ainda",
  "numbers.rent.plan_full_line": "O plano já usa os {max} números que permite. Para contratar mais um, fale com a Nuvvun para mudar de plano.",
  "page.unsaved_bar": "Você tem alterações não salvas",
  "platform.ai.base_url": "Endereço da API (opcional)",
  "platform.ai.default_key": "Chave padrão deste provedor",
  "platform.ai.auto": "Automático",
  "platform.ai.manual": "Escolhido à mão",
  "platform.ai.back_to_auto": "voltar ao automático",
  "platform.ai.task_retiring": "{model} se aposenta em {date}; o substituto é {next}.",
  "platform.ai.task_manual_until": "{model} se aposenta em {date}. Como foi escolhido à mão, fica até lá e então passa para {next}.",
  "platform.ai.task_retiring_alone": "{model} se aposenta em {date} e ainda não tem substituto. Escolha outro modelo.",
  "platform.ai.task_replaced": "Trocado automaticamente de {from} em {date}.",
  "platform.ai.task_moved": "{task}: {from} → {to} (aposentadoria anunciada)",
  "platform.ai.task_moved_retired": "{task}: {from} → {to} (modelo aposentado)",
  "platform.ai.catalog_added": "{count} modelo novo no catálogo|{count} modelos novos no catálogo",
  "platform.ai.replaced_by": "substituto: {model}",
  "platform.ai.col.mode": "Tipo",
  "platform.ai.mode.chat": "Conversa",
  "platform.ai.mode.embedding": "Embeddings",
  "platform.ai.mode.audio_transcription": "Transcrição",
  "platform.ai.surfaces_hint": "Automático: quando o fornecedor anuncia a aposentadoria de um modelo, a tarefa passa sozinha para o substituto. Escolher outro modelo aqui fixa a escolha até o dia da aposentadoria; a partir desse dia, as chamadas vão para o substituto, inclusive as dos clientes que escolheram o modelo.",
  "builder.arrange": "Organizar",
  "builder.arrange_selection": "Organizar seleção",
  "builder.arrange_hint": "Arruma os blocos da esquerda para a direita, com menos linhas se cruzando, e mostra o fluxo inteiro na tela (Shift+Alt+T). Com vários blocos selecionados, arruma só eles.",
  "builder.arranged": "Blocos organizados",
  "builder.selection_count": "{count} bloco selecionado|{count} blocos selecionados",
  "builder.duplicate": "Duplicar",
  "builder.duplicated": "{count} bloco duplicado|{count} blocos duplicados",
  "builder.delete_selected": "Excluir",
  "builder.deleted_many": "{count} bloco excluído|{count} blocos excluídos",
  "builder.clear_selection": "Limpar seleção",
  "builder.canvas_hint": "Shift ou ⌘/Ctrl + clique escolhe vários · solte uma ligação no vazio para criar o próximo bloco · ⌨ mostra os atalhos",
  "onboarding.guide.payment_done": "Cadastrada. A Meta confirma que o número pode enviar.",
  "onboarding.guide.payment_done_at": "Cadastrada. A Meta confirmou que o número pode enviar na verificação de {when}.",
  "onboarding.guide.payment_change": "Ver ou trocar o cartão na Meta",
  "onboarding.guide.payment_after": "Depois de cadastrar, clique em “Verificar agora” no cartão do número: a etapa fica pronta quando a Meta confirmar.",
  "tags.pill.label": "Etiquetas: {names}",
  "tags.menu.manage": "Gerenciar etiquetas",
  "tags.panel.close": "Fechar etiquetas",
  "tags.panel.people": "{count} contato|{count} contatos",
  "tags.panel.empty": "Nenhuma etiqueta ainda",
  "tags.panel.empty_hint": "Crie etiquetas como Lead ou Pagamento pendente para separar as pessoas e filtrar os atendimentos por elas.",
  "tags.editor.new": "Criar nova etiqueta",
  "tags.editor.edit": "Editar etiqueta",
  "tags.editor.name": "Nome da etiqueta",
  "tags.editor.color": "Escolher a cor",
  "tags.editor.suggestions": "Sugestões",
  "tags.editor.people": "Pessoas incluídas",
  "tags.editor.add_people": "Adicionar pessoas",
  "tags.editor.remove_person": "Tirar {name} da etiqueta",
  "tags.editor.create": "Criar etiqueta",
  "tags.editor.archive": "Arquivar etiqueta",
  "tags.editor.archive_hint": "Ela sai dos filtros e das listas; os relatórios continuam com ela.",
  "tags.editor.archived": "Etiqueta arquivada",
  "tags.editor.created": "Etiqueta criada",
  "tags.editor.saved": "Etiqueta salva",
  "tags.editor.exists": "Já existe uma etiqueta com esse nome",
  "tags.picker.search": "Pesquisar nome ou número",
  "tags.picker.add": "Adicionar ({count})",
  "tags.picker.empty": "Ninguém encontrado",
  "tags.filter.empty": "Ninguém com esta etiqueta",
  "tags.filter.empty_hint": "Use o botão de etiqueta no topo de um atendimento para incluir alguém.",
  "tags.suggest.new_customer": "Novo cliente",
  "tags.suggest.new_order": "Novo pedido",
  "tags.suggest.payment_pending": "Pagamento pendente",
  "tags.suggest.follow_up": "Acompanhar",
  "tags.suggest.paid": "Pago",
  "tags.suggest.order_done": "Pedido finalizado",
  "tags.suggest.lead": "Lead",
  "tags.suggest.important": "Importante",
  "permission.tags.manage": "Criar e editar etiquetas",
  "permission.appointments.read": "Ver agendas e agendamentos",
  "permission.appointments.write": "Marcar, remarcar e cancelar para contatos",
  "permission.scheduling.manage": "Configurar agendas, horários e avisos",
  "permissions.group.scheduling": "Agenda",
  "plan.label.agendas": "Agendas",
  "plan.label.appointment_types": "Tipos de agendamento",
  "plan.limit.agendas": "1 agenda|{count} agendas",
  "plan.limit.appointment_types": "1 tipo de agendamento|{count} tipos de agendamento",
  "platform.plans.hint.agendas": "Agendas ativas. Bloqueia criar mais uma.",
  "platform.plans.hint.appointment_types": "Tipos de agendamento ativos. Bloqueia criar mais um.",
  "integrations.event.appointment.booked": "Agendamento marcado",
  "integrations.event.appointment.rescheduled": "Agendamento remarcado",
  "integrations.event.appointment.cancelled": "Agendamento cancelado",
  "integrations.event.appointment.confirmed": "Agendamento confirmado",
  "integrations.event.appointment.attended": "Compareceu ao agendamento",
  "integrations.event.appointment.no_show": "Faltou ao agendamento",
  "push.appointment.booked": "Novo agendamento",
  "push.appointment.rescheduled": "Agendamento remarcado",
  "push.appointment.cancelled": "Agendamento cancelado",
  "push.appointment.unconfirmed": "O cliente não confirmou",
  "push.appointment.change_requested": "O cliente quer mudar o horário",
  "push.appointment.confirmed": "O cliente confirmou",
  "push.appointment.summary": "Sua agenda de hoje",
  "push.appointment.summary_body": "1 compromisso|{count} compromissos",
  "mail.appointment.booked": "Novo agendamento: {contact} · {type} · {when}",
  "mail.appointment.rescheduled": "Agendamento remarcado: {contact} · {type} · {when}",
  "mail.appointment.cancelled": "Agendamento cancelado: {contact} · {type} · {when}",
  "mail.appointment.add": "Adicionar à sua agenda: {link}",
  "date.previous_month": "Mês anterior",
  "date.next_month": "Próximo mês",
  "node.schedule": "Agendar",
  "node.schedule.type": "Agenda e tipo",
  "node.schedule.no_types": "Crie uma agenda com um tipo de agendamento em Configurações › Agendas.",
  "node.schedule.body": "Texto antes dos horários",
  "node.schedule.body_placeholder": "Escolha um horário para a visita:",
  "node.schedule.mode": "Como mostrar os horários",
  "node.schedule.mode.list": "Lista do WhatsApp",
  "node.schedule.mode.calendar": "Calendário do WhatsApp",
  "node.schedule.mode.buttons": "Botões",
  "node.schedule.mode_hint.list": "Até 8 horários por vez, com \"Outros horários\" e \"Nenhum desses\".",
  "node.schedule.mode_hint.calendar": "A pessoa escolhe o dia e depois a hora num calendário dentro do WhatsApp. Precisa ativar o Calendário do WhatsApp na agenda; sem ele, vai a lista.",
  "node.schedule.mode_hint.buttons": "As 2 melhores opções e \"Outros horários\".",
  "node.schedule.answer": "Resposta para \"{question}\"",
  "node.schedule.hint": "Confirmação, lembretes e regras de remarcar vêm da agenda; o bloco só oferece e marca.",
  "builder.exit_booked": "Agendado",
  "builder.exit_declined": "Nenhum horário serve",
  "builder.exit_no_times": "Sem horários livres",
  "simulator.schedule_offer": "Ofereceria os horários livres (no teste, horários de exemplo)",
  "simulator.schedule_book": "Marcaria o horário de {when} (no teste, nada é marcado)",
  "assistants.tab.agenda": "Agenda",
  "assistants.agenda.title": "Agenda",
  "assistants.agenda.lead": "Quando o cliente quiser marcar, {name} consulta a agenda, oferece horários livres e marca o que ele escolher.",
  "assistants.agenda.on": "Marcar na agenda",
  "assistants.agenda.on_hint": "Ver horários livres, marcar, remarcar, cancelar e ver os compromissos do cliente.",
  "assistants.agenda.types": "Pode marcar em",
  "assistants.agenda.duration": "{min} min",
  "assistants.agenda.no_types": "Ainda não há agendas com tipos de agendamento.",
  "assistants.agenda.open_agendas": "Abrir Agendas",
  "assistants.agenda.all_types": "Nenhum marcado: pode marcar em todos.",
  "assistants.agenda.some_types": "Só nos tipos marcados.",
  "assistants.agenda.how": "Como oferece",
  "assistants.agenda.offer": "Oferecer",
  "assistants.agenda.offer_label": "Quantos horários",
  "assistants.agenda.times": "1 horário|{count} horários",
  "assistants.agenda.at_a_time": "de cada vez,",
  "assistants.agenda.prefer": "de preferência",
  "assistants.agenda.prefer_label": "Preferência",
  "assistants.agenda.prefer_any": "os primeiros livres",
  "assistants.agenda.prefer_days": "no próximo dia|nos próximos {count} dias",
  "assistants.agenda.shown_as": "mostrados como",
  "assistants.agenda.shown_as_label": "Como mostrar",
  "assistants.agenda.present.list": "lista do WhatsApp",
  "assistants.agenda.present.text": "texto na resposta",
  "assistants.agenda.before": "Antes de marcar,",
  "assistants.agenda.before_label": "Antes de marcar",
  "assistants.agenda.confirm_yes": "repetir dia, hora e local e esperar o sim",
  "assistants.agenda.confirm_no": "marcar assim que o cliente escolher",
  "assistants.agenda.refusals": "Se nenhum servir",
  "assistants.agenda.refusals_label": "Quantas vezes",
  "assistants.agenda.refusal_n": "na primeira vez|na {count}ª vez",
  "assistants.agenda.handoff": "passar para uma pessoa ({team}).",
  "assistants.agenda.can_find": "Ver horários livres: só horários que existem de verdade; nunca inventa nem calcula data.",
  "assistants.agenda.can_book": "Marcar: só um horário que veio da lista. Se alguém pegou antes, oferece outros.",
  "assistants.agenda.can_move": "Remarcar: dentro das regras do tipo (ex.: até 4 h antes).",
  "assistants.agenda.can_cancel": "Cancelar: quando o cliente pede, dentro das regras do tipo.",
  "assistants.agenda.can_list": "Ver os compromissos do cliente: para responder \"que horas é a minha visita?\".",
  "assistant.tool.scheduling": "Agenda",
  "assistant.tool_hint.scheduling": "Ver horários livres e marcar compromissos.",
  "assistants.test.appointment_book": "Marcaria: {detail} (no teste, nada é marcado)",
  "assistants.test.appointment_reschedule": "Remarcaria: {detail}",
  "assistants.test.appointment_cancel": "Cancelaria: {detail}",
  "templates.header.location": "Localização (mapa)",
  "templates.header.location_hint": "Em cada envio vai o lugar (ex.: o endereço do agendamento), mostrado como mapa no topo.",
  "templates.header.location_preview": "O mapa do local",
  "push.appointment.calendar_changed": "O evento mudou na sua agenda: o cliente vai escolher outro horário",
  "event.appointment_booked": "Agendamento marcado: {type} · {when}",
  "event.appointment_booked_with": "Agendamento marcado: {type} · {when} · com {name}",
  "event.appointment_rescheduled": "Agendamento remarcado: {type} · {when}",
  "event.appointment_cancelled": "Agendamento cancelado: {type} · {when}",
  "event.appointment_confirmed": "O cliente confirmou: {type} · {when}",
  "event.appointment_attended": "Compareceu: {type} · {when}",
  "event.appointment_no_show": "Faltou: {type} · {when}",
  "event.appointment_unconfirmed": "Sem confirmação do cliente: {type} · {when}",
  "event.appointment_change_requested_move": "O cliente quer remarcar fora do prazo: {type} · {when}",
  "event.appointment_change_requested_cancel": "O cliente quer cancelar fora do prazo: {type} · {when}",
  "event.appointment_calendar_changed": "O evento mudou na agenda de quem atende: fale com o cliente sobre {type} · {when}",
  "event.appointment_calendar_changed_asked": "O evento mudou na agenda de quem atende; pedimos ao cliente um novo horário para {type}",
  "nav.agenda": "Agenda",
  "agendaview.title": "Agenda",
  "agendaview.book": "Agendar",
  "agendaview.busy": "Ocupado",
  "agendaview.busy_where": "{calendar} · {name}",
  "agendaview.day_empty": "Nada marcado",
  "agendaview.empty": "Ainda não há nenhuma agenda",
  "agendaview.empty_hint": "Crie uma em Configurações › Agendas para marcar compromissos com os clientes.",
  "agendaview.empty_action": "Criar uma agenda",
  "agendaview.filter.agenda": "Agenda",
  "agendaview.filter.all_agendas": "Todas as agendas",
  "agendaview.filter.all_people": "Todas as pessoas",
  "agendaview.filter.me": "{name} (você)",
  "agendaview.filter.person": "Pessoa",
  "agendaview.go_to": "Ir para o dia",
  "agendaview.legend": "Legenda",
  "agendaview.legend.confirmed": "Confirmado",
  "agendaview.legend.booked": "Aguardando o cliente",
  "agendaview.legend.no_show": "Faltou",
  "agendaview.legend.busy": "Ocupado no Google/Outlook",
  "agendaview.next_week": "Próxima semana",
  "agendaview.previous_week": "Semana anterior",
  "agendaview.provider.google": "Google",
  "agendaview.provider.microsoft": "Outlook",
  "agendaview.provider.caldav": "iCloud/CalDAV",
  "agendaview.provider.ics": "Link da agenda",
  "agendaview.today": "Hoje",
  "agendaview.tomorrow": "Amanhã",
  "agendaview.week": "Semana",
  "agendaview.week_of": "{from} a {to}",
  "agendaview.zone_note": "Horários no fuso {zone}",
  "agendaview.demo.week": "Semana da equipe (WeekView)",
  "agendaview.demo.week_hint": "Compromissos que se sobrepõem ficam lado a lado; a linha vermelha é a hora atual; o ocupado do Google/Outlook aparece listrado. No celular vira uma lista de dias.",
  "agendaview.demo.slots": "Horários livres (SlotGrid)",
  "agendaview.demo.slots_hint": "As setas andam entre os horários; Enter escolhe.",
  "agendaview.demo.panel": "Agendamento aberto (AppointmentPanel)",
  "appointment.status.booked": "Aguardando o cliente",
  "appointment.status.confirmed": "Confirmado",
  "appointment.status.cancelled": "Cancelado",
  "appointment.status.attended": "Compareceu",
  "appointment.status.no_show": "Faltou",
  "appointment.panel": "Agendamento",
  "appointment.loading": "Carregando…",
  "appointment.when": "Quando",
  "appointment.when_value": "{day} {date}, {start}–{end}",
  "appointment.with": "Com",
  "appointment.contact": "Cliente",
  "appointment.where": "Onde",
  "appointment.join": "Entrar na chamada",
  "appointment.cancel_reason": "Motivo",
  "appointment.moved": "Remarcado",
  "appointment.moved_count": "1 vez|{count} vezes",
  "appointment.open_conversation": "Abrir a conversa",
  "appointment.reschedule": "Remarcar",
  "appointment.confirm_for_contact": "Confirmar pelo cliente",
  "appointment.attended": "Compareceu",
  "appointment.no_show": "Faltou",
  "appointment.cancel": "Cancelar",
  "appointment.answers": "Respostas",
  "appointment.notes": "Observação da equipe",
  "appointment.notes_label": "Só a equipe vê",
  "appointment.notes_saved": "Observação salva",
  "appointment.story": "O que aconteceu",
  "appointment.by.member": "por {name}",
  "appointment.by.team": "por alguém da equipe",
  "appointment.by.assistant": "pelo assistente {name}",
  "appointment.by.assistant_unnamed": "pelo assistente de IA",
  "appointment.by.flow": "pelo fluxo {name}",
  "appointment.by.flow_unnamed": "por um fluxo",
  "appointment.by.api": "por uma integração",
  "appointment.by.contact": "pelo cliente",
  "appointment.by.system": "pelo DoneTalk",
  "appointment.history.booked": "Marcado {by}",
  "appointment.history.rescheduled": "Remarcado {by}",
  "appointment.history.cancelled": "Cancelado {by}",
  "appointment.history.confirmed": "Confirmado {by}",
  "appointment.history.attended": "Presença registrada {by}",
  "appointment.history.no_show": "Falta registrada {by}",
  "appointment.history.confirmed_by_contact": "O cliente tocou em Confirmar",
  "appointment.notice.confirmation": "Confirmação",
  "appointment.notice.confirm_request": "Pedido de confirmação",
  "appointment.notice.reminder": "Lembrete",
  "appointment.notice.rescheduled": "Aviso do novo horário",
  "appointment.notice.cancelled": "Aviso de cancelamento",
  "appointment.notice.no_show": "Mensagem “Sentimos sua falta”",
  "appointment.notice.confirm_deadline": "Prazo para o cliente confirmar",
  "appointment.notice.sent.confirmation": "Confirmação enviada",
  "appointment.notice.sent.confirm_request": "Pedido de confirmação enviado",
  "appointment.notice.sent.reminder": "Lembrete enviado",
  "appointment.notice.sent.rescheduled": "Aviso do novo horário enviado",
  "appointment.notice.sent.cancelled": "Aviso de cancelamento enviado",
  "appointment.notice.sent.no_show": "Mensagem “Sentimos sua falta” enviada",
  "appointment.notice.deadline_passed": "Passou o prazo para o cliente confirmar",
  "appointment.notice.failed": "{name}: não saiu",
  "appointment.notice.skipped": "{name}: não precisou",
  "appointment.calendar.synced": "Na agenda {calendar} de {name}",
  "appointment.calendar.pending": "Indo para a agenda {calendar} de {name}",
  "appointment.calendar.failed": "Não entrou na agenda {calendar} de {name}",
  "appointment.cancel_title": "Cancelar o agendamento",
  "appointment.cancel_lead": "{when}. O horário fica livre de novo.",
  "appointment.cancel_reason_label": "Motivo (opcional)",
  "appointment.cancel_notify": "Avisar o cliente pelo WhatsApp",
  "appointment.cancel_notify_hint": "Vai o aviso de cancelamento da agenda.",
  "appointment.cancel_keep": "Voltar",
  "appointment.cancel_confirm": "Cancelar agendamento",
  "appointment.cancelled_toast": "Agendamento cancelado",
  "appointment.marked.confirmed": "Confirmado pelo cliente",
  "appointment.marked.attended": "Presença registrada",
  "appointment.marked.no_show": "Falta registrada",
  "appointment.contact_title": "Agendamentos",
  "appointment.contact_empty": "Nenhum agendamento ainda.",
  "appointment.book": "Agendar",
  "appointment.more_past": "Ver mais 1 anterior|Ver mais {count} anteriores",
  "appointment.fewer_past": "Ver menos",
  "appointment.place.contact_field": "Endereço do cliente",
  "appointment.place.online_google_meet": "Online, pelo Google Meet",
  "appointment.place.online_teams": "Online, pelo Microsoft Teams",
  "appointment.place.online_link": "Online, pelo link",
  "appointment.place.phone": "Por telefone",
  "appointment.place.to_agree": "Local a combinar",
  "appointment.error.slot_taken": "Esse horário acabou de ser ocupado. Escolha outro.",
  "appointment.error.contact_has_appointment": "Esse cliente já tem um agendamento desse tipo marcado.",
  "appointment.error.agenda_inactive": "Essa agenda está pausada ou desligada.",
  "appointment.error.agenda_has_no_people": "Ninguém atende nessa agenda ainda.",
  "appointment.error.appointment_closed": "Esse agendamento já foi cancelado ou concluído.",
  "appointment.error.appointment_not_started": "Só dá para marcar presença ou falta depois que o horário começar.",
  "appointment.error.appointment_not_found": "Esse agendamento não existe mais.",
  "appointment.error.contact_not_found": "Esse contato não existe mais.",
  "appointment.error.member_not_in_agenda": "Essa pessoa não atende nessa agenda.",
  "book.action": "Agendar",
  "book.title": "Agendar com {name}",
  "book.title_pick": "Agendar",
  "book.title_reschedule": "Remarcar com {name}",
  "book.pick_hint": "Para quem é o agendamento?",
  "book.pick_search": "Buscar contato",
  "book.pick_empty": "Nenhum contato encontrado.",
  "book.for": "Para",
  "book.change_contact": "Trocar",
  "book.from_when": "Horário atual:",
  "book.no_types": "Nenhum tipo de agendamento ativo. Crie um em Configurações › Agendas.",
  "book.type": "Agenda e tipo",
  "book.who": "Quem atende",
  "book.anyone": "Qualquer pessoa livre",
  "book.together": "Todos juntos",
  "book.required": "{label} (obrigatório)",
  "book.slots": "Horários livres",
  "book.loading": "Procurando horários livres…",
  "book.no_slots": "Nenhum horário livre nos próximos dias.",
  "book.more_times": "+1 horário|+{count} horários",
  "book.all_times": "Mostrar todos os horários",
  "book.fewer_times": "Mostrar menos horários",
  "book.days_before": "Dias anteriores",
  "book.days_after": "Próximos dias",
  "book.days_range": "{from} a {to}",
  "book.more": "Ver mais dias ou escolher outro horário",
  "book.other_title": "Escolher outro horário",
  "book.other_hint": "Vale também fora dos horários livres. Só não dá se a pessoa já tiver outro compromisso nessa hora.",
  "book.other_day": "Dia",
  "book.other_time": "Hora",
  "book.taken": "Alguém marcou esse horário agora há pouco. Estes ainda estão livres:",
  "book.has_one": "{name} já tem um agendamento desse tipo marcado.",
  "book.open_existing": "Abrir o agendamento",
  "book.note_window_open": "A confirmação vai sozinha pelo WhatsApp, como mensagem normal, porque a conversa está aberta (grátis até 1.000 por mês no número).",
  "book.note_template": "A confirmação vai sozinha pelo WhatsApp, pelo modelo aprovado pela Meta.",
  "book.note_unknown": "A confirmação vai sozinha pelo WhatsApp: como mensagem normal se a conversa estiver aberta, senão pelo modelo aprovado pela Meta.",
  "book.note_rescheduled": "O aviso do novo horário vai sozinho para o cliente pelo WhatsApp.",
  "book.note_off": "Esta agenda não manda esse aviso pelo WhatsApp (está desligado nos avisos da agenda).",
  "book.summary_when": "{day}, {date}, {start} às {end}",
  "book.summary_anyone": "quem estiver livre",
  "book.summary_calendar": "Vai para a agenda {calendar} de {name} e os lembretes saem sozinhos.",
  "book.summary_donetalk": "Fica na agenda do DoneTalk e os lembretes saem sozinhos.",
  "book.summary_reminders": "Os lembretes saem sozinhos.",
  "book.submit": "Agendar",
  "book.submit_reschedule": "Remarcar",
  "book.done": "Agendado: {when}",
  "book.done_rescheduled": "Remarcado: {when}",
  "report.agenda.tab": "Agenda",
  "report.agenda.agenda": "Agenda",
  "report.agenda.all": "Todas as agendas",
  "report.agenda.export": "Exportar CSV",
  "report.agenda.loading": "Calculando…",
  "report.agenda.kpi.booked": "Marcados",
  "report.agenda.kpi.vs_previous": "{change} sobre o período anterior",
  "report.agenda.kpi.no_previous": "Nada no período anterior",
  "report.agenda.kpi.confirmed": "Confirmaram",
  "report.agenda.kpi.by_button": "{rate} pelo botão do pedido",
  "report.agenda.kpi.no_show": "Faltaram",
  "report.agenda.kpi.no_show_count": "1 falta|{count} faltas",
  "report.agenda.kpi.to_book": "Do primeiro “oi” até marcar",
  "report.agenda.kpi.to_book_hint": "com o assistente (mediana)",
  "report.agenda.kpi.meta": "Mensagens da Meta",
  "report.agenda.kpi.per_appointment": "{value} por agendamento",
  "report.agenda.minutes": "1 min|{count} min",
  "report.agenda.hours": "{h} h {m} min",
  "report.agenda.sources": "Quem marcou",
  "report.agenda.source.assistant": "Assistente de IA",
  "report.agenda.source.flow": "Fluxos",
  "report.agenda.source.member": "Pessoas da equipe",
  "report.agenda.source.contact": "O próprio cliente",
  "report.agenda.source.api": "Integrações",
  "report.agenda.outcomes": "Como terminaram",
  "report.agenda.outcome.attended": "Compareceram",
  "report.agenda.outcome.rescheduled": "Remarcados",
  "report.agenda.outcome.cancelled": "Cancelados",
  "report.agenda.outcome.noShow": "Faltaram",
  "report.agenda.people": "Por pessoa",
  "report.agenda.col.person": "Pessoa",
  "report.agenda.col.booked": "Marcados",
  "report.agenda.col.confirmed": "Confirmaram",
  "report.agenda.col.no_show": "Faltas",
  "report.agenda.col.sales": "Viraram venda",
  "report.agenda.empty": "Nenhum agendamento no período.",
  "report.agenda.sales_hint": "“Viraram venda”: atendimentos do cliente concluídos com desfecho de sucesso em até 30 dias depois do horário.",
  "settings.agendas": "Agendas",
  "settings.my_calendar": "Minha agenda",
  "settings.find.agendas": "agenda agendamento horário marcar visita consulta compromisso calendário reserva",
  "settings.find.agenda_types": "tipo de agendamento duração visita consulta regras antecedência intervalo",
  "settings.find.agenda_notices": "lembrete aviso confirmação whatsapp modelo remarcar cancelar falta",
  "settings.find.my_calendar": "minha agenda google outlook icloud calendário conectar ocupado",
  "settings.find.my_calendar_connect": "conectar google outlook microsoft icloud apple caldav ics link agenda",
  "agendas.lead": "Onde o assistente, os fluxos e a equipe marcam compromissos com os clientes. Cada agenda diz quem atende, quando e de que jeito.",
  "agendas.new": "Nova agenda",
  "agendas.new_title": "Nova agenda",
  "agendas.new_hint": "Ela começa aberta de segunda a sexta, das 09:00 às 12:00 e das 13:00 às 18:00. Depois você ajusta tudo.",
  "agendas.create": "Criar agenda",
  "agendas.created": "Agenda criada",
  "agendas.empty": "Nenhuma agenda ainda. Crie a primeira para o assistente, os fluxos e a equipe marcarem horários.",
  "agendas.field.name": "Nome da agenda",
  "agendas.field.name_placeholder": "Ex.: Visitas aos imóveis",
  "agendas.field.person": "Quem atende",
  "agendas.kind.team": "Uma equipe",
  "agendas.kind.person": "Uma pessoa",
  "agendas.kind.resource": "Um lugar ou recurso",
  "agendas.kind_hint.team": "Várias pessoas atendem, em rodízio ou juntas.",
  "agendas.kind_hint.person": "Só uma pessoa atende: um médico, um consultor.",
  "agendas.kind_hint.resource": "Uma sala, um equipamento: guarda só o horário.",
  "agendas.state.active": "Ativa",
  "agendas.state.off": "Desligada",
  "agendas.state.paused": "Pausada até {day}",
  "agendas.banner.title": "A sua agenda ainda não está conectada",
  "agendas.banner.text": "Conecte o Google, o Outlook ou o iCloud para que ninguém marque nada em cima dos seus compromissos.",
  "agendas.banner.action": "Conectar minha agenda",
  "agendas.card.who": "Quem atende",
  "agendas.card.types_title": "Tipos",
  "agendas.card.next": "Próximo horário livre",
  "agendas.card.this_week": "Esta semana",
  "agendas.card.who_resource": "Recurso: só o horário",
  "agendas.card.who_nobody": "Ninguém ainda",
  "agendas.card.who_fixed": "uma pessoa fixa",
  "agendas.card.who_round_robin": "rodízio de 1 pessoa|rodízio entre {count}",
  "agendas.card.who_owner": "quem já atende o cliente",
  "agendas.card.who_collective": "1 pessoa|{count} pessoas juntas",
  "agendas.card.types": "1 tipo|{count} tipos",
  "agendas.card.no_types": "Nenhum tipo ainda",
  "agendas.card.none_free": "Nada livre nos próximos dias",
  "agendas.card.week": "1 marcado · {missed}|{count} marcados · {missed}",
  "agendas.card.missed": "1 falta|{count} faltas",
  "agendas.card.week_none": "Nada marcado",
  "agendas.card.calendar": "{provider} · {people}",
  "agendas.card.people": "1 pessoa|{count} pessoas",
  "agendas.card.only_here": "Só no DoneTalk",
  "agendas.card.reminders": "Avisos: {list}",
  "agendas.card.and": " e ",
  "agendas.card.asks_confirmation": "Pede confirmação",
  "agenda.tab.hours": "Horários",
  "agenda.tab.types": "Tipos de agendamento",
  "agenda.tab.people": "Quem atende",
  "agenda.tab.calendars": "Agendas conectadas",
  "agenda.tab.notices": "Avisos e lembretes",
  "agenda.menu.rename": "Renomear",
  "agenda.menu.turn_off": "Desligar agenda",
  "agenda.menu.turn_on": "Ligar agenda",
  "agenda.menu.delete": "Apagar agenda",
  "agenda.off_done": "Agenda desligada. Nada novo é marcado nela.",
  "agenda.on_done": "Agenda ligada.",
  "agenda.delete.title": "Apagar {name}?",
  "agenda.delete.text": "O assistente, os fluxos e a equipe deixam de marcar nela. Se já tem compromissos, ela só é desligada e o histórico fica.",
  "agenda.delete.confirm": "Apagar agenda",
  "agenda.delete.done": "Pronto. Se a agenda já tinha compromissos, ela ficou desligada para guardar o histórico.",
  "agenda.pause.action": "Pausar agenda",
  "agenda.pause.title": "Pausar a agenda",
  "agenda.pause.text": "Enquanto estiver pausada, ninguém marca nada novo nela. Os compromissos já marcados continuam.",
  "agenda.pause.until": "Pausada até (inclusive)",
  "agenda.pause.confirm": "Pausar",
  "agenda.pause.done": "Agenda pausada até {day}.",
  "agenda.pause.resume": "Retomar",
  "agenda.pause.resumed": "Agenda retomada.",
  "agenda.save.bad_hours": "Há faixas de horário fora de ordem ou uma em cima da outra. Arrume as marcadas em vermelho.",
  "agenda.save.pick_hours": "Escolha qual horário de atendimento esta agenda usa.",
  "agenda.save.event_title": "Escreva o título do evento em Agendas conectadas.",
  "agenda.save.type": "Tipo {name}: {problem}",
  "agenda.undo": "Desfazer",
  "agenda.time.minutes": "{m} min",
  "agenda.time.hours": "{h} h",
  "agenda.time.hours_minutes": "{h} h {m} min",
  "agenda.time.days": "1 dia|{count} dias",
  "agenda.time.before": "{time} antes",
  "agenda.time.at_start": "até a hora",
  "agenda.when.today": "Hoje, {time}",
  "agenda.when.tomorrow": "Amanhã, {time}",
  "agenda.when.day": "{day}, {time}",
  "agenda.ago.now": "agora há pouco",
  "agenda.ago.minutes": "há {n} min",
  "agenda.ago.hours": "há {n} h",
  "agenda.ago.day": "em {day}",
  "agenda.ago.never": "nunca",
  "agenda.hours.title": "Quando esta agenda aceita compromissos",
  "agenda.hours.mode.business_hours": "Os horários de atendimento",
  "agenda.hours.mode.own": "Horários próprios da agenda",
  "agenda.hours.mode.per_person": "Cada pessoa tem os seus",
  "agenda.hours.mode_hint.business_hours": "Os mesmos dias e horas de um horário de atendimento da equipe.",
  "agenda.hours.mode_hint.own": "Uma semana só para esta agenda.",
  "agenda.hours.mode_hint.per_person": "Cada pessoa tem a sua semana em Quem atende.",
  "agenda.hours.which": "Qual horário de atendimento",
  "agenda.hours.no_business_hours": "Ainda não há horários de atendimento.",
  "agenda.hours.open_business_hours": "Criar em Horários de atendimento",
  "agenda.hours.per_person_hint": "Cada pessoa pode ter a sua semana em Quem atende. Quem não tiver usa a semana abaixo.",
  "agenda.hours.open_people": "Abrir Quem atende",
  "agenda.weekly.add": "+ faixa",
  "agenda.weekly.copy": "Copiar segunda para os dias úteis",
  "agenda.weekly.from": "Início ({day})",
  "agenda.weekly.to": "Fim ({day})",
  "agenda.weekly.remove": "Tirar a faixa ({day})",
  "agenda.weekly.order": "O fim precisa vir depois do início.",
  "agenda.weekly.overlap": "Duas faixas se cruzam neste dia.",
  "agenda.override.title": "Datas especiais e exceções",
  "agenda.override.lead": "Feriado, horário diferente num dia, férias de alguém. Vale por cima das regras da semana.",
  "agenda.override.add": "Adicionar data",
  "agenda.override.add_title": "Data especial",
  "agenda.override.added": "Data adicionada",
  "agenda.override.none": "Nenhuma data especial.",
  "agenda.override.closed": "Fechado",
  "agenda.override.closed_hint": "Nada é oferecido nesses dias.",
  "agenda.override.other_hours": "Outro horário",
  "agenda.override.other_hours_hint": "Nesses dias, só nestas faixas.",
  "agenda.override.only": "Só {ranges}",
  "agenda.override.person_off": "{name} fora (só essa pessoa sai do rodízio)",
  "agenda.override.everyone": "A agenda toda",
  "agenda.override.who": "Vale para",
  "agenda.override.from": "De",
  "agenda.override.to": "Até",
  "agenda.override.span": "{from} a {to}",
  "agenda.override.note": "Motivo (opcional)",
  "agenda.override.note_placeholder": "Ex.: Natal, férias",
  "agenda.override.range_from": "Início",
  "agenda.override.range_to": "Fim",
  "agenda.override.range_remove": "Tirar a faixa",
  "agenda.override.save": "Adicionar",
  "agenda.override.remove": "Tirar a data",
  "agenda.override.removed": "Data tirada",
  "agenda.holidays.label": "Fechar sozinha nos feriados nacionais",
  "agenda.holidays.hint": "Nesses dias nada é oferecido. Para um feriado da sua cidade, use Adicionar data.",
  "agenda.holidays.optional": "Também no Carnaval e no Corpus Christi (pontos facultativos)",
  "agenda.tz.title": "Fuso horário",
  "agenda.tz.contact": "Mostrar ao cliente no fuso dele quando for outro",
  "agenda.tz.america_sao_paulo": "São Paulo, Rio e Brasília",
  "agenda.tz.america_manaus": "Manaus",
  "agenda.tz.america_belem": "Belém",
  "agenda.tz.america_fortaleza": "Fortaleza",
  "agenda.tz.america_recife": "Recife",
  "agenda.tz.america_cuiaba": "Cuiabá",
  "agenda.tz.america_rio_branco": "Rio Branco (Acre)",
  "agenda.tz.america_noronha": "Fernando de Noronha",
  "agenda.tz.america_argentina_buenos_aires": "Buenos Aires",
  "agenda.tz.america_santiago": "Santiago",
  "agenda.tz.america_bogota": "Bogotá",
  "agenda.tz.america_mexico_city": "Cidade do México",
  "agenda.tz.america_lima": "Lima",
  "agenda.tz.america_new_york": "Nova York",
  "agenda.tz.europe_lisbon": "Lisboa",
  "agenda.tz.europe_madrid": "Madri",
  "agenda.tz.utc": "Tempo universal",
  "agenda.preview.title": "Assim fica a próxima semana",
  "agenda.preview.hint": "Os horários livres para marcar, já sem o que está ocupado nas agendas conectadas. Mostra o que está salvo.",
  "agenda.preview.more": "+{count}",
  "agenda.preview.total": "1 horário livre de {type} ({duration}) nos próximos 7 dias.|{count} horários livres de {type} ({duration}) nos próximos 7 dias.",
  "agenda.preview.no_type": "Crie um tipo de agendamento para ver os horários livres.",
  "agenda.preview.open_types": "Abrir os tipos",
  "agenda.people.title": "Quem atende",
  "agenda.people.lead": "Quem recebe os compromissos desta agenda. A ordem desempata o rodízio.",
  "agenda.people.team": "Equipe",
  "agenda.people.no_team": "Nenhuma equipe",
  "agenda.people.add_team": "Adicionar 1 pessoa da equipe {team}|Adicionar {count} pessoas da equipe {team}",
  "agenda.people.add": "Adicionar pessoa",
  "agenda.people.empty": "Ninguém atende ainda. Adicione as pessoas abaixo.",
  "agenda.people.active": "Atende",
  "agenda.people.on_hint": "recebe compromissos",
  "agenda.people.off_hint": "fora por enquanto: não recebe compromissos novos",
  "agenda.people.up": "Subir {name}",
  "agenda.people.down": "Descer {name}",
  "agenda.people.remove": "Tirar {name}",
  "agenda.people.order_hint": "No rodízio, vai para quem tem menos compromissos na semana; no empate, quem está mais acima.",
  "agenda.people.own_week": "Semana própria",
  "agenda.people.own_week_hint": "Sem semana própria, vale a semana da agenda.",
  "agenda.people.own_week_on": "semana própria",
  "agenda.people.agenda_week": "usa a semana da agenda",
  "agenda.people.show_week": "Ver a semana",
  "agenda.people.hide_week": "Fechar a semana",
  "agenda.people.person": "Quem atende",
  "agenda.people.person_hint": "Agenda de uma pessoa só: os compromissos vão sempre para ela.",
  "agenda.people.resource": "Uma sala, um equipamento: a agenda guarda só o horário, sem pessoas. Ninguém precisa conectar agenda.",
  "agenda.type.new": "Novo tipo",
  "agenda.type.new_name": "Novo tipo",
  "agenda.type.created": "Tipo criado. Ajuste e salve.",
  "agenda.type.empty": "Nenhum tipo ainda. Crie o primeiro: é o que o cliente marca (uma visita, uma consulta).",
  "agenda.type.inactive": "desligado",
  "agenda.type.untitled": "Sem nome",
  "agenda.type.on": "Ligado",
  "agenda.type.off": "Desligado",
  "agenda.type.name": "Nome",
  "agenda.type.duration": "Duração",
  "agenda.type.step": "Começa",
  "agenda.type.every": "a cada {time}",
  "agenda.type.description": "O que é (o assistente lê isto para saber quando oferecer)",
  "agenda.type.rules": "Regras do horário",
  "agenda.type.rule.after_a": "Deixar",
  "agenda.type.rule.after_label": "Intervalo depois",
  "agenda.type.rule.after_b": "livres depois de cada um e",
  "agenda.type.rule.before_label": "Intervalo antes",
  "agenda.type.rule.before_b": "antes.",
  "agenda.type.rule.notice_a": "Marcar com pelo menos",
  "agenda.type.rule.notice_label": "Antecedência mínima",
  "agenda.type.rule.notice_b": "de antecedência e no máximo",
  "agenda.type.rule.ahead_label": "Até quantos dias à frente",
  "agenda.type.rule.ahead_b": "à frente.",
  "agenda.type.rule.per_day_a": "No máximo",
  "agenda.type.rule.per_day_label": "Limite por dia",
  "agenda.type.rule.per_day_b": "por pessoa por dia e",
  "agenda.type.rule.per_contact_label": "Limite por cliente",
  "agenda.type.rule.per_contact_b": "em aberto por cliente.",
  "agenda.type.appointments": "1 horário|{count} horários",
  "agenda.type.no_limit": "sem limite",
  "agenda.type.where": "Onde acontece",
  "agenda.type.place.contact_field": "Endereço do contato (campo)",
  "agenda.type.place.address": "Endereço fixo",
  "agenda.type.place.online": "Online: Meet, Teams ou um link",
  "agenda.type.place.phone": "Por telefone",
  "agenda.type.place.to_agree": "Combinar depois",
  "agenda.type.place_hint.none": "Escolha onde acontece: vai na confirmação e nos lembretes.",
  "agenda.type.place_hint.contact_field": "O endereço do contato vai na confirmação e nos lembretes.",
  "agenda.type.place_hint.address": "O endereço vai na confirmação e nos lembretes, com o link do mapa.",
  "agenda.type.place_hint.online": "O link vai na confirmação e nos lembretes.",
  "agenda.type.place_hint.phone": "Quem atende liga para o número do cliente.",
  "agenda.type.place_hint.to_agree": "O lugar é combinado na conversa.",
  "agenda.type.place_short.none": "sem lugar",
  "agenda.type.place_short.address": "presencial",
  "agenda.type.place_short.contact_field": "no endereço do cliente",
  "agenda.type.place_short.online": "online",
  "agenda.type.place_short.phone": "por telefone",
  "agenda.type.place_short.to_agree": "lugar a combinar",
  "agenda.type.place_field": "Campo do contato com o endereço",
  "agenda.type.place_no_fields": "Ainda não há campos do contato. Crie um em Campos do contato.",
  "agenda.type.address": "Endereço",
  "agenda.type.address_placeholder": "Rua, número, bairro, cidade",
  "agenda.type.maps": "Link do Google Maps (opcional)",
  "agenda.type.maps_hint": "Cole o link do lugar no Google Maps para a confirmação e o lembrete mostrarem o mapa.",
  "agenda.type.maps_missed": "Não achamos o ponto do mapa nesse link. Abra o lugar no Google Maps e copie o endereço da barra.",
  "agenda.type.pin": "Ponto do mapa: {pin}",
  "agenda.type.pin_clear": "Tirar",
  "agenda.type.online.title": "Como é a chamada",
  "agenda.type.online.google_meet": "Google Meet (link criado sozinho)",
  "agenda.type.online.teams": "Microsoft Teams (link criado sozinho)",
  "agenda.type.online.link": "Um link fixo",
  "agenda.type.online.link_field": "Link da chamada",
  "agenda.type.online.hint": "O link é criado na agenda de quem atende, que precisa ter o Google (para o Meet) ou o Outlook (para o Teams) conectado.",
  "agenda.type.who": "Quem atende",
  "agenda.type.who_mode.round_robin": "Rodízio",
  "agenda.type.who_mode.owner": "Quem já atende o cliente",
  "agenda.type.who_mode.fixed": "Uma pessoa fixa",
  "agenda.type.who_mode.collective": "Várias pessoas juntas",
  "agenda.type.who_hint.round_robin": "Vai para quem tem menos compromissos na semana; no empate, a ordem em Quem atende.",
  "agenda.type.who_hint.owner": "Vai para quem já cuida do cliente; se ninguém cuida, para qualquer pessoa livre da agenda.",
  "agenda.type.who_hint.fixed": "Sempre a mesma pessoa.",
  "agenda.type.who_hint.collective": "Todos da agenda precisam estar livres, e todos vão juntos.",
  "agenda.type.who_short.round_robin": "rodízio",
  "agenda.type.who_short.owner": "quem já atende",
  "agenda.type.who_short.fixed": "pessoa fixa",
  "agenda.type.who_short.collective": "juntos",
  "agenda.type.prefer_owner": "Se o cliente já foi atendido por alguém, prefere a mesma pessoa",
  "agenda.type.fixed_person": "Pessoa",
  "agenda.type.no_people": "Ninguém atende nesta agenda ainda.",
  "agenda.type.who_person": "Agenda de uma pessoa só: {name} atende todos os compromissos.",
  "agenda.type.who_resource": "Agenda de um recurso: guarda só o horário, sem pessoa.",
  "agenda.intake.title": "Antes de marcar, pedir",
  "agenda.intake.label": "Pergunta",
  "agenda.intake.label_placeholder": "Ex.: Código do imóvel",
  "agenda.intake.new_label": "pergunta",
  "agenda.intake.kind_label": "Tipo de resposta",
  "agenda.intake.kind.text": "Texto livre",
  "agenda.intake.kind.choice": "Escolher entre opções",
  "agenda.intake.save_to": "Guardar no campo",
  "agenda.intake.no_save": "Não guardar no contato",
  "agenda.intake.options": "Opções",
  "agenda.intake.options_placeholder": "Digite e aperte Enter",
  "agenda.intake.required": "Obrigatória",
  "agenda.intake.remove": "Tirar a pergunta",
  "agenda.intake.add": "Pergunta",
  "agenda.intake.add_field": "+ campo do contato",
  "agenda.intake.hint": "O assistente e o fluxo perguntam o que faltar; o que o contato já tem não é perguntado de novo.",
  "agenda.type.confirm_title": "Confirmação, remarcar e cancelar",
  "agenda.type.confirm_a": "Pedir confirmação ao cliente:",
  "agenda.type.no_reply_a": "Sem resposta até",
  "agenda.type.reply_by_label": "Prazo para responder",
  "agenda.type.no_reply_label": "O que fazer sem resposta",
  "agenda.type.no_reply.notify": "avisar quem atende e manter o horário",
  "agenda.type.no_reply.release": "liberar o horário e avisar o cliente",
  "agenda.type.no_reply.ask_again": "mandar o pedido de novo",
  "agenda.type.reschedule_a": "Remarcar sozinho:",
  "agenda.type.cancel_a": "Cancelar sozinho:",
  "agenda.type.cannot": "não pode",
  "agenda.type.until_start": "até a hora de começar",
  "agenda.type.until": "até {time} antes",
  "agenda.type.confirm_hint": "O pedido sai pelo aviso “Pedido de confirmação”, em Avisos e lembretes. Depois do prazo para remarcar ou cancelar, uma pessoa da equipe assume.",
  "agenda.type.on_book.title": "Ao marcar",
  "agenda.type.on_book.tags": "Pôr a etiqueta:",
  "agenda.type.on_book.crm": "Registrar no CRM",
  "agenda.type.on_book.crm_hint": "O compromisso vira uma atividade no CRM conectado.",
  "agenda.type.on_book.close": "Concluir o atendimento como",
  "agenda.type.on_book.no_close": "Não concluir",
  "agenda.type.delete": "Apagar tipo",
  "agenda.type.delete_title": "Apagar {name}?",
  "agenda.type.delete_text": "Ele some das opções do assistente, dos fluxos e da equipe. Se já tem compromissos, ele só é desligado e o histórico fica.",
  "agenda.type.deleted": "Pronto. Se o tipo já tinha compromissos, ele ficou desligado.",
  "agenda.type.problem.name": "dê um nome.",
  "agenda.type.problem.address": "escreva o endereço.",
  "agenda.type.problem.field": "escolha o campo do endereço.",
  "agenda.type.problem.link": "o link da chamada precisa começar com https://.",
  "agenda.type.problem.person": "escolha a pessoa que atende.",
  "agenda.type.problem.intake": "escreva todas as perguntas.",
  "agenda.type.problem.options": "uma pergunta de escolha precisa de pelo menos 2 opções.",
  "agenda.provider.google": "Google",
  "agenda.provider.microsoft": "Outlook",
  "agenda.provider.caldav": "iCloud/CalDAV",
  "agenda.provider.ics": "Link da agenda",
  "agenda.calendars.title": "A agenda de cada pessoa",
  "agenda.calendars.lead": "O que estiver marcado nas agendas que contam como ocupado nunca é oferecido. O compromisso é gravado na agenda que a pessoa escolheu.",
  "agenda.calendars.resource": "Esta agenda é de um recurso (uma sala, um equipamento): não tem pessoas nem agendas conectadas.",
  "agenda.calendars.no_people": "Ninguém atende nesta agenda ainda. Adicione as pessoas em Quem atende.",
  "agenda.calendars.chip": "{provider} · {status}",
  "agenda.calendars.status.active": "conectada",
  "agenda.calendars.status.needs_consent": "falta a aprovação do TI",
  "agenda.calendars.status.needs_reauth": "conectar de novo",
  "agenda.calendars.status.error": "com erro",
  "agenda.calendars.status.disconnected": "desconectada",
  "agenda.calendars.none": "Sem agenda conectada",
  "agenda.calendars.only_here": "Usa só a agenda do DoneTalk.",
  "agenda.calendars.read": "lida {ago}",
  "agenda.calendars.not_read": "ainda não lida",
  "agenda.calendars.how.google": "avisa as mudanças na hora",
  "agenda.calendars.how.microsoft": "avisa as mudanças na hora",
  "agenda.calendars.how.caldav": "lida a cada 5 min (a Apple não avisa as mudanças na hora)",
  "agenda.calendars.how.ics": "atualizada a cada 15 min · não grava os compromissos",
  "agenda.calendars.needs_consent": "A Microsoft pede que o TI da empresa aprove o DoneTalk uma vez. A pessoa pega o link pronto em Minha agenda.",
  "agenda.calendars.needs_reauth": "A conexão caiu (senha trocada ou acesso vencido). É preciso conectar de novo.",
  "agenda.calendars.error": "A conexão deu erro. A pessoa precisa abrir Minha agenda.",
  "agenda.calendars.ask": "Pedir para conectar",
  "agenda.calendars.ask_text": "Oi, {name}! Conecte a sua agenda no DoneTalk para ninguém marcar nada em cima dos seus compromissos: {link}",
  "agenda.calendars.asked": "Mensagem com o link copiada. Mande para {name}.",
  "agenda.calendars.private": "Aqui aparece só se a agenda de cada um está conectada; o que tem nela continua visível só para a pessoa.",
  "agenda.calendars.event_title": "Como o compromisso aparece na agenda",
  "agenda.calendars.title_field": "Título do evento",
  "agenda.calendars.tokens": "Inserir:",
  "agenda.calendars.token.type": "tipo",
  "agenda.calendars.token.contact": "cliente",
  "agenda.calendars.token.agenda": "agenda",
  "agenda.calendars.looks_like": "Fica assim:",
  "agenda.calendars.details": "Pôr o telefone e o link da conversa na descrição",
  "agenda.calendars.details_hint": "Quem abre o evento no Google ou no Outlook vê com quem é e entra na conversa com um toque.",
  "agenda.calendars.invite_all": "Gravar na agenda de todos que atendem juntos",
  "agenda.calendars.invite_all_hint": "Nos tipos com várias pessoas, o evento vai para a agenda de cada uma, não só da primeira.",
  "agenda.calendars.invite_contact": "Convidar o cliente por e-mail",
  "agenda.calendars.invite_contact_hint": "Usa o e-mail do contato, quando houver. O convite sai da agenda de quem atende.",
  "agenda.calendars.on_change": "Se a pessoa mover ou apagar o evento no Google ou no Outlook",
  "agenda.calendars.change.notify_and_ask": "Avisar a pessoa e pedir ao cliente um novo horário",
  "agenda.calendars.change.notify": "Só avisar a pessoa",
  "agenda.calendars.change.ignore": "Não fazer nada",
  "agenda.calendars.connect_title": "Conectar uma agenda",
  "agenda.calendars.connect_hint": "Cada pessoa conecta a própria agenda em Minha agenda.",
  "agenda.notice.title": "Para o cliente, pelo WhatsApp",
  "agenda.notice.kind.confirmation": "Confirmação",
  "agenda.notice.kind.confirm_request": "Pedido de confirmação",
  "agenda.notice.kind.reminder": "Lembrete",
  "agenda.notice.kind.rescheduled": "Novo horário",
  "agenda.notice.kind.cancelled": "Cancelamento",
  "agenda.notice.kind.no_show": "Sentimos sua falta",
  "agenda.notice.desc.confirmation": "Dia, hora, endereço e quem atende, com o link para guardar na agenda.",
  "agenda.notice.desc.confirm_request": "Pergunta se o cliente vai e espera a resposta pelos botões.",
  "agenda.notice.desc.reminder": "Curto, com o endereço e quem atende.",
  "agenda.notice.desc.rescheduled": "O que mudou, do horário antigo para o novo.",
  "agenda.notice.desc.cancelled": "Confirma o cancelamento e oferece marcar outro dia.",
  "agenda.notice.desc.no_show": "Sem cobrança nem promoção (para continuar sendo utilidade). Responder remarca.",
  "agenda.notice.buttons.confirmation": "Remarcar · Cancelar",
  "agenda.notice.buttons.confirm_request": "Confirmo · Remarcar · Cancelar",
  "agenda.notice.buttons.reminder": "Preciso remarcar",
  "agenda.notice.buttons.rescheduled": "Está certo · Cancelar",
  "agenda.notice.buttons.cancelled": "Marcar outro dia",
  "agenda.notice.buttons.no_show": "Marcar outro horário · Não preciso mais",
  "agenda.notice.buttons_line": "Botões: {buttons}.",
  "agenda.notice.on_event.confirmation": "Ao marcar",
  "agenda.notice.on_event.confirm_request": "Ao marcar",
  "agenda.notice.on_event.reminder": "Ao marcar",
  "agenda.notice.on_event.rescheduled": "Ao remarcar",
  "agenda.notice.on_event.cancelled": "Ao cancelar",
  "agenda.notice.on_event.no_show": "Se faltou",
  "agenda.notice.label.days_before": "1 dia antes, {at}|{count} dias antes, {at}",
  "agenda.notice.label.same_day": "No dia, {at}",
  "agenda.notice.label.no_show": "{time} depois, se faltou",
  "agenda.notice.timing.before": "{time} antes",
  "agenda.notice.timing.after": "{time} depois",
  "agenda.notice.timing.after_now": "Logo depois",
  "agenda.notice.timing.days_before": "1 dia antes|{count} dias antes",
  "agenda.notice.timing.same_day": "No mesmo dia",
  "agenda.notice.goes": "Sai",
  "agenda.notice.when_label": "Quando sai",
  "agenda.notice.at": "às",
  "agenda.notice.at_label": "Horário do aviso",
  "agenda.notice.template": "{name} · {status}",
  "agenda.notice.template_missing": "{name} · ainda não criado na Meta",
  "agenda.notice.edit_text": "Editar o texto",
  "agenda.notice.see_text": "Ver o texto",
  "agenda.notice.on": "Ligado",
  "agenda.notice.off": "Desligado",
  "agenda.notice.add": "+ Outro aviso (ex.: 1 semana antes)",
  "agenda.notice.add_title": "Outro aviso",
  "agenda.notice.add_confirm": "Adicionar aviso",
  "agenda.notice.added": "Aviso adicionado",
  "agenda.notice.remove": "Apagar aviso",
  "agenda.notice.remove_title": "Apagar este aviso?",
  "agenda.notice.remove_text": "O aviso deixa de sair nos próximos compromissos. Os que já saíram continuam no histórico.",
  "agenda.notice.removed": "Aviso apagado",
  "agenda.notice.text_title": "Texto: {kind}",
  "agenda.notice.text_label": "Texto da mensagem",
  "agenda.notice.variables": "Inserir:",
  "agenda.notice.unknown": "A Meta não conhece estas partes: {list}. Use os botões para inserir.",
  "agenda.notice.utility_hint": "Fale só deste compromisso: o quê, quando, onde e com quem. Desconto ou promoção fazem a Meta cobrar como marketing, que custa bem mais.",
  "agenda.notice.save_text": "Salvar texto",
  "agenda.notice.text_saved": "Texto salvo",
  "agenda.notice.use_suggested": "Usar o texto sugerido",
  "agenda.notice.preview": "Assim chega no WhatsApp (com dados de exemplo)",
  "agenda.notice.map_hint": "A versão com mapa mostra o ponto do endereço no topo, quando o tipo tem o link do Google Maps.",
  "agenda.notice.map": "com mapa",
  "agenda.notice.with_map": "Também a versão com mapa",
  "agenda.notice.meta_title": "Modelo na Meta",
  "agenda.notice.meta_text": "Fora da janela de 24 h, o aviso sai pelo modelo {name}, depois que a Meta aprovar. No idioma da empresa ele usa este texto; nos outros, o texto sugerido pelo DoneTalk.",
  "agenda.notice.meta_create": "Criar na Meta",
  "agenda.notice.meta_hint": "A Meta costuma analisar em minutos. Enquanto isso, com a conversa aberta, o aviso já sai como mensagem normal.",
  "agenda.notice.meta_needs_channels": "Para criar o modelo na Meta, peça a quem cuida dos números do WhatsApp.",
  "agenda.notice.meta_sent": "Modelos enviados para a análise da Meta.",
  "agenda.notice.meta_failed": "1 modelo não foi criado. Veja o motivo na janela.|{count} modelos não foram criados. Veja os motivos na janela.",
  "agenda.notice.meta_result_failed": "não criado ({error})",
  "agenda.notice.account": "Conta do WhatsApp",
  "agenda.notice.no_reply_title": "Se o cliente não confirmar",
  "agenda.notice.no_reply_text": "O prazo e o que fazer quando o cliente não responde são escolhidos em cada tipo de agendamento: avisar quem atende e manter, liberar o horário e avisar o cliente, ou mandar o pedido de novo.",
  "agenda.notice.no_reply_line": "{type}: sem resposta até {until}, {then}.",
  "agenda.notice.no_reply_none": "Nenhum tipo pede confirmação ainda.",
  "agenda.team.title": "Para a equipe",
  "agenda.team.push": "Aviso no app e no celular ao marcar, remarcar e cancelar",
  "agenda.team.summary": "Resumo do dia",
  "agenda.team.summary_hint": "Cada pessoa recebe de manhã os compromissos do dia.",
  "agenda.team.summary_at": "Resumo às",
  "agenda.team.email": "E-mail com o convite (.ics)",
  "agenda.team.email_hint": "Quem atende recebe o compromisso por e-mail para pôr em qualquer agenda.",
  "agenda.saving.title": "Economia",
  "agenda.saving.window": "Mandar como mensagem normal quando a conversa estiver aberta",
  "agenda.saving.window_hint": "Dentro da janela de 24 h, o aviso sai como mensagem comum com os mesmos botões: grátis até 1.000 por número por mês.",
  "agenda.saving.quiet": "Não mandar avisos de madrugada",
  "agenda.saving.quiet_hint": "Um aviso que cairia nesse horário sai antes dele.",
  "agenda.saving.quiet_from": "Entre",
  "agenda.saving.quiet_to": "e",
  "agenda.saving.quiet_from_label": "Início do silêncio",
  "agenda.saving.quiet_to_label": "Fim do silêncio",
  "agenda.wa.title": "Calendário do WhatsApp",
  "agenda.wa.text": "Um calendário dentro da conversa: o cliente escolhe o dia e a hora sem sair do WhatsApp. É preparado uma vez em cada conta do WhatsApp; depois os fluxos podem usar.",
  "agenda.wa.status.published": "Pronto",
  "agenda.wa.status.pending": "Preparando",
  "agenda.wa.status.failed": "Deu erro",
  "agenda.wa.status.none": "Não preparado",
  "agenda.wa.setup": "Preparar o calendário",
  "agenda.wa.again": "Preparar de novo",
  "agenda.wa.done": "Calendário enviado para a Meta.",
  "agenda.wa.failed": "1 conta deu erro.|{count} contas deram erro.",
  "agenda.wa.no_account": "Conecte um número de WhatsApp primeiro.",
  "agenda.wa.needs_channels": "Para preparar, peça a quem cuida dos números do WhatsApp.",
  "agenda.var.name": "nome",
  "agenda.var.type": "tipo",
  "agenda.var.date": "data",
  "agenda.var.time": "hora",
  "agenda.var.place": "local",
  "agenda.var.with": "com quem",
  "agenda.var.link": "link da agenda",
  "agenda.var.previous": "horário antigo",
  "agenda.lang.pt-BR": "Português",
  "agenda.lang.es": "Espanhol",
  "agenda.lang.en": "Inglês",
  "agenda.sample.name": "Ana",
  "agenda.sample.contact": "Ana Souza",
  "agenda.sample.type": "Avaliação",
  "agenda.sample.date": "sexta-feira, 10 de outubro",
  "agenda.sample.time": "14:30",
  "agenda.sample.place": "Av. Paulista, 1000",
  "agenda.sample.with": "Paulo",
  "agenda.sample.previous": "quinta-feira, 9 de outubro, 10:00",
  "agenda.notice.preset.confirmation": "Olá, {{name}}! Seu horário de {{type}} está marcado para {{date}}, às {{time}}, com {{with}}.\n\n📍 {{place}}\n\nPara guardar na sua agenda: {{link}}\n\nSe precisar mudar, toque abaixo.",
  "agenda.notice.preset.confirm_request": "Olá, {{name}}! Seu horário de {{type}} é {{date}}, às {{time}}, em {{place}}.\n\nVocê confirma a presença?",
  "agenda.notice.preset.reminder": "Olá, {{name}}! Lembrete: seu horário de {{type}} é {{date}}, às {{time}}, com {{with}}.\n\n📍 {{place}}\n\nAté lá!",
  "agenda.notice.preset.rescheduled": "Olá, {{name}}! Seu horário de {{type}} mudou de {{previous}} para {{date}}, às {{time}}, com {{with}}.\n\n📍 {{place}}\n\nPara guardar na sua agenda: {{link}}",
  "agenda.notice.preset.cancelled": "Olá, {{name}}. Seu horário de {{type}} de {{date}}, às {{time}}, foi cancelado.\n\nSe quiser, marcamos outro dia.",
  "agenda.notice.preset.no_show": "Olá, {{name}}. Não conseguimos te encontrar no horário de {{type}} de {{date}}, às {{time}}.\n\nQuer marcar outro horário?",
  "mycal.lead": "Conecte a sua agenda para que ninguém marque nada em cima dos seus compromissos. O DoneTalk lê o que está ocupado e grava ali o que for marcado com você.",
  "mycal.empty": "Nenhuma agenda conectada ainda. Escolha abaixo.",
  "mycal.busy": "Conta como ocupado",
  "mycal.write": "Grava aqui",
  "mycal.read_only": "só leitura",
  "mycal.primary": "principal",
  "mycal.no_calendars": "Nenhuma agenda encontrada nessa conta.",
  "mycal.sync": "Atualizar agora",
  "mycal.synced": "Agenda atualizada.",
  "mycal.reconnect": "Conectar de novo",
  "mycal.disconnect": "Desconectar",
  "mycal.disconnect_title": "Desconectar esta agenda?",
  "mycal.disconnect_text": "O DoneTalk para de ler os horários ocupados e de gravar compromissos nela. Os eventos já gravados continuam lá.",
  "mycal.disconnected": "Agenda desconectada",
  "mycal.soon": "em breve",
  "mycal.connect.title": "Conectar uma agenda",
  "mycal.connect.action": "Conectar",
  "mycal.connect.privacy": "O DoneTalk lê só os horários ocupados (não o que é cada compromisso) e grava os compromissos marcados com você.",
  "mycal.provider.google": "Google Agenda",
  "mycal.provider.microsoft": "Outlook e Microsoft 365",
  "mycal.provider.icloud": "Apple iCloud",
  "mycal.provider.caldav": "Outra (CalDAV)",
  "mycal.provider.caldav_short": "iCloud ou CalDAV",
  "mycal.provider.ics": "Só um link da agenda",
  "mycal.provider_hint.google": "Lê o ocupado, grava e fica sabendo das mudanças na hora.",
  "mycal.provider_hint.microsoft": "Contas da empresa e pessoais (outlook.com, hotmail).",
  "mycal.provider_hint.icloud": "Com uma senha de app criada no ID Apple.",
  "mycal.provider_hint.caldav": "Zoho, Fastmail, Nextcloud e afins.",
  "mycal.provider_hint.ics": "Somente leitura, quando a empresa não deixa conectar.",
  "mycal.result.connected": "Agenda conectada.",
  "mycal.result.denied": "Você não autorizou o acesso. Tente de novo quando quiser.",
  "mycal.result.expired": "O tempo para conectar acabou. Tente de novo.",
  "mycal.result.consent_required": "A sua empresa precisa aprovar o DoneTalk na Microsoft. Mande o link para o TI.",
  "mycal.result.needs_consent": "A sua empresa precisa aprovar o DoneTalk na Microsoft. Mande o link para o TI.",
  "mycal.result.failed": "Não foi possível conectar. Tente de novo.",
  "mycal.result.admin_consented": "O TI aprovou o DoneTalk. Agora conecte a sua conta.",
  "mycal.it.title": "A Microsoft pede a aprovação do TI",
  "mycal.it.text": "Na maioria das empresas o TI precisa aprovar o DoneTalk uma vez. Mande este link para o TI; depois disso, toda a equipe conecta sozinha.",
  "mycal.it.copy": "Copiar o link para o TI",
  "mycal.it.copied": "Link copiado. Mande para o TI da sua empresa.",
  "mycal.it.copy_failed": "Não foi possível copiar o link. Tente de novo.",
  "mycal.caldav.title": "Outra agenda (CalDAV)",
  "mycal.caldav.icloud_title": "Apple iCloud",
  "mycal.caldav.icloud_help": "Na Apple, crie uma senha de app (Entrar e segurança › Senhas de app) e cole aqui. Não use a sua senha normal.",
  "mycal.caldav.icloud_link": "Abrir account.apple.com",
  "mycal.caldav.help": "Zoho, Fastmail, Nextcloud e afins: use o endereço CalDAV e a senha de app que o serviço mostra nas configurações.",
  "mycal.caldav.url": "Endereço do servidor",
  "mycal.caldav.apple_id": "E-mail da conta Apple",
  "mycal.caldav.username": "Usuário",
  "mycal.caldav.app_password": "Senha de app",
  "mycal.caldav.password": "Senha (de app, se o serviço tiver)",
  "mycal.caldav.safe": "A senha fica guardada com criptografia e só serve para ler e gravar a sua agenda.",
  "mycal.ics.title": "Só um link da agenda",
  "mycal.ics.url": "Link da agenda (.ics)",
  "mycal.ics.help": "No Google: Configurações da agenda › Endereço secreto no formato iCal. No Outlook: Calendário › Compartilhado › Publicar a agenda.",
  "mycal.ics.limits": "Só leitura: mostra o ocupado, atualiza a cada 15 min e não grava os compromissos.",
  "mycal.error.login": "Usuário ou senha recusados. Confira e use uma senha de app.",
  "mycal.error.unreachable": "Não conseguimos falar com esse endereço. Confira e tente de novo.",
  "mycal.error.invalid": "Confira o endereço: ele precisa começar com https://.",
  "agenda.var_token.name": "nome",
  "agenda.var_token.type": "tipo",
  "agenda.var_token.date": "data",
  "agenda.var_token.time": "hora",
  "agenda.var_token.place": "local",
  "agenda.var_token.with": "com_quem",
  "agenda.var_token.link": "link",
  "agenda.var_token.previous": "horario_antigo",
  "book.send_confirmation": "Mandar a confirmação no WhatsApp agora",
  "book.confirmation_held": "A confirmação não vai agora; os lembretes saem no horário de sempre.",
  "report.agenda.source_named.assistant": "Assistente {name}",
  "report.agenda.source_named.flow": "Fluxo {name}",
  "agenda.holidays.see": "Ver a lista de {year}",
  "agenda.holidays.list_title": "Feriados de {year}",
  "agenda.holidays.list_hint": "Feriados do seu estado e da sua cidade entram como datas especiais.",
  "agenda.holiday.new_year": "Confraternização Universal",
  "agenda.holiday.tiradentes": "Tiradentes",
  "agenda.holiday.labour_day": "Dia do Trabalho",
  "agenda.holiday.independence": "Independência do Brasil",
  "agenda.holiday.aparecida": "Nossa Senhora Aparecida",
  "agenda.holiday.all_souls": "Finados",
  "agenda.holiday.republic": "Proclamação da República",
  "agenda.holiday.black_consciousness": "Dia da Consciência Negra",
  "agenda.holiday.christmas": "Natal",
  "agenda.holiday.good_friday": "Sexta-feira Santa",
  "agenda.holiday.carnival_monday": "Carnaval (segunda)",
  "agenda.holiday.carnival_tuesday": "Carnaval (terça)",
  "agenda.holiday.corpus_christi": "Corpus Christi",
  "agenda.preview.holiday": "Feriado",
  "agenda.calendars.connect_mine": "Conectar minha agenda",
  "conversas.handoff.assistant_requested": "A IA pediu uma pessoa",
  "conversas.handoff.exit_condition": "A IA chegou à condição de saída",
  "conversas.handoff.max_turns": "A IA chegou ao limite de respostas",
  "conversas.handoff.ai_error": "A IA não conseguiu responder",
  "conversas.handoff.review_hold": "A revisão segurou a resposta da IA",
  "conversas.handoff.assistant_finished": "A IA terminou a parte dela",
  "conversas.card.context": "Contexto",
  "settings.import": "Importar dados",
  "settings.find.import": "importar trazer migrar copiloto outra plataforma histórico",
  "settings.find.import-copiloto": "copiloto chave migração histórico conversas",
  "import.lead": "Traga contatos e conversas de outra plataforma. O DoneTalk só lê: nada é apagado na origem.",
  "import.who": "Só Dono e Administrador veem esta área. Conectar, importar e cancelar ficam na auditoria.",
  "import.copiloto.title": "Copiloto",
  "import.copiloto.lead": "Contatos, conversas com fotos e áudios, etiquetas, notas e motivos de encerramento.",
  "import.copiloto.address": "Endereço do Copiloto",
  "import.copiloto.other_address": "Outro endereço",
  "import.copiloto.address_other": "Endereço",
  "import.copiloto.key": "Chave de migração",
  "import.copiloto.key_hint": "Um administrador da conta gera no Copiloto, em Perfil › API › Chave de migração. Vale até 7 dias e só lê.",
  "import.copiloto.connect": "Conectar",
  "import.open.title": "Importação de {account}",
  "import.csv.title": "Planilha de contatos",
  "import.csv.lead": "Só contatos, de um arquivo CSV. Fica em Contatos › Importar.",
  "import.others.title": "Outras plataformas",
  "import.others.lead": "Em breve. Quem vem de outro sistema pode pedir pelo suporte.",
  "import.past": "Importações anteriores",
  "import.page.title": "Do Copiloto · {account}",
  "import.status.connected": "Conectada",
  "import.status.running": "Importando",
  "import.status.paused": "Pausada",
  "import.status.done": "Concluída",
  "import.status.failed": "Parou",
  "import.status.cancelled": "Cancelada",
  "import.step": "Passo {n} de {of}",
  "import.step1.title": "o que vem",
  "import.step2.title": "ligar ao DoneTalk",
  "import.continue": "Continuar",
  "import.start": "Começar a importação",
  "import.cancel": "Cancelar",
  "import.cancel_keep": "Cancelar (o que já veio fica)",
  "import.pause": "Pausar",
  "import.resume": "Retomar",
  "import.open_item": "Abrir",
  "import.numbers.title": "Números",
  "import.numbers.official": "API oficial",
  "import.numbers.qr": "QR code: só o histórico vem",
  "import.numbers.conversations": "{count} conversa|{count} conversas",
  "import.numbers.waits_connection": "Entra no DoneTalk esperando a conexão pela Meta, com o histórico.",
  "import.numbers.on_channel": "O histórico vai para o número {name}.",
  "import.numbers.qr_target": "Ligar ao número oficial",
  "import.numbers.same_as": "O mesmo de {name}",
  "import.numbers.qr_needs_official": "Escolha antes um número da API oficial para receber este histórico.",
  "import.period.title": "Período",
  "import.period.all": "Tudo, desde a primeira conversa ({date})",
  "import.period.12m": "Últimos 12 meses",
  "import.period.6m": "Últimos 6 meses",
  "import.period.retention": "A empresa guarda as mensagens por {days} dias: conversas mais antigas que isso não vêm.",
  "import.include.title": "O que vem",
  "import.include.totals": "{contacts} contatos, {conversations} conversas e {messages} mensagens no Copiloto.",
  "import.include.files": "Fotos, áudios, vídeos e documentos ({count})",
  "import.include.notes": "Notas da equipe",
  "import.include.assistant": "Instruções da IA como rascunho de assistente",
  "import.never": "Nunca vem: conversas do simulador e de teste, grupos, tokens e senhas, negócios e funis do CRM.",
  "import.people.title": "Quem mandou as mensagens",
  "import.people.lead": "Cada pessoa do Copiloto ligada à conta dela no DoneTalk, encontrada pelo e-mail. Quem não tem conta aparece com o nome.",
  "import.people.no_account": "Sem conta: só o nome",
  "import.people.assistant": "As mensagens da IA aparecem como do assistente criado a partir dela.",
  "import.people.same_contact": "Contato que já existe no DoneTalk é juntado pelo número, com ou sem o nono dígito.",
  "import.reasons.title": "Motivos de encerramento → desfechos",
  "import.reasons.lead": "Cada motivo do Copiloto vira um desfecho. \"Pediu para sair\" também marca o contato como sem marketing.",
  "import.reasons.create": "Criar: {name}",
  "import.reasons.none": "Sem desfecho",
  "import.running.lead": "Pode fechar esta tela e seguir usando o DoneTalk. O andamento aparece aqui.",
  "import.progress.title": "Andamento",
  "import.progress.contacts": "Contatos",
  "import.progress.conversations": "Conversas",
  "import.progress.messages": "Mensagens",
  "import.progress.files": "Arquivos",
  "import.progress.of": "{done} de {total}",
  "import.progress.files_missing": "{count} arquivo o Copiloto não tinha guardado: aparece como indisponível na conversa.|{count} arquivos o Copiloto não tinha guardado: aparecem como indisponíveis na conversa.",
  "import.progress.matched": "{count} contato já existia no DoneTalk e foi juntado pelo número.|{count} contatos já existiam no DoneTalk e foram juntados pelo número.",
  "import.progress.no_phone": "{count} contato sem número de WhatsApp ficou de fora.|{count} contatos sem número de WhatsApp ficaram de fora.",
  "import.progress.groups": "{count} conversa de grupo ficou de fora.|{count} conversas de grupo ficaram de fora.",
  "import.progress.assistant_unavailable": "A configuração da IA não pôde ser lida: crie o assistente à mão.",
  "import.failed.title": "A importação parou",
  "import.failed.key": "O Copiloto não aceitou mais a chave (venceu ou foi revogada). Gere outra e conecte de novo: o que já veio não se repete.",
  "import.failed.other": "O Copiloto não respondeu depois de várias tentativas. Conecte de novo daqui a pouco: o que já veio não se repete.",
  "import.failed.again": "Conectar de novo",
  "import.todo.title": "O que ainda falta montar no DoneTalk",
  "import.todo.assistant": "Revisar o rascunho do assistente e ligar no número",
  "import.todo.closing": "Encerrar conversas paradas, como o Copiloto fazia",
  "import.todo.systems": "Sistemas da empresa que usavam a API do Copiloto passam a usar a do DoneTalk",
  "import.todo.templates": "Modelos de mensagem: vêm da Meta com o número",
  "import.key.kept": "A chave de migração fica guardada com criptografia até a busca final.",
  "import.key.gone": "A chave de migração foi apagada daqui. No Copiloto ela pode ser revogada antes de vencer.",
  "import.finished_at": "terminou em {when}",
  "import.switch.title": "Trocar o número para o DoneTalk",
  "import.switch.lead": "O número continua o mesmo, na mesma conta de WhatsApp: sem código por SMS, e os modelos aprovados vêm junto.",
  "import.switch.both": "Enquanto o Copiloto e o DoneTalk estiverem ligados à conta, os dois recebem cada mensagem. Faça os passos 2 a 5 no mesmo dia, fora do horário de mais movimento.",
  "import.switch.who.copiloto": "Copiloto",
  "import.switch.who.meta": "Meta",
  "import.switch.ready.title": "Deixe o DoneTalk pronto",
  "import.switch.ready.body": "O histórico já está aqui. Revise o assistente, a equipe e os horários antes de ligar o número.",
  "import.switch.ai.title": "No Copiloto, desligue a IA do número",
  "import.switch.ai.body": "Agentes de IA › o número › desligar as respostas. Assim só o DoneTalk responde depois do passo 3.",
  "import.switch.ai.done": "Marcado como feito em {when}.",
  "import.switch.ai.mark": "Já desliguei",
  "import.switch.ai.undo": "Desmarcar",
  "import.switch.connect.title": "Conecte o número no DoneTalk",
  "import.switch.connect.body": "Em Números, clique em Conectar com a Meta e escolha a mesma empresa, conta de WhatsApp e número. Sem código por SMS.",
  "import.switch.connect.done": "Conectado. As mensagens novas já chegam no DoneTalk.",
  "import.switch.connect.go": "Ir para Números",
  "import.switch.final.title": "Busca final",
  "import.switch.final.body": "Depois de conectar, o DoneTalk busca no Copiloto o que chegou desde a importação. Uns minutos.",
  "import.switch.final.done": "Feita. O que chegou no meio da troca já está aqui.",
  "import.switch.final.run": "Fazer a busca final",
  "import.switch.disconnect.title": "No Copiloto, desconecte o número",
  "import.switch.disconnect.after": "Depois da busca final: Configurações › WhatsApp › Desconectar. O DoneTalk confere sozinho.",
  "import.switch.disconnect.still": "Ainda ligado à conta de WhatsApp: {apps}. Desconecte no Copiloto e confira de novo.",
  "import.switch.disconnect.done": "Só o DoneTalk recebe as mensagens deste número.",
  "import.switch.disconnect.unknown": "Não foi possível conferir agora. Tente de novo em instantes.",
  "import.switch.disconnect.recheck": "Conferir de novo",
  "import.switch.systems": "Campanhas, avisos e sistemas da empresa que usam a API do Copiloto param no passo 5: eles precisam passar a usar a API do DoneTalk antes.",
  "numbers.waiting_connection": "Esperando conexão",
  "numbers.imported.lead": "Veio do Copiloto com o histórico. Para ativar, conecte pela janela da Meta escolhendo esta mesma conta e este número.",
  "numbers.imported.connect": "Conectar com a Meta",
  "numbers.imported.see_import": "Ver a importação",
  "contact.history_copiloto": "Histórico do Copiloto",
  "errors.import_key_rejected": "O Copiloto não aceitou a chave. Confira se ela foi copiada inteira, se não venceu e se a função de migração está ligada.",
  "errors.import_address_invalid": "Esse endereço não pode ser usado. Use o endereço do Copiloto, com https.",
  "errors.import_source_unreachable": "O Copiloto não respondeu. Tente de novo em instantes.",
  "errors.import_source_busy": "O Copiloto pediu para esperar um pouco. Tente de novo em um minuto.",
  "errors.import_open": "Já existe uma importação em andamento. Conclua ou cancele antes de começar outra.",
  "errors.import_not_editable": "Essa importação já começou: as escolhas não podem mais mudar.",
  "errors.import_not_startable": "Essa importação não pode começar agora.",
  "errors.import_wrong_state": "Essa ação não vale no momento atual da importação.",
  "errors.import_key_gone": "A chave de migração já foi apagada. Gere outra no Copiloto e conecte de novo.",
  "message.imported": "Veio do Copiloto",
  "message.imported_by": "Veio do Copiloto · enviada por {name}",
  "message.file_unavailable": "arquivo indisponível",
  "numbers.meta.steps_title": "Na janela da Meta",
  "numbers.meta.importing": "Vai trazer números do Copiloto? Não conecte por aqui agora: comece pela importação. Eles são conectados no dia da troca.",
  "numbers.meta.importing_link": "Importar do Copiloto",
  "campaigns.var.value": "Valor da integração: {name}",
  "team.capacity_hint": "Quantas conversas cada pessoa atende ao mesmo tempo, de 0 a {max}.",
  "errors.validation_field": "Confira o campo “{field}” e tente de novo.",
  "field.defaultCapacity": "Capacidade por pessoa",
  "field.capacityOverride": "Capacidade da pessoa",
  "field.name": "Nome",
  "field.email": "E-mail",
  "field.phone": "Telefone",
  "numbers.handling.first": "Quem atende primeiro",
  "numbers.handling.people": "As pessoas da equipe",
  "numbers.handling.flow": "Fluxo: {name}",
  "numbers.handling.team": "Equipe do número",
  "numbers.handling.no_team": "Nenhuma equipe",
  "numbers.handling.hint": "As mensagens que chegam neste número vão para a equipe escolhida.",
  "numbers.handling.hint_assistant": "A assistente responde quem escreve neste número e passa para a equipe quando precisa de uma pessoa.",
  "numbers.handling.saved": "Atendimento do número salvo",
  "numbers.handling.hint_flow": "O fluxo responde primeiro; quando ele passa para uma pessoa, a conversa vai para a equipe escolhida.",
  "numbers.disconnect": "Desconectar",
  "numbers.disconnect_title": "Desconectar o {number}?",
  "numbers.disconnect_lead": "O número sai do DoneTalk:",
  "numbers.disconnect_1": "O DoneTalk para de receber e de enviar mensagens por ele, inclusive campanhas e avisos.",
  "numbers.disconnect_2": "As conversas continuam aqui, como histórico.",
  "numbers.disconnect_3": "Na Meta nada muda: o número continua registrado e funcionando em outros sistemas que usem ele.",
  "numbers.disconnect_4": "Para usar de novo, é só conectar pela Meta.",
  "numbers.disconnect_keep": "Manter conectado",
  "numbers.disconnected": "Número desconectado.",
  "numbers.disconnected_meta_failed": "Número desconectado. A Meta não respondeu agora, mas o que ela mandar para ele será ignorado.",
  "numbers.off_since": "Desconectado do DoneTalk em {date}. Nada chega nem sai por ele aqui.",
  "numbers.off_lead": "Este número está desligado: nada chega nem sai por ele aqui.",
  "numbers.off_hint": "As conversas dele continuam no histórico. Para usar de novo, conecte pela Meta.",
  "delivery.error.channel_disconnected": "O número foi desconectado do DoneTalk. Conecte de novo em Configurações › Números para enviar.",
  "errors.number_rented": "Este número foi alugado pelo DoneTalk: encerre o aluguel no próprio cartão do número.",
  "onboarding.org.outcomes_locked_hint": "Os desfechos do DoneTalk ficam com o nome fixo: desmarque os que não servem e crie os seus no fim da lista.",
  "onboarding.org.outcome_locked": "Desfecho do DoneTalk: o nome não muda. Desmarque para não usar.",
  "select.chosen": "1 escolhido|{count} escolhidos",
  "select.add": "Adicionar “{value}”",
  "assistant.language_auto": "O mesmo do contato",
  "assistant.tone_option.cordial": "Cordial",
  "assistant.tone_option.friendly": "Amigável",
  "assistant.tone_option.objective": "Objetivo",
  "assistant.tone_option.formal": "Formal",
  "assistant.tone_option.relaxed": "Descontraído",
  "assistant.tone_option.empathetic": "Empático",
  "assistant.tone_option.welcoming": "Acolhedor",
  "assistant.tone_option.patient": "Paciente",
  "assistant.tone_option.direct": "Direto",
  "assistant.tone_option.humorous": "Bem-humorado",
  "assistant.tone_option.enthusiastic": "Entusiasmado",
  "assistant.tone_option.professional": "Profissional",
  "assistant.tone_option.technical": "Técnico",
  "assistant.tone_option.consultative": "Consultivo",
  "assistant.tone_option.persuasive": "Persuasivo",
  "assistant.tone_option.calm": "Calmo",
  "assistant.tone_option.respectful": "Respeitoso",
  "assistant.tone_option.simple": "Simples",
  "builder.missing_choice": "Falta escolher {field} no bloco “{block}” ({id}).",
  "builder.invalid_generic": "O fluxo tem um bloco incompleto. Confira os blocos e tente de novo.",
  "composer.link_preview_remove": "Enviar sem a prévia do link",
  "message.list_view_only": "Só para ver: quem escolhe é o cliente, no WhatsApp.",
  "message.list_chosen": "Escolhida pelo cliente",
  "knowledge.source.file": "Arquivo",
  "knowledge.file_choose": "Escolher arquivo",
  "knowledge.file_change": "Trocar arquivo",
  "knowledge.file_reading": "Lendo o arquivo…",
  "knowledge.file_ready": "{name}: {chars} caracteres de texto.",
  "knowledge.file_hint": "PDF, Markdown (.md) ou texto (.txt). O texto é lido aqui no navegador; PDFs escaneados (só imagem) não têm texto para ler.",
  "knowledge.file_unsupported": "Esse tipo de arquivo não é aceito. Use PDF, Markdown (.md) ou texto (.txt).",
  "knowledge.file_empty": "Esse arquivo está vazio.",
  "knowledge.file_unreadable": "Não foi possível ler esse arquivo.",
  "list.drag": "Arrastar {name} para mudar a ordem (ou use as setas ↑ ↓)",
  "ai.surface.flow.choice": "Menu respondido por escrito",
  "replies.title": "Respostas do fluxo e do assistente",
  "replies.hint": "Várias mensagens seguidas recebem uma resposta só. Um toque num botão é respondido na hora.",
  "replies.answer": "Responder",
  "replies.after_last": "depois da última mensagem do contato",
  "replies.wait": "Tempo de espera",
  "replies.seconds": "{n} segundos",
  "replies.at_once": "logo",
  "node.field.menu_text": "Quando escrevem em vez de tocar",
  "node.menu_text.understand": "A IA entende e segue",
  "node.menu_text.fallback": "Segue por \"Sem resposta válida\"",
  "node.menu_text.resend": "Manda o menu de novo",
  "node.menu_text_hint.understand": "A IA lê o que a pessoa escreveu e escolhe a opção certa. Se não der para saber, segue por \"Sem resposta válida\" (ou manda o menu de novo, se essa saída não estiver ligada).",
  "node.menu_text_hint.fallback": "Só o nome exato de uma opção vale. O resto segue por \"Sem resposta válida\" (ou manda o menu de novo, se essa saída não estiver ligada).",
  "node.menu_text_hint.resend": "Só o nome exato de uma opção vale. O resto recebe o texto ao não entender e o menu de novo; quando acabam as tentativas, segue por \"Sem resposta válida\".",
  "inbox.header.attendances": "{n} atendimentos",
  "event.taken_over.flow": "{name} escreveu e assumiu · o fluxo pausou",
  "event.taken_over.assistant": "{name} escreveu e assumiu · o assistente pausou",
  "event.reason.member_reply": "Escreveu na conversa",
  "handoff.from_label": "Começar",
  "handoff.from.beginning": "Do início",
  "handoff.from.resume": "De onde parou: {step}",
  "handoff.from.step": "Numa etapa escolhida",
  "handoff.step_label": "Etapa",
  "errors.flow_not_stopped": "Esse fluxo não parou nesta conversa: comece do início ou numa etapa.",
  "errors.flow_step_not_found": "Essa etapa não existe mais na versão publicada do fluxo.",
  "outcome.when_label": "Quando concluir",
  "outcome.when.now": "Agora",
  "outcome.when.hour": "Se não responder em 1 hora",
  "outcome.when.hours": "Se não responder em {n} horas",
  "outcome.when.day": "Se não responder em 1 dia",
  "outcome.when.days": "Se não responder em {n} dias",
  "outcome.when_hint": "Enquanto isso a conversa fica aguardando o contato. Se ele responder antes, a conclusão é cancelada.",
  "outcome.schedule": "Agendar",
  "outcome.scheduled": "Conclusão agendada.",
  "inbox.scheduled_close.chip": "Conclui em {time} · {outcome}",
  "inbox.scheduled_close.tip": "Conclui como {outcome} em {when}, se o contato não responder antes.",
  "inbox.scheduled_close.cancel": "Cancelar conclusão agendada",
  "inbox.scheduled_close.cancelled": "Conclusão agendada cancelada.",
  "event.close_scheduled": "Concluir como {outcome} em {when} se o contato não responder",
  "event.close_unscheduled.contact_replied": "Conclusão agendada cancelada: o contato respondeu",
  "event.close_unscheduled.cancelled": "{name} cancelou a conclusão agendada",
  "event.close_unscheduled.failed": "A conclusão agendada não aconteceu: o desfecho foi desativado ou passou a pedir observação",
  "node.split": "Dividir",
  "node.repeat": "Repetir",
  "node.goto_flow": "Ir para outro fluxo",
  "node.optout": "Mensagens automáticas",
  "builder.exit_path": "Caminho {n} · {pct}%",
  "builder.exit_repeat_loop": "Repetir (até {n}×)",
  "builder.exit_repeat_done": "Já repetiu",
  "builder.exit_reply": "Se o cliente responder",
  "builder.exit_timeout": "{time} sem resposta",
  "builder.repeat_summary": "Até {n}×",
  "node.optout.label": "Mensagens automáticas",
  "node.optout.on": "Volta a receber",
  "node.optout.off": "Para de receber",
  "node.optout.hint": "\"Para de receber\" registra o descadastro do contato: campanhas e mensagens automáticas deixam de ir para ele. \"Volta a receber\" registra que ele aceitou de novo.",
  "node.field.flow": "Fluxo",
  "node.goto_flow.hint": "A conversa entra no fluxo escolhido (publicado) e este termina aqui. O que este fluxo guardou não passa para o outro.",
  "node.field.option_keywords": "Também aceita",
  "node.field.option_keywords_placeholder": "palavras, apelidos… Enter para incluir",
  "node.field.own_timeout": "Esperar resposta por (minutos)",
  "node.field.own_timeout_placeholder": "O tempo do fluxo",
  "node.field.own_timeout_hint": "Com um tempo aqui, aparece a saída \"sem resposta\" deste bloco. Vazio, vale o tempo de inatividade do fluxo.",
  "node.condition.subject": "Sobre",
  "node.condition.subject.tag": "Etiqueta do contato",
  "node.condition.subject.field": "Campo do contato",
  "node.condition.subject.message": "Mensagem recebida",
  "node.condition.subject.assignee": "Atendente responsável",
  "node.condition.subject.window": "Janela de 24 horas",
  "node.condition.subject.variable": "Variável do fluxo",
  "node.condition.window_open": "Aberta",
  "node.condition.window_closed": "Fechada",
  "node.condition.label.tag_with": "Tem a etiqueta {tag}",
  "node.condition.label.tag_without": "Não tem a etiqueta {tag}",
  "node.condition.label.assignee_any": "Tem atendente",
  "node.condition.label.assignee_is": "Atendente é {name}",
  "node.condition.label.assignee_not": "Atendente não é {name}",
  "node.condition.label.window_open": "Janela de 24 h aberta",
  "node.condition.label.window_closed": "Janela de 24 h fechada",
  "op.not_contains": "não contém",
  "node.tag.add": "Adicionar etiquetas",
  "node.tag.remove": "Remover etiquetas",
  "node.split.paths": "Caminhos",
  "node.split.weight": "Peso",
  "node.split.add": "Adicionar caminho",
  "node.split.hint": "Cada conversa segue um caminho sorteado, na proporção dos pesos: bom para testar duas mensagens ou dividir o trabalho.",
  "node.repeat.times": "Quantas vezes repetir",
  "node.repeat.hint": "Nas primeiras vezes que a conversa passa aqui, segue por \"Repetir\"; depois, uma vez por \"Já repetiu\", e a contagem recomeça.",
  "node.ai_route": "Triagem com IA",
  "node.ai_condition": "Condição com IA",
  "node.ai_tags": "Etiquetas pela IA",
  "node.ai_fields": "Campos pela IA",
  "ai.surface.flow.blocks": "Blocos de IA dos fluxos",
  "builder.exit_ai_unsure": "IA não identificou",
  "builder.exit_yes": "Sim",
  "builder.exit_no": "Não",
  "builder.default_route": "Caminho {n}",
  "node.ai_route.reads_message": "Lê a mensagem do cliente",
  "node.ai_route.prompt": "Pergunta (opcional)",
  "node.ai_route.prompt_hint": "Com uma pergunta, a IA lê a resposta. Sem pergunta, lê a mensagem que trouxe o cliente até aqui.",
  "node.ai_route.routes": "Caminhos",
  "node.ai_route.label": "Nome do caminho (ex.: Financeiro)",
  "node.ai_route.description": "Quando seguir por aqui (ex.: boleto, pagamento, nota fiscal)",
  "node.ai_route.add": "Adicionar caminho",
  "node.ai_route.hint": "A IA escolhe o caminho que combina com o que o cliente precisa. Quando não dá para saber, segue por \"IA não identificou\".",
  "node.ai_condition.question": "Pergunta para a IA",
  "node.ai_condition.hint": "Uma pergunta de sim ou não sobre a conversa, como \"O cliente já decidiu cancelar?\". A IA responde \"Não\" quando a conversa não deixa claro.",
  "node.ai_tags.tags": "Etiquetas que a IA pode usar",
  "node.ai_tags.any": "Qualquer etiqueta",
  "node.ai_tags.instructions": "Orientação (opcional)",
  "node.ai_tags.hint": "A IA lê a conversa e coloca no contato as etiquetas que combinam. Sem nenhuma escolhida, pode usar todas.",
  "node.ai_fields.fields": "Campos do contato",
  "node.ai_fields.hint": "A IA preenche os campos com o que o cliente disse na conversa. Um campo que a conversa não diz fica como estava.",
  "node.message.vary": "Variar com IA",
  "node.message.vary_hint": "Cada cliente recebe a mesma mensagem com outras palavras, mantendo o sentido, links e números.",
  "builder.exit_other_reply": "Outra resposta",
  "builder.exit_replied": "Respondeu",
  "builder.tag_trigger": "Quando uma etiqueta é colocada no contato",
  "builder.tag_trigger_hint": "O fluxo começa na conversa aberta do contato. Sem conversa aberta, abre uma: comece então com um modelo aprovado, porque a janela de 24 horas está fechada.",
  "node.message.attach": "Anexar arquivo",
  "node.message.uploading": "Enviando…",
  "node.message.remove_file": "Tirar o arquivo",
  "node.message.file_hint": "O texto vai como legenda da foto, do vídeo ou do documento; com um áudio, vai logo depois.",
  "node.message.kind.image": "Foto",
  "node.message.kind.video": "Vídeo",
  "node.message.kind.audio": "Áudio",
  "node.message.kind.document": "Documento",
  "node.template.wait": "Esperar a resposta",
  "node.template.wait_hint": "O fluxo para aqui até o contato responder ao modelo, e segue por \"Respondeu\".",
  "node.template.by_button": "Um caminho por botão",
  "node.template.by_button_hint": "Cada botão de resposta rápida do modelo ganha a sua saída; o que não for botão segue por \"Outra resposta\".",
  "builder.remove_link": "Tirar esta ligação",
  "builder.search_blocks": "Buscar bloco",
  "builder.no_blocks": "Nenhum bloco com esse nome.",
  "builder.copied": "{count} bloco(s) copiado(s): ⌘/Ctrl+V cola aqui ou em outro fluxo.",
  "builder.pasted": "{count} bloco(s) colado(s).",
  "builder.group.messages": "Mensagens",
  "builder.group.ai": "Inteligência artificial",
  "builder.group.logic": "Caminhos",
  "builder.group.contact": "Contato",
  "builder.group.service": "Atendimento",
  "builder.group.integrations": "Integrações",
  "node.desc.message": "Envia um texto, com foto, vídeo, áudio ou documento se quiser.",
  "node.desc.template": "Envia um modelo aprovado: o único jeito de falar fora da janela de 24 horas. Pode esperar a resposta e seguir por botão.",
  "node.desc.menu": "Pergunta com opções (lista ou botões do WhatsApp); cada opção leva a um caminho.",
  "node.desc.input": "Faz uma pergunta e guarda a resposta, conferindo CPF, e-mail, data…",
  "node.desc.ai_route": "A IA entende o que o cliente precisa e segue pelo caminho certo.",
  "node.desc.ai_condition": "Uma pergunta de sim ou não sobre a conversa, respondida pela IA.",
  "node.desc.ai_tags": "A IA coloca no contato as etiquetas que combinam com a conversa.",
  "node.desc.ai_fields": "A IA preenche campos do contato com o que ele disse.",
  "node.desc.assistant": "Passa a conversa para um assistente de IA, que pode devolver ao fluxo.",
  "node.desc.condition": "Segue por caminhos diferentes conforme etiqueta, campo, mensagem, atendente ou janela de 24 h.",
  "node.desc.split": "Sorteia um caminho, na proporção que você escolher.",
  "node.desc.repeat": "Conta quantas vezes passou aqui: repete algumas vezes e depois segue outro caminho.",
  "node.desc.wait": "Espera um tempo, até uma data ou um horário; pode seguir antes se o cliente responder.",
  "node.desc.business_hours": "Um caminho dentro do horário de atendimento, outro fora.",
  "node.desc.tag": "Coloca e tira etiquetas do contato ou da conversa.",
  "node.desc.set_field": "Grava um valor num campo do contato.",
  "node.desc.set_variable": "Guarda um valor para usar mais adiante no fluxo.",
  "node.desc.optout": "Registra se o contato recebe mensagens automáticas (descadastro).",
  "node.desc.transfer": "Passa a conversa para uma pessoa ou equipe.",
  "node.desc.schedule": "Oferece horários livres e agenda com o cliente.",
  "node.desc.close": "Conclui o atendimento com um desfecho.",
  "node.desc.goto_flow": "Coloca a conversa em outro fluxo publicado.",
  "node.desc.end": "Termina o fluxo aqui.",
  "node.desc.http_request": "Chama um endereço de outro sistema e guarda a resposta.",
  "node.desc.script": "Calcula valores com um trecho de código.",
  "node.desc.event": "Avisa outros sistemas que algo aconteceu.",
  "node.desc.exception": "Para onde o fluxo vai quando algo dá errado.",
  "builder.undo": "Desfazer",
  "builder.redo": "Refazer",
  "builder.undo_hint": "Desfazer (⌘/Ctrl+Z)",
  "builder.redo_hint": "Refazer (⌘/Ctrl+Shift+Z)",
  "builder.shortcuts": "Atalhos do editor",
  "builder.versions_hint": "As versões publicadas: veja e volte para uma anterior.",
  "builder.triggers_hint": "Quando o fluxo começa: no número, por palavra, por etiqueta ou pelo assistente.",
  "builder.test_hint": "Converse com o fluxo aqui, sem mandar nada a ninguém.",
  "builder.save_hint": "Guarda as mudanças sem colocá-las no ar (⌘/Ctrl+S).",
  "builder.publish_hint": "Coloca no ar: as próximas conversas seguem esta versão.",
  "builder.shortcut.add.keys": "Clique num bloco do painel",
  "builder.shortcut.add.does": "Cria o bloco ligado ao bloco selecionado (ou no meio da tela).",
  "builder.shortcut.drop.keys": "Arrastar do painel",
  "builder.shortcut.drop.does": "Solta o bloco onde você quiser.",
  "builder.shortcut.link.keys": "Arrastar a bolinha de uma saída",
  "builder.shortcut.link.does": "Liga a outro bloco; solta no vazio para criar o próximo bloco já ligado.",
  "builder.shortcut.unlink.keys": "× no meio da ligação",
  "builder.shortcut.unlink.does": "Tira a ligação (aparece ao passar o mouse).",
  "builder.shortcut.select.keys": "Shift ou ⌘/Ctrl + clique",
  "builder.shortcut.select.does": "Escolhe vários blocos.",
  "builder.shortcut.box.keys": "Shift ou ⌘/Ctrl + arrastar",
  "builder.shortcut.box.does": "Escolhe os blocos dentro da área.",
  "builder.shortcut.all.keys": "⌘/Ctrl+A",
  "builder.shortcut.all.does": "Escolhe todos os blocos.",
  "builder.shortcut.copy.keys": "⌘/Ctrl+C",
  "builder.shortcut.copy.does": "Copia os blocos escolhidos.",
  "builder.shortcut.paste.keys": "⌘/Ctrl+V",
  "builder.shortcut.paste.does": "Cola no meio da tela, neste ou em outro fluxo.",
  "builder.shortcut.duplicate.keys": "⌘/Ctrl+D",
  "builder.shortcut.duplicate.does": "Duplica os blocos escolhidos.",
  "builder.shortcut.delete.keys": "Delete ou Backspace",
  "builder.shortcut.delete.does": "Apaga os blocos ou a ligação escolhidos.",
  "builder.shortcut.undo.keys": "⌘/Ctrl+Z",
  "builder.shortcut.undo.does": "Desfaz a última mudança.",
  "builder.shortcut.redo.keys": "⌘/Ctrl+Shift+Z",
  "builder.shortcut.redo.does": "Refaz o que foi desfeito.",
  "builder.shortcut.save.keys": "⌘/Ctrl+S",
  "builder.shortcut.save.does": "Salva o rascunho.",
  "builder.shortcut.arrange.keys": "Shift+Alt+T",
  "builder.shortcut.arrange.does": "Organiza os blocos.",
  "builder.shortcut.zoom.keys": "⌘/Ctrl + rolar, ou pinça",
  "builder.shortcut.zoom.does": "Aproxima e afasta; rolar sozinho move a tela.",
  "builder.shortcut.fit.keys": "⛶ no canto de baixo",
  "builder.shortcut.fit.does": "Mostra o fluxo inteiro.",
  "builder.channel_default_none": "Esta empresa ainda não tem número conectado. Depois de conectar, marque aqui o número cujas conversas novas começam por este fluxo.",
  "builder.start_when": "Quando este fluxo começa",
  "builder.start_none": "Nenhum gatilho ainda. Assim o fluxo só começa quando uma pessoa passa a conversa para ele ou quando outro fluxo vai para ele.",
  "builder.start_none_short": "Nenhum gatilho: clique para escolher quando começa",
  "builder.start_choose": "Escolher gatilhos",
  "builder.start_published_hint": "Os gatilhos valem para a versão publicada: enquanto o fluxo for só rascunho, nada começa sozinho.",
  "builder.start_line.channel_default": "Um contato inicia uma conversa no número {number}",
  "builder.start_line.keyword": "O contato escreve: {words}",
  "builder.start_line.tag_added": "A etiqueta {tag} é colocada no contato",
  "composer.format.bar": "Formatação",
  "composer.format.bold": "Negrito",
  "composer.format.italic": "Itálico",
  "composer.format.strike": "Tachado",
  "composer.format.code": "Código inline",
  "composer.format.numbered": "Lista enumerada",
  "composer.format.bulleted": "Lista com marcadores",
  "composer.format.quote": "Citar",
  "settings.api": "API",
  "api.title": "API",
  "api.lead": "Chaves para outros sistemas (ERP, CRM, site, automações) usarem o DoneTalk: criar e disparar campanhas, cadastrar contatos, mandar mensagens e mais. Cada chave só faz o que for marcado nela.",
  "api.address": "Endereço da API",
  "api.docs": "Ver documentação",
  "api.keys": "Chaves",
  "api.new_key": "Nova chave",
  "api.edit_key": "Editar chave",
  "api.key_name": "Nome",
  "api.key_name_placeholder": "Ex.: ERP da empresa",
  "api.environment": "Ambiente",
  "api.environment.live": "Produção",
  "api.environment.test": "Teste (não envia nada)",
  "api.environment.test_short": "Teste",
  "api.environment_hint": "Uma chave de teste responde como a de produção, com dados de exemplo, e não grava, não envia e não cobra nada.",
  "api.scopes": "O que esta chave pode fazer",
  "api.scopes_required": "Marque ao menos uma permissão.",
  "api.group.campaigns": "Campanhas",
  "api.group.contacts": "Contatos",
  "api.group.templates": "Modelos",
  "api.group.messages": "Mensagens e atendimentos",
  "api.group.flows": "Fluxos e agenda",
  "api.group.other": "Outros",
  "api.scope.campaigns:read": "Ver campanhas e resultados",
  "api.scope.campaigns:write": "Criar e editar rascunhos",
  "api.scope.campaigns:send": "Disparar, pausar e cancelar",
  "api.scope.contacts:read": "Ver contatos e os valores dos campos",
  "api.scope.contacts:write": "Criar e atualizar contatos",
  "api.scope.fields:read": "Ver a lista de campos",
  "api.scope.fields:write": "Criar campos",
  "api.scope.contacts:delete": "Apagar dados de contatos (LGPD)",
  "api.scope.templates:read": "Ver modelos",
  "api.scope.templates:write": "Criar e enviar modelos para a Meta",
  "api.scope.messages:send_template": "Enviar modelos",
  "api.scope.messages:send_text": "Enviar texto e arquivos (janela de 24h)",
  "api.scope.conversations:read": "Ver atendimentos e mensagens",
  "api.scope.conversations:write": "Concluir e reabrir atendimentos",
  "api.scope.flows:start": "Iniciar fluxos",
  "api.scope.appointments:read": "Ver agendamentos",
  "api.scope.appointments:write": "Marcar, remarcar e cancelar agendamentos",
  "api.scope.webhooks:manage": "Gerenciar avisos (webhooks)",
  "api.scope.reports:read": "Ver relatórios e custos",
  "api.scope.workspace:read": "Ver números, equipes e etiquetas",
  "api.scope.integrations:outboundpro": "Conectar ao OutboundPro Conversas",
  "api.skip_approval": "Disparar campanhas sem esperar aprovação",
  "api.skip_approval_hint": "Sem isso, as campanhas desta chave seguem a regra de aprovação da empresa. O orçamento vale sempre.",
  "api.expires": "Vale até (opcional)",
  "api.ips": "Só destes endereços IP (opcional)",
  "api.ips_hint": "Um por linha, como 200.155.12.10 ou 200.155.12.0/24. Vazio: qualquer endereço.",
  "api.create": "Criar chave",
  "api.created_title": "Chave criada",
  "api.created_hint": "Copie e guarde num lugar seguro. Por segurança, ela não aparece de novo.",
  "api.created_warning": "Quem tiver esta chave age em nome da empresa dentro do que você marcou. Se vazar, revogue e crie outra.",
  "api.copy_key": "Copiar chave",
  "api.legacy": "Acesso de integração (antiga)",
  "api.legacy_hint": "Feita antes das permissões por chave: faz tudo o que uma integração fazia. Escolha as permissões para limitá-la.",
  "api.all_scopes": "Tudo",
  "api.created_by": "criada por {name}",
  "api.expires_on": "vale até {date}",
  "api.revoke_confirm": "Revogar a chave {name}? O sistema que a usa para de funcionar na hora.",
  "api.empty": "Nenhuma chave ainda. Crie uma para conectar outro sistema.",
  "api.saved": "Chave salva",
  "api.keys_moved": "As chaves da API ficam em Configurações › API.",
  "integrations.event.campaign.started": "Campanha começou",
  "integrations.event.campaign.paused": "Campanha pausou",
  "integrations.event.campaign.resumed": "Campanha retomou",
  "integrations.event.campaign.completed": "Campanha concluiu",
  "integrations.event.campaign.cancelled": "Campanha cancelada",
  "integrations.event.campaign.recipient.sent": "Campanha: mensagem enviada",
  "integrations.event.campaign.recipient.delivered": "Campanha: mensagem entregue",
  "integrations.event.campaign.recipient.read": "Campanha: mensagem lida",
  "integrations.event.campaign.recipient.replied": "Campanha: contato respondeu",
  "integrations.event.campaign.recipient.failed": "Campanha: falhou para um contato",
  "integrations.event.campaign.recipient.opted_out": "Campanha: contato pediu para sair",
  "policy.gate.authors": "Revisa as mensagens de",
  "policy.gate.author.member": "Pessoas da equipe",
  "policy.gate.author.assistant": "Assistente de IA",
  "policy.gate.author.flow": "Fluxos",
  "policy.gate.author_short.member": "pessoas",
  "policy.gate.author_short.assistant": "assistente de IA",
  "policy.gate.author_short.flow": "fluxos",
  "policy.gate.authors_hint": "O assistente de IA segue as regras desta política mesmo sem ser revisado: elas entram nas instruções dele. Marque o assistente só se quiser que cada resposta dele também passe pela revisão.",
  "policy.summary.authors": "Revisa: {who}",
  "event.transfer_note.gate_hold": "a revisão de mensagens segurou uma resposta",
  "event.transfer_note.max_turns": "o assistente chegou ao limite de respostas",
  "event.transfer_note.exit_field_set": "o assistente conseguiu o dado que buscava",
  "event.transfer_note.exit_keyword": "o contato disse uma palavra de saída do assistente",
  "event.transfer_note.error": "o assistente não conseguiu continuar",
  "gate.your_edit": "Sua mensagem, para editar",
  "errors.gate_override_denied": "A política não deixa você enviar esta mensagem como está. Edite o texto.",
  "errors.gate_decision_unavailable": "Esta revisão expirou. Envie a mensagem de novo.",
  "errors.gate_no_rewrite": "Não há sugestão para usar. Edite o texto.",
  "inbox.draft": "Rascunho:",
  "common.delete": "Excluir",
  "settings.tools": "Ferramentas",
  "permission.tools.manage": "Criar e editar ferramentas e conexões dos assistentes",
  "ai.surface.tools.draft": "Criar ferramenta com IA",
  "assistants.tab.tools": "Ferramentas",
  "errors.tool_key_taken": "Já existe uma ferramenta com este nome para a IA. Escolha outro.",
  "errors.connection_in_use": "Esta conexão ainda é usada por ferramentas. Troque a conexão delas antes.",
  "errors.tool_call_decided": "Este pedido já foi decidido por outra pessoa.",
  "errors.package_not_found": "Este pacote não está disponível para a empresa.",
  "errors.tool_not_found": "Ferramenta não encontrada.",
  "errors.connection_not_found": "Conexão não encontrada.",
  "tools.lead": "O que os assistentes podem fazer no meio da conversa: consultar e alterar dados no sistema da empresa.",
  "tools.new": "Nova ferramenta",
  "tools.active": "Ativa",
  "tools.inactive": "Desligada",
  "tools.empty": "Nenhuma ferramenta ainda. Crie a primeira descrevendo para a IA o que ela faz.",
  "tools.soon": "Em breve",
  "tools.group.company": "Da empresa",
  "tools.group.company_hint": "Feitas aqui, ligadas nos assistentes que você escolher",
  "tools.group.connections": "Conexões",
  "tools.group.connections_hint": "O endereço do sistema e o segredo, guardados uma vez para várias ferramentas",
  "tools.group.platform": "Da plataforma",
  "tools.group.platform_hint": "Prontas: é só ligar em cada assistente",
  "tools.kind.form": "formulário",
  "tools.kind.flow": "fluxo",
  "tools.list.assistants": "1 assistente|{count} assistentes",
  "tools.list.no_assistant": "nenhum assistente",
  "tools.list.uses": "1 uso em 60 dias|{count} usos em 60 dias",
  "tools.effect.read": "Só consulta",
  "tools.effect.read_hint": "Lê e não muda nada. Roda de verdade também em teste.",
  "tools.effect.write": "Altera dados",
  "tools.effect.write_hint": "Muda algo no sistema. Em teste é simulada.",
  "tools.confirm_short.contact": "confirma com o contato",
  "tools.confirm_short.person": "uma pessoa aprova",
  "tools.confirm_short.none": "sem confirmação",
  "tools.confirm.title": "Antes de alterar",
  "tools.confirm.contact": "Confirmar com o contato",
  "tools.confirm.contact_hint": "a IA diz o que vai mudar; o DoneTalk só chama depois que o contato concordar, com os mesmos dados.",
  "tools.confirm.person": "Uma pessoa aprova",
  "tools.confirm.person_hint": "a equipe vê o pedido na conversa e aprova ou recusa.",
  "tools.confirm.none": "Sem confirmação",
  "tools.confirm.none_hint": "chama assim que a IA decidir.",
  "tools.preview": "O sistema descreve a mudança antes",
  "tools.preview_hint": "A primeira chamada vai com confirmed = false e o sistema responde o que faria; a IA lê isso para o contato.",
  "tools.timeout": "Esperar a resposta por até",
  "tools.seconds": "1 segundo|{n} segundos",
  "tools.hourly_limit": "Chamadas por conversa",
  "tools.per_hour": "até {n} por hora",
  "tools.ms": "{n} ms",
  "tools.required": "obrigatório",
  "tools.secret_hint": "segredo terminado em {hint}",
  "tools.auth.donetalk": "Assinatura DoneTalk",
  "tools.auth.copiloto": "Assinatura no formato do Copiloto",
  "tools.auth.bearer": "Token (Bearer)",
  "tools.auth.header": "Chave num cabeçalho",
  "tools.auth.none": "Sem autenticação",
  "tools.auth_hint.donetalk": "O DoneTalk assina cada chamada com o segredo e o horário (DoneTalk-Signature), como os avisos.",
  "tools.auth_hint.copiloto": "Para sistemas feitos para a consulta externa do Copiloto: X-Copiloto-Timestamp e X-Copiloto-Signature.",
  "tools.auth_hint.bearer": "O segredo vai em Authorization: Bearer.",
  "tools.auth_hint.header": "O segredo vai no cabeçalho que você indicar.",
  "tools.auth_hint.none": "Só para testes: qualquer um que saiba o endereço consegue chamar.",
  "tools.connection.title": "Conexão",
  "tools.connection.new": "Nova conexão",
  "tools.connection.new_option": "+ Nova conexão…",
  "tools.connection.edit": "Editar conexão",
  "tools.connection.name": "Nome",
  "tools.connection.name_placeholder": "Sistema da loja",
  "tools.connection.base_url": "Endereço",
  "tools.connection.auth": "Como o DoneTalk se identifica",
  "tools.connection.header": "Nome do cabeçalho",
  "tools.connection.secret": "Segredo",
  "tools.connection.secret_replace": "Segredo novo (o atual termina em {hint}; vazio mantém)",
  "tools.connection.secret_hint": "Guardado cifrado. Depois de salvo, só os 4 últimos caracteres aparecem.",
  "tools.connection.used_by": "usada por 1 ferramenta|usada por {count} ferramentas",
  "tools.connection.in_use": "Usada por ferramentas: troque a conexão delas antes de excluir.",
  "tools.name": "Nome",
  "tools.key": "Nome para a IA",
  "tools.key_taken": "Já existe uma ferramenta com este nome para a IA.",
  "tools.description": "Quando usar (é o que a IA lê)",
  "tools.description_hint": "Diga em que situações usar, o que não fazer e o que dizer ao contato depois. Cada assistente pode ajustar este texto na aba Ferramentas dele.",
  "tools.part.name": "Nome e quando usar",
  "tools.part.inputs": "O que a IA precisa saber",
  "tools.part.call": "Para onde chamar",
  "tools.part.response": "O que volta para a IA",
  "tools.part.safety": "Segurança",
  "tools.inputs.key": "Campo",
  "tools.inputs.type": "Tipo",
  "tools.inputs.description": "Para a IA",
  "tools.inputs.remove": "Tirar o campo",
  "tools.inputs.add": "Adicionar campo",
  "tools.inputs.none": "Nenhum campo: a ferramenta usa só o que vem da conversa.",
  "tools.inputs.options": "Valores aceitos",
  "tools.inputs.options_placeholder": "hotel, motel",
  "tools.inputs.automatic": "Vai sozinho, tirado da conversa (a IA nunca informa): telefone e nome do contato, a conversa e o assistente.",
  "tools.inputs.contact_fields": "Mandar também estes campos do contato",
  "tools.inputs.contact_fields_placeholder": "plano, cidade",
  "tools.input_type.text": "Texto",
  "tools.input_type.number": "Número",
  "tools.input_type.boolean": "Sim ou não",
  "tools.input_type.list": "Lista",
  "tools.input_type.date": "Data",
  "tools.call.method": "Método",
  "tools.call.path": "Caminho",
  "tools.call.format": "Formato",
  "tools.call.donetalk": "Padrão DoneTalk",
  "tools.call.donetalk_hint": "o sistema recebe o pedido assinado e responde um texto para a IA.",
  "tools.call.docs": "Ver o formato",
  "tools.call.any": "Qualquer API",
  "tools.call.any_hint": "monte o caminho e o corpo com os dados da conversa, por exemplo {phone} e {input}.",
  "tools.call.headers": "Cabeçalhos (um por linha)",
  "tools.call.body": "Corpo",
  "tools.response.text": "O texto da resposta (campo text, ou a resposta inteira)",
  "tools.response.field": "Um campo da resposta",
  "tools.response.template": "Uma frase montada com a resposta",
  "tools.response.field_path": "Caminho do campo",
  "tools.response.template_text": "Frase",
  "tools.response.limit": "A IA lê até {chars} caracteres. Se o sistema não responder em {seconds} s, ela ouve \"indisponível agora\" e segue a conversa sem o dado.",
  "tools.ai_view.title": "O que a IA vê",
  "tools.ai_view.phone": "O telefone não aparece aqui: a IA não pode trocar de contato.",
  "tools.ai_view.checked": "o DoneTalk confere",
  "tools.missing.title": "Falta para salvar",
  "tools.missing.name": "O nome da ferramenta",
  "tools.missing.key": "Um nome para a IA: letras minúsculas, números e _",
  "tools.missing.description": "O \"quando usar\", com pelo menos 10 letras",
  "tools.missing.connection": "A conexão com o sistema",
  "tools.missing.input_key": "Campos com nome válido: letras minúsculas, números e _",
  "tools.missing.input_repeated": "Campos sem nome repetido",
  "tools.missing.response_field": "O caminho do campo da resposta",
  "tools.missing.response_template": "A frase com a resposta",
  "tools.flow.title": "Precisa de mais etapas?",
  "tools.flow.hint": "Consultar antes e só alterar se a conta existir, por exemplo: a ferramenta poderá ser aberta como fluxo.",
  "tools.on_assistants": "Ligada em",
  "tools.on_assistants_hint": "Ligue ou ajuste na aba Ferramentas de cada assistente.",
  "tools.remove.title": "Excluir a ferramenta",
  "tools.remove.hint": "Os assistentes param de usá-la na hora. O histórico de chamadas continua.",
  "tools.remove.action": "Excluir",
  "tools.how.ai": "Descrever para a IA",
  "tools.how.ai_hint": "Diga em palavras o que ela faz, ou cole a documentação da API. A IA preenche tudo.",
  "tools.how.form": "Formulário",
  "tools.how.form_hint": "Uma chamada a um sistema. Você preenche cada parte.",
  "tools.how.start_form": "Abrir o formulário",
  "tools.how.flow": "Fluxo de várias etapas",
  "tools.how.flow_hint": "Consulta, decide e chama de novo, no construtor de fluxos, sem código.",
  "tools.how.package": "Pacote pronto",
  "tools.ai.title": "O que a ferramenta faz",
  "tools.ai.describe": "Em palavras",
  "tools.ai.describe_placeholder": "Quando o cliente perguntar do pedido, consulte o status pelo número do pedido no nosso sistema.",
  "tools.ai.docs": "Documentação, cURL ou exemplo da API (opcional)",
  "tools.ai.create": "Criar com IA",
  "tools.ai.hint": "A IA monta o rascunho; nada é salvo nem ligado sem você revisar.",
  "tools.ai.drafted": "A IA montou este rascunho. Revise cada parte e use \"Testar agora\" antes de salvar.",
  "tools.test.title": "Testar agora",
  "tools.test.phone": "Telefone do contato de exemplo",
  "tools.test.real": "Fazer de verdade",
  "tools.test.real_hint": "Desmarcado, nada é chamado: esta ferramenta altera dados.",
  "tools.test.real_hint_preview": "Desmarcado, o sistema só descreve o que faria (confirmed = false).",
  "tools.test.run": "Testar",
  "tools.test.ai_reads": "O que a IA lê",
  "tools.test.sent": "O que foi",
  "tools.test.received": "O que voltou",
  "tools.test.not_called": "Nada foi chamado: marque \"Fazer de verdade\" para chamar o sistema.",
  "tools.test.note": "O teste não entra no histórico nem conta no limite. O segredo nunca aparece aqui.",
  "tools.test.status.ok": "Deu certo",
  "tools.test.status.refused": "O sistema respondeu que não",
  "tools.test.status.failed": "Não respondeu",
  "tools.test.status.simulated": "Simulado",
  "tools.call_status.ok": "Deu certo",
  "tools.call_status.refused": "O sistema recusou",
  "tools.call_status.failed": "Falhou",
  "tools.call_status.limited": "Passou do limite",
  "tools.call_status.simulated": "Simulada",
  "tools.call_status.awaiting_contact": "Esperando o sim do contato",
  "tools.call_status.awaiting_person": "Esperando aprovação",
  "tools.call_status.declined": "Recusada pela equipe",
  "tools.call_status.expired": "Expirou",
  "tools.error.timeout": "o sistema não respondeu a tempo",
  "tools.error.network": "não foi possível conectar",
  "tools.error.too_large": "resposta grande demais",
  "tools.error.no_text": "a resposta não trouxe texto",
  "tools.error.field_missing": "o campo escolhido não veio",
  "tools.error.empty": "resposta vazia",
  "tools.error.no_connection": "sem conexão",
  "tools.error.bad_address": "endereço inválido",
  "tools.error.unsafe_address": "endereço não permitido (só https público)",
  "tools.error.hourly_limit": "limite por hora",
  "tools.error.tool_inactive": "ferramenta desligada",
  "tools.error.other": "erro",
  "tools.error.http": "o sistema respondeu HTTP {status}",
  "tools.calls.title": "Histórico de chamadas",
  "tools.calls.total": "Chamadas em {n} dias",
  "tools.calls.ok": "Deram certo",
  "tools.calls.failed": "Falharam",
  "tools.calls.failed_n": "{n} falharam",
  "tools.calls.all_tools": "Todas as ferramentas",
  "tools.calls.any_result": "Qualquer resultado",
  "tools.calls.filter.ok": "Deram certo",
  "tools.calls.filter.refused": "O sistema recusou",
  "tools.calls.filter.failed": "Falharam",
  "tools.calls.filter.limited": "Passaram do limite",
  "tools.calls.filter.pending": "Esperando",
  "tools.calls.filter.declined": "Recusadas pela equipe",
  "tools.calls.days": "Últimos {n} dias",
  "tools.calls.period": "Período",
  "tools.calls.when": "Quando",
  "tools.calls.tool": "Ferramenta",
  "tools.calls.assistant": "Assistente",
  "tools.calls.conversation": "Conversa",
  "tools.calls.result": "Resultado",
  "tools.calls.time": "Tempo",
  "tools.calls.by_tool": "Por ferramenta",
  "tools.calls.empty": "Nenhuma chamada no período.",
  "tools.calls.more": "Mostrar mais",
  "tools.decide.approve": "Aprovar",
  "tools.decide.decline": "Recusar",
  "tools.package.install": "Instalar {name}",
  "tools.package.install_n": "Instalar 1 ferramenta|Instalar {count} ferramentas",
  "tools.package.installed": "1 ferramenta instalada|{count} ferramentas instaladas",
  "tools.package.connection": "Conexão: {name}",
  "tools.package.secret": "Segredo combinado com o sistema",
  "tools.package.test": "Testar conexão",
  "tools.package.connected": "Conectado: \"{tool}\" respondeu em {ms} ms",
  "tools.package.tools": "Ferramentas do pacote",
  "tools.package.already": "já instalada",
  "tools.package.preview": "prévia do sistema",
  "tools.package.on": "Ligar em",
  "tools.package.on_hint": "Os assistentes marcados passam a usar as ferramentas na hora (uma versão nova é publicada).",
  "tools.package.kit_aco.name": "Kit ACO",
  "tools.package.kit_aco.lead": "As ferramentas da Amanda no Copiloto, prontas para o DoneTalk: mesmos endereços e mesmos textos de \"quando usar\". Só falta o segredo.",
  "event.tool.read": "{who} consultou {tool}",
  "event.tool.write": "{who} usou {tool}",
  "event.tool.write_confirmed": "{who} usou {tool} · confirmado pelo contato",
  "event.tool.approved": "{tool} aprovado por {name}",
  "event.tool.declined": "{name} recusou {tool}",
  "event.tool.failed": "{tool} não respondeu; a conversa seguiu sem o dado",
  "event.tool.waiting_contact": "Esperando o sim do contato: {tool}",
  "event.tool.waiting_person": "Esperando aprovação da equipe: {tool}",
  "event.info.tool": "Ferramenta",
  "event.info.tool_input": "Pedido",
  "event.info.tool_preview": "Prévia",
  "event.info.tool_result": "A IA leu",
  "event.info.tool_confirmed": "Confirmado por",
  "event.info.tool_approved": "Aprovado por",
  "event.info.tool_time": "Tempo",
  "assistants.tools.title": "Ferramentas da empresa",
  "assistants.tools.hint": "Ligue as que este assistente pode usar. Ele decide quando, pelo \"quando usar\".",
  "assistants.tools.own": "Quando usar, neste assistente",
  "assistants.tools.adjust": "Ajustar o \"quando usar\" para este assistente",
  "assistants.tools.back_to_tool": "Voltar ao texto da ferramenta",
  "assistants.tools.none": "A empresa ainda não tem ferramentas.",
  "assistants.tools.open": "Ver as ferramentas da empresa",
  "assistants.tools.rules_title": "Valem sempre, para qualquer ferramenta",
  "assistants.tools.rule_phone": "O telefone e o nome vêm da conversa; a IA não escolhe de quem é a conta.",
  "assistants.tools.rule_confirm": "O que altera dados segue a confirmação escolhida na ferramenta.",
  "assistants.tools.rule_test": "No \"Testar\" deste assistente, o que altera dados é simulado.",
  "assistants.tools.rule_fact": "A IA usa a resposta como fato e diz \"vi aqui\", nunca \"consultei o sistema\".",
  "assistants.tools.rule_limit": "Até 5 chamadas da mesma ferramenta por conversa por hora.",
  "assistants.test.phone": "Telefone do contato de teste (para as ferramentas)",
  "assistants.test.note_tools": "Nada vai para o WhatsApp. Ferramentas que só consultam rodam de verdade com o telefone acima; as que alteram dados são simuladas.",
  "assistants.test.tool_read": "Consultou {tool}: {text}",
  "assistants.test.tool_preview": "{tool} mostrou a prévia: {text}",
  "assistants.test.tool_waiting": "{tool}: esperaria o sim do contato",
  "assistants.test.tool_simulated": "Simulado: {tool} {text}",
  "assistants.test.tool_approval": "{tool}: uma pessoa da equipe aprovaria",
  "assistants.test.tool_missing": "{tool}: faltou {text}",
  "email.tool_failing.subject": "DoneTalk · {workspace}: a ferramenta {tool} está falhando",
  "email.tool_failing.text": "A ferramenta {tool} falhou nas últimas 5 chamadas. O assistente seguiu as conversas sem o dado e a ferramenta continua ligada.",
  "email.tool_failing.error": "Último motivo: {error}.",
  "email.tool_failing.cta": "Ver o histórico de chamadas",
  "email.tool_failing.why": "Você recebe este aviso porque é dono ou administrador da empresa no DoneTalk. Ele vem no máximo uma vez por dia por ferramenta.",
  "errors.tool_call_not_yours": "Só quem atende esta conversa, ou quem distribui as conversas, aprova este pedido.",
  "errors.tool_call_not_found": "Pedido não encontrado.",
  "templates.category.authentication_hint": "Códigos de acesso e de verificação. A Meta escreve o texto e põe o botão de copiar o código.",
  "templates.otp.title": "Código de acesso",
  "templates.otp.lead": "A Meta escreve o texto no idioma do modelo, com o código em negrito e o botão Copiar código. Você escolhe só o que vem junto.",
  "templates.otp.security": "Pedir para não compartilhar",
  "templates.otp.security_hint": "Depois do código, a Meta acrescenta um aviso de segurança.",
  "templates.otp.expiry": "Avisar quando expira",
  "templates.otp.expiry_hint": "No rodapé, a Meta escreve em quantos minutos o código expira.",
  "templates.otp.minutes": "Minutos até expirar",
  "templates.otp.minutes_hint": "De 1 a 90 minutos.",
  "templates.otp.send_hint": "Ao enviar, o código vai como o primeiro valor do corpo; o botão copia o mesmo código.",
  "templates.otp.not_verified": "A Meta libera modelos de código de acesso só para empresas verificadas. Verifique a empresa no Gerenciador de Negócios da Meta e volte aqui.",
  "templates.otp.refused": "A Meta ainda não liberou modelos de código de acesso para esta conta. Ela libera com o tempo: dá para tentar de novo a partir de {date}.",
  "templates.otp.row": "Código de acesso: a Meta escreve o texto ao aprovar.",
  "templates.otp.preview_body": "Seu código de verificação é *{{1}}*.",
  "templates.otp.preview_security": "Para sua segurança, não o compartilhe.",
  "templates.otp.preview_footer": "Expira em {n} minutos.",
  "templates.otp.preview_button": "Copiar código",
  "templates.issue.otp_expiration_range": "A Meta aceita de 1 a 90 minutos.",
  "errors.authentication_not_allowed": "A Meta ainda não liberou modelos de código de acesso para esta conta.",
  "settings.skills": "Skills",
  "skills.lead": "Os jeitos de fazer que os assistentes de IA seguem: um método de vendas, como cobrar, como acolher uma reclamação. A IA abre cada skill quando a conversa pede.",
  "skills.new": "Nova skill",
  "skills.add": "Adicionar à empresa",
  "skills.added": "Skill adicionada. Agora ligue-a nos assistentes que vão usar.",
  "skills.copy": "Copiar para editar",
  "skills.copied": "Cópia criada. Ela é da empresa e não recebe mais as melhorias da biblioteca.",
  "skills.removed": "Skill removida.",
  "skills.in_use": "Esta skill está ligada em: {names}. Desligue-a nesses assistentes antes de remover.",
  "skills.version": "Versão {n}",
  "skills.revision": "Revisão {n}",
  "skills.revisions": "Histórico de revisões",
  "skills.ai_view": "O que o assistente lê",
  "skills.on_assistants": "Nos assistentes",
  "skills.on_assistants_hint": "Cada assistente escolhe as suas skills na aba Skills.",
  "skills.to_assistants": "Ir para os assistentes",
  "skills.group.company": "Da empresa",
  "skills.group.company_hint": "Escritas por vocês, com o jeito da casa.",
  "skills.group.library": "Da biblioteca DoneTalk",
  "skills.group.library_hint": "Métodos conhecidos, ajustados para a sua empresa. Recebem melhorias.",
  "skills.list.unused": "Nenhum assistente usa",
  "skills.list.company_empty": "Nenhuma ainda. Crie uma ou use “Organizar com IA” para tirar skills das instruções que vocês já têm.",
  "skills.list.library_empty": "Nenhuma skill da biblioteca adicionada.",
  "skills.area.essentials": "Essenciais",
  "skills.area.sales": "Vendas",
  "skills.area.marketing": "Marketing",
  "skills.area.support": "Atendimento",
  "skills.area.success": "Sucesso do cliente",
  "skills.area.retention": "Retenção",
  "skills.area.finance": "Financeiro",
  "skills.area.people": "Pessoas",
  "skills.area.operations": "Operações",
  "skills.audience.customers": "Com clientes",
  "skills.audience.team": "Com a equipe",
  "skills.origin.organize": "Organizada com IA",
  "skills.origin.copy": "Cópia da biblioteca",
  "skills.library.title": "Biblioteca DoneTalk",
  "skills.library.open": "Ver a biblioteca",
  "skills.library.lead": "{count} skill pronta para usar. Cada uma segue um método conhecido; vocês só dizem como a empresa faz.|{count} skills prontas para usar. Cada uma segue um método conhecido; vocês só dizem como a empresa faz.",
  "skills.library.search": "Pesquisar na biblioteca",
  "skills.library.filter.all": "Todas",
  "skills.library.filter.customers": "Com clientes",
  "skills.library.filter.team": "Com a equipe",
  "skills.library.filter.added": "Adicionadas",
  "skills.library.added": "Adicionada",
  "skills.library.market_hint": "Por padrão aparecem as skills gerais e as do seu país ({country}). Algumas seguem regras de um país, como cobrança e dados pessoais.",
  "skills.part.when": "Quando usar",
  "skills.part.goal": "Objetivo",
  "skills.part.steps": "Passos",
  "skills.part.always": "Sempre",
  "skills.part.never": "Nunca",
  "skills.part.examples": "Exemplos",
  "skills.part.origin": "Baseada em:",
  "skills.setup.title": "Ajustes para a sua empresa",
  "skills.setup.hint": "O método é da DoneTalk; aqui vocês dizem como a empresa faz. O que ficar em branco a IA não inventa: ela pergunta ou passa para uma pessoa.",
  "skills.setup.pending": "Ajustes em branco",
  "skills.brings.title": "O que ela traz",
  "skills.brings.hint": "Ao adicionar, os itens marcados são criados na empresa.",
  "skills.brings.hint_added": "O que foi criado quando a skill foi adicionada. Ajuste em Campos do contato e Resultados.",
  "skills.brings.fields": "Campos que a IA preenche",
  "skills.brings.outcomes": "Resultados de atendimento",
  "skills.brings.handoff": "Quando passa para uma pessoa",
  "skills.brings.exists": "Já existe",
  "skills.update.available": "Nova versão",
  "skills.update.title": "Versão {n} disponível",
  "skills.update.hint": "Os seus ajustes continuam. Nada muda até vocês atualizarem.",
  "skills.update.take": "Atualizar",
  "skills.update.later": "Agora não",
  "skills.update.taken": "Atualizada. Os assistentes já usam a nova versão.",
  "skills.update.later_done": "Combinado. Avisamos de novo na próxima versão.",
  "skills.remove.title": "Remover skill",
  "skills.remove.hint": "Só pode ser removida quando nenhum assistente a usa.",
  "skills.remove.action": "Remover",
  "skills.field.name": "Nome",
  "skills.field.area": "Área",
  "skills.field.audience": "Com quem",
  "skills.field.when_hint": "É o que a IA lê para decidir abrir esta skill. Seja concreto: “quando o cliente pede desconto”.",
  "skills.field.lines_hint": "Um item por linha.",
  "skills.field.examples_hint": "Uma mensagem do contato e a resposta ideal. Dois ou três bons exemplos ensinam mais que muitas regras.",
  "skills.field.example_contact": "O contato escreve",
  "skills.field.example_reply": "A IA responde",
  "skills.field.example_add": "Adicionar exemplo",
  "skills.field.example_remove": "Remover exemplo",
  "skills.field.notes": "Observações",
  "skills.links.title": "Ligações",
  "skills.links.handoff_hint": "Situações em que a IA passa para uma pessoa. Uma por linha.",
  "skills.links.fields": "Campos do contato que ela preenche",
  "skills.links.tools": "Ferramentas que ela usa",
  "skills.links.collections": "Bases de conhecimento que ela consulta",
  "skills.links.hint": "A skill só lembra a IA de usar esses itens; cada assistente ainda precisa tê-los ligados.",
  "skills.mode.on_demand": "Quando precisar",
  "skills.mode.always": "Sempre",
  "skills.mode.on_demand_hint": "A IA vê só o nome e quando usar, e abre a skill quando a conversa pede. Gasta pouca memória.",
  "skills.mode.always_hint": "A skill inteira vai em toda resposta. Use para o que vale em qualquer conversa, como o tom da marca.",
  "skills.assistant.title": "Skills deste assistente",
  "skills.assistant.hint": "Ligue as que ele usa. Elas valem depois de publicar.",
  "skills.assistant.mode": "Como usa",
  "skills.assistant.when_own": "Quando usar, só neste assistente",
  "skills.assistant.when_own_hint": "Em branco, vale o da skill.",
  "skills.assistant.open": "Abrir a skill",
  "skills.assistant.none": "A empresa ainda não tem skills. Adicione da biblioteca ou crie uma.",
  "skills.assistant.modes_title": "Quando precisar ou sempre?",
  "skills.assistant.many_always": "{n} skills em “Sempre” pesam em toda resposta. Deixe em “Sempre” só o que vale para qualquer conversa.",
  "skills.scenarios.title": "Cenários",
  "skills.scenarios.hint": "Um cliente simulado escreve, o rascunho responde e outra IA confere o que uma boa resposta faz. Nada é enviado.",
  "skills.scenarios.library_hint": "Rode no “Testar” de um assistente que usa esta skill.",
  "skills.scenarios.none": "Nenhum cenário. As skills da biblioteca trazem os seus; crie os da empresa.",
  "skills.scenarios.run": "Rodar",
  "skills.scenarios.run_all": "Rodar todos",
  "skills.scenarios.replies": "Ver a conversa",
  "skills.scenarios.add": "Novo cenário",
  "skills.scenarios.remove": "Remover cenário",
  "skills.scenarios.field.title": "Título",
  "skills.scenarios.field.persona": "Quem é o cliente",
  "skills.scenarios.field.messages": "O que o cliente escreve",
  "skills.scenarios.field.messages_hint": "Uma mensagem por linha, até 6.",
  "skills.scenarios.field.expect": "O que uma boa resposta faz",
  "skills.scenarios.field.expect_hint": "Uma por linha, até 8. Ex.: “pergunta o tamanho antes de dar o preço”.",
  "skills.organize.button": "Organizar com IA",
  "skills.organize.lead": "Cole aqui o que vocês já têm: o prompt de hoje, um manual, roteiros. A IA separa o que é instrução curta, o que vira skill, o que é informação para a base de conhecimento e os campos do contato. O que ela não conseguir decidir, pergunta.",
  "skills.organize.text": "Texto",
  "skills.organize.chars": "{n} de {max} caracteres",
  "skills.organize.assistant": "Para qual assistente",
  "skills.organize.assistant_hint": "O resultado vira um rascunho dele, para revisar e publicar. Sem assistente, só as skills, campos e informações são criados.",
  "skills.organize.no_assistant": "Nenhum, só organizar",
  "skills.organize.start": "Organizar",
  "skills.organize.how.title": "Como funciona",
  "skills.organize.how.1": "A IA lê tudo e compara com o que a empresa já tem.",
  "skills.organize.how.2": "Pergunta o que não dá para decidir sozinha, em rodadas curtas.",
  "skills.organize.how.3": "Mostra a proposta: cada parte com uma caixa para marcar.",
  "skills.organize.how.4": "Vocês aplicam o que quiserem. O assistente recebe um rascunho.",
  "skills.organize.how.safe": "Nada muda até aplicar, e o que está publicado continua respondendo.",
  "skills.organize.reading": "A IA está lendo e organizando…",
  "skills.organize.reading_hint": "Pode levar alguns minutos. Pode sair desta tela: a análise continua e fica em Skills.",
  "skills.organize.failed": "Não deu para organizar",
  "skills.organize.failed_hint": "A análise parou no meio. Tente de novo; se repetir, fale com o suporte.",
  "skills.organize.again": "Tentar de novo",
  "skills.organize.into_draft": "O que for aplicado vira um rascunho de {name}.",
  "skills.organize.no_assistant_hint": "Sem assistente: são criadas só as skills, os campos e as informações.",
  "skills.organize.instructions": "Instruções novas, mais curtas",
  "skills.organize.skills": "Skills",
  "skills.organize.skills_hint": "As skills da empresa ficam editáveis depois em Skills.",
  "skills.organize.knowledge": "Informações para a base de conhecimento",
  "skills.organize.fact.new": "Nova",
  "skills.organize.fact.present": "Já está na base",
  "skills.organize.fact.outdated": "Diferente da base",
  "skills.organize.base": "Guardar em",
  "skills.organize.new_base": "Nova base “Organizado com IA”",
  "skills.organize.fields": "Campos do contato",
  "skills.organize.field_action.create": "Criar",
  "skills.organize.field_action.fix": "Ajustar",
  "skills.organize.handoff_hint": "Vira uma skill da empresa com estas situações.",
  "skills.organize.apply": "Aplicar {n} itens",
  "skills.organize.applied_toast": "Aplicado.",
  "skills.organize.done": "Pronto",
  "skills.organize.done_skills": "Skills: {names}",
  "skills.organize.done_fields": "{n} campos do contato",
  "skills.organize.done_facts": "{n} informações na base de conhecimento",
  "skills.organize.done_draft": "Um rascunho de {name}, para revisar no Testar e publicar",
  "skills.organize.open_assistant": "Abrir o assistente",
  "skills.organize.to_skills": "Ver as skills",
  "ai_questions.title": "A IA precisa de algumas respostas",
  "ai_questions.round": "Rodada {n} de {total}",
  "ai_questions.recommended": "Recomendado",
  "ai_questions.other": "Outra resposta…",
  "ai_questions.recorded": "As respostas ficam registradas.",
  "ai_questions.submit": "Responder",
  "memory.title": "Memória do assistente",
  "memory.window": "Memória de {tokens} tokens",
  "memory.loading": "Calculando…",
  "memory.part.rules": "Regras e instruções",
  "memory.part.skills": "Skills",
  "memory.part.knowledge": "Bases inteiras",
  "memory.part.conversation": "Conversa (típica)",
  "memory.tokens": "{tokens} tokens",
  "memory.share": "Usa {percent} da memória.",
  "memory.share_room": "Sobra bastante espaço para conversas longas.",
  "memory.share_tight": "Conversas muito longas podem ficar apertadas; deixe bases grandes em busca.",
  "memory.cost": "Cada resposta custa por volta de {usd} ({brl}), já com o cache.",
  "memory.cost_usd": "Cada resposta custa por volta de {usd}, já com o cache.",
  "assistants.tab.skills": "Skills",
  "assistants.knows.mode_label": "Como lê esta base",
  "assistants.knows.mode.auto": "Automático",
  "assistants.knows.mode.whole": "Inteira",
  "assistants.knows.mode.search": "Por busca",
  "assistants.knows.mode_hint": "Inteira: a IA lê a base toda em cada resposta (melhor para bases pequenas). Por busca: lê só os trechos ligados à conversa. Automático: inteira até 150 mil caracteres.",
  "assistants.knows.is_whole": "Lida inteira · {chars} caracteres",
  "assistants.knows.is_search": "Lida por busca · {chars} caracteres",
  "assistants.test.view_chat": "Conversa",
  "assistants.test.skill": "Abriu a skill {name}",
  "event.skill_opened": "A IA abriu a skill {name}",
  "event.info.skill": "Skill",
  "event.info.skill_version": "Versão",
  "message.trace.title": "Como a IA respondeu",
  "message.trace.skills": "Skills:",
  "message.trace.skill_always": "{name} (sempre)",
  "message.trace.skill_earlier": "{name} (aberta antes)",
  "message.trace.skill_here": "{name} (aberta agora)",
  "message.trace.whole": "Bases lidas inteiras:",
  "message.trace.passages": "Trechos consultados:",
  "message.trace.tools": "Ferramentas:",
  "message.trace.read": "Leu {n} mensagens desta conversa",
  "message.trace.previous": "{n} de conversas anteriores",
  "message.trace.cached": "{percent}% vindo do cache",
  "message.trace.adjust": "Ajustar o que aparece na conversa",
  "ai.conversation.title": "Na conversa",
  "ai.conversation.skill_events": "Mostrar quando a IA abre uma skill",
  "ai.conversation.skill_events_hint": "Uma linha discreta na conversa, como “A IA abriu a skill Negociação”. Só a equipe vê; o contato nunca.",
  "ai.surface.skills.organize": "Organizar com IA",
  "ai.surface.skills.draft": "Melhorar skill com IA",
  "ai.surface.skills.judge": "Cenários de teste",
  "errors.skill_not_found": "Skill não encontrada.",
  "errors.skill_already_added": "Esta skill já foi adicionada.",
  "errors.skill_not_library": "Esta skill não é da biblioteca.",
  "errors.skill_in_use": "A skill está ligada em algum assistente.",
  "errors.organize_not_found": "Organização não encontrada.",
  "errors.organize_not_ready": "A proposta ainda não está pronta.",
  "skills.tips.title": "Uma boa skill",
  "skills.tips.1": "“Quando usar” concreto: é por ele que a IA decide abrir a skill.",
  "skills.tips.2": "Passos curtos, na ordem em que acontecem na conversa.",
  "skills.tips.3": "Dois ou três exemplos reais valem mais que muitas regras.",
  "assistants.instructions_long": "{n} caracteres: isto parece mais um manual que instruções. Partes como métodos e roteiros funcionam melhor como skills, e informações como base de conhecimento.",
  "onboarding.step.entry.skills": "Skills do assistente",
  "onboarding.when.entry.skills": "Pronto com pelo menos uma skill adicionada. É opcional.",
  "onboarding.done.entry.skills": "Skills adicionadas",
  "onboarding.lead.entry.skills": "Escolha os jeitos de fazer que o assistente segue: vendas, cobrança, reclamações.",
  "onboarding.detail.skills": "1 skill|{count} skills",
  "onboarding.guide.skills.title": "Skills do assistente",
  "onboarding.guide.skills.text": "Métodos prontos que o assistente segue, como qualificar um lead ou acolher uma reclamação. As sugestões vêm do que vocês contaram no questionário.",
  "onboarding.guide.skills.then": "Depois, ligue as skills no assistente, na aba Skills, e responda os ajustes de cada uma.",
  "skills.suggested.title": "Sugeridas para a sua empresa",
  "skills.suggested.hint": "Pelo que vocês contaram no questionário: o que a empresa faz e o segmento. Os ajustes de cada uma podem ser respondidos depois.",
  "skills.suggested.add": "Adicionar 1 marcada|Adicionar {count} marcadas",
  "skills.suggested.added": "1 skill adicionada.|{count} skills adicionadas.",
  "skills.library.show_all": "Mostrar de todos os países",
  "active.title": "Mensagens ativas",
  "active.state.can_receive": "Pode receber mensagens ativas",
  "active.state.paused": "Em pausa até {day}",
  "active.state.opted_out": "Não quer mensagens ativas",
  "active.status.can_receive": "Pode receber",
  "active.status.paused": "Em pausa",
  "active.status.opted_out": "Não quer",
  "active.since": "Desde {day}: {how}.",
  "active.answered": "Se escrever, é atendido normalmente.",
  "active.history": "Histórico",
  "active.history_paused": "Em pausa até {day}",
  "active.origin.button": "tocou “{button}” no modelo {template}",
  "active.origin.assistant": "pediu na conversa, a IA registrou",
  "active.origin.keyword": "escreveu “{word}”",
  "active.origin.api": "por uma integração",
  "active.origin.pause_ended": "a pausa acabou",
  "active.origin.flow": "por um fluxo",
  "active.origin.person": "registrado por alguém da equipe",
  "active.action.pause": "Pausar…",
  "active.action.opt_out": "Não quer",
  "active.action.change_date": "Mudar data",
  "active.action.end_pause": "Encerrar pausa",
  "active.action.resume": "Voltar a receber",
  "active.pause.title": "Pausar mensagens ativas",
  "active.pause.hint": "Nada que a empresa começa sai até a data. Se o contato escrever, é atendido normalmente.",
  "active.pause.for": "Por quanto tempo",
  "active.pause.until": "Ou até o dia",
  "active.pause.save": "Pausar",
  "active.period.7d": "7 dias",
  "active.period.30d": "30 dias",
  "active.period.3m": "3 meses",
  "active.period.6m": "6 meses",
  "active.period.1y": "1 ano",
  "active.picker.paused": "{name} pausou as mensagens ativas até {day}. Modelos de marketing não saem.",
  "active.picker.opted_out": "{name} não quer mensagens ativas. Modelos de marketing não saem.",
  "active.picker.held": "Não saem para este contato",
  "active.confirm.title": "Enviar mesmo em pausa?",
  "active.confirm.paused": "{name} pausou as mensagens ativas até {day}. Este é um modelo de utilidade: ele sai se você confirmar, e fica registrado quem enviou.",
  "active.confirm.opted_out": "{name} não quer mensagens ativas. Este é um modelo de utilidade: ele sai se você confirmar, e fica registrado quem enviou.",
  "active.confirm.cancel": "Não enviar",
  "active.confirm.send": "Enviar",
  "active.refused.paused": "O contato pausou as mensagens ativas até {day}.",
  "active.rules.title": "Pausa e descadastro: o que segura",
  "active.rules.hint": "Vale para tudo que a empresa manda primeiro: campanhas, modelos enviados na conversa, fluxos e a API.",
  "active.rules.category": "Tipo de modelo",
  "active.rules.never": "Não envia, nunca (política da Meta e LGPD)",
  "active.rules.always": "Envia sempre: a pessoa pediu o código",
  "active.rules.utility": "Utilidade",
  "active.rules.answered": "Quando o contato escreve, o atendimento é normal: a pausa e o descadastro só seguram o que a empresa começa.",
  "active.utility.send": "Envia",
  "active.utility.hold": "Não envia",
  "active.utility.ask": "Avisa quem está enviando",
  "active.end.title": "Quando a pausa acaba",
  "active.end.hint": "O contato volta sozinho para os públicos das campanhas e para os envios da API. Além disso:",
  "active.end.none": "Nada",
  "active.end.team": "Volta para a fila da equipe",
  "active.end.tag": "Pôr a etiqueta",
  "active.end.flow": "Iniciar o fluxo",
  "active.end.flow_hint": "A equipe recebe o último atendimento do contato de volta na fila. O fluxo deve começar com um modelo, porque a janela de 24 horas já fechou.",
  "active.assistant.label": "A IA aplica quando o contato pede na conversa",
  "active.assistant.hint": "“Me chama em março”, “não quero mais mensagens”: o assistente pausa ou descadastra e confirma na resposta. Sem data clara, ele pergunta.",
  "buttons.menu": "O que os botões fazem",
  "buttons.title": "O que os botões de {name} fazem",
  "buttons.lead": "O texto do botão é da Meta; o que acontece quando tocam é do DoneTalk. Vale em todo envio (campanha, conversa, fluxo e API) e não precisa de nova aprovação.",
  "buttons.none": "Este modelo não tem botões de resposta rápida.",
  "buttons.when_tapped": "Quando tocarem:",
  "buttons.action": "Ação",
  "buttons.main.pause": "Pausar mensagens ativas",
  "buttons.main.opt_out": "Não quer mensagens ativas",
  "buttons.main.opt_in": "Voltar a receber",
  "buttons.main.route": "Abrir atendimento",
  "buttons.main.close": "Concluir com um desfecho",
  "buttons.main.record": "Só registrar o toque",
  "buttons.main_hint.pause": "Preenche “Pode contatar a partir de”. Se o contato escrever, é atendido normalmente.",
  "buttons.main_hint.opt_out": "Até pedir para voltar. É o mesmo descadastro das palavras “sair” e “parar”.",
  "buttons.main_hint.opt_in": "Para um botão “Quero receber de novo”: encerra a pausa ou o descadastro.",
  "buttons.main_hint.route": "O atendimento abre na fila escolhida, ou o fluxo ou o assistente começa.",
  "buttons.main_hint.close": "Entra nos relatórios como qualquer atendimento concluído.",
  "buttons.main_hint.record": "Conta nos relatórios e avisa os sistemas, sem mudar nada.",
  "buttons.pause_for": "Por",
  "buttons.route.with": "Com",
  "buttons.route.team": "Uma equipe",
  "buttons.route.flow": "Um fluxo",
  "buttons.route.assistant": "Um assistente de IA",
  "buttons.route.which_team": "Equipe",
  "buttons.route.which_flow": "Fluxo",
  "buttons.route.which_assistant": "Assistente",
  "buttons.route.usual_queue": "A fila de sempre do número",
  "buttons.outcome": "Desfecho",
  "buttons.also_and": "e também",
  "buttons.also_label": "E também",
  "buttons.also.tag_add": "Pôr etiqueta",
  "buttons.also.tag_remove": "Tirar etiqueta",
  "buttons.also.field": "Preencher campo",
  "buttons.also.tag": "Etiqueta",
  "buttons.also.field_key": "Campo",
  "buttons.also.field_value": "Valor",
  "buttons.also_add": "+ Outra ação",
  "buttons.also_remove": "Tirar esta ação",
  "buttons.where": "Uma campanha pode trocar a ação de um botão só para ela. Sem troca, vale a do modelo.",
  "event.button_tapped": "Tocou em “{button}”",
  "event.applied.pause": "mensagens ativas pausadas até {day}",
  "event.applied.opt_out": "não quer mensagens ativas",
  "event.applied.opt_in": "voltou a receber mensagens ativas",
  "event.applied.route": "atendimento aberto",
  "event.applied.close": "concluído",
  "event.applied.tag_add": "etiqueta adicionada",
  "event.applied.tag_remove": "etiqueta retirada",
  "event.applied.field": "campo {field} preenchido",
  "event.active.paused": "{who} pausou as mensagens ativas até {day}",
  "event.active.opted_out": "{who} marcou: não quer mensagens ativas",
  "event.active.resumed": "{who} liberou as mensagens ativas",
  "event.active.pause_ended": "A pausa das mensagens ativas acabou",
  "event.active.integration": "Uma integração",
  "event.info.button": "Botão",
  "event.info.template": "Modelo",
  "event.info.applied": "Aplicado",
  "assistants.test.active_pause": "Pausaria as mensagens ativas até {day}",
  "assistants.test.active_stop": "Marcaria: não quer mensagens ativas",
  "assistants.test.active_resume": "Liberaria as mensagens ativas",
  "assistant.tool.active_messages": "Pausar ou parar mensagens ativas",
  "assistant.tool_hint.active_messages": "Quando o contato pede “me chama em março” ou “não quero mais mensagens”. Ele continua sendo atendido quando escreve.",
  "builder.exit_held": "Não enviado",
  "node.template.held_hint": "“Não enviado”: o contato pausou ou não quer mensagens ativas, e este modelo seria uma. Sem esse caminho, segue pelo de erro.",
  "campaigns.button.template": "Faz o que o modelo diz",
  "campaigns.skip.paused": "Pausaram as mensagens ativas",
  "campaigns.recipient.skip.paused": "Fora: em pausa",
  "segments.marketing.paused": "Em pausa",
  "segments.marketing.can_receive": "Pode receber mensagens ativas",
  "segments.field.pause_ends_days": "Dias até a pausa acabar",
  "integrations.event.template.button_clicked": "Botão de modelo tocado",
  "errors.contact_paused": "O contato pausou as mensagens ativas.",
  "errors.marketing_opted_out": "O contato não quer mensagens ativas.",
  "errors.active_messages_confirm": "O contato pausou as mensagens ativas: confirme para enviar.",
  "memory.part.tools": "Ferramentas",
  "memory.strip.label": "Memória",
  "memory.strip.share": "{percent} usada",
  "memory.strip.per_reply": "{cost} por resposta",
  "memory.strip.details": "Ver detalhes",
  "inbox.action.clear": "Limpar conversa",
  "clear.title": "Limpar esta conversa?",
  "clear.text": "Todas as mensagens com {name} somem para a equipe e para a IA, que deixa de ler o que veio antes. O contato continua vendo tudo no WhatsApp dele.",
  "clear.kept": "Fica registrado quem limpou e quando. Quem pode ver mensagens apagadas ainda consegue vê-las e trazer de volta.",
  "clear.confirm": "Limpar conversa",
  "clear.done": "Conversa limpa.",
  "event.cleared": "{name} limpou a conversa",
  "permission.conversations.clear": "Limpar conversas",
  "export.title": "Conversa com {name}",
  "export.number": "Número: {number}",
  "export.exported": "Exportado por {name} em {when} (fuso {zone})",
  "export.counts": "{attendances} atendimento(s) · {messages} mensagem(ns)",
  "export.role.team": "{name} (equipe)",
  "export.role.ai": "{name} (IA)",
  "export.role.flow": "Fluxo {name}",
  "export.role.campaign": "Campanha {name}",
  "export.role.system": "Mensagem automática",
  "export.role.api": "Integração",
  "export.reply_to": "↪ Em resposta a {name}: “{text}”",
  "export.from_ad": "Veio do anúncio: {ad}",
  "export.voice": "🎤 Áudio de voz",
  "export.audio": "🎵 Áudio",
  "export.transcript": "Transcrição: “{text}”",
  "export.no_transcript": "(sem transcrição)",
  "export.location": "📍 Localização: {place}",
  "export.contact_card": "👤 Contato: {name} {phones}",
  "export.template": "Modelo {name}",
  "export.buttons": "Botões: {buttons}",
  "export.options": "Opções: {options}",
  "export.chose": "Escolheu: {option}",
  "export.flag.edited": "editada",
  "export.flag.deleted": "apagada pelo contato",
  "export.flag.removed": "apagada por {name} em {day}",
  "export.flag.failed": "não entregue",
  "export.flag.read": "lida às {time}",
  "export.flag.delivered": "entregue",
  "export.flag.played": "ouvido às {time}",
  "export.attendance_open": "Atendimento aberto em {start} · Equipe: {team}",
  "export.attendance_closed": "Atendimento de {start} a {end} · Equipe: {team} · Desfecho: {outcome}",
  "export.note": "Nota interna de {name}",
  "export.attached": "<anexado: {file}>",
  "export.file": "📎 {file} ({size})",
  "export.reactions": "Reações: {list}",
  "export.zip_text": "Conversa.txt",
  "export.event.snoozed": "Em soneca",
  "export.event.opted_out": "Pediu para sair: “{word}”",
  "export.event.tool": "Ferramenta usada: {tool}",
  "permission.conversations.export": "Exportar conversas",
  "inbox.action.export": "Exportar conversa",
  "exportchat.title": "Exportar conversa",
  "exportchat.format": "Formato",
  "exportchat.pdf": "PDF",
  "exportchat.pdf_hint": "Organizado por dia, com fotos, para ler ou imprimir.",
  "exportchat.txt": "Texto (como o WhatsApp)",
  "exportchat.txt_hint": "Uma linha por mensagem, no formato do WhatsApp.",
  "exportchat.zip": "Texto com os arquivos (ZIP)",
  "exportchat.zip_hint": "O texto e todas as fotos, áudios e documentos, como o “anexar mídia” do WhatsApp.",
  "exportchat.scope": "O que exportar",
  "exportchat.scope_thread": "Toda a conversa com este contato",
  "exportchat.scope_conversation": "Só este atendimento",
  "exportchat.notes": "Notas internas",
  "exportchat.events": "Eventos do atendimento (transferências, desfechos, IA…)",
  "exportchat.hidden": "Mensagens apagadas (marcadas como apagadas)",
  "exportchat.audit": "A exportação fica registrada na auditoria.",
  "exportchat.submit": "Exportar",
  "export.by": "por {name}",
  "export.flag.failed_code": "não entregue (código {code} da Meta)",
  "api.scope.conversations:export": "Exportar conversas (PDF, texto, ZIP)",
  "knowledge.download": "Baixar {name}",
  "knowledge.file_not_kept": "{n} trechos. O arquivo original não pôde ser guardado: a IA lê o texto normalmente.",
  "knowledge.doc.reads": "O que a IA lê",
  "knowledge.doc.reads_hint": "O texto inteiro, como a IA recebe, dividido em {chunks} trechos para a busca.",
  "knowledge.doc.no_text": "Este conteúdo ainda não tem texto lido.",
  "knowledge.doc.about": "Sobre este conteúdo",
  "knowledge.doc.file": "Arquivo",
  "knowledge.doc.file_not_kept": "Original não guardado",
  "knowledge.doc.file_not_kept_hint": "Este arquivo foi enviado antes de o DoneTalk guardar os originais, por isso só o texto está aqui. Para ter o arquivo para abrir e baixar, remova este conteúdo e envie o arquivo de novo.",
  "knowledge.doc.added": "Adicionado",
  "knowledge.doc.added_by": "{when} por {name}",
  "knowledge.doc.chars": "Caracteres",
  "knowledge.doc.download_text": "Baixar texto",
  "knowledge.doc.download_file": "Baixar arquivo",
  "knowledge.doc.open_file": "Abrir arquivo",
  "errors.document_not_found": "Este conteúdo não existe mais na base de conhecimento.",
  "errors.file_not_found": "O arquivo original deste conteúdo não está guardado.",
  "campaigns.banner.waiting": "Fora do horário de envio · {sent} de {total} enviados. Volta a enviar {at}, conforme os dias e horários da campanha.",
  "campaigns.status.waiting_at": "Aguardando horário · {at}",
  "fields.search": "Pesquisar campo pelo nome, chave ou opção",
  "fields.search_none": "Nenhum campo com «{query}».",
  "email.ai_model_off.subject": "DoneTalk · {workspace}: o modelo {model} saiu do ar",
  "email.ai_model_off.text": "O modelo {model}, que a empresa escolheu, foi desligado. Estas tarefas voltaram a usar o modelo do DoneTalk: {tasks}. Nada parou de funcionar.",
  "email.ai_model_off.cta": "Ver os modelos de IA",
  "email.ai_model_off.why": "Você recebe este aviso porque é dono ou administrador da empresa no DoneTalk.",
  "aimodels.effort": "Esforço",
  "aimodels.reasoning": "Raciocínio",
  "aimodels.level.none": "Nenhum",
  "aimodels.level.minimal": "Mínimo",
  "aimodels.level.low": "Baixo",
  "aimodels.level.medium": "Médio",
  "aimodels.level.high": "Alto",
  "aimodels.level.xhigh": "Muito alto",
  "aimodels.level.max": "Máximo",
  "aimodels.chip.temperature": "Temperatura: {value}",
  "aimodels.chip.fallback": "Reserva: {model}",
  "aimodels.hint.assistant.reply": "O que os assistentes respondem aos contatos.",
  "aimodels.hint.gate.judge": "Confere as mensagens antes de sair, conforme as Políticas.",
  "aimodels.hint.outcome.classify": "Sugere o desfecho quando um atendimento é concluído.",
  "aimodels.hint.summary.brief": "O resumo que vai junto quando a conversa passa para outra pessoa.",
  "aimodels.hint.knowledge.embed": "Prepara a base de conhecimento para a busca.",
  "aimodels.hint.audio.transcribe": "Transforma os áudios recebidos em texto.",
  "aimodels.hint.learning.mine": "Lê a semana de conversas e sugere melhorias.",
  "aimodels.hint.onboarding.propose": "Monta as sugestões da implantação.",
  "aimodels.hint.flow.choice": "Entende quem escreve em vez de tocar no menu de um fluxo.",
  "aimodels.hint.flow.blocks": "Os blocos de IA dentro dos fluxos.",
  "aimodels.hint.tools.draft": "Monta uma ferramenta a partir da descrição.",
  "aimodels.hint.skills.organize": "Divide um prompt longo em instruções, skills e conhecimento.",
  "aimodels.hint.skills.draft": "Melhora o texto de uma skill da empresa.",
  "aimodels.hint.skills.judge": "Avalia as respostas nos cenários de teste.",
  "aimodels.fallback_none": "Nenhum",
  "aimodels.price": "Preço: {input} por milhão de tokens lidos, {output} por milhão escritos.",
  "aimodels.offered_tools": "Esta tarefa precisa de um modelo que use ferramentas. A lista mostra só os que servem.",
  "aimodels.offered": "A lista mostra só os modelos que servem para esta tarefa.",
  "aimodels.model": "Modelo",
  "aimodels.settings": "Ajustes deste modelo",
  "aimodels.thinking_hint.effort": "Mais esforço pensa mais antes de responder: mais lento e mais caro. Para conversa no WhatsApp, baixo.",
  "aimodels.thinking_hint.reasoning": "Mais raciocínio pensa mais antes de responder: mais lento e mais caro. Para conversa no WhatsApp, baixo.",
  "aimodels.fallback": "Modelo reserva, se este falhar",
  "aimodels.note.no_temperature": "Temperatura: este modelo não usa. A Criatividade dos assistentes fica sem efeito com ele.",
  "aimodels.note.temperature_without_thinking": "Temperatura: só vale com raciocínio \"Nenhum\".",
  "aimodels.note.temperature": "Temperatura: usa a de cada tarefa e a Criatividade dos assistentes.",
  "aimodels.note.responses": "Ferramentas: pela interface Responses da OpenAI.",
  "aimodels.none_offered": "Nenhum modelo disponível para esta tarefa. Ligue modelos em Console › IA › Modelos.",
  "aimodels.chosen_company": "Escolhido pela empresa",
  "aimodels.chosen_custom": "Personalizado",
  "aimodels.platform_only": "Definido pelo DoneTalk",
  "aimodels.from_donetalk": "Do DoneTalk: ",
  "aimodels.follows_platform": "Segue a plataforma: ",
  "aimodels.change": "Mudar",
  "aimodels.choose_other": "Escolher outro",
  "aimodels.use_donetalk": "Usar o do DoneTalk",
  "aimodels.back_to_platform": "Voltar ao padrão",
  "aimodels.tab.models": "Modelos",
  "aimodels.tab.keys": "Chaves",
  "aimodels.tab.usage": "Uso",
  "aimodels.notice.model_off": "O modelo {model} saiu do ar. Estas tarefas voltaram ao modelo do DoneTalk: {tasks}.",
  "aimodels.notice.ok": "Entendi",
  "aimodels.locked": "O DoneTalk escolhe os modelos de IA desta empresa. Fale com o suporte para mudar.",
  "aimodels.keys_note": "Sem mudar nada, cada tarefa usa o modelo do DoneTalk, que se atualiza sozinho. Modelos de outro fornecedor usam as chaves do DoneTalk, e o custo de cada um aparece em Uso; com \"Usar minhas próprias chaves\" ligado, usam a chave da empresa.",
  "aimodels.footer": "Para donos e admins. Toda mudança fica na auditoria. Se um modelo escolhido sair do ar, a tarefa passa para o substituto ou volta ao do DoneTalk, com aviso aqui e por e-mail.",
  "aimodels.compare.title": "Comparar modelos",
  "aimodels.compare.task": "Tarefa",
  "aimodels.compare.period": "Período",
  "aimodels.compare.assistant": "Assistente",
  "aimodels.compare.days": "Últimos {n} dias",
  "aimodels.compare.all_assistants": "Todos",
  "aimodels.compare.line": "Indicador",
  "aimodels.compare.replies": "Respostas enviadas",
  "aimodels.compare.reply_time": "Tempo médio até responder",
  "aimodels.compare.calls": "Chamadas",
  "aimodels.compare.call_time": "Tempo médio do modelo",
  "aimodels.compare.cost": "Custo médio por chamada",
  "aimodels.compare.cache": "Lido do cache",
  "aimodels.compare.handed_off": "Conversas passadas para uma pessoa",
  "aimodels.compare.tools": "Ferramentas usadas",
  "aimodels.compare.successes": "Desfechos de sucesso",
  "aimodels.compare.errors": "Erros",
  "aimodels.compare.empty": "Nenhuma chamada desta tarefa no período.",
  "aimodels.compare.few": "Algum modelo tem menos de 30 no período: a comparação ainda diz pouco.",
  "aimodels.console.following": "{count} clientes seguem",
  "aimodels.console.own": "{count} personalizados: {names}",
  "aimodels.console.impact": "Ao salvar, {count} clientes que seguem o padrão passam a usar o modelo escolhido, com os ajustes traduzidos para ele. Os personalizados continuam no que escolheram.",
  "aimodels.console.embed_locked": "Trocar este modelo exige ler de novo as bases de todos os clientes, e isso ainda não é automático. Por isso a troca está desligada aqui.",
  "aimodels.console.lock": "O cliente pode escolher os modelos",
  "aimodels.console.lock_hint": "Desligado, só a plataforma escolhe por ele aqui; em Configurações › IA ele vê os modelos, sem mudar.",
  "aimodels.console.assistants": "Assistentes",
  "aimodels.console.assistant_own": "Modelo próprio: {model}",
  "aimodels.console.assistant_company": "Usa o da empresa",
  "aimodels.console.history": "Histórico",
  "aimodels.history.chosen": "{task}: {from} → {to}",
  "aimodels.history.assistant": "Modelo de um assistente: {from} → {to}",
  "aimodels.history.locked_on": "Escolha travada: só a plataforma escolhe",
  "aimodels.history.locked_off": "Escolha liberada para o cliente",
  "aimodels.history.platform": "Plataforma",
  "aimodels.history.default": "padrão",
  "aimodels.assistant.title": "Modelo das respostas",
  "aimodels.assistant.company": "O da empresa",
  "aimodels.assistant.own": "Outro só neste assistente",
  "aimodels.assistant.own_hint": "Bom para testar um modelo sem mexer nos outros assistentes.",
  "aimodels.assistant.from_next": "Vale a partir da próxima resposta, sem publicar versão nova.",
  "aimodels.assistant.choose": "Escolher o modelo",
  "aimodels.assistant.creativity_off": "O {model} não usa a Criatividade: o jeito de falar vem do tom e das instruções.",
  "aimodels.trace.model": "Modelo",
  "aimodels.trace.time": "Tempo da resposta",
  "aimodels.trace.fallback": "Respondeu no lugar de {model}, que falhou",
  "platform.page.ai": "IA",
  "marketing.open_conversation.title": "Campanha numa conversa aberta",
  "marketing.open_conversation.hint": "Quando a campanha chega a um contato que já tem uma conversa aberta (de outra campanha ou com alguém da equipe) e ele responde: com quem a conversa fica.",
  "marketing.open_conversation.keep": "Manter com quem está atendendo",
  "marketing.open_conversation.keep_hint": "A resposta fica na conversa como está: a pessoa, o assistente ou o fluxo que já cuidava dela continua.",
  "marketing.open_conversation.route_if_free": "Passar para o destino da campanha se ninguém estiver atendendo",
  "marketing.open_conversation.route_if_free_hint": "Se uma pessoa da equipe está com a conversa, ela continua. Se não, a equipe, o fluxo ou o assistente da campanha assume.",
  "marketing.open_conversation.route": "Passar sempre para o destino da campanha",
  "marketing.open_conversation.route_hint": "A equipe, o fluxo ou o assistente da campanha assume, mesmo que alguém estivesse atendendo; essa pessoa deixa a conversa e isso fica na linha do tempo.",
  "campaigns.open_rule": "Quem tem conversa aberta recebe. Se responder, vale a regra da empresa: \"{rule}\".",
  "message.transcript": "Transcrição",
  "message.transcribing": "Transcrevendo o áudio…",
  "ai.conversation.transcribe": "Transcrever os áudios recebidos",
  "ai.conversation.transcribe_hint": "O assistente entende o que o contato falou e a equipe lê o texto embaixo do áudio. Cada transcrição é uma chamada de IA, com o custo em Uso.",
  "ai.surface.media.describe": "Descrição de imagens e arquivos",
  "aimodels.hint.media.describe": "Descreve para o assistente as imagens, figurinhas e documentos trocados na conversa.",
  "ai.conversation.describe": "Descrever imagens e arquivos para o assistente",
  "ai.conversation.describe_hint": "Cada foto, figurinha ou documento trocado (pelo contato ou pela equipe) ganha uma descrição que só o assistente lê, e as fotos mais recentes vão inteiras para os modelos que enxergam. Cada descrição é uma chamada de IA, com o custo em Uso.",
  "email.ai_provider_down.subject_credit": "DoneTalk · a {provider} recusou a chave da plataforma: sem crédito",
  "email.ai_provider_down.subject_key": "DoneTalk · a {provider} recusou a chave da plataforma",
  "email.ai_provider_down.text_credit": "Desde {since}, a {provider} recusa as chamadas da plataforma por falta de crédito na conta.",
  "email.ai_provider_down.text_key": "Desde {since}, a {provider} não aceita mais a chave da plataforma (chave inválida ou revogada).",
  "email.ai_provider_down.meanwhile": "Enquanto isso, cada tarefa passa para o fornecedor reserva dela, escolhido em Console › IA › Tarefas, e o atendimento não para. Tarefas sem reserva ficam paradas até resolver. Você recebe outro e-mail quando o fornecedor voltar.",
  "email.ai_provider_down.cta": "Abrir o Console",
  "email.ai_provider_down.why": "Você recebe este aviso porque é administrador da plataforma DoneTalk.",
  "email.ai_provider_back.subject": "DoneTalk · a {provider} voltou a responder",
  "email.ai_provider_back.text": "A {provider} voltou a aceitar a chave da plataforma às {until}. Ficou fora desde {since}; nesse tempo, {count} chamadas foram recusadas e passaram para o fornecedor reserva quando havia um.",
  "email.ai_key_refused.subject": "DoneTalk · {workspace}: a {provider} recusou a chave da empresa",
  "email.ai_key_refused.text_credit": "A {provider} recusou a chave de IA da empresa por falta de crédito na conta.",
  "email.ai_key_refused.text_key": "A {provider} não aceita mais a chave de IA da empresa (chave inválida ou revogada).",
  "email.ai_key_refused.meanwhile": "Enquanto isso, o DoneTalk usa outro fornecedor para o atendimento não parar. Coloque crédito ou troque a chave em Configurações › IA › Chaves.",
  "email.ai_key_refused.cta": "Ver as chaves de IA",
  "errors.ai_provider_account": "O fornecedor de IA recusou o acesso (crédito ou chave). Já avisamos quem cuida disso.",
  "aimodels.cross": "Se o fornecedor falhar",
  "aimodels.cross_hint": "Modelo de outro fornecedor, usado por último quando o da tarefa recusa ou cai (por exemplo, sem crédito). Vale para todas as empresas.",
  "aimodels.console.cross": "Se o fornecedor falhar: {model}",
  "aimodels.console.no_cross": "Sem fornecedor reserva: se o fornecedor falhar, a tarefa para",
  "aimodels.notice.key_refused_credit": "{provider} recusou a chave da empresa por falta de crédito. Enquanto isso, o DoneTalk usa outro fornecedor. Coloque crédito ou troque a chave em Chaves.",
  "aimodels.notice.key_refused_key": "{provider} não aceita mais a chave da empresa. Enquanto isso, o DoneTalk usa outro fornecedor. Troque a chave em Chaves.",
  "aimodels.trace.fallback_account": "Respondeu no lugar de {model}: o fornecedor recusou (crédito ou chave)",
  "platform.ai.incident.open_credit": "{provider} sem crédito: a chave da plataforma está sendo recusada",
  "platform.ai.incident.open_key": "{provider} não aceita mais a chave da plataforma",
  "platform.ai.incident.open_text": "Desde {since} · {count} chamadas recusadas. As tarefas estão no fornecedor reserva; as sem reserva estão paradas. Volta sozinho na primeira chamada que passar depois de colocar crédito ou trocar a chave.",
  "platform.ai.incident.past_credit": "{provider} ficou sem crédito de {since} a {until} ({count} chamadas recusadas)",
  "platform.ai.incident.past_key": "{provider} recusou a chave de {since} a {until} ({count} chamadas recusadas)",
  "campaigns.read_rule": "Lidas conta só quem deixa a confirmação de leitura ligada no WhatsApp; quem desligou aparece como entregue.",
  "message.trace.version": "Instruções",
  "message.trace.version_number": "versão {number}",
  "campaigns.config.title": "Configuração",
  "campaigns.config.start": "Início",
  "campaigns.config.started": "Começou em {when}",
  "campaigns.config.window": "Horário de envio",
  "campaigns.config.days_hours": "{days}, das {from} às {to}",
  "campaigns.config.every_day": "Todos os dias",
  "campaigns.config.no_window": "Sem horário definido",
  "campaigns.config.people": "1 pessoa|{count} pessoas",
  "campaigns.config.skips": "Não envia para",
  "campaigns.config.skip_open": "quem já está em atendimento",
  "campaigns.config.skip_recent": "quem recebeu campanha nos últimos {days} dias",
  "campaigns.config.no_goal": "Nenhum: o assistente não sabe o que esta campanha quer",
  "campaigns.config.no_fallback": "nada (a mensagem pode falhar)",
  "campaigns.config.never_stops": "Nunca para sozinha",
  "campaigns.config.approval": "Aprovação",
  "campaigns.config.approved_by": "Aprovada por {name} em {when}",
  "campaigns.config.waiting_approval": "Esperando aprovação",
  "campaigns.pace.title": "Ritmo de envio",
  "campaigns.pace.fast": "O mais rápido que a Meta deixar",
  "campaigns.pace.per_minute": "Até {count} por hora ({per} por minuto)",
  "campaigns.pace.every_minutes": "Até {count} por hora (1 a cada {minutes} minutos)",
  "campaigns.pace.hint": "Mais devagar dá tempo de a campanha parar sozinha se muita gente pedir para sair, e espalha as respostas para quem atende. O limite diário da Meta vale sempre.",
  "campaigns.sending.title": "Alterar envio",
  "campaigns.sending.when": "Vale a partir do próximo minuto, sem pausar a campanha. O resto da campanha continua como foi aprovado.",
  "inbox.view.automation": "Automação",
  "inbox.with_flow": "Com o fluxo {name}",
  "inbox.with_a_flow": "Com um fluxo",
  "inbox.with_assistant": "Com {name} (IA)",
  "inbox.with_an_assistant": "Com o assistente",
  "inbox.contact_wrote": "contato escreveu {when}",
  "inbox.ago_minutes": "há {n} min",
  "inbox.ago_hours": "há {n} h",
  "inbox.ago_days": "há {n} d",
  "campaigns.filter.in_flow": "Num fluxo",
  "campaigns.col.handler": "Quem atende",
  "campaigns.handler.closed": "Concluído",
  "campaigns.handler.queue": "Na fila",
  "numbers.name.in_use": "Em uso, ainda não analisado pela Meta",
  "numbers.health.code.141012": "O número atingiu o limite de conversas novas iniciadas pela empresa (com modelos) nas últimas 24 horas. As vagas voltam conforme os envios de 24 horas atrás vencem. Conversas em que o contato escreveu continuam normais.",
  "numbers.health.code.141015": "A empresa (o portfólio na Meta) atingiu o limite de conversas iniciadas por ela nas últimas 24 horas. O limite vale para todos os números do portfólio e libera aos poucos, conforme os envios de 24 horas atrás vencem.",
  "contact.copy_phone": "Copiar telefone",
  "contact.phone_copied": "Telefone copiado",
  "editor.label": "Editor de imagem",
  "editor.undo": "Desfazer",
  "editor.redo": "Refazer",
  "editor.crop": "Cortar e girar",
  "editor.filter": "Filtrar",
  "editor.draw": "Desenho",
  "editor.text": "Texto",
  "editor.shapes": "Formas",
  "editor.blur": "Desfocar",
  "editor.emoji": "Emoji",
  "editor.sticker": "Figurinha",
  "editor.quality": "Qualidade da foto",
  "editor.quality_none": "A mídia não tem uma resolução em alta definição.",
  "editor.quality_standard": "Qualidade padrão",
  "editor.quality_hd": "Qualidade em alta definição",
  "editor.quality_help": "Fotos em alta definição são mais nítidas, mas fotos de qualidade padrão ocupam menos espaço de armazenamento e são enviadas mais rapidamente.",
  "editor.copy": "Copiar",
  "editor.copied": "Imagem copiada",
  "editor.copy_failed": "O navegador não deixou copiar a imagem.",
  "editor.download": "Baixar",
  "editor.ok": "OK",
  "editor.rotate_left": "Girar à esquerda",
  "editor.rotate_right": "Girar à direita",
  "editor.reset": "Redefinir",
  "editor.filter_name.none": "Nenhum",
  "editor.filter_name.pop": "Pop",
  "editor.filter_name.bw": "P&B",
  "editor.filter_name.cool": "Frio",
  "editor.filter_name.chrome": "Chrome",
  "editor.filter_name.film": "Filme",
  "editor.color.black": "Preto",
  "editor.color.gray": "Cinza",
  "editor.color.white": "Branco",
  "editor.color.blue": "Azul",
  "editor.color.green": "Verde",
  "editor.color.purple": "Roxo",
  "editor.color.orange": "Laranja",
  "editor.color.red": "Vermelho",
  "editor.more_colors": "Mais cores",
  "editor.hex": "Código da cor",
  "editor.brush_size": "Espessura {size}",
  "editor.font": "Fonte",
  "editor.align_left": "Alinhar à esquerda",
  "editor.align_center": "Centralizar",
  "editor.align_right": "Alinhar à direita",
  "editor.background": "Plano de fundo",
  "editor.delete": "Apagar",
  "editor.text_label": "Texto na imagem",
  "editor.shape.rect": "Quadrado",
  "editor.shape.circle": "Círculo",
  "editor.shape.line": "Linha",
  "editor.shape.arrow": "Seta",
  "editor.fill": "Preenchimento",
  "editor.stroke": "Contorno",
  "editor.no_color": "Sem cor",
  "editor.stroke_width": "Espessura do contorno",
  "editor.blur_mode": "Modo desfocado",
  "editor.blur_pixelate": "Pixelado",
  "editor.blur_soft": "Desfocado",
  "editor.blur_size": "Tamanho do pincel",
  "editor.rotate_item": "Girar",
  "editor.stickers_recent": "Recentes",
  "editor.stickers_none": "As figurinhas usadas nas conversas aparecem aqui.",
  "editor.sticker_file": "Usar uma imagem",
  "editor.export_failed": "Não deu para preparar a imagem editada. Tente de novo.",
  "media.discard_title": "Deseja descartar a seleção?",
  "campaigns.after.title": "Depois do envio",
  "campaigns.after.lead": "O que acontece com quem não responde e com quem para de responder. Tudo dentro do horário de envio da campanha.",
  "campaigns.after.never_title": "Quem não responder ao modelo",
  "campaigns.after.send": "Mandar",
  "campaigns.after.no_reminder": "nenhum lembrete",
  "campaigns.after.one_reminder": "1 lembrete",
  "campaigns.after.reminders": "Lembretes",
  "campaigns.after.with_template": "com o modelo",
  "campaigns.after.template": "Modelo do lembrete",
  "campaigns.after.pick_template": "escolha o modelo",
  "campaigns.after.after": "depois de",
  "campaigns.after.delay": "Quando mandar o lembrete",
  "campaigns.after.reminder_hint": "É um novo modelo, cobrado como marketing, e conta no limite diário do número. Usa as mesmas variáveis da campanha. Não vai para quem pausou ou saiu das mensagens ativas, e para sozinho se a qualidade do número cair.",
  "campaigns.after.no_templates": "Nenhum outro modelo aprovado neste número.",
  "campaigns.after.quiet_title": "Quem respondeu e parou de responder",
  "campaigns.after.resumes": "{name} retoma",
  "campaigns.after.the_assistant": "O assistente",
  "campaigns.after.follow_up": "Quando retomar",
  "campaigns.after.times": "Quantas retomadas",
  "campaigns.after.quiet_hint": "{name} relê a conversa e decide: uma mensagem curta puxando para o objetivo, concluir se já terminou, ou passar para uma pessoa só em caso extremo. Grátis: vai dentro da janela de 24 h.",
  "campaigns.after.quiet_needs_assistant": "A retomada é do assistente: vale quando um assistente responde a campanha.",
  "campaigns.after.closing_title": "Encerramento por silêncio",
  "campaigns.after.follows.customer": "Segue a regra da empresa:",
  "campaigns.after.follows.channel": "Segue a regra do número:",
  "campaigns.after.follows.team": "Segue a regra da equipe:",
  "campaigns.after.follows.campaign": "Segue a regra da campanha:",
  "campaigns.after.no_rule": "Nenhuma regra conclui por silêncio: as conversas ficam abertas.",
  "campaigns.after.customize": "Personalizar nesta campanha",
  "campaigns.after.custom": "Personalizada: substitui a regra da empresa nesta campanha.",
  "campaigns.after.back_to_rule": "Voltar à regra da empresa",
  "campaigns.after.saved_hint": "Vale a partir do próximo minuto.",
  "campaigns.after.report": "Resultado depois do envio",
  "campaigns.after.reminders_line": "enviados · {replied} responderam · custo {cost}",
  "campaigns.after.reminders_off": "Só aparece com o lembrete ligado.",
  "campaigns.after.follow_ups": "Retomadas",
  "campaigns.after.follow_ups_of": "Retomadas de {name}",
  "campaigns.after.follow_ups_line": "enviadas · {resumed} voltaram a conversar",
  "campaigns.after.follow_ups_hint": "Grátis, dentro da janela.",
  "campaigns.after.closed_rule": "Concluídas por silêncio",
  "campaigns.after.closed_rule_line": "pela regra da campanha",
  "campaigns.after.closed_rule_hint": "Com o desfecho que a IA escolheu, ou {outcome}.",
  "campaigns.after.closed_rule_off": "A campanha segue a regra da empresa.",
  "campaigns.after.endings": "Como as conversas terminaram",
  "campaigns.after.ending.automation": "Concluídas pela automação",
  "campaigns.after.ending.automation_of": "Concluídas por {name}",
  "campaigns.after.ending.silence": "Concluídas por silêncio",
  "campaigns.after.ending.person": "Passadas para uma pessoa",
  "campaigns.after.ending.open": "Ainda abertas",
  "campaigns.after.endings_hint": "Cada linha abre a lista dessas conversas, com o motivo de cada transferência.",
  "campaigns.after.endings_empty": "Nenhuma conversa aqui.",
  "campaigns.after.reason": "Motivo: {reason}",
  "followup.when.before_close": "1 h antes de a janela fechar",
  "followup.when.after_2h": "depois de 2 h de silêncio",
  "followup.when.after_4h": "depois de 4 h de silêncio",
  "followup.when.after_8h": "depois de 8 h de silêncio",
  "followup.when.off": "não retomar",
  "followup.up_to": "até",
  "followup.times": "1 vez|{count} vezes",
  "followup.hours": "{n} h",
  "followup.days": "1 dia|{count} dias",
  "policy.choose": "a IA escolhe (ou {outcome})",
  "policy.when_silent": "Quando o contato não responde por",
  "policy.close_as": "→ concluir como",
  "policy.short": "{hours} sem resposta → {outcome}",
  "policy.sentence.choose": "Quando o contato não responde por {hours} horas → a IA escolhe o desfecho (ou {outcome})",
  "policy.company": "Da empresa",
  "policy.custom": "Personalizadas",
  "policy.custom_hint": "Uma regra personalizada substitui a da empresa onde ela vale: a mais específica ganha.",
  "policy.replaces": "substitui a da empresa",
  "policy.level.campaign": "Campanha",
  "policy.level.channel": "Número",
  "policy.level.team": "Equipe",
  "policy.level.customer": "Empresa",
  "policy.order_title": "Qual regra vale para uma conversa",
  "policy.order": "Campanha › número › equipe › empresa. Só uma vale por conversa: a primeira que se aplica nessa ordem. Conversa na fila da equipe esperando a empresa responder nunca é concluída por silêncio.",
  "policy.campaign_rule_hint": "Muda na campanha, em Depois do envio.",
  "policy.scope_channel": "número {name}",
  "policy.applies_number": "Número",
  "inbox.next.follow_up": "retomada {when}",
  "inbox.next.closes": "conclui em {time} sem resposta",
  "inbox.next.at": "às {time}",
  "inbox.next.tomorrow": "amanhã às {time}",
  "inbox.next.chip": "Retomada {when}",
  "inbox.next.chip_tip": "{name} retoma antes de a janela fechar, se o contato não responder: retomada {n} de {of}, {when}.",
  "inbox.next.rule": "Regra de encerramento",
  "inbox.next.rule_line": "{whose}: {rule}",
  "inbox.next.closes_at": "Conclui {when} se o contato não responder.",
  "event.follow_up.running": "Retomada {n} de {of}",
  "event.follow_up.sent": "Retomada {n} de {of}",
  "event.follow_up.closed": "Retomada {n} de {of} · a conversa já tinha terminado: concluída",
  "event.follow_up.handed_off": "Retomada {n} de {of} · passada para uma pessoa",
  "event.follow_up.nothing": "Retomada {n} de {of} · nada a dizer",
  "event.follow_up.superseded": "Retomada {n} de {of} · o contato escreveu antes",
  "event.follow_up.failed": "Retomada {n} de {of} · não foi possível",
  "event.closed_rule": "Concluída pela regra {whose}: {hours} sem resposta",
  "event.rule_whose.campaign": "da campanha",
  "event.rule_whose.channel": "do número",
  "event.rule_whose.team": "da equipe",
  "event.rule_whose.customer": "da empresa",
  "event.closed_chosen": "desfecho escolhido pela IA",
  "event.info.rule": "Regra",
  "message.follow_up": "retomada {n} de {of}",
  "assistant.follow_up.title": "Retomada fora de campanhas",
  "assistant.follow_up.hint": "Quando o contato para de responder, {name} retoma antes de a janela de 24 h fechar, dentro do horário escolhido, e decide: uma mensagem curta, concluir, ou uma pessoa só em caso extremo. Nas conversas de campanha vale o que a campanha diz.",
  "assistant.follow_up.hours": "Horário da retomada",
  "assistant.follow_up.any_time": "A qualquer hora",
  "assistant.follow_up.within": "No horário abaixo",
  "inbox.next.today": "hoje às {time}",
  "inbox.next.other_day": "{date} às {time}",
  "message.trace.follow_up": "Por que escreveu"
}
